import { reactive } from 'vue'

const messages = {
  th: {
    home: {
      title: 'หน้าแรก',
      familySection: 'ครอบครัว',
      information: 'ข้อมูล',
      courseInfo: 'ข้อมูลคอร์ส',
      reservation: 'การจอง',
      date: 'วันที่',
      classTime: 'เวลาคลาส',
      noBooking: 'ยังไม่มีการจองคลาส',
      selectMember: 'เลือกสมาชิกเพื่อดูข้อมูล',
      courseExpired: 'คอร์สหมดอายุแล้ว!!',
      addFamilyHint: 'กรุณาเพิ่มสมาชิกครอบครัวในเมนู ครอบครัว',
      monthly: 'รายเดือน',
      expired: 'หมดอายุแล้ว',
      noCourse: 'ไม่มีคอร์ส',
      usedUp: 'คอร์สหมด',
      bookClass: 'จองคลาส',
      genderAge: 'เพศ {gender} อายุ {age}',
      errorSelectFirst: 'กรุณาเลือกสมาชิกในครอบครัว',
      errorNoCourse: 'ไม่สามารถจองคลาสได้ เนื่องจากยังไม่มีข้อมูลคอร์สเรียน กรุณาติดต่อ Admin',
      errorExpired: 'ไม่สามารถจองคลาสได้ เนื่องจากหมดอายุแล้ว',
      errorNoRemaining: 'ไม่สามารถจองคลาสได้ จำนวนคลาสของท่านหมดแล้ว',
      ageUnit: '{years} ปี {months} เดือน {days} วัน',
      remainBadge: 'เหลือ {n} ครั้ง',
      remainOf: 'เหลือ {n} / {total} ครั้ง',
      timeLeftLabel: 'เวลาคงเหลือ',
      daysValue: '{n} วัน',
      privateBooking: 'การจองเรียน Private',
      noPrivateBooking: 'ยังไม่มีการจองเรียน Private',
      privateBookingWith: 'ร่วมกับ {names}',
      coachName: 'โค้ช{name}',
    },
    family: {
      title: 'ครอบครัว',
      sectionHeader: 'สมาชิกในครอบครัว',
      addMember: 'เพิ่มสมาชิก',
      confirmDelete: 'คุณต้องการลบ {name} ออกจากครอบครัวใช่หรือไม่?',
      editSuccess: 'แก้ไขข้อมูลสมาชิกสำเร็จ',
      editFail: 'แก้ไขข้อมูลไม่สำเร็จ',
    },
    btn: {
      ok: 'ตกลง',
      cancel: 'ยกเลิก',
      save: 'บันทึก',
      delete: 'ลบ',
      edit: 'แก้ไข',
      add: 'เพิ่ม',
      close: 'ปิด',
      confirm: 'ยืนยัน',
      back: 'กลับ',
      refresh: 'รีเฟรช',
      copy: 'คัดลอก',
      create: 'สร้าง',
      search: 'ค้นหา',
      newCourse: 'สร้างคอร์สใหม่',
      newBooking: 'เพิ่มการจอง',
      newStudent: 'นักเรียนใหม่',
      approve: 'อนุมัติ',
      finish: 'จบคอร์ส',
      reset: 'รีเซ็ต',
      newClass: 'คลาสใหม่',
      newHoliday: 'วันหยุดใหม่',
    },
    grid: {
      perPage: 'ต่อหน้า',
      range: '{from}–{to} จาก {total} รายการ',
    },
    table: {
      profileImage: 'รูปโปรไฟล์',
      courseRef: 'หมายเลขคอร์ส',
      courseName: 'ชื่อคอร์ส',
      courseShortName: 'ชื่อย่อคอร์ส',
      courseType: 'ประเภท',
      price: 'ราคา',
      startDate: 'วันเริ่มต้น',
      expireDate: 'วันหมดอายุ',
      remaining: 'คงเหลือ',
      courseUser: 'ผู้ใช้คอร์ส',
      payment: 'ชำระเงิน',
      edit: 'แก้ไข',
      delete: 'ลบ',
      finish: 'จบคอร์ส',
      name: 'ชื่อ',
      time: 'เวลา',
      view: 'ดู',
      history: 'ประวัติแก้ไข',
      checkin: 'เช็คชื่อ',
      date: 'วันที่',
      studentId: 'รหัสนักเรียน',
      class: 'คลาส',
      classDay: 'วันเรียน',
      classTime: 'เวลาเรียน',
      maxStudent: 'จำนวนสูงสุด',
      gender: 'เพศ',
      age: 'อายุ',
      school: 'โรงเรียน',
      parentUsername: 'Username ผปค.',
      phone: 'เบอร์โทร',
      holidayDate: 'วันที่หยุด',
      description: 'รายละเอียด',
      nickname: 'ชื่อเล่น',
      level: 'Level',
      studentInfo: 'ข้อมูลนักเรียน',
      courseUsageHistory: 'ประวัติการใช้คอร์ส',
      expired: 'หมดอายุ',
      yearAbbr: 'ปี',
      monthAbbr: 'เดือน',
      dayAbbr: 'วัน',
      firstname: 'ชื่อ',
      middlename: 'ชื่อกลาง',
      lastname: 'นามสกุล',
      dob: 'วันเกิด',
      shortNote: 'หมายเหตุ',
      courseRefer: 'หมายเลขคอร์ส',
      continueCourseRefer: 'หมายเลขคอร์สต่อเนื่อง',
      createBy: 'สร้างโดย',
      createDate: 'วันที่สร้าง',
      updateBy: 'แก้ไขล่าสุดโดย',
      editDate: 'วันที่แก้ไขล่าสุด',
      deleteBy: 'ลบโดย',
    },
    role: {
      head: 'ผู้จัดการ',
      admin: 'แอดมิน',
      coach: 'ครูผู้สอน',
      customer: 'ผู้ปกครอง',
    },
    nav: {
      mainMenu: 'เมนูหลัก',
      home: 'หน้าแรก',
      family: 'ครอบครัว',
      checkingMenu: 'เมนูตรวจสอบ',
      viewClasses: 'ดูตารางเรียน',
      adminMenu: 'เมนูแอดมิน',
      dashboard: 'แดชบอร์ด',
      insightView: 'รายงานเชิงลึก',
      opsChecklist: 'ตรวจสอบประจำวัน',
      chatbot: 'ผู้ช่วย AI',
      gymnasts: 'รายชื่อนักกีฬา',
      gymnastsAll: 'นักเรียนทั้งหมด',
      bookingManagement: 'การจองคลาส',
      privateBookingManagement: 'การจอง Private',
      eventManager: 'อีเวนต์/แข่งขัน',
      customerCourse: 'คอร์สของลูกค้า',
      courseHistory: 'ประวัติคอร์ส',
      managementMenu: 'เมนูจัดการ',
      holidays: 'จัดการวันหยุด',
      accountManagement: 'จัดการบัญชีผู้ใช้',
      theme: 'ธีม',
      editProfile: 'แก้ไขข้อมูลผู้ใช้งาน',
      language: 'ภาษา: ไทย',
      logout: 'ออกจากระบบ',
      groupMine: 'ของฉัน',
      groupOverview: 'ภาพรวม',
      groupSchedule: 'ตารางเรียน & การจอง',
      groupCoach: 'โค้ช',
      groupStudents: 'นักเรียน', groupCourses: 'จัดการคอร์สลูกค้า',
      groupSetup: 'ตั้งค่าระบบ',
      groupFinance: 'การเงิน',
      groupAccount: 'บัญชี',
      paymentDocs: 'เอกสารรับจ่าย',
      financeReport: 'รายงานยอดขาย/การเงิน',
    },
    auth: {
      loginTitle: 'เข้าสู่ระบบ',
      welcome: 'ยินดีต้อนรับสู่ iStar Gymnastics,',
      welcomeSub: 'ขอให้มีวันที่ยอดเยี่ยม :D...',
      heroTag: 'จองคลาส เช็คอิน<br />จัดการคอร์ส<br />ครบ จบ ในที่เดียว',
      heroBlurb: 'ผู้ปกครองจองคลาสให้ลูกได้เองบนมือถือ แอดมินดูตารางและเช็คอินได้ในจอเดียว',
      username: 'ชื่อผู้ใช้',
      password: 'รหัสผ่าน',
      loginBtn: 'เข้าสู่ระบบ',
      registerBtn: 'สมัครสมาชิก',
      forgotBtn: 'ลืมรหัสผ่าน ?',
      logoutConfirm: 'ต้องการออกจากระบบ ?',
    },
    common: {
      yes: 'ใช่',
      no: 'ไม่ใช่',
      close: 'ปิด',
      confirm: 'ยืนยัน',
      ok: 'โอเค',
      required: 'จำเป็นต้องกรอกข้อมูล',
      male: 'ชาย',
      female: 'หญิง',
      loading: 'กำลังโหลด... กรุณารอสักครู่',
      nextCourse: 'คอร์สถัดไป',
      times: 'ครั้ง',
      noCourseData: 'ไม่มีข้อมูลคอร์ส',
      noStudentData: 'ไม่มีข้อมูลนักเรียน',
      noClassData: 'ไม่มีข้อมูลคลาส',
      noStudentList: 'ไม่มีรายชื่อนักเรียน',
      invalidDob: 'วันเกิดไม่ถูกต้อง',
      serverError: 'เกิดข้อผิดพลาดในการสื่อสารกับเซิร์ฟเวอร์',
      noServerResponse: 'ไม่ได้รับการตอบกลับจากเซิร์ฟเวอร์',
      errorPrefix: 'เกิดข้อผิดพลาด',
      hoursUnit: 'ชม.',
    },
    dialog: {
      error: 'เกิดข้อผิดพลาด',
      success: 'สำเร็จ',
      selectTheme: 'เลือกธีม',
      themeNote: 'ธีมที่เลือกจะมีผลกับผู้ใช้ทุกคน',
      themeDarkNote: 'เครื่องนี้เปิดโหมดมืดอยู่ จึงแสดงชุดสีมืดแทนธีมที่เลือก — เครื่องที่ใช้โหมดสว่างยังเห็นธีมตามปกติ',
    },
    theme: {
      default: 'ค่าเริ่มต้น',
      defaultSub: 'iStar สีชมพู',
      mothersday: 'วันแม่',
      mothersdaySub: 'ฟ้าครามและดอกมะลิ',
      loykrathong: 'ลอยกระทง',
      loykrathongSub: 'แสงเทียนและโคมลอย',
      newyear: 'ปีใหม่',
      newyearSub: 'พลุและทองแชมเปญ',
      songkran: 'สงกรานต์',
      songkranSub: 'สายน้ำและแสงแดด',
      halloween: 'ฮาโลวีน',
      halloweenSub: 'ฟักทองและค้างคาว',
      christmas: 'คริสต์มาส',
      christmasSub: 'หิมะและไฟประดับ',
      fathersday: 'วันพ่อ',
      fathersdaySub: 'เหลืองพุทธรักษา',
      muaythai: 'มวยไทย',
      muaythaiSub: 'แดง น้ำเงิน และทอง',

      saveFailed: 'บันทึกธีมให้ทุกคนไม่สำเร็จ — ธีมเปลี่ยนเฉพาะเครื่องนี้',
    },
    validation: {
      usernameRequired: 'กรุณากรอกชื่อผู้ใช้',
      usernameNoSpaces: 'ชื่อผู้ใช้ต้องไม่มีเว้นวรรค',
      usernameEnglishOnly: 'ชื่อผู้ใช้ต้องเป็นตัวอักษรภาษาอังกฤษ ตัวเลข หรืออักขระพิเศษเท่านั้น',

      usernameHint: 'ยาว 4-20 ตัว ใช้ได้เฉพาะ a-z A-Z 0-9 และ . _ -',
      passwordRequired: 'กรุณากรอกรหัสผ่าน',
      nameRequired: 'กรุณากรอกชื่อ',
      mobileRequired: 'กรุณากรอกเบอร์โทรศัพท์',
      emailRequired: 'กรุณากรอกอีเมล',
      emailInvalid: 'รูปแบบอีเมลไม่ถูกต้อง',
      newPasswordRequired: 'กรุณากรอกรหัสผ่านใหม่',
      newPasswordMaxLength: 'รหัสผ่านใหม่ต้องไม่เกิน 10 ตัวอักษร',
      phoneRequired: 'กรุณากรอกเบอร์โทรศัพท์',
      otpRequired: 'กรุณากรอกรหัส OTP',
      otpLength: 'รหัส OTP ต้องมี 6 หลัก',
    },
    bookingList: {
      classBooking: 'การจองคลาส',
      menuCheckin: 'เช็คชื่อ',
      menuUndoCheckin: 'ยกเลิกเช็คชื่อ',
      menuEdit: 'ดู/แก้ไขข้อมูล',
      menuCheckedInBadge: 'เช็คชื่อแล้ว',
      notCheckedIn: 'ยังไม่เช็คชื่อ',
      legendTrial: 'ทดลองเรียน',
      legendPerSession: 'รายครั้ง',
      legendPayment: 'ต้องชำระเงิน / คอร์สหมด',
      legendBlind: 'ซ่อนชื่อจากผู้ปกครองอื่น',
      checkinFail: 'เช็คชื่อไม่สำเร็จ',
      undoCheckinFail: 'ยกเลิกเช็คชื่อไม่สำเร็จ',
      menuCancel: 'ยกเลิกการจอง',
      eventRowNote: 'แถวอีเวนต์ — ย้าย/ยกเลิกทำที่หน้าอีเวนต์',
      confirmCancelBooking: 'ต้องการยกเลิกการจองของ "{name}" ใช่หรือไม่?',
      cancelBookingFail: 'ยกเลิกการจองไม่สำเร็จ',
    },
    customerCourse: {
      period: 'ระยะเวลา (เดือน)',
      payDate: 'วันที่ชำระ',
      uploadSlip: 'อัพโหลดสลิป',
      slipTitle: 'สลิปการชำระเงิน',
      viewSlip: 'ดูสลิปที่อัพโหลดแล้ว',
      doubleBookingNote: 'คอร์สเรียนนี้ สามารถเรียนได้',
      doubleBookingMore: 'มากกว่า',
      doubleBookingUnit: '1 รอบ/วัน',
      paid: 'จ่ายแล้ว',
      unpaid: 'ยังไม่จ่าย',
      shortNote: 'หมายเหตุ',
      noCourseList: 'ไม่มีรายการคอร์สของลูกค้า',
      loadFail: 'โหลดข้อมูลคอร์สไม่สำเร็จ',
      deleteInUse: 'คอร์สเรียนนี้ กำลังถูกใช้โดย {names} ต้องการลบใช่ไหม ?',
      priceCatalog: 'จัดการราคากลาง',
      priceCatalogSub: 'ราคานี้ใช้เติมอัตโนมัติตอนสร้างแพ็กเกจใหม่เท่านั้น ไม่กระทบแพ็กเกจที่ขายไปแล้ว',
      priceSaved: 'บันทึกราคาสำเร็จ',
      noPriceSet: 'ยังไม่ตั้งราคา',
      groupPricing: 'ราคาคอร์สกลุ่ม',
      privatePricing: 'ราคาคอร์ส Private (ต่อชั่วโมง)',
      quantitySessions: 'จำนวนครั้ง',
      quantityOrPeriod: 'จำนวน (ครั้ง/เดือน)',
      pricePerHour: 'ราคา/ชั่วโมง',
      privateType: 'ประเภท Private',
      private1on1: 'ตัวต่อตัว (1:1)',
      private2on1: 'กลุ่มเล็ก (2:1)',
      private3on1: 'กลุ่มเล็ก (3:1)',
      slipVerifyChecking: 'กำลังดึงผลตรวจสลิป…',
      slipVerifyNone: 'ยังไม่มีผลตรวจสำหรับสลิปนี้',
      slipVerified: 'สลิปจริง — ยืนยันกับธนาคารแล้ว',
      slipDuplicate: 'สลิปซ้ำ — เคยถูกใช้ไปแล้ว',
      slipAmountMismatch: 'ยอดเงินบนสลิปไม่ตรงกับราคา',
      slipWrongReceiver: 'บัญชีผู้รับเงินไม่ตรงกับบัญชีร้าน',
      slipFailed: 'ตรวจไม่ผ่าน — อ่านสลิปไม่ได้/ไม่ใช่สลิปจริง',
      slipSkipped: 'ยังไม่ได้ตรวจกับธนาคาร',
      slipReverify: 'ตรวจใหม่',
      slipReverifying: 'กำลังตรวจ…',
      slipReverifyFail: 'ตรวจใหม่ไม่สำเร็จ กรุณาลองอีกครั้ง',
      slipAmount: 'ยอดโอน',
      slipWhen: 'โอนเมื่อ',
      slipFrom: 'ผู้โอน',
      slipSaveVerified: 'ตรวจสลิปแล้ว: เป็นสลิปจริง',
      slipSaveWarn: 'บันทึกข้อมูลสำเร็จ แต่ผลตรวจสลิป',
    },
    eventMgr: {
      tab: 'อีเวนต์/แข่งขัน', pageSubtitle: 'สร้างอีเวนต์ จัดการรายชื่อ และเช็คชื่อวันงาน', newEvent: 'สร้างอีเวนต์', addKidsTitle: 'เพิ่มเด็กเข้าอีเวนต์', addKids: 'เพิ่มเด็ก',

      pastHeadOnly: 'อีเวนต์ย้อนหลังจัดการได้เฉพาะผู้จัดการ',
      step1: 'ข้อมูล', step2: 'เลือกเด็ก', step3: 'ตรวจสอบ', step4: 'ยืนยัน',
      date: 'วันที่', datePh: 'เลือกวันที่แข่ง', coursePh: '— เลือกคอร์ส —',
      label: 'ชื่ออีเวนต์', labelPh: 'เช่น แข่ง KAO Cup', labelHint: 'ชื่อนี้จะเป็นหัวคอลัมน์ในตารางจองของวันแข่ง', defaultLabel: 'แข่ง',
      pickKids: 'ค้นหาและเลือกเด็กที่ไปแข่ง', searchKidPh: 'พิมพ์ชื่อเด็ก…', noKidsYet: 'ยังไม่ได้เลือกเด็ก', noMatch: 'ไม่พบรายชื่อ',
      tagTrial: 'ทดลองเรียน — ไม่หักโควต้า', tagNoCourse: 'ไม่มีคอร์ส', tagExpired: 'คอร์สหมดอายุ', tagQuotaEmpty: 'โควต้าหมด', tagListed: 'ลงชื่อไม่หักโควต้า',
      tagMonthly: 'รายเดือน — ไม่หักครั้ง', tagRemaining: 'เหลือ {n} ครั้ง', tagClockStart: 'อายุคอร์สจะเริ่มนับจากวันแข่ง', tagAlreadyIn: 'มีชื่อในอีเวนต์แล้ว — ข้าม',
      conflictInfo: 'มีจองคลาสปกติวันเดียวกัน ({time})', keepBoth: 'คงคลาสเดิมไว้ (เรียน + แข่ง)', moveBooking: 'ย้ายใบจองเดิมมาเป็นแข่งแทน (ไม่หักเพิ่ม)',
      modeDeduct: 'หักโควต้าคอร์ส', modeList: 'ลงชื่อไม่หักโควต้า (เก็บค่าแข่งแยก/ไม่มีคอร์ส)',
      sumDeduct: 'หักโควต้า {n} คน', sumList: 'ลงชื่อไม่หักโควต้า {n} คน', sumMove: 'ย้ายใบจองมาเป็นแข่ง {n} คน',
      back: 'ย้อนกลับ', next: 'ถัดไป', create: 'บันทึกอีเวนต์',
      kids: 'จำนวนเด็ก', roster: 'รายชื่อ', checkedinShort: 'เช็คอิน', undoCheckin: 'ยกเลิกเช็คอิน', removeKid: 'เอาออก (คืนสิทธิ์)',
      confirmTitle: 'ยืนยัน', confirmRemove: 'เอา {name} ออกจากอีเวนต์? ใบจองจะถูกยกเลิกและคืนสิทธิ์ตามปกติ',
      confirmDelete: 'ลบอีเวนต์ "{name}"?', deleteBlockedHint: 'ลบได้เมื่อไม่มีรายชื่อ', renameTitle: 'แก้ชื่ออีเวนต์',
    },
    bookingMgmt: {
      title: 'การจองคลาส',
      tabBooking: 'จองคลาส',
      viewByDate: 'ดูการจองตามวันที่',
      allBookingsToday: 'การจองคลาสทั้งหมด',
      noBooking: 'ไม่มีการจอง',
      confirmDelete: 'ต้องการลบการจองของ {name} ?',
      confirmCheckin: 'ต้องการ Check-in สำหรับ {name} ?',
      confirmUndoCheckin: 'ต้องการยกเลิก Check-in สำหรับ {name} ?',
      freeClass: 'ทดลองเรียนฟรี',
      courseInfoMonthly: 'หมายเลขคอร์ส: {ref} วันหมดอายุ: {expiry} รายเดือน',
      courseInfoLimited: 'หมายเลขคอร์ส: {ref} วันหมดอายุ: {expiry} เหลือ: {remaining} ครั้ง',
      noCourse: 'นักเรียนคนนี้ยังไม่มี Course ที่สมัครเรียน',
      bookingInfoTitle: 'ข้อมูลการจอง',
      createBy: 'จองโดย',
      createDate: 'เวลาที่ทำการจอง',
      updateBy: 'แก้ไขการจองโดย',
      editDate: 'เวลาที่แก้ไข',
      visibility: 'การแสดงชื่อ',
      visPrivate: 'ส่วนตัว (ซ่อนชื่อ)',
      visPublic: 'สาธารณะ',
      blindBooking: 'ปิดบังชื่อจากผู้ปกครองท่านอื่น',
    },
    courses: {
      newCourse: 'คอร์สใหม่',
      editCourse: 'แก้ไขคอร์ส',
      confirmDelete: 'ต้องการลบคอร์สเรียนนี้ใช่หรือไม่?',
    },
    holidays: {
      title: 'จัดการวันหยุด',
      description: 'เมื่อเพิ่มวันหยุดแล้ว ผู้ปกครองจะไม่สามารถจองคลาสในวันหยุดได้',
      ourHolidays: 'วันหยุดทั้งหมด',
      newHoliday: 'วันหยุดใหม่',
      editHoliday: 'แก้ไขวันหยุด',
      confirmDelete: 'ต้องการลบวันหยุด {date} ใช่หรือไม่?',
      holidayDate: 'วันที่หยุด',
      holidayDescription: 'รายละเอียด',
    },
    gymnasts: {
      title: 'รายชื่อนักกีฬา',
      listTitle: 'รายชื่อนักกีฬา',
      addStudent: 'เพิ่มนักเรียนใหม่',
      editStudent: 'แก้ไขข้อมูลนักเรียน',
      confirmDelete: 'ต้องการลบนักเรียนคนนี้ใช่หรือไม่?',
      confirmFinish: 'ยืนยันการจบคอร์ส และเก็บประวัติ?',
      filterStatus: 'สถานะ',
      statusAll: 'ทุกสถานะ',
      statusActive: 'มีคอร์ส (ใช้งานอยู่)',
      statusNoCourse: 'ไม่มีคอร์ส/หมดอายุ',
      filterGender: 'เพศ',
      genderAll: 'ทุกเพศ',
      filterCourse: 'คอร์ส',
      courseAll: 'ทุกคอร์ส',
    },
    learningHistory: {
      title: 'ข้อมูลนักเรียน + ประวัติการเรียน',
      tableTitle: 'ประวัติการเรียน (คลาสกลุ่ม + Private)',
      currentCourse: 'คอร์สที่ใช้อยู่',
      noCourse: 'ไม่มีคอร์ส',
      monthly: 'รายเดือน',
      sumTotal: 'ทั้งหมด',
      sumGroup: 'คลาสกลุ่ม',
      sumPrivate: 'Private',
      sumFree: 'เรียนฟรี',
      colType: 'ประเภท',
      colCoach: 'โค้ช',
      typeGroup: 'กลุ่ม',
      typePrivate: 'Private',
      typeEvent: 'แข่ง',
      badgeFree: 'ฟรี',
      badgeWalkin: 'รายครั้ง',
      noHistory: 'ยังไม่มีประวัติการเรียน',
      loadFail: 'โหลดประวัติการเรียนไม่สำเร็จ',
    },
    approve: {
      title: 'คำขอนักเรียนใหม่',
      confirmApprove: 'ยืนยันการเพิ่มนักเรียน {count} คน?',
      confirmDelete: 'ต้องการลบนักเรียนคนนี้ใช่หรือไม่?',
      noData: 'ไม่มีนักเรียนใหม่รอการยืนยัน',
      selectAtLeastOne: 'เลือกนักเรียนที่ต้องการอนุมัติอย่างน้อย 1 คน',
    },
    viewClasses: {
      title: 'ดูตารางเรียน',
      viewByDate: 'ดูการจองตามวันที่',
    },
    privateBooking: {
      title: 'ตารางจองเรียน Private',
      addNew: 'เพิ่มการจอง Private',
      editTitle: 'แก้ไขการจอง Private',
      groupClassOption: 'จองคลาสกลุ่ม',
      privateClassOption: 'จองคลาส Private',
      noBooking: 'ยังไม่มีการจองเรียน Private ในวันนี้',
      coach: 'ครูผู้สอน',
      type: 'ประเภท',
      startTime: 'เวลาเริ่ม',
      endTime: 'เวลาสิ้นสุด',
      student1: 'นักเรียนคนที่ 1',
      student2: 'นักเรียนคนที่ 2',
      student3: 'นักเรียนคนที่ 3',
      students: 'นักเรียน',
      hours: 'จำนวนชั่วโมง',
      price: 'ราคา',
      note: 'โน้ต',
      othersCount: 'เด็กอีก {n} คน',
      menuCancel: 'ยกเลิกการจอง',
      cancelConfirm: 'ต้องการยกเลิกการจองของครู {name} ใช่หรือไม่?',
      cancelSuccess: 'ยกเลิกการจองสำเร็จ',
      cancelFail: 'ยกเลิกการจองไม่สำเร็จ ลองใหม่อีกครั้งนะ',
      invalidClasstime: 'รูปแบบเวลาไม่ถูกต้อง กรุณาเลือกเวลาเรียนใหม่',
      managementTitle: 'การจอง Private',
      viewByPeriod: 'ดูตามช่วงเวลา',
      viewSubtitle: 'แตะวันในปฏิทินเพื่อดูรายวัน หรือสลับดูทั้งเดือน',
      periodDay: 'รายวัน',
      periodMonth: 'รายเดือน',
      today: 'วันนี้',
      markLegend: 'วันที่มีการจอง',
      bookingsInMonth: 'การจองทั้งเดือน',
      rangeSummary: '{count} การจอง · {coaches} ครู · {days} วัน',
    },
    courseHistory: {
      title: 'ประวัติคอร์สของลูกค้า',
      ourCourses: 'คอร์สของลูกค้า',
      courseInfo: 'ข้อมูลคอร์ส',
      courseRefer: 'หมายเลขคอร์ส',
    },
    reservation: {
      title: 'การจอง',
      bookingFor: 'การจองคลาสของ {name}',
      confirmBooking: 'ต้องการจองคลาส {name} วันที่ {date} เวลา {time}',
      confirmBtn: 'แน่นอน จองเลย!',
      noClassTime: 'ไม่มีเวลาคลาส',
      blindName: 'ปิดบังชื่อจากผู้ปกครองท่านอื่น',
      blindNameHint: 'ชื่อลูกของคุณจะถูกเบลอในหน้าตารางเรียนของผู้ปกครองคนอื่น',
      blindBadge: 'ส่วนตัว',
    },
    groupbooking: {
      title: 'จองพร้อมกันหลายคน',
      subtitle: 'เลือกคลาสครั้งเดียว จองให้ลูกได้หลายคน',
      entryBtn: 'เริ่มจองหลายคน',
      entryNew: 'ใหม่',
      stepCourse: 'เลือกประเภทคลาส',
      stepDate: 'เลือกวันที่',
      stepTime: 'เลือกรอบเวลา',
      stepKids: 'เลือกลูกที่จะจอง',
      kidsEligible: 'จองได้ {n} คน',
      pickCourseFirst: 'กรุณาเลือกประเภทคลาสก่อน',
      pickSlotFirst: 'เลือกวันที่และรอบเวลาก่อน จึงจะเลือกรายชื่อได้',
      notThisCourse: 'คนละประเภทคลาส',
      expired: 'คอร์สหมดอายุ',
      usedUp: 'คอร์สหมด',
      alreadyBooked: 'จองวันนี้แล้ว',
      sharedShort: 'ครั้งไม่พอ (ใช้คอร์สร่วมกัน)',
      seatShort: 'ที่นั่งว่างไม่พอ',
      monthly: 'รายเดือน',
      remainN: 'เหลือ {n} ครั้ง',
      summary: 'เลือกแล้ว {n} คน · ที่นั่งว่าง {seats} ที่',
      bookBtn: 'จองคลาสให้ {n} คน',
      confirmTitle: 'ยืนยันการจอง {n} คน',
      afterRemain: 'เหลือ {a} → {b}',
      allOrNothingNote: 'ระบบจะจองให้ครบทุกคนเท่านั้น หากมีคนใดจองไม่ผ่าน จะยังไม่จองให้ใครเลย',
      successMsg: 'จองคลาสสำเร็จทั้ง {n} คน',
    },
    dashboard: {
      title: 'แดชบอร์ด',
      subtitle: 'ภาพรวมการจัดการคลาสยิมนาสติก',
      btnPlaceholder: 'มันต้องเป็นปุ่มอะไรสักอย่างแหละ ถ้าคิดออกแล้วจะทำให้ เสนอมาได้นะ',
      totalGymnasts: 'นักกีฬาทั้งหมด',
      activeGymnasts: 'นักกีฬาที่ active',
      todayBooking: "การจองวันนี้",
      tomorrowBooking: "การจองพรุ่งนี้",
      vsLastWeek: "จากสัปดาห์ก่อน",
      studentsUnit: 'นักเรียน',
      bookingsUnit: 'การจอง',
    },
    finance: {
      title: 'รายงานยอดขายและการเงิน',
      subtitle: 'มูลค่าแพ็กเกจที่ขาย เงินที่เก็บได้ ค้างรับ และภาระที่ยังต้องสอน',
      statsSinceBadge: 'เก็บสถิติตั้งแต่ {date}',
      statsSinceNote: 'รายงานนี้เริ่มเก็บสถิติตั้งแต่ {date} — ตัวเลขทุกตัวในหน้านี้นับเฉพาะข้อมูลตั้งแต่วันนั้นเป็นต้นไป รวมถึงค้างรับ เงินรับล่วงหน้า และความครบถ้วนของข้อมูล · แพ็กเกจที่ขายก่อนหน้านั้นและยังค้างจ่าย ต้องดูที่หน้าคอร์สลูกค้าแทน',
      presetBeforeStats: 'ช่วงนี้จบไปก่อน {date} ซึ่งเป็นวันเริ่มเก็บสถิติ จึงไม่มีข้อมูลให้แสดง',
      managerOnly: 'ผู้จัดการเท่านั้น',
      exportCsv: 'ดาวน์โหลด CSV',
      permissionDenied: 'คุณไม่มีสิทธิ์เข้าถึงรายงานนี้',
      fromDate: 'ตั้งแต่วันที่',
      toDate: 'ถึงวันที่',
      sectionFlow: 'การเคลื่อนไหวในช่วงที่เลือก',
      sectionStock: 'ยอดคงค้าง ณ วันนี้',
      sectionTrend: 'ยอดขายรายเดือน',
      sectionReceivables: 'ค้างรับแยกตามอายุหนี้',
      sectionPrivateCoach: 'Private แยกตามโค้ช',
      privateCoachHint: 'นับตามวันที่สอนจริง · ยอดเงินคือราคารวมค่าธรรมเนียมที่ลูกค้าจ่าย',
      noPrivateInRange: 'ไม่มีคาบ Private ในช่วงที่เลือก',
      privSessions: 'จำนวนคาบ',
      privHours: 'ชั่วโมง',
      privRevenue: 'สอนแล้วทั้งหมด',
      privCollected: 'เก็บเงินได้แล้ว',
      privUnpaidInRange: 'ค้างจ่าย (เฉพาะช่วงที่เลือก)',
      privRatePerHour: 'เฉลี่ยต่อชั่วโมง',
      privFeeUnknown: 'มี {n} คาบที่จ่ายด้วยบัตรเครดิตแต่ไม่รู้ค่าธรรมเนียม ยอดจริงอาจสูงกว่าที่แสดง',
      privPriceUnknown: 'ไม่รวม {n} คาบที่ยังไม่กรอกราคา — รายได้จริงสูงกว่าที่แสดง',
      privLoadError: 'โหลดข้อมูลส่วนนี้ไม่สำเร็จ',
      privLoadRetry: 'ลองใหม่',
      privNotProfit: 'ตัวเลขนี้คือรายได้ ไม่ใช่กำไร — ยังไม่ได้หักค่าตอบแทนโค้ชหรือค่าใช้จ่ายอื่น · ช่อง "ค้างจ่าย" นับเฉพาะคาบในช่วงที่เลือก จึงไม่เท่ากับการ์ด "ค้างรับ Private" ด้านบนที่นับ ณ วันนี้ทุกช่วงเวลา',
      viewByMonth: 'รายเดือน',
      viewByCoach: 'รวมต่อโค้ช',
      viewByType: 'ตามประเภท',
      colMonth: 'เดือน',
      colPrivateType: 'ประเภท',
      sectionDataQuality: 'ความครบถ้วนของข้อมูล',
      asOfToday: 'ณ วันที่',
      salesTile: 'ยอดขาย (มูลค่าแพ็กเกจที่ขาย)',
      collectedNetTile: 'เงินเข้าสุทธิ',
      collectedTile: 'เงินเข้าบัญชี',
      vatTile: 'VAT {pct}% ในเงินที่เก็บได้',
      vatFrom: 'จากยอดที่ลูกค้าจ่ายจริง {amount} ฿ ไม่หักค่าธรรมเนียม (ราคารวม VAT ถอดด้วย 7/107)',
      vatSeeCollected: 'ดูรายวันได้ที่การ์ด "เงินเข้าบัญชี" (คิดจากฐานเดียวกัน)',
      salesParts: 'ค่าคอร์ส {course} ฿ + ค่าธรรมเนียม {fee} ฿',
      collectedFeeIncluded: 'รวมค่าธรรมเนียมบัตร {fee} ฿ (เป็นรายรับของยิม)',
      clickDetail: 'กดดูรายละเอียด',
      clickGoTable: 'กดไปที่ตารางค้างรับ',
      legendCourse: 'ค่าคอร์ส',
      legendGrossAll: 'ลูกค้าจ่ายรวม (เข้าบัญชีทั้งหมด)',
      colIntoAccount: 'เข้าบัญชี',
      colFeePart: 'ในนั้นค่าธรรมเนียม',
      colDate: 'วันที่',
      colItem: 'รายการ',
      colCourseAmount: 'ค่าคอร์ส',
      colVatInAmount: 'VAT ในยอด',
      colStatus: 'สถานะ',
      colMethod: 'วิธีจ่าย',
      colSessions: 'ครั้งที่สอน',
      colUnitPrice: 'ราคาต่อครั้ง',
      colRemaining: 'ครั้งคงเหลือ',
      colExpire: 'หมดอายุ',
      paidYes: 'จ่ายแล้ว', flagYes: 'ใช่',
      paidNo: 'ยังไม่จ่าย',
      detailTotal: 'รวม {count} รายการ — ยอดรวม',
      receivablePrivateTile: 'ค้างรับ Private (ยังไม่จ่าย)',
      receivablePrivateCount: '{count} คาบ',
      receivablePrivateTaught: 'สอนไปแล้วแต่ยังไม่ได้เงิน {count} คาบ · {amount} ฿',
      colDay: 'วันที่',
      colDayCount: 'จำนวนรายการ',
      colCoach: 'โค้ช',
      colTaughtStatus: 'สถานะการสอน',
      taughtUnpaid: 'สอนแล้ว ยังไม่จ่าย',
      notYetTaught: 'ยังไม่ถึงวันสอน',
      backToDaily: 'กลับไปสรุปรายวัน',
      detailTotalDays: 'รวม {days} วัน · {count} รายการ — ยอดรวม',
      earnedTile: 'รายได้ตามบริการที่สอนจริง',
      receivableTile: 'ค้างรับ (ยังไม่จ่าย)',
      deferredTile: 'เงินรับล่วงหน้าที่ยังต้องสอน',
      breakageTile: 'ครั้งที่หลุดหมดอายุ (30 วัน)',
      vsPrevPeriod: 'เทียบช่วงก่อน',
      avgPerPackage: 'เฉลี่ย',
      paidAmount: 'ลูกค้าจ่าย',
      feeAmount: 'ค่าธรรมเนียม',
      ofSales: 'ของยอดขาย',
      unitPackages: 'ราย',
      unitDays: 'วัน',
      unitTimes: 'ครั้ง',
      estimatedPart: 'รวมราคาประมาณ {amount} ฿ ({count} ราย)',
      missingPriceWarn: 'ยังไม่ได้กรอกราคา {count} ราย — กดดูรายการ',
      feeUnknownWarn: 'จ่ายบัตรเครดิตแต่ไม่รู้ค่าธรรมเนียม {count} ราย',
      earnedFrom: 'จาก {sessions} ครั้งที่เรียนไปแล้ว',
      earnedUnpriceable: 'อีก {sessions} ครั้งคิดเป็นเงินไม่ได้ (รายเดือน/ไม่ทราบราคา)',
      receivableUsed: '{count} รายเรียนไปแล้วทั้งที่ยังไม่จ่าย',
      deferredSessions: '{sessions} ครั้งคงเหลือ',
      deferredProgress: 'ขายไป {sold} ฿ · ส่งมอบแล้ว {delivered} ฿ ({pct}%)',
      salesUnpaid: 'ในก้อนนี้ยังเก็บเงินไม่ได้ {amount} ฿ ({count} ราย)',
      colUsedOfTotal: 'ใช้ไป / ทั้งหมด',
      colDeliveredPct: 'ส่งมอบแล้ว',
      deferredExpiring: '{amount} ฿ หมดอายุใน 30 วัน',
      deferredMonthlyExcluded: 'ไม่รวมแพ็กเกจรายเดือน {count} ราย (คิดเป็นครั้งไม่ได้)',
      breakageDetail: '{sessions} ครั้ง จาก {count} ราย — เก็บเงินแล้วแต่ไม่ได้ใช้',
      legendActual: 'ราคาจริง',
      legendEstimated: 'ประมาณจากราคากลาง',
      legendCollected: 'เงินเข้าสุทธิ',
      legendNet: 'เข้าบัญชีจริง',
      legendFee: 'ค่าธรรมเนียม',
      legendGross: 'ลูกค้าจ่ายรวม',
      legendVat: 'เส้นประ = VAT {pct}% ที่อยู่ในยอดที่ลูกค้าจ่าย',
      legendCollectedEstimated: 'เงินเข้า (จากราคาประมาณ)',
      showEstimates: 'แสดงค่าประมาณย้อนหลัง',
      eraBefore: 'ยังไม่เก็บราคา — ไม่มีข้อมูลจริง',
      eraAfter: 'เก็บราคาจริงแล้ว',
      trendNoteRealOnly: 'กราฟแสดงยอดขายรายเดือนเต็มเดือนเสมอ ไม่ขึ้นกับช่วงเวลาที่เลือกด้านบน — ใช้ราคาจริงที่บันทึกไว้ นับตามวันที่ขาย เริ่มจาก {date} ตามขอบเขตของรายงาน · แท่งเขียว + ส้ม รวมกันคือลูกค้าจ่ายรวม (= เงินเข้าบัญชี) · กดที่แท่งเพื่อดูรายการของเดือนนั้น',
      trendNote: 'ระบบเริ่มบังคับเก็บราคาขายตั้งแต่ {date} — แพ็กเกจก่อนหน้านั้นที่ไม่ได้บันทึกราคาไว้ จะถูกประมาณจากราคากลางปัจจุบัน (แท่งเส้นประ) ส่วนแท่งทึบคือราคาจริงที่บันทึกไว้ ใช้ดูแนวโน้มได้ แต่อย่าใช้ส่วนที่ประมาณเป็นตัวเลขทางบัญชี',
      byProgram: 'แยกตามโปรแกรม',
      byMethod: 'แยกตามวิธีจ่ายเงิน',
      priceAndDiscount: 'ราคาและส่วนลด',
      colPaid: 'ลูกค้าจ่าย',
      colFee: 'ค่าธรรมเนียม',
      colNet: 'เข้าบัญชีจริง',
      methodUnspecified: 'ไม่ระบุวิธี',
      methodPrivate: 'คลาส Private (ยังไม่ระบุวิธีจ่าย)',
      promoPackages: 'แพ็กเกจโปรโมชั่น',
      totalDiscount: 'ส่วนลดรวมที่ให้ไป',
      avgDiscountPct: 'ลดเฉลี่ยเทียบราคากลาง',
      comparedAgainstList: 'เทียบได้',
      aging0: 'ไม่เกิน 30 วัน',
      aging31: '31–60 วัน',
      aging61: '61–90 วัน',
      aging90: 'เกิน 90 วัน',
      colStudents: 'นักเรียน',
      colPhone: 'เบอร์ผู้ปกครอง',
      colCourse: 'คอร์ส',
      colAmount: 'ยอด',
      colOverdue: 'ค้างมา',
      colUsedUnpaid: 'เรียนไปแล้ว',
      colRefer: 'เลขที่แพ็กเกจ',
      colCreated: 'วันที่สร้าง',
      colSuggested: 'ราคากลางที่แนะนำ',
      unknownPrice: 'ไม่ทราบราคา',
      noReceivables: 'ไม่มีรายการค้างรับ',
      noData: 'ไม่มีข้อมูล',
      viewList: 'ดูรายการ',
      dqPriceActual: 'แพ็กเกจที่มีราคาจริง',
      dqMissingPrice: 'ยังไม่ได้กรอกราคา',
      dqEstimated: 'ใช้ราคาประมาณ',
      dqUnknownPrice: 'ไม่ทราบราคา (ประมาณไม่ได้)',
      unknownPriceWarn: 'ไม่ทราบราคาอีก {count} ราย — ยอดจริงสูงกว่าที่แสดง',
      unknownPriceExcluded: 'ไม่รวม {count} รายที่ไม่ทราบราคา',
      deferredUnknownExcluded: 'ไม่รวม {count} รายที่ไม่ทราบราคา ({sessions} ครั้ง)',
      dqFeeUnknown: 'ไม่รู้ค่าธรรมเนียมบัตร',
      dqNoPaydate: 'จ่ายแล้วแต่ไม่มีวันที่จ่าย',
      dqMonthly: 'รายเดือนที่คิดภาระไม่ได้',
      missingPriceTitle: 'แพ็กเกจที่ยังไม่ได้กรอกราคา',
      missingPriceSub: 'สร้างตั้งแต่ {date} เป็นต้นมา — กรอกราคาให้ครบแล้วตัวเลขในรายงานจะแม่นขึ้นทันที',
      notProfitNote: 'ตัวเลขทั้งหมดคือรายได้ที่ยิมเก็บได้ ไม่ใช่กำไร — ระบบยังไม่เก็บต้นทุนหรือค่าตอบแทนโค้ช',
      preset: { thisMonth: 'เดือนนี้', lastMonth: 'เดือนก่อน', last3Months: '3 เดือน', thisYear: 'ปีนี้', custom: 'กำหนดเอง' },
    },
    insightView: {
      title: 'รายงานเชิงลึก',
      subtitle: 'สรุปเหตุการณ์รายสัปดาห์ + รายชื่อผู้ปกครองที่ควรติดตาม',
      generateBtn: 'สร้างรายงานใหม่',
      generating: 'กำลังสร้างรายงาน...',
      generateSuccess: 'สร้างรายงานใหม่สำเร็จ',
      generateFail: 'สร้างรายงานไม่สำเร็จ',
      historyTitle: 'ประวัติย้อนหลัง',
      emptyReports: 'ยังไม่มีรายงาน',
      newStudentsTile: 'นักเรียนใหม่ (เดือนล่าสุด)',
      packagesSoldTile: 'แพ็กเกจขายได้ (เดือนล่าสุด) — ยังไม่รวมมูลค่าเงิน',
      vsPrevMonth: 'เทียบเดือนก่อน',
      showMonthly: 'ดูข้อมูลรายเดือน',
      hideMonthly: 'ซ่อนข้อมูลรายเดือน',
      unitPeople: 'คน',
      unitPackages: 'ราย',
      winBackTitle: 'ผู้ปกครองที่ควรชวนกลับ',
      atRiskTitle: 'เสี่ยงใช้ครั้งเรียนไม่ทันก่อนหมดอายุ',
      opsLinkTitle: 'ตารางรายการที่ต้องตามเก็บ ย้ายไปหน้าตรวจสอบประจำวันแล้ว',
      opsLinkBody: 'ค้างชำระ · ใกล้หมด · ซื้อแล้วไม่เริ่มใช้ · หมดอายุแต่ยังเหลือครั้ง — ดูที่นั่นได้ข้อมูลสด ณ ตอนนี้ (หน้านี้เป็นภาพนิ่ง ณ วันที่สร้างรายงาน)',
      opsLinkBtn: 'ไปหน้าตรวจสอบประจำวัน',
      colNickname: 'ชื่อเล่น',
      colMobile: 'เบอร์โทร',
      colEndedOn: 'สิ้นสุดแพ็กเกจเมื่อ',
      colDaysLapsed: 'ผ่านมา (วัน)',
      colCourse: 'คอร์ส',
      colRef: 'รหัสคอร์ส',
      colStudents: 'นักเรียน',
      colPhones: 'เบอร์โทร',
      colRemaining: 'คงเหลือ (ครั้ง)',
      colExpiredate: 'วันหมดอายุ',
      colDaysLeft: 'เหลือเวลา (วัน)',
    },
    addFamily: {
      title: 'เพิ่มสมาชิก',
      firstname: 'ชื่อ',
      middlename: 'ชื่อกลาง',
      lastname: 'นามสกุล',
      nickname: 'ชื่อเล่น',
      school: 'โรงเรียน',
      gender: 'เพศ',
      dob: 'วันเกิด',
      submit: 'บันทึก',
      clear: 'ล้างข้อมูล',
      errorRequired: 'กรุณากรอกข้อมูลให้ครบถ้วน',
    },
    register: {
      title: 'สมัครสมาชิก',
      username: 'ชื่อผู้ใช้',
      password: 'รหัสผ่าน',
      firstname: 'ชื่อ',
      middlename: 'ชื่อกลาง',
      lastname: 'นามสกุล',
      address: 'ที่อยู่',
      email: 'อีเมล',
      mobile: 'เบอร์โทรศัพท์',
      code: 'รหัสลงทะเบียน',
      privacyConsent: 'ฉันยอมรับว่าได้อ่านและตกลงกับ',
      privacyPolicy: 'นโยบายความเป็นส่วนตัว',
      privacyOf: 'ของ iStar Gymnastics',
      submit: 'สมัคร',
      clear: 'ล้างข้อมูล',
      cancel: 'ยกเลิก',
    },
    accountMgmt: {
      listTitle: 'จัดการบัญชีผู้ใช้',
      subtitle: 'ค้นหา แก้ไข รีเซ็ตรหัสผ่าน จัดการครอบครัว และกำหนดสิทธิ์',
      editUser: 'แก้ไขบัญชีผู้ใช้',
      username: 'ชื่อผู้ใช้',
      fullname: 'ชื่อ-สกุล',
      mobileno: 'เบอร์โทร',
      roleCol: 'สิทธิ์',
      province: 'จังหวัด',
      status: 'สถานะ',
      active: 'ปกติ',
      restricted: 'ถูกจำกัด',
      noUsers: 'ไม่พบผู้ใช้งาน',
      roleAll: 'ทุกสิทธิ์',
      loadFail: 'โหลดรายชื่อผู้ใช้ไม่สำเร็จ',
      saveFail: 'ดำเนินการไม่สำเร็จ',
      tabPersonal: 'ข้อมูลส่วนตัว',
      tabPassword: 'รหัสผ่าน',
      tabFamily: 'สมาชิกครอบครัว',
      tabPermissions: 'สิทธิ์การใช้งาน',
      personalSection: 'ข้อมูลผู้ใช้',
      contactSection: 'ข้อมูลติดต่อ',
      addressSection: 'ที่อยู่',
      firstname: 'ชื่อจริง',
      middlename: 'ชื่อกลาง',
      lastname: 'นามสกุล',
      email: 'อีเมล',
      savedProfile: 'บันทึกข้อมูลผู้ใช้เรียบร้อยแล้ว',
      passwordSection: 'ตั้งรหัสผ่านใหม่',
      newPassword: 'รหัสผ่านใหม่',
      confirmPassword: 'ยืนยันรหัสผ่านใหม่',
      resetPasswordBtn: 'รีเซ็ตรหัสผ่าน',
      pwMismatch: 'รหัสผ่านทั้งสองช่องไม่ตรงกัน',
      pwResetOk: 'รีเซ็ตรหัสผ่านเรียบร้อยแล้ว',
      pwSessionNote: 'การรีเซ็ตรหัสผ่านจะใช้ได้ทันที แต่ผู้ใช้ที่กำลังล็อกอินอยู่จะยังใช้งานต่อได้จนกว่าเซสชันจะหมดอายุ (ไม่สามารถบังคับให้ออกจากระบบทันทีได้)',
      familySection: 'สมาชิกในครอบครัว',
      childName: 'ชื่อสมาชิก',
      childCourse: 'คอร์ส',
      transferTo: 'ย้ายไปครอบครัว',
      searchFamily: 'พิมพ์ชื่อผู้ใช้ครอบครัวปลายทาง…',
      chooseFamily: '— เลือกครอบครัวปลายทาง —',
      addChild: 'เพิ่มสมาชิก',
      nickname: 'ชื่อเล่น',
      gender: 'เพศ',
      dob: 'วันเกิด',
      pending: 'รออนุมัติ',
      noChildren: 'ยังไม่มีสมาชิกในครอบครัวนี้',
      deleteChildTitle: 'ลบสมาชิก',
      confirmDeleteChild: 'ต้องการลบสมาชิกคนนี้ใช่หรือไม่?',
      childDeleted: 'ลบสมาชิกเรียบร้อยแล้ว',
      childAdded: 'เพิ่มสมาชิกเรียบร้อยแล้ว',
      transferOk: 'ย้ายสมาชิกเรียบร้อยแล้ว (คอร์สถูกย้ายตามไปด้วย)',
      roleSection: 'เปลี่ยนสิทธิ์การใช้งาน',
      roleLabel: 'สิทธิ์',
      applyRole: 'บันทึกสิทธิ์',
      roleChanged: 'เปลี่ยนสิทธิ์เรียบร้อยแล้ว',
      cannotChangeSelf: 'ไม่สามารถเปลี่ยนสิทธิ์ของตนเองได้',
      accessSection: 'การเข้าถึงระบบ',
      unlockAccess: 'ปลดล็อกการเข้าถึง',
      notRestricted: 'บัญชีนี้ไม่ได้ถูกจำกัดการเข้าถึง',
      accessUnlocked: 'ปลดล็อกการเข้าถึงเรียบร้อยแล้ว',
      adminStaffBlocked: 'คุณมีสิทธิ์จัดการเฉพาะบัญชีผู้ปกครองเท่านั้น ไม่สามารถแก้ไขบัญชีทีมงานได้',
    },
    addr: {
      no: 'บ้านเลขที่ / หมู่ / ซอย / ถนน',
      noPlaceholder: 'เช่น 99/1 หมู่ 2 ซ.สุขุมวิท 101',
      search: 'ค้นหาที่อยู่ (ตำบล อำเภอ จังหวัด หรือรหัสไปรษณีย์)',
      searchPlaceholder: 'พิมพ์เช่น "สวนหลวง" หรือ "10250"',
      subdistrict: 'ตำบล/แขวง',
      district: 'อำเภอ/เขต',
      province: 'จังหวัด',
      postalcode: 'รหัสไปรษณีย์',
      noResult: 'ไม่พบข้อมูล ลองพิมพ์ชื่อตำบล อำเภอ หรือจังหวัด',
      loading: 'กำลังโหลดข้อมูลที่อยู่...',
      clear: 'ล้างที่อยู่',
      legacyHint: 'ที่อยู่ที่บันทึกไว้เดิม',
      updateHint: 'กรุณาเลือกตำบล/อำเภอ/จังหวัดจากช่องค้นหา เพื่ออัปเดตที่อยู่ให้เป็นรูปแบบใหม่',
    },
    forgot: {
      title: 'ลืมรหัสผ่าน',
      subtitle: 'กรอก username และเบอร์โทรศัพท์ที่ท่านเคยลงทะเบียนไว้',
      username: 'ชื่อผู้ใช้',
      phone: 'เบอร์โทรศัพท์',
      otp: 'รหัส OTP',
      requestOTP: 'ขอ OTP',
      submit: 'ยืนยัน',
      cancel: 'ยกเลิก',
      newPassword: 'รหัสผ่านใหม่',
      confirmPassword: 'ยืนยันรหัสผ่านใหม่',
      phoneMatchError: 'username และเบอร์โทรศัพท์ไม่ถูกต้อง',
      otpInvalid: 'รหัส OTP ไม่ถูกต้อง',
      passwordMismatch: 'รหัสผ่านไม่ตรงกัน',
      passwordChangedSuccess: 'เปลี่ยนรหัสผ่านสำเร็จ',
    },
    editProfile: {
      title: 'แก้ไขข้อมูลผู้ใช้งาน',
      personalInfo: 'ข้อมูลส่วนตัว',
      email: 'อีเมล',
      phone: 'เบอร์โทรศัพท์',
      address: 'ที่อยู่',
      saveProfile: 'บันทึกข้อมูล',
      changePasswordSection: 'เปลี่ยนรหัสผ่าน',
      currentPassword: 'รหัสผ่านปัจจุบัน',
      newPassword: 'รหัสผ่านใหม่',
      confirmNewPassword: 'ยืนยันรหัสผ่านใหม่',
      changePasswordBtn: 'เปลี่ยนรหัสผ่าน',
      emailRequired: 'กรุณากรอกอีเมล',
      emailInvalid: 'รูปแบบอีเมลไม่ถูกต้อง',
      phoneRequired: 'กรุณากรอกเบอร์โทรศัพท์',
      passwordRequired: 'กรุณากรอกรหัสผ่าน',
      passwordMinLength: 'รหัสผ่านต้องมีอย่างน้อย 6 ตัวอักษร',
      confirmRequired: 'กรุณายืนยันรหัสผ่าน',
      passwordMismatch: 'รหัสผ่านไม่ตรงกัน',
      saveSuccess: 'บันทึกข้อมูลสำเร็จ',
      saveFail: 'บันทึกข้อมูลไม่สำเร็จ',
      passwordChangeSuccess: 'เปลี่ยนรหัสผ่านสำเร็จ',
      passwordChangeFail: 'เปลี่ยนรหัสผ่านไม่สำเร็จ',
    },
    msg: {
      required: 'กรุณากรอกข้อมูลให้ครบถ้วน',
      updated: 'แก้ไขข้อมูลสำเร็จแล้ว',
      created: 'สร้างสำเร็จแล้ว',
      deleted: 'ลบสำเร็จแล้ว',
      courseDone: 'สำเร็จ จบคอร์สแล้ว',
      courseDeleted: 'สำเร็จ ลบคอร์สเรียนแล้ว',
      updateFail: 'แก้ไขข้อมูลไม่สำเร็จ ลองใหม่อีกครั้งนะ',
      addFail: 'เพิ่มข้อมูลไม่สำเร็จ ลองใหม่อีกครั้งนะ',
      memberAdded: 'เพิ่มสมาชิกสำเร็จแล้ว',
      memberAddFail: 'เพิ่มสมาชิกไม่สำเร็จ',
      familyAdded: 'เพิ่มสมาชิกครอบครัวสำเร็จแล้ว',
      familyDuplicate: 'มีชื่อนี้อยู่ในสมาชิกครอบครัวแล้ว กรุณาติดต่อแอดมิน',
      familyAddFail: 'เพิ่มสมาชิกครอบครัวไม่สำเร็จ',
      bookingAdded: 'เพิ่มการจองคลาสสำเร็จแล้ว',
      bookingAddFail: 'เพิ่มการจองคลาสไม่สำเร็จ ลองใหม่อีกครั้งนะ',
      bookingSuccess: 'จองคลาสสำเร็จ แล้วพบกัน :)',
      bookingDuplicate: 'คุณได้จองคลาสในวันที่ {date} ไปแล้ว กรุณาเลือกวันอื่น',
      noRemaining: 'ไม่สามารถจองคลาสได้ จำนวนคลาสของท่านหมดแล้ว',
      cannotEditDeleted: 'ไม่สามารถแก้ไขข้อมูลเด็กที่ถูกลบไปแล้ว',
      courseCreated: 'สำเร็จ สร้างคอร์สใหม่แล้ว',
      courseUpdated: 'สำเร็จ แก้ไขข้อมูลคอร์สแล้ว',
      fileTooLarge: 'ไฟล์รูปต้องไม่เกิน 4MB',
      uploadSuccess: 'อัพโหลดรูปสำเร็จ',
      uploadFail: 'อัพโหลดรูปไม่สำเร็จ',
      loadFail: 'โหลดข้อมูลไม่สำเร็จ',
      studentDeleted: 'ลบนักเรียนสำเร็จ',
      studentDeleteFail: 'ลบนักเรียนไม่สำเร็จ',
      studentListFail: 'โหลดรายชื่อนักเรียนไม่สำเร็จ',
      reservationDeleted: 'ลบการจองสำเร็จ',
      reservationDeleteFail: 'ลบการจองไม่สำเร็จ',
      familyDeleted: 'ลบสมาชิกครอบครัวสำเร็จ',
      familyLoadFail: 'โหลดข้อมูลครอบครัวไม่สำเร็จ',
      studentApproved: 'อนุมัตินักเรียนใหม่สำเร็จ',
      approveFail: 'อนุมัตินักเรียนไม่สำเร็จ',
      bothCredsRequired: 'กรุณากรอกทั้งชื่อผู้ใช้และรหัสผ่าน',
      registerSuccess: 'สมัครสมาชิกสำเร็จ',
      registerFail: 'สมัครสมาชิกไม่สำเร็จ',
    },
  },
  en: {
    home: {
      title: 'Home',
      familySection: 'Family',
      information: 'Information',
      courseInfo: 'Course Info',
      reservation: 'Reservation',
      date: 'Date',
      classTime: 'Class Time',
      noBooking: 'No class bookings yet',
      selectMember: 'Select a member to view details',
      courseExpired: 'Course Expired!!',
      addFamilyHint: 'Please add your family member in the FAMILY menu',
      monthly: 'Monthly',
      expired: 'Expired',
      noCourse: 'No course',
      usedUp: 'Used up',
      bookClass: 'Book a class',
      genderAge: '{gender} · Age {age}',
      errorSelectFirst: 'Please select a family member',
      errorNoCourse: 'Cannot book — no course assigned. Please contact Admin',
      errorExpired: 'Cannot book — your course has expired',
      errorNoRemaining: 'Cannot book — no classes remaining',
      ageUnit: '{years} yr {months} mo {days} d',
      remainBadge: '{n} left',
      remainOf: '{n} / {total} left',
      timeLeftLabel: 'Time left',
      daysValue: '{n} days',
      privateBooking: 'Private Lesson Bookings',
      noPrivateBooking: 'No private lesson bookings yet',
      privateBookingWith: 'With {names}',
      coachName: 'Coach {name}',
    },
    family: {
      title: 'Family',
      sectionHeader: 'Family Member',
      addMember: 'Add Family Member',
      confirmDelete: 'Remove {name} from your family?',
      editSuccess: 'Member updated successfully',
      editFail: 'Update failed',
    },
    btn: {
      ok: 'OK',
      cancel: 'Cancel',
      save: 'Save',
      delete: 'Delete',
      edit: 'Edit',
      add: 'Add',
      close: 'Close',
      confirm: 'Confirm',
      back: 'Back',
      refresh: 'Refresh',
      copy: 'Copy',
      create: 'Create',
      search: 'Search',
      newCourse: 'New Course',
      newBooking: 'New Booking',
      newStudent: 'New Student',
      approve: 'Approve',
      finish: 'Finish',
      reset: 'Reset',
      newClass: 'New Class',
      newHoliday: 'New Holiday',
    },
    grid: {
      perPage: 'per page',
      range: '{from}–{to} of {total} items',
    },
    table: {
      profileImage: 'Profile Photo',
      courseRef: 'Course Ref #',
      courseName: 'Course Name',
      courseShortName: 'Short Name',
      courseType: 'Type',
      price: 'Price',
      startDate: 'Start Date',
      expireDate: 'Expire Date',
      remaining: 'Remaining',
      courseUser: 'Course User',
      payment: 'Payment',
      edit: 'Edit',
      delete: 'Delete',
      finish: 'Finish',
      name: 'Name',
      time: 'Time',
      view: 'View',
      history: 'History',
      checkin: 'Check-in',
      date: 'Date',
      studentId: 'Student ID',
      class: 'Class',
      classDay: 'Class Day',
      classTime: 'Class Time',
      maxStudent: 'Max Student',
      gender: 'Gender',
      age: 'Age',
      school: 'School',
      parentUsername: 'Parent Username',
      phone: 'Phone',
      holidayDate: 'Holiday Date',
      description: 'Description',
      nickname: 'Nickname',
      level: 'Level',
      studentInfo: 'Student Information',
      courseUsageHistory: 'Course Usage History',
      expired: 'Expired',
      yearAbbr: 'yr',
      monthAbbr: 'mo',
      dayAbbr: 'd',
      firstname: 'Firstname',
      middlename: 'Middlename',
      lastname: 'Lastname',
      dob: 'Date of Birth',
      shortNote: 'Short Note',
      courseRefer: 'Course Ref',
      continueCourseRefer: 'Continue Course Ref',
      createBy: 'Created by',
      createDate: 'Created at',
      updateBy: 'Last edited by',
      editDate: 'Last edited at',
      deleteBy: 'Deleted by',
    },
    role: {
      head: 'Head Manager',
      admin: 'Admin',
      coach: 'Coach',
      customer: 'Parent',
    },
    nav: {
      mainMenu: 'Main Menu',
      home: 'Home',
      family: 'Family',
      checkingMenu: 'Checking Menu',
      viewClasses: 'View Classes',
      adminMenu: 'Admin Menu',
      dashboard: 'Dashboard',
      insightView: 'Insights',
      opsChecklist: 'Daily Checks',
      chatbot: 'AI Assistant',
      gymnasts: 'Gymnast List',
      gymnastsAll: 'All Students',
      bookingManagement: 'Class Bookings',
      privateBookingManagement: 'Private Bookings',
      eventManager: 'Events/Competitions',
      customerCourse: 'Customer Courses',
      courseHistory: 'Course History',
      managementMenu: 'Management Menu',
      holidays: 'Manage Holidays',
      accountManagement: 'User Accounts',
      theme: 'Theme',
      editProfile: 'Edit User Profile',
      language: 'Language: EN',
      logout: 'Logout',
      groupMine: 'My area',
      groupOverview: 'Overview',
      groupSchedule: 'Classes & bookings',
      groupCoach: 'Coaches',
      groupStudents: 'Students', groupCourses: 'Customer Courses',
      groupSetup: 'Setup',
      groupFinance: 'Finance',
      groupAccount: 'Account',
      paymentDocs: 'Payment documents',
      financeReport: 'Sales & finance report',
    },
    auth: {
      loginTitle: 'Login',
      welcome: 'Welcome to iStar Gymnastics,',
      welcomeSub: 'Have a wonderful day :D...',
      heroTag: 'Book classes, check in,<br />manage courses,<br />all in one place',
      heroBlurb: 'Parents book classes for their kids on mobile; admins view schedules and check in on one screen',
      username: 'Username',
      password: 'Password',
      loginBtn: 'Login',
      registerBtn: 'Register',
      forgotBtn: 'Forgot Password ?',
      logoutConfirm: 'Do you want to logout ?',
    },
    common: {
      yes: 'Yes',
      no: 'No',
      close: 'Close',
      confirm: 'Confirm',
      ok: 'OK',
      required: 'This field is required',
      male: 'Male',
      female: 'Female',
      loading: 'Loading... Please wait',
      nextCourse: 'Next Course',
      times: 'times',
      noCourseData: 'No course data',
      noStudentData: 'No student data',
      noClassData: 'No class data',
      noStudentList: 'No student list',
      invalidDob: 'Invalid Date of Birth',
      serverError: 'Server communication error',
      noServerResponse: 'No response from server',
      errorPrefix: 'Error',
      hoursUnit: 'hrs',
    },
    dialog: {
      error: 'Error',
      success: 'Success',
      selectTheme: 'Select Theme',
      themeNote: 'The selected theme applies to all users',
      themeDarkNote: 'This device is in dark mode, so it shows the dark palette instead of the selected theme. Devices in light mode still see the theme.',
    },
    theme: {
      default: 'Default',
      defaultSub: 'iStar Pink',
      mothersday: "Mother's Day",
      mothersdaySub: 'Sky blue & jasmine',
      loykrathong: 'Loy Krathong',
      loykrathongSub: 'Candlelight & lanterns',
      newyear: 'New Year',
      newyearSub: 'Fireworks & champagne gold',
      songkran: 'Songkran',
      songkranSub: 'Water & summer sun',
      halloween: 'Halloween',
      halloweenSub: 'Pumpkins & bats',
      christmas: 'Christmas',
      christmasSub: 'Snow & lights',
      fathersday: "Father's Day",
      fathersdaySub: 'Royal yellow canna',
      muaythai: 'Muay Thai',
      muaythaiSub: 'Crimson, blue & gold',

      saveFailed: 'Could not save the theme for everyone — it changed on this device only',
    },
    validation: {
      usernameRequired: 'Username is required',
      usernameNoSpaces: 'Username must not contain spaces',
      usernameEnglishOnly: 'Username must be English letters, numbers, or special characters only',

      usernameHint: '4-20 characters; letters, digits and . _ - only',
      passwordRequired: 'Password is required',
      nameRequired: 'Name is required',
      mobileRequired: 'Mobile Number is required',
      emailRequired: 'E-mail is required',
      emailInvalid: 'E-mail must be valid',
      newPasswordRequired: 'New Password is required',
      newPasswordMaxLength: 'New Password must be 10 characters or less',
      phoneRequired: 'Phone number is required',
      otpRequired: 'OTP is required',
      otpLength: 'OTP must be 6 characters long',
    },
    bookingList: {
      classBooking: 'Class Booking',
      menuCheckin: 'Check in',
      menuUndoCheckin: 'Undo check-in',
      menuEdit: 'View / Edit',
      menuCheckedInBadge: 'Checked in',
      notCheckedIn: 'Not checked in',
      legendTrial: 'Trial class',
      legendPerSession: 'Per session',
      legendPayment: 'Payment required / Course used up',
      legendBlind: 'Name hidden from other parents',
      checkinFail: 'Check-in failed',
      undoCheckinFail: 'Undo check-in failed',
      menuCancel: 'Cancel booking',
      eventRowNote: 'Event row — move or cancel it on the event page',
      confirmCancelBooking: 'Cancel the booking for "{name}"?',
      cancelBookingFail: 'Failed to cancel the booking',
    },
    customerCourse: {
      period: 'Period (months)',
      payDate: 'Payment Date',
      uploadSlip: 'Upload Slip',
      slipTitle: 'Payment Slip',
      viewSlip: 'View Uploaded Slip',
      doubleBookingNote: 'This course can be attended',
      doubleBookingMore: 'more than',
      doubleBookingUnit: '1 session/day',
      paid: 'Paid',
      unpaid: 'Not Paid',
      shortNote: 'Short Note',
      noCourseList: "No customer's course list",
      loadFail: 'Failed to load course info',
      deleteInUse: 'This course is being used by {names}. Delete it?',
      priceCatalog: 'Manage Price List',
      priceCatalogSub: 'Used to auto-fill new packages only — does not affect packages already sold',
      priceSaved: 'Price saved successfully',
      noPriceSet: 'Not set',
      groupPricing: 'Group course pricing',
      privatePricing: 'Private lesson pricing (per hour)',
      quantitySessions: 'Number of sessions',
      quantityOrPeriod: 'Quantity (sessions/months)',
      pricePerHour: 'Price / hour',
      privateType: 'Private type',
      private1on1: '1-on-1',
      private2on1: 'Small group (2:1)',
      private3on1: 'Small group (3:1)',
      slipVerifyChecking: 'Loading verification result…',
      slipVerifyNone: 'No verification result for this slip yet',
      slipVerified: 'Genuine slip — verified with the bank',
      slipDuplicate: 'Duplicate slip — already used',
      slipAmountMismatch: 'Slip amount does not match the price',
      slipWrongReceiver: 'Receiving account does not match the shop',
      slipFailed: 'Verification failed — unreadable or not a real slip',
      slipSkipped: 'Not verified with the bank yet',
      slipReverify: 'Re-check',
      slipReverifying: 'Checking…',
      slipReverifyFail: 'Re-check failed, please try again',
      slipAmount: 'Amount',
      slipWhen: 'Transferred at',
      slipFrom: 'From',
      slipSaveVerified: 'Slip verified: genuine',
      slipSaveWarn: 'Saved successfully, but slip verification',
    },
    eventMgr: {
      tab: 'Events/Competitions', pageSubtitle: 'Create events, manage rosters and check in on the day', newEvent: 'New Event', addKidsTitle: 'Add kids to event', addKids: 'Add kids',

      pastHeadOnly: 'Only the manager can work on past events',
      step1: 'Details', step2: 'Pick kids', step3: 'Review', step4: 'Confirm',
      date: 'Date', datePh: 'Pick the event date', coursePh: '— select course —',
      label: 'Event name', labelPh: 'e.g. KAO Cup', labelHint: 'This name becomes the roster column header on the event day', defaultLabel: 'แข่ง',
      pickKids: 'Search and pick the kids attending', searchKidPh: 'Type a kid name…', noKidsYet: 'No kids selected yet', noMatch: 'No match',
      tagTrial: 'Trial — no quota cut', tagNoCourse: 'No course', tagExpired: 'Course expired', tagQuotaEmpty: 'No sessions left', tagListed: 'Listed — no deduction',
      tagMonthly: 'Monthly — no session cut', tagRemaining: '{n} sessions left', tagClockStart: 'Course clock starts on the event date', tagAlreadyIn: 'Already in this event — skipped',
      conflictInfo: 'Has a regular class booking that day ({time})', keepBoth: 'Keep the class booking (class + event)', moveBooking: 'Move that booking into the event (no extra cut)',
      modeDeduct: 'Deduct course quota', modeList: 'List only, no deduction (fee collected separately / no course)',
      sumDeduct: 'Deduct quota: {n} kids', sumList: 'List only: {n} kids', sumMove: 'Move booking: {n} kids',
      back: 'Back', next: 'Next', create: 'Save event',
      kids: 'Kids', roster: 'Roster', checkedinShort: 'checked in', undoCheckin: 'Undo check-in', removeKid: 'Remove (refund)',
      confirmTitle: 'Confirm', confirmRemove: 'Remove {name} from the event? The booking is cancelled and quota refunded as usual.',
      confirmDelete: 'Delete event "{name}"?', deleteBlockedHint: 'Deletable only when empty', renameTitle: 'Rename event',
    },
    bookingMgmt: {
      title: 'Class Bookings',
      tabBooking: 'Bookings',
      viewByDate: 'View class booking by date',
      allBookingsToday: 'All class bookings',
      noBooking: 'No booking',
      confirmDelete: 'Delete booking for {name}?',
      confirmCheckin: 'Check-in {name}?',
      confirmUndoCheckin: 'Undo check-in for {name}?',
      freeClass: 'Free Trial',
      courseInfoMonthly: 'Course Ref: {ref} · Expires: {expiry} · Monthly',
      courseInfoLimited: 'Course Ref: {ref} · Expires: {expiry} · {remaining} sessions left',
      noCourse: 'This student has no enrolled course',
      bookingInfoTitle: 'Booking Info',
      createBy: 'Booked by',
      createDate: 'Booked at',
      updateBy: 'Edited by',
      editDate: 'Edited at',
      visibility: 'Name visibility',
      visPrivate: 'Private (hidden)',
      visPublic: 'Public',
      blindBooking: 'Hide name from other parents',
    },
    courses: {
      newCourse: 'New Course',
      editCourse: 'Edit Course',
      confirmDelete: 'Delete this course?',
    },
    holidays: {
      title: 'Holiday Management',
      description: 'When holidays are added, parents cannot book classes on those days.',
      ourHolidays: 'Our Holidays',
      newHoliday: 'New Holiday',
      editHoliday: 'Edit Holiday',
      confirmDelete: 'Delete holiday {date}?',
      holidayDate: 'Holiday Date',
      holidayDescription: 'Description',
    },
    gymnasts: {
      title: 'Gymnast Management',
      listTitle: 'Gymnasts\' List',
      addStudent: 'Add New Student',
      editStudent: 'Edit Student',
      confirmDelete: 'Delete this student?',
      confirmFinish: 'Finish course and archive history?',
      filterStatus: 'Status',
      statusAll: 'All statuses',
      statusActive: 'Has active course',
      statusNoCourse: 'No / expired course',
      filterGender: 'Gender',
      genderAll: 'All genders',
      filterCourse: 'Course',
      courseAll: 'All courses',
    },
    learningHistory: {
      title: 'Student Info + Learning History',
      tableTitle: 'Learning history (group + private)',
      currentCourse: 'Current course',
      noCourse: 'No course',
      monthly: 'Monthly',
      sumTotal: 'Total',
      sumGroup: 'Group',
      sumPrivate: 'Private',
      sumFree: 'Free',
      colType: 'Type',
      colCoach: 'Coach',
      typeGroup: 'Group',
      typePrivate: 'Private',
      typeEvent: 'Event',
      badgeFree: 'Free',
      badgeWalkin: 'Walk-in',
      noHistory: 'No learning history yet',
      loadFail: 'Failed to load learning history',
    },
    approve: {
      title: 'New Student Request',
      confirmApprove: 'Approve {count} student(s)?',
      confirmDelete: 'Delete this student?',
      noData: 'No new students waiting for approval',
      selectAtLeastOne: 'Please select at least 1 student to approve',
    },
    viewClasses: {
      title: 'View Classes',
      viewByDate: 'View class booking by date',
    },
    privateBooking: {
      title: 'Private Lesson Schedule',
      addNew: 'Add Private Booking',
      editTitle: 'Edit Private Booking',
      groupClassOption: 'Group Class Booking',
      privateClassOption: 'Private Lesson Booking',
      noBooking: 'No private lesson bookings today',
      coach: 'Coach',
      type: 'Type',
      startTime: 'Start time',
      endTime: 'End time',
      student1: 'Student 1',
      student2: 'Student 2',
      student3: 'Student 3',
      students: 'Students',
      hours: 'Hours',
      price: 'Price',
      note: 'Note',
      othersCount: '{n} other student(s)',
      menuCancel: 'Cancel booking',
      cancelConfirm: 'Cancel this booking with coach {name}?',
      cancelSuccess: 'Booking cancelled successfully',
      cancelFail: 'Failed to cancel booking, please try again',
      invalidClasstime: 'Invalid time format — please pick the class time again',
      managementTitle: 'Private Bookings',
      viewByPeriod: 'View by period',
      viewSubtitle: 'Tap a day to view that day, or switch to the whole month',
      periodDay: 'Day',
      periodMonth: 'Month',
      today: 'Today',
      markLegend: 'Days with bookings',
      bookingsInMonth: "This month's bookings",
      rangeSummary: '{count} bookings · {coaches} coaches · {days} days',
    },
    courseHistory: {
      title: 'Customer Course History',
      ourCourses: "Customer's Courses",
      courseInfo: 'Course Information',
      courseRefer: 'Course Ref',
    },
    reservation: {
      title: 'Reservation',
      bookingFor: 'Booking for {name}',
      confirmBooking: 'Book class for {name} on {date} at {time}?',
      confirmBtn: 'Book it!',
      noClassTime: 'No class time available',
      blindName: 'Hide name from other parents',
      blindNameHint: "Your child's name will be blurred on other parents' class timetable",
      blindBadge: 'Private',
    },
    groupbooking: {
      title: 'Book for multiple kids',
      subtitle: 'Pick a class once, book it for several kids together',
      entryBtn: 'Start group booking',
      entryNew: 'New',
      stepCourse: 'Choose class type',
      stepDate: 'Choose a date',
      stepTime: 'Choose a time slot',
      stepKids: 'Choose kids to book',
      kidsEligible: '{n} bookable',
      pickCourseFirst: 'Choose a class type first',
      pickSlotFirst: 'Pick a date and time slot before choosing kids',
      notThisCourse: 'Different class type',
      expired: 'Course expired',
      usedUp: 'No sessions left',
      alreadyBooked: 'Already booked today',
      sharedShort: 'Not enough sessions (shared course)',
      seatShort: 'Not enough seats',
      monthly: 'Monthly',
      remainN: '{n} sessions left',
      summary: '{n} selected · {seats} seats available',
      bookBtn: 'Book for {n} kids',
      confirmTitle: 'Confirm booking for {n} kids',
      afterRemain: '{a} → {b} left',
      allOrNothingNote: 'All kids are booked together — if any one fails, nobody is booked.',
      successMsg: 'Successfully booked all {n} kids',
    },
    dashboard: {
      title: 'Dashboard',
      subtitle: 'Gymnastics Class Management Overview',
      btnPlaceholder: 'This button needs a purpose — have a suggestion? Let us know!',
      totalGymnasts: 'Total Gymnasts',
      activeGymnasts: 'Active Gymnasts',
      todayBooking: "Today's Booking",
      tomorrowBooking: "Tomorrow's Booking",
      vsLastWeek: "vs last week",
      studentsUnit: 'Students',
      bookingsUnit: 'Bookings',
    },
    finance: {
      title: 'Sales & finance report',
      subtitle: 'Packages sold, money collected, receivables, and lessons still owed',
      statsSinceBadge: 'Statistics from {date}',
      statsSinceNote: 'This report starts collecting statistics on {date} — every figure on this page counts only data from that date onward, including receivables, deferred revenue and data completeness. Packages sold earlier that are still unpaid must be checked on the Customer Courses page instead.',
      presetBeforeStats: 'This range ends before {date}, the date statistics start, so there is nothing to show.',
      managerOnly: 'Manager only',
      exportCsv: 'Download CSV',
      permissionDenied: 'You do not have access to this report',
      fromDate: 'From',
      toDate: 'To',
      sectionFlow: 'Activity in the selected period',
      sectionStock: 'Outstanding balances today',
      sectionTrend: 'Monthly sales',
      sectionReceivables: 'Receivables by age',
      sectionPrivateCoach: 'Private lessons by coach',
      privateCoachHint: 'Counted by the date taught · amounts are what the customer paid, including fees',
      noPrivateInRange: 'No Private lessons in the selected range',
      privSessions: 'Sessions',
      privHours: 'Hours',
      privRevenue: 'Taught (total)',
      privCollected: 'Collected',
      privUnpaidInRange: 'Unpaid (selected range)',
      privRatePerHour: 'Avg per hour',
      privFeeUnknown: '{n} session(s) paid by credit card with an unknown fee — the real total may be higher',
      privPriceUnknown: '{n} session(s) have no price recorded — real revenue is higher than shown',
      privLoadError: 'Failed to load this section',
      privLoadRetry: 'Retry',
      privNotProfit: 'This is revenue, not profit — coach pay and other costs are not deducted. "Unpaid" counts only sessions in the selected range, so it differs from the "Private receivable" card above, which is as-of-today across all time.',
      viewByMonth: 'By month',
      viewByCoach: 'By coach',
      viewByType: 'By type',
      colMonth: 'Month',
      colPrivateType: 'Type',
      sectionDataQuality: 'Data completeness',
      asOfToday: 'As of',
      salesTile: 'Sales (value of packages sold)',
      collectedNetTile: 'Net cash received',
      collectedTile: 'Money into the account',
      vatTile: 'VAT {pct}% in collected money',
      vatFrom: 'From what customers actually paid, {amount} ฿, fees not deducted (prices include VAT, extracted at 7/107)',
      vatSeeCollected: 'For a daily view, open the "Money into the account" card (same base).',
      salesParts: 'Course {course} ฿ + fees {fee} ฿',
      collectedFeeIncluded: 'Includes card fees {fee} ฿ (gym revenue)',
      clickDetail: 'Click for details',
      clickGoTable: 'Go to receivables table',
      legendCourse: 'Course price',
      legendGrossAll: 'Customer paid total (all into the account)',
      colIntoAccount: 'Into account',
      colFeePart: 'of which fees',
      colDate: 'Date',
      colItem: 'Item',
      colCourseAmount: 'Course',
      colVatInAmount: 'VAT within',
      colStatus: 'Status',
      colMethod: 'Method',
      colSessions: 'Sessions taught',
      colUnitPrice: 'Per session',
      colRemaining: 'Remaining',
      colExpire: 'Expires',
      paidYes: 'Paid', flagYes: 'Yes',
      paidNo: 'Unpaid',
      detailTotal: '{count} items — total',
      receivablePrivateTile: 'Private lessons unpaid',
      receivablePrivateCount: '{count} sessions',
      receivablePrivateTaught: 'Already taught but unpaid: {count} sessions · {amount} ฿',
      colDay: 'Date',
      colDayCount: 'Items',
      colCoach: 'Coach',
      colTaughtStatus: 'Teaching status',
      taughtUnpaid: 'Taught, unpaid',
      notYetTaught: 'Not yet taught',
      backToDaily: 'Back to daily summary',
      detailTotalDays: '{days} days · {count} items — total',
      earnedTile: 'Revenue for lessons delivered',
      receivableTile: 'Receivables (unpaid)',
      deferredTile: 'Prepaid lessons still owed',
      breakageTile: 'Expired unused sessions (30 days)',
      vsPrevPeriod: 'vs previous period',
      avgPerPackage: 'avg',
      paidAmount: 'Customer paid',
      feeAmount: 'fee',
      ofSales: 'of sales',
      unitPackages: 'packages',
      unitDays: 'days',
      unitTimes: 'sessions',
      estimatedPart: 'includes {amount} ฿ estimated ({count} packages)',
      missingPriceWarn: '{count} packages have no price yet — view list',
      feeUnknownWarn: '{count} card payments with unknown fee',
      earnedFrom: 'from {sessions} lessons already taught',
      earnedUnpriceable: '{sessions} more lessons cannot be valued (monthly/unknown price)',
      receivableUsed: '{count} already took lessons without paying',
      deferredSessions: '{sessions} sessions remaining',
      deferredProgress: 'Sold {sold} ฿ · delivered {delivered} ฿ ({pct}%)',
      salesUnpaid: 'Of this figure, {amount} ฿ ({count} items) is not collected yet',
      colUsedOfTotal: 'Used / total',
      colDeliveredPct: 'Delivered',
      deferredExpiring: '{amount} ฿ expires within 30 days',
      deferredMonthlyExcluded: 'excludes {count} monthly packages (cannot value per session)',
      breakageDetail: '{sessions} sessions across {count} packages — paid for but never used',
      legendActual: 'Actual price',
      legendEstimated: 'Estimated from rate card',
      legendCollected: 'Net received',
      legendNet: 'Into the account',
      legendFee: 'Payment fee',
      legendGross: 'Total paid by customer',
      legendVat: 'Dashed = VAT {pct}% contained in the amount paid',
      legendCollectedEstimated: 'Received (from estimated price)',
      showEstimates: 'Show historical estimates',
      eraBefore: 'No price recorded yet',
      eraAfter: 'Real prices recorded',
      trendNoteRealOnly: 'The chart always shows full calendar months, independent of the range selected above — real recorded prices only, counted by sale date, starting at {date} per the report scope. Green + orange together are the customer-paid total (= money into the account). Click a bar to see that month\'s items.',
      trendNote: 'Sale prices became mandatory on {date} — earlier packages with no recorded price are estimated from the current rate card (dashed bars); solid bars are real recorded prices. Fine for spotting trends, but do not use the estimated part as accounting figures.',
      byProgram: 'By program',
      byMethod: 'By payment method',
      priceAndDiscount: 'Price and discount',
      colPaid: 'Paid',
      colFee: 'Fee',
      colNet: 'Net',
      methodUnspecified: 'Unspecified',
      methodPrivate: 'Private lessons (method not recorded)',
      promoPackages: 'Promotion packages',
      totalDiscount: 'Total discount given',
      avgDiscountPct: 'Avg discount vs rate card',
      comparedAgainstList: 'Comparable',
      aging0: 'Up to 30 days',
      aging31: '31–60 days',
      aging61: '61–90 days',
      aging90: 'Over 90 days',
      colStudents: 'Students',
      colPhone: 'Parent phone',
      colCourse: 'Course',
      colAmount: 'Amount',
      colOverdue: 'Overdue',
      colUsedUnpaid: 'Lessons taken',
      colRefer: 'Package no.',
      colCreated: 'Created',
      colSuggested: 'Suggested rate',
      unknownPrice: 'Unknown price',
      noReceivables: 'No outstanding receivables',
      noData: 'No data',
      viewList: 'View list',
      dqPriceActual: 'Packages with a real price',
      dqMissingPrice: 'Price not entered yet',
      dqEstimated: 'Using estimated price',
      dqUnknownPrice: 'Unknown price (cannot estimate)',
      unknownPriceWarn: '{count} more with unknown price — the real total is higher than shown',
      unknownPriceExcluded: 'excludes {count} with unknown price',
      deferredUnknownExcluded: 'excludes {count} with unknown price ({sessions} sessions)',
      dqFeeUnknown: 'Card fee unknown',
      dqNoPaydate: 'Paid but no payment date',
      dqMonthly: 'Monthly, cannot value',
      missingPriceTitle: 'Packages with no price entered',
      missingPriceSub: 'Created on or after {date} — fill these in and the report becomes exact immediately',
      notProfitNote: 'All figures are revenue the studio collects, not profit — the system does not track costs or coach pay.',
      preset: { thisMonth: 'This month', lastMonth: 'Last month', last3Months: '3 months', thisYear: 'This year', custom: 'Custom' },
    },
    insightView: {
      title: 'Insights',
      subtitle: 'Weekly narrative summary + parents to follow up',
      generateBtn: 'Generate new report',
      generating: 'Generating...',
      generateSuccess: 'New report generated successfully',
      generateFail: 'Failed to generate report',
      historyTitle: 'History',
      emptyReports: 'No reports yet',
      newStudentsTile: 'New students (latest month)',
      packagesSoldTile: 'Packages sold (latest month) — not revenue in currency',
      vsPrevMonth: 'vs previous month',
      showMonthly: 'Show monthly data',
      hideMonthly: 'Hide monthly data',
      unitPeople: 'people',
      unitPackages: 'packages',
      winBackTitle: 'Parents to win back',
      atRiskTitle: 'At risk of not using all sessions before expiry',
      opsLinkTitle: 'Action lists moved to the Daily Checklist',
      opsLinkBody: 'Unpaid · running out · never started · expired with sessions left — see them there with live data (this page is a snapshot from the day the report was generated).',
      opsLinkBtn: 'Open Daily Checklist',
      colNickname: 'Nickname',
      colMobile: 'Mobile',
      colEndedOn: 'Package ended',
      colDaysLapsed: 'Days since',
      colCourse: 'Course',
      colRef: 'Course Ref',
      colStudents: 'Students',
      colPhones: 'Mobile',
      colRemaining: 'Remaining (sessions)',
      colExpiredate: 'Expires on',
      colDaysLeft: 'Days left',
    },
    addFamily: {
      title: 'Add Member',
      firstname: 'Firstname',
      middlename: 'Middlename',
      lastname: 'Lastname',
      nickname: 'Nickname',
      school: 'School',
      gender: 'Gender',
      dob: 'Date of Birth',
      submit: 'Save',
      clear: 'Clear',
      errorRequired: 'Please fill in all required fields',
    },
    register: {
      title: 'Register',
      username: 'Username',
      password: 'Password',
      firstname: 'Firstname',
      middlename: 'Middlename',
      lastname: 'Lastname',
      address: 'Address',
      email: 'E-mail',
      mobile: 'Mobile Number',
      code: 'Register Code',
      privacyConsent: 'I acknowledge that I have read and agree to',
      privacyPolicy: 'Privacy Policy',
      privacyOf: "iStar Gymnastics's",
      submit: 'Submit',
      clear: 'Clear',
      cancel: 'Cancel',
    },
    accountMgmt: {
      listTitle: 'User Accounts',
      subtitle: 'Search, edit, reset password, manage family, and set permissions',
      editUser: 'Edit User Account',
      username: 'Username',
      fullname: 'Full Name',
      mobileno: 'Mobile',
      roleCol: 'Role',
      province: 'Province',
      status: 'Status',
      active: 'Active',
      restricted: 'Restricted',
      noUsers: 'No users found',
      roleAll: 'All roles',
      loadFail: 'Failed to load users',
      saveFail: 'Action failed',
      tabPersonal: 'Personal Info',
      tabPassword: 'Password',
      tabFamily: 'Family Members',
      tabPermissions: 'Permissions',
      personalSection: 'User Info',
      contactSection: 'Contact',
      addressSection: 'Address',
      firstname: 'First Name',
      middlename: 'Middle Name',
      lastname: 'Last Name',
      email: 'Email',
      savedProfile: 'User info saved',
      passwordSection: 'Set New Password',
      newPassword: 'New Password',
      confirmPassword: 'Confirm New Password',
      resetPasswordBtn: 'Reset Password',
      pwMismatch: 'The two passwords do not match',
      pwResetOk: 'Password reset',
      pwSessionNote: 'The reset takes effect immediately, but a user who is currently logged in stays signed in until their session expires — it cannot be force-ended immediately.',
      familySection: 'Family Members',
      childName: 'Member',
      childCourse: 'Course',
      transferTo: 'Transfer to family',
      searchFamily: 'Type destination family username…',
      chooseFamily: '— Choose destination family —',
      addChild: 'Add Member',
      nickname: 'Nickname',
      gender: 'Gender',
      dob: 'Date of Birth',
      pending: 'pending',
      noChildren: 'No members in this family yet',
      deleteChildTitle: 'Delete Member',
      confirmDeleteChild: 'Delete this member?',
      childDeleted: 'Member deleted',
      childAdded: 'Member added',
      transferOk: 'Member transferred (course moved along with them)',
      roleSection: 'Change Role',
      roleLabel: 'Role',
      applyRole: 'Save Role',
      roleChanged: 'Role changed',
      cannotChangeSelf: 'You cannot change your own role',
      accessSection: 'System Access',
      unlockAccess: 'Unlock Access',
      notRestricted: 'This account is not restricted',
      accessUnlocked: 'Access unlocked',
      adminStaffBlocked: 'You may manage parent accounts only — staff accounts cannot be edited.',
    },
    addr: {
      no: 'House No. / Moo / Soi / Road',
      noPlaceholder: 'e.g. 99/1 Moo 2 Soi Sukhumvit 101',
      search: 'Search address (subdistrict, district, province, or postal code)',
      searchPlaceholder: 'Type in Thai, e.g. "สวนหลวง", or a postal code like "10250"',
      subdistrict: 'Subdistrict',
      district: 'District',
      province: 'Province',
      postalcode: 'Postal Code',
      noResult: 'No match — try a subdistrict, district, or province name',
      loading: 'Loading address data...',
      clear: 'Clear address',
      legacyHint: 'Previously saved address',
      updateHint: 'Please pick your subdistrict/district/province from the search box to update it to the new format',
    },
    forgot: {
      title: 'Forgot Password',
      subtitle: 'Enter your registered username and phone number',
      username: 'Username',
      phone: 'Phone number',
      otp: 'OTP Password',
      requestOTP: 'Request OTP',
      submit: 'Submit',
      cancel: 'Cancel',
      newPassword: 'New Password',
      confirmPassword: 'Confirm New Password',
      phoneMatchError: "The username and phone number you entered don't match",
      otpInvalid: 'OTP is invalid',
      passwordMismatch: 'Password does not match',
      passwordChangedSuccess: 'Password changed successfully',
    },
    editProfile: {
      title: 'Edit User Profile',
      personalInfo: 'Personal Information',
      email: 'Email',
      phone: 'Phone Number',
      address: 'Address',
      saveProfile: 'Save Information',
      changePasswordSection: 'Change Password',
      currentPassword: 'Current Password',
      newPassword: 'New Password',
      confirmNewPassword: 'Confirm New Password',
      changePasswordBtn: 'Change Password',
      emailRequired: 'Please enter your email',
      emailInvalid: 'Invalid email format',
      phoneRequired: 'Please enter your phone number',
      passwordRequired: 'Please enter your password',
      passwordMinLength: 'Password must be at least 6 characters',
      confirmRequired: 'Please confirm your password',
      passwordMismatch: 'Passwords do not match',
      saveSuccess: 'Information saved successfully',
      saveFail: 'Failed to save information',
      passwordChangeSuccess: 'Password changed successfully',
      passwordChangeFail: 'Failed to change password',
    },
    msg: {
      required: 'Please fill in all required fields',
      updated: 'Updated successfully',
      created: 'Created successfully',
      deleted: 'Deleted successfully',
      courseDone: 'Course finished successfully',
      courseDeleted: 'Course deleted successfully',
      updateFail: 'Update failed, please try again',
      addFail: 'Add failed, please try again',
      memberAdded: 'Member added successfully',
      memberAddFail: 'Failed to add member',
      familyAdded: 'Family member added successfully',
      familyDuplicate: 'This name is already a member of your family. Please contact the admin.',
      familyAddFail: 'Failed to add family member',
      bookingAdded: 'Booking added successfully',
      bookingAddFail: 'Booking failed, please try again',
      bookingSuccess: 'Class booked! See you there :)',
      bookingDuplicate: 'You already have a booking on {date}. Please choose another date.',
      noRemaining: 'Cannot book — no classes remaining',
      cannotEditDeleted: 'Cannot edit a deleted student',
      courseCreated: 'Course created successfully',
      courseUpdated: 'Course updated successfully',
      fileTooLarge: 'Image must not exceed 4MB',
      uploadSuccess: 'Image uploaded successfully',
      uploadFail: 'Image upload failed',
      loadFail: 'Failed to load data',
      studentDeleted: 'Student deleted successfully',
      studentDeleteFail: 'Failed to delete student',
      studentListFail: 'Failed to load student list',
      reservationDeleted: 'Booking deleted successfully',
      reservationDeleteFail: 'Failed to delete booking',
      familyDeleted: 'Family member deleted successfully',
      familyLoadFail: 'Failed to load family members',
      studentApproved: 'Students approved successfully',
      approveFail: 'Failed to approve students',
      bothCredsRequired: 'Please enter both username and password',
      registerSuccess: 'Registration successful',
      registerFail: 'Registration failed',
    },
  },
  zh: {
    home: {
      title: '首页',
      familySection: '家庭',
      information: '信息',
      courseInfo: '课程信息',
      reservation: '预约',
      date: '日期',
      classTime: '上课时间',
      noBooking: '暂无课程预约',
      selectMember: '选择成员以查看详情',
      courseExpired: '课程已过期！！',
      addFamilyHint: '请在"家庭"菜单中添加家庭成员',
      monthly: '按月',
      expired: '已过期',
      noCourse: '暂无课程',
      usedUp: '已用完',
      bookClass: '预约课程',
      genderAge: '{gender} · 年龄 {age}',
      errorSelectFirst: '请选择家庭成员',
      errorNoCourse: '无法预约——尚未分配课程，请联系管理员',
      errorExpired: '无法预约——您的课程已过期',
      errorNoRemaining: '无法预约——课程次数已用完',
      ageUnit: '{years}岁 {months}个月 {days}天',
      remainBadge: '剩余 {n} 次',
      remainOf: '剩余 {n} / {total} 次',
      timeLeftLabel: '剩余时间',
      daysValue: '{n} 天',
      privateBooking: '私教课预约',
      noPrivateBooking: '暂无私教课预约',
      privateBookingWith: '与 {names} 一起',
      coachName: '{name}教练',
    },
    family: {
      title: '家庭',
      sectionHeader: '家庭成员',
      addMember: '添加家庭成员',
      confirmDelete: '将 {name} 从您的家庭中移除？',
      editSuccess: '成员信息更新成功',
      editFail: '更新失败',
    },
    btn: {
      ok: '确定',
      cancel: '取消',
      save: '保存',
      delete: '删除',
      edit: '编辑',
      add: '添加',
      close: '关闭',
      confirm: '确认',
      back: '返回',
      refresh: '刷新',
      copy: '复制',
      create: '创建',
      search: '搜索',
      newCourse: '新建课程',
      newBooking: '新建预约',
      newStudent: '新建学员',
      approve: '批准',
      finish: '结课',
      reset: '重置',
      newClass: '新建班级',
      newHoliday: '新建假日',
    },
    grid: {
      perPage: '每页',
      range: '{from}–{to} / 共 {total} 项',
    },
    table: {
      profileImage: '头像',
      courseRef: '课程编号',
      courseName: '课程名称',
      courseShortName: '课程简称',
      courseType: '类型',
      price: '价格',
      startDate: '开始日期',
      expireDate: '到期日期',
      remaining: '剩余',
      courseUser: '课程使用者',
      payment: '付款',
      edit: '编辑',
      delete: '删除',
      finish: '结课',
      name: '姓名',
      time: '时间',
      view: '查看',
      history: '修改历史',
      checkin: '签到',
      date: '日期',
      studentId: '学员编号',
      class: '班级',
      classDay: '上课日',
      classTime: '上课时间',
      maxStudent: '最大人数',
      gender: '性别',
      age: '年龄',
      school: '学校',
      parentUsername: '家长用户名',
      phone: '电话',
      holidayDate: '假日日期',
      description: '说明',
      nickname: '昵称',
      level: '级别',
      studentInfo: '学员信息',
      courseUsageHistory: '课程使用记录',
      expired: '已过期',
      yearAbbr: '岁',
      monthAbbr: '个月',
      dayAbbr: '天',
      firstname: '名',
      middlename: '中间名',
      lastname: '姓',
      dob: '出生日期',
      shortNote: '备注',
      courseRefer: '课程编号',
      continueCourseRefer: '续接课程编号',
      createBy: '创建人',
      createDate: '创建时间',
      updateBy: '最后修改人',
      editDate: '最后修改时间',
      deleteBy: '删除人',
    },
    role: {
      head: '总管理员',
      admin: '管理员',
      coach: '教练',
      customer: '家长',
    },
    nav: {
      mainMenu: '主菜单',
      home: '首页',
      family: '家庭',
      checkingMenu: '查看菜单',
      viewClasses: '查看课表',
      adminMenu: '管理员菜单',
      dashboard: '仪表盘',
      insightView: '洞察分析',
      opsChecklist: '每日检查',
      chatbot: 'AI 助手',
      gymnasts: '学员名单',
      gymnastsAll: '全部学员',
      bookingManagement: '课程预约',
      privateBookingManagement: '私教预约',
      eventManager: '赛事/活动',
      customerCourse: '客户课程',
      courseHistory: '课程历史',
      managementMenu: '管理菜单',
      holidays: '假日管理',
      accountManagement: '用户账户',
      theme: '主题',
      editProfile: '编辑用户资料',
      language: '语言：中文',
      logout: '退出登录',
      groupMine: '我的',
      groupOverview: '概览',
      groupSchedule: '课表与预约',
      groupCoach: '教练',
      groupStudents: '学员', groupCourses: '客户课程管理',
      groupSetup: '设置',
      groupFinance: '财务',
      groupAccount: '账户',
      paymentDocs: '收支单据',
      financeReport: '销售与财务报表',
    },
    auth: {
      loginTitle: '登录',
      welcome: '欢迎来到 iStar Gymnastics，',
      welcomeSub: '祝您拥有美好的一天 :D...',
      heroTag: '预约课程、签到<br />管理课程<br />一站式全搞定',
      heroBlurb: '家长可在手机上为孩子预约课程，管理员在同一屏幕查看课表并签到',
      username: '用户名',
      password: '密码',
      loginBtn: '登录',
      registerBtn: '注册',
      forgotBtn: '忘记密码 ?',
      logoutConfirm: '您要退出登录吗 ?',
    },
    common: {
      yes: '是',
      no: '否',
      close: '关闭',
      confirm: '确认',
      ok: '好的',
      required: '此项为必填',
      male: '男',
      female: '女',
      loading: '加载中... 请稍候',
      nextCourse: '下一个课程',
      times: '次',
      noCourseData: '暂无课程数据',
      noStudentData: '暂无学员数据',
      noClassData: '暂无班级数据',
      noStudentList: '暂无学员名单',
      invalidDob: '出生日期无效',
      serverError: '与服务器通信出错',
      noServerResponse: '服务器无响应',
      errorPrefix: '错误',
      hoursUnit: '小时',
    },
    dialog: {
      error: '错误',
      success: '成功',
      selectTheme: '选择主题',
      themeNote: '所选主题将应用于所有用户',
      themeDarkNote: '本设备处于深色模式，因此显示深色配色而非所选主题。使用浅色模式的设备仍会看到该主题。',
    },
    theme: {
      default: '默认',
      defaultSub: 'iStar 粉',
      mothersday: '母亲节',
      mothersdaySub: '天蓝与茉莉',
      loykrathong: '水灯节',
      loykrathongSub: '烛光与天灯',
      newyear: '新年',
      newyearSub: '烟花与香槟金',
      songkran: '泼水节',
      songkranSub: '水与夏日阳光',
      halloween: '万圣节',
      halloweenSub: '南瓜与蝙蝠',
      christmas: '圣诞节',
      christmasSub: '白雪与灯饰',
      fathersday: '父亲节',
      fathersdaySub: '皇家黄美人蕉',
      muaythai: '泰拳',
      muaythaiSub: '深红、蓝与金',

      saveFailed: '无法为所有人保存主题 — 仅在本设备上更改',
    },
    validation: {
      usernameRequired: '请输入用户名',
      usernameNoSpaces: '用户名不能包含空格',
      usernameEnglishOnly: '用户名只能包含英文字母、数字或特殊字符',

      usernameHint: '4-20 个字符，仅限字母、数字及 . _ -',
      passwordRequired: '请输入密码',
      nameRequired: '请输入姓名',
      mobileRequired: '请输入手机号码',
      emailRequired: '请输入电子邮箱',
      emailInvalid: '电子邮箱格式无效',
      newPasswordRequired: '请输入新密码',
      newPasswordMaxLength: '新密码不得超过 10 个字符',
      phoneRequired: '请输入电话号码',
      otpRequired: '请输入 OTP 验证码',
      otpLength: 'OTP 验证码须为 6 位',
    },
    bookingList: {
      classBooking: '课程预约',
      menuCheckin: '签到',
      menuUndoCheckin: '取消签到',
      menuEdit: '查看/编辑',
      menuCheckedInBadge: '已签到',
      notCheckedIn: '未签到',
      legendTrial: '试听课',
      legendPerSession: '按次',
      legendPayment: '需付款 / 课程已用完',
      legendBlind: '对其他家长隐藏姓名',
      checkinFail: '签到失败',
      undoCheckinFail: '取消签到失败',
      menuCancel: '取消预约',
      eventRowNote: '赛事行 — 请在赛事页面移动或取消',
      confirmCancelBooking: '要取消 "{name}" 的预约吗？',
      cancelBookingFail: '取消预约失败',
    },
    customerCourse: {
      period: '时长（月）',
      payDate: '付款日期',
      uploadSlip: '上传付款凭证',
      slipTitle: '付款凭证',
      viewSlip: '查看已上传的凭证',
      doubleBookingNote: '此课程可参加',
      doubleBookingMore: '超过',
      doubleBookingUnit: '每天1节',
      paid: '已付款',
      unpaid: '未付款',
      shortNote: '备注',
      noCourseList: '暂无客户课程列表',
      loadFail: '加载课程信息失败',
      deleteInUse: '此课程正被 {names} 使用。要删除吗？',
      priceCatalog: '管理价目表',
      priceCatalogSub: '仅用于新套餐自动填充价格——不影响已售出的套餐',
      priceSaved: '价格保存成功',
      noPriceSet: '未设置',
      groupPricing: '团体课定价',
      privatePricing: '私教课定价（每小时）',
      quantitySessions: '节数',
      quantityOrPeriod: '数量（次/月）',
      pricePerHour: '每小时价格',
      privateType: '私教类型',
      private1on1: '一对一 (1:1)',
      private2on1: '小组 (2:1)',
      private3on1: '小组 (3:1)',
      slipVerifyChecking: '正在获取验证结果…',
      slipVerifyNone: '此凭证暂无验证结果',
      slipVerified: '凭证真实——已与银行核实',
      slipDuplicate: '凭证重复——已被使用',
      slipAmountMismatch: '凭证金额与价格不符',
      slipWrongReceiver: '收款账户与本店不符',
      slipFailed: '验证失败——无法识别或非真实凭证',
      slipSkipped: '尚未与银行核实',
      slipReverify: '重新验证',
      slipReverifying: '验证中…',
      slipReverifyFail: '重新验证失败，请重试',
      slipAmount: '金额',
      slipWhen: '转账时间',
      slipFrom: '转账人',
      slipSaveVerified: '凭证已验证：真实',
      slipSaveWarn: '保存成功，但凭证验证',
    },
    eventMgr: {
      tab: '赛事/活动', pageSubtitle: '创建赛事、管理名单并在当天签到', newEvent: '新建赛事', addKidsTitle: '添加学员到赛事', addKids: '添加学员',

      pastHeadOnly: '仅经理可处理过往赛事',
      step1: '信息', step2: '选择学员', step3: '核对', step4: '确认',
      date: '日期', datePh: '选择比赛日期', coursePh: '— 选择课程 —',
      label: '赛事名称', labelPh: '例如 KAO Cup', labelHint: '该名称将作为比赛当天预约表的列标题', defaultLabel: 'แข่ง',
      pickKids: '搜索并选择参赛学员', searchKidPh: '输入学员姓名…', noKidsYet: '尚未选择学员', noMatch: '无匹配结果',
      tagTrial: '试课 — 不扣次数', tagNoCourse: '无课程', tagExpired: '课程已过期', tagQuotaEmpty: '次数已用完', tagListed: '仅登记 — 不扣次数',
      tagMonthly: '包月 — 不扣次数', tagRemaining: '剩余 {n} 次', tagClockStart: '课程有效期将从比赛日开始计算', tagAlreadyIn: '已在此赛事中 — 跳过',
      conflictInfo: '当天已有常规课预约（{time}）', keepBoth: '保留原预约（上课 + 比赛）', moveBooking: '将原预约转为比赛（不额外扣次）',
      modeDeduct: '扣除课程次数', modeList: '仅登记不扣次（费用另收/无课程）',
      sumDeduct: '扣次数：{n} 人', sumList: '仅登记：{n} 人', sumMove: '转移预约：{n} 人',
      back: '上一步', next: '下一步', create: '保存赛事',
      kids: '人数', roster: '名单', checkedinShort: '已签到', undoCheckin: '取消签到', removeKid: '移除（退还次数）',
      confirmTitle: '确认', confirmRemove: '将 {name} 从赛事中移除？预约将被取消并按常规退还次数。',
      confirmDelete: '删除赛事"{name}"？', deleteBlockedHint: '名单为空时才能删除', renameTitle: '修改赛事名称',
    },
    bookingMgmt: {
      title: '课程预约',
      tabBooking: '课程预约',
      viewByDate: '按日期查看课程预约',
      allBookingsToday: '全部课程预约',
      noBooking: '暂无预约',
      confirmDelete: '删除 {name} 的预约？',
      confirmCheckin: '为 {name} 签到？',
      confirmUndoCheckin: '取消 {name} 的签到？',
      freeClass: '免费试听',
      courseInfoMonthly: '课程编号：{ref} · 到期：{expiry} · 按月',
      courseInfoLimited: '课程编号：{ref} · 到期：{expiry} · 剩余 {remaining} 次',
      noCourse: '该学员尚未报名任何课程',
      bookingInfoTitle: '预约信息',
      createBy: '预约人',
      createDate: '预约时间',
      updateBy: '修改人',
      editDate: '修改时间',
      visibility: '姓名显示',
      visPrivate: '私密（隐藏）',
      visPublic: '公开',
      blindBooking: '对其他家长隐藏姓名',
    },
    courses: {
      newCourse: '新建课程',
      editCourse: '编辑课程',
      confirmDelete: '删除此课程？',
    },
    holidays: {
      title: '假日管理',
      description: '添加假日后，家长将无法在这些日期预约课程。',
      ourHolidays: '全部假日',
      newHoliday: '新建假日',
      editHoliday: '编辑假日',
      confirmDelete: '删除假日 {date}？',
      holidayDate: '假日日期',
      holidayDescription: '说明',
    },
    gymnasts: {
      title: '学员管理',
      listTitle: '学员名单',
      addStudent: '添加新学员',
      editStudent: '编辑学员',
      confirmDelete: '删除此学员？',
      confirmFinish: '结课并存档记录？',
      filterStatus: '状态',
      statusAll: '所有状态',
      statusActive: '有有效课程',
      statusNoCourse: '无课程/已过期',
      filterGender: '性别',
      genderAll: '所有性别',
      filterCourse: '课程',
      courseAll: '所有课程',
    },
    learningHistory: {
      title: '学员资料 + 学习记录',
      tableTitle: '学习记录（团课 + 私教）',
      currentCourse: '当前课程',
      noCourse: '暂无课程',
      monthly: '按月',
      sumTotal: '合计',
      sumGroup: '团课',
      sumPrivate: '私教',
      sumFree: '免费',
      colType: '类型',
      colCoach: '教练',
      typeGroup: '团课',
      typePrivate: '私教',
      typeEvent: '比赛',
      badgeFree: '免费',
      badgeWalkin: '单次',
      noHistory: '暂无学习记录',
      loadFail: '加载学习记录失败',
    },
    approve: {
      title: '新学员申请',
      confirmApprove: '批准 {count} 名学员？',
      confirmDelete: '删除此学员？',
      noData: '暂无等待批准的新学员',
      selectAtLeastOne: '请至少选择 1 名学员进行批准',
    },
    viewClasses: {
      title: '查看课表',
      viewByDate: '按日期查看课程预约',
    },
    privateBooking: {
      title: '私教课表',
      addNew: '添加私教预约',
      editTitle: '编辑私教预约',
      groupClassOption: '团体课预约',
      privateClassOption: '私教课预约',
      noBooking: '今天暂无私教课预约',
      coach: '教练',
      type: '类型',
      startTime: '开始时间',
      endTime: '结束时间',
      student1: '学员 1',
      student2: '学员 2',
      student3: '学员 3',
      students: '学员',
      hours: '小时数',
      price: '价格',
      note: '备注',
      othersCount: '另有 {n} 名学员',
      menuCancel: '取消预约',
      cancelConfirm: '取消与教练 {name} 的这次预约？',
      cancelSuccess: '预约取消成功',
      cancelFail: '取消预约失败，请重试',
      invalidClasstime: '时间格式无效——请重新选择上课时间',
      managementTitle: '私教预约',
      viewByPeriod: '按时段查看',
      viewSubtitle: '点按某一天查看当天，或切换到整月',
      periodDay: '按天',
      periodMonth: '按月',
      today: '今天',
      markLegend: '有预约的日期',
      bookingsInMonth: '本月预约',
      rangeSummary: '{count} 个预约 · {coaches} 位教练 · {days} 天',
    },
    courseHistory: {
      title: '客户课程历史',
      ourCourses: '客户课程',
      courseInfo: '课程信息',
      courseRefer: '课程编号',
    },
    reservation: {
      title: '预约',
      bookingFor: '为 {name} 预约',
      confirmBooking: '为 {name} 预约 {date} {time} 的课程？',
      confirmBtn: '确定预约！',
      noClassTime: '暂无可选上课时间',
      blindName: '对其他家长隐藏姓名',
      blindNameHint: '您孩子的姓名将在其他家长的课表上被模糊处理',
      blindBadge: '私密',
    },
    groupbooking: {
      title: '为多个孩子预约',
      subtitle: '选一次课，一起为多个孩子预约',
      entryBtn: '开始多人预约',
      entryNew: '新',
      stepCourse: '选择课程类型',
      stepDate: '选择日期',
      stepTime: '选择时段',
      stepKids: '选择要预约的孩子',
      kidsEligible: '{n} 名可预约',
      pickCourseFirst: '请先选择课程类型',
      pickSlotFirst: '请先选择日期和时段，再选择孩子',
      notThisCourse: '课程类型不同',
      expired: '课程已过期',
      usedUp: '次数已用完',
      alreadyBooked: '今天已预约',
      sharedShort: '次数不足（共享课程）',
      seatShort: '座位不足',
      monthly: '按月',
      remainN: '剩余 {n} 次',
      summary: '已选 {n} 名 · 剩余 {seats} 个座位',
      bookBtn: '为 {n} 个孩子预约',
      confirmTitle: '确认为 {n} 个孩子预约',
      afterRemain: '剩余 {a} → {b}',
      allOrNothingNote: '所有孩子一起预约——只要有一人失败，则全部不预约。',
      successMsg: '已成功为全部 {n} 个孩子预约',
    },
    dashboard: {
      title: '仪表盘',
      subtitle: '体操课程管理概览',
      btnPlaceholder: '这个按钮还需要一个用途——有建议吗？告诉我们！',
      totalGymnasts: '学员总数',
      activeGymnasts: '活跃学员',
      todayBooking: '今日预约',
      tomorrowBooking: '明日预约',
      vsLastWeek: '较上周',
      studentsUnit: '学员',
      bookingsUnit: '预约',
    },
    finance: {
      title: '销售与财务报表',
      subtitle: '售出套餐金额、已收款、应收款，以及尚需授课的责任',
      statsSinceBadge: '统计自 {date} 起',
      statsSinceNote: '本报表自 {date} 起开始统计 — 页面上的所有数字仅计入该日期之后的数据，包括应收款、预收待授课金额和数据完整度。此前售出且仍未付款的套餐，请到「客户课程」页面查看。',
      presetBeforeStats: '该时间段早于统计起始日 {date}，没有可显示的数据。',
      managerOnly: '仅限管理者',
      exportCsv: '下载 CSV',
      permissionDenied: '您没有查看此报表的权限',
      fromDate: '起始日期',
      toDate: '结束日期',
      sectionFlow: '所选期间的变动',
      sectionStock: '今日未结余额',
      sectionTrend: '每月销售',
      sectionReceivables: '按账龄划分的应收款',
      sectionPrivateCoach: '私教课按教练统计',
      privateCoachHint: '按实际授课日期计算 · 金额为客户支付的含手续费总额',
      noPrivateInRange: '所选期间没有私教课',
      privSessions: '课时数',
      privHours: '小时',
      privRevenue: '已授课总额',
      privCollected: '已收款',
      privUnpaidInRange: '未付款（仅所选期间）',
      privRatePerHour: '每小时平均',
      privFeeUnknown: '有 {n} 节课以信用卡支付但手续费未知，实际金额可能更高',
      privPriceUnknown: '有 {n} 节课未录入价格，实际收入高于显示金额',
      privLoadError: '本部分数据加载失败',
      privLoadRetry: '重试',
      privNotProfit: '此为收入而非利润 — 未扣除教练报酬及其他费用。“未付款”仅统计所选期间的课时，因此与上方“私教应收”卡片（截至今日、涵盖所有时间）不同。',
      viewByMonth: '按月',
      viewByCoach: '按教练',
      viewByType: '按类型',
      colMonth: '月份',
      colPrivateType: '类型',
      sectionDataQuality: '数据完整性',
      asOfToday: '截至',
      salesTile: '销售额（售出套餐金额）',
      collectedNetTile: '净入账金额',
      collectedTile: '入账金额',
      vatTile: '已收款中的增值税 {pct}%',
      vatFrom: '按客户实际支付金额 {amount} ฿ 计算，不扣手续费（价格含税，按 7/107 提取）',
      vatSeeCollected: '如需按日查看，请打开「入账金额」卡片（同一计算基数）。',
      salesParts: '课程 {course} ฿ + 手续费 {fee} ฿',
      collectedFeeIncluded: '含刷卡手续费 {fee} ฿（属场馆收入）',
      clickDetail: '点击查看明细',
      clickGoTable: '前往应收款表格',
      legendCourse: '课程费',
      legendGrossAll: '客户支付总额（全额入账）',
      colIntoAccount: '入账',
      colFeePart: '其中手续费',
      colDate: '日期',
      colItem: '项目',
      colCourseAmount: '课程费',
      colVatInAmount: '含增值税',
      colStatus: '状态',
      colMethod: '支付方式',
      colSessions: '已授课次数',
      colUnitPrice: '每次单价',
      colRemaining: '剩余次数',
      colExpire: '到期日',
      paidYes: '已付款', flagYes: '是',
      paidNo: '未付款',
      detailTotal: '共 {count} 项 — 合计',
      receivablePrivateTile: 'Private 应收款（未付）',
      receivablePrivateCount: '{count} 节课',
      receivablePrivateTaught: '已授课但未收款 {count} 节 · {amount} ฿',
      colDay: '日期',
      colDayCount: '项目数',
      colCoach: '教练',
      colTaughtStatus: '授课状态',
      taughtUnpaid: '已授课，未付款',
      notYetTaught: '尚未授课',
      backToDaily: '返回每日汇总',
      detailTotalDays: '共 {days} 天 · {count} 项 — 合计',
      earnedTile: '已授课对应收入',
      receivableTile: '应收款（未付）',
      deferredTile: '预收但尚需授课',
      breakageTile: '过期未使用次数（30天）',
      vsPrevPeriod: '较上期',
      avgPerPackage: '平均',
      paidAmount: '客户支付',
      feeAmount: '手续费',
      ofSales: '占销售额',
      unitPackages: '笔',
      unitDays: '天',
      unitTimes: '次',
      estimatedPart: '其中估算 {amount} ฿（{count} 笔）',
      missingPriceWarn: '{count} 笔尚未填写价格 — 查看列表',
      feeUnknownWarn: '{count} 笔刷卡未知手续费',
      earnedFrom: '来自已授课 {sessions} 次',
      earnedUnpriceable: '另有 {sessions} 次无法计价（月卡／价格未知）',
      receivableUsed: '{count} 笔已上课但未付款',
      deferredSessions: '剩余 {sessions} 次',
      deferredProgress: '售出 {sold} ฿ · 已交付 {delivered} ฿（{pct}%）',
      salesUnpaid: '其中尚未收款 {amount} ฿（{count} 项）',
      colUsedOfTotal: '已用 / 总数',
      colDeliveredPct: '已交付',
      deferredExpiring: '{amount} ฿ 将在30天内过期',
      deferredMonthlyExcluded: '不含 {count} 笔月卡（无法按次计价）',
      breakageDetail: '{count} 笔共 {sessions} 次 — 已付款但未使用',
      legendActual: '实际价格',
      legendEstimated: '按标准价估算',
      legendCollected: '净入账',
      legendNet: '实际入账',
      legendFee: '手续费',
      legendGross: '客户支付总额',
      legendVat: '虚线 = 客户支付金额中包含的 {pct}% 增值税',
      legendCollectedEstimated: '入账（按估算价）',
      showEstimates: '显示历史估算值',
      eraBefore: '尚未记录价格',
      eraAfter: '已记录真实价格',
      trendNoteRealOnly: '图表始终按完整月份显示，与上方所选时间范围无关 — 仅使用已记录的真实价格，按销售日期统计，并按报表范围自 {date} 起。绿色 + 橙色合计为客户支付总额（= 入账金额）。点击柱形可查看该月明细。',
      trendNote: '系统自 {date} 起强制记录售价；此前未填价格的套餐按当前标准价估算（虚线柱），实线柱为已记录的真实价格。可用于观察趋势，但估算部分请勿作为会计数字使用。',
      byProgram: '按项目划分',
      byMethod: '按支付方式划分',
      priceAndDiscount: '价格与折扣',
      colPaid: '已付',
      colFee: '手续费',
      colNet: '净额',
      methodUnspecified: '未指定',
      methodPrivate: '私教课（未填写支付方式）',
      promoPackages: '促销套餐',
      totalDiscount: '折扣总额',
      avgDiscountPct: '相对标准价平均折扣',
      comparedAgainstList: '可比较',
      aging0: '30天以内',
      aging31: '31–60天',
      aging61: '61–90天',
      aging90: '超过90天',
      colStudents: '学员',
      colPhone: '家长电话',
      colCourse: '课程',
      colAmount: '金额',
      colOverdue: '逾期',
      colUsedUnpaid: '已上课',
      colRefer: '套餐编号',
      colCreated: '创建日期',
      colSuggested: '建议标准价',
      unknownPrice: '价格未知',
      noReceivables: '没有应收款',
      noData: '暂无数据',
      viewList: '查看列表',
      dqPriceActual: '有真实价格的套餐',
      dqMissingPrice: '尚未填写价格',
      dqEstimated: '使用估算价格',
      dqUnknownPrice: '价格未知（无法估算）',
      unknownPriceWarn: '另有 {count} 笔价格未知 — 实际金额高于显示值',
      unknownPriceExcluded: '不含 {count} 笔价格未知',
      deferredUnknownExcluded: '不含 {count} 笔价格未知（{sessions} 次）',
      dqFeeUnknown: '刷卡手续费未知',
      dqNoPaydate: '已付但无付款日期',
      dqMonthly: '月卡无法计价',
      missingPriceTitle: '尚未填写价格的套餐',
      missingPriceSub: '{date} 之后创建 — 补齐价格后报表立即变准确',
      notProfitNote: '所有数字均为场馆收到的收入，而非利润 — 系统尚未记录成本或教练报酬。',
      preset: { thisMonth: '本月', lastMonth: '上月', last3Months: '近3个月', thisYear: '今年', custom: '自定义' },
    },
    insightView: {
      title: '洞察分析',
      subtitle: '每周纪要 + 需跟进的家长',
      generateBtn: '生成新报告',
      generating: '生成中...',
      generateSuccess: '新报告生成成功',
      generateFail: '报告生成失败',
      historyTitle: '历史记录',
      emptyReports: '暂无报告',
      newStudentsTile: '新学员（最新月份）',
      packagesSoldTile: '售出套餐（最新月份）——非货币收入',
      vsPrevMonth: '较上月',
      showMonthly: '显示月度数据',
      hideMonthly: '隐藏月度数据',
      unitPeople: '人',
      unitPackages: '份',
      winBackTitle: '需赢回的家长',
      atRiskTitle: '有到期前用不完次数的风险',
      opsLinkTitle: '待办列表已移至“每日检查”页面',
      opsLinkBody: '欠款 · 即将用完 · 购买后未开始 · 已过期但仍有剩余次数 — 在那里可查看实时数据（本页是生成报告当天的快照）。',
      opsLinkBtn: '前往每日检查',
      colNickname: '昵称',
      colMobile: '手机',
      colEndedOn: '套餐结束于',
      colDaysLapsed: '距今天数',
      colCourse: '课程',
      colRef: '课程编号',
      colStudents: '学员',
      colPhones: '手机',
      colRemaining: '剩余（次）',
      colExpiredate: '到期日',
      colDaysLeft: '剩余天数',
    },
    addFamily: {
      title: '添加成员',
      firstname: '名',
      middlename: '中间名',
      lastname: '姓',
      nickname: '昵称',
      school: '学校',
      gender: '性别',
      dob: '出生日期',
      submit: '保存',
      clear: '清除',
      errorRequired: '请填写所有必填项',
    },
    register: {
      title: '注册',
      username: '用户名',
      password: '密码',
      firstname: '名',
      middlename: '中间名',
      lastname: '姓',
      address: '地址',
      email: '电子邮箱',
      mobile: '手机号码',
      code: '注册码',
      privacyConsent: '我确认已阅读并同意',
      privacyPolicy: '隐私政策',
      privacyOf: 'iStar Gymnastics 的',
      submit: '提交',
      clear: '清除',
      cancel: '取消',
    },
    accountMgmt: {
      listTitle: '用户账户',
      subtitle: '搜索、编辑、重置密码、管理家庭及设置权限',
      editUser: '编辑用户账户',
      username: '用户名',
      fullname: '姓名',
      mobileno: '手机',
      roleCol: '角色',
      province: '省份',
      status: '状态',
      active: '正常',
      restricted: '受限',
      noUsers: '未找到用户',
      roleAll: '所有角色',
      loadFail: '加载用户列表失败',
      saveFail: '操作失败',
      tabPersonal: '个人信息',
      tabPassword: '密码',
      tabFamily: '家庭成员',
      tabPermissions: '权限',
      personalSection: '用户信息',
      contactSection: '联系方式',
      addressSection: '地址',
      firstname: '名',
      middlename: '中间名',
      lastname: '姓',
      email: '电子邮箱',
      savedProfile: '用户信息已保存',
      passwordSection: '设置新密码',
      newPassword: '新密码',
      confirmPassword: '确认新密码',
      resetPasswordBtn: '重置密码',
      pwMismatch: '两次输入的密码不一致',
      pwResetOk: '密码已重置',
      pwSessionNote: '重置立即生效，但当前已登录的用户会保持登录状态，直到其会话过期——无法立即强制其退出。',
      familySection: '家庭成员',
      childName: '成员',
      childCourse: '课程',
      transferTo: '转移到家庭',
      searchFamily: '输入目标家庭的用户名…',
      chooseFamily: '— 选择目标家庭 —',
      addChild: '添加成员',
      nickname: '昵称',
      gender: '性别',
      dob: '出生日期',
      pending: '待审核',
      noChildren: '此家庭暂无成员',
      deleteChildTitle: '删除成员',
      confirmDeleteChild: '删除此成员？',
      childDeleted: '成员已删除',
      childAdded: '成员已添加',
      transferOk: '成员已转移（课程随之一并转移）',
      roleSection: '更改角色',
      roleLabel: '角色',
      applyRole: '保存角色',
      roleChanged: '角色已更改',
      cannotChangeSelf: '您无法更改自己的角色',
      accessSection: '系统访问',
      unlockAccess: '解锁访问',
      notRestricted: '此账户未被限制',
      accessUnlocked: '访问已解锁',
      adminStaffBlocked: '您只能管理家长账户，无法编辑员工账户。',
    },
    addr: {
      no: '门牌号 / 组 / 巷 / 路',
      noPlaceholder: '例如 99/1 组2 素坤逸巷101',
      search: '搜索地址（乡、区、府或邮政编码）',
      searchPlaceholder: '用泰文输入，例如 "สวนหลวง"，或邮政编码如 "10250"',
      subdistrict: '乡/街道',
      district: '县/区',
      province: '府',
      postalcode: '邮政编码',
      noResult: '未找到匹配——请尝试乡、县或府名称',
      loading: '正在加载地址数据...',
      clear: '清除地址',
      legacyHint: '此前保存的地址',
      updateHint: '请从搜索框中选择您的乡/县/府，以将地址更新为新格式',
    },
    forgot: {
      title: '忘记密码',
      subtitle: '请输入您注册时使用的用户名和电话号码',
      username: '用户名',
      phone: '电话号码',
      otp: 'OTP 验证码',
      requestOTP: '获取 OTP',
      submit: '确认',
      cancel: '取消',
      newPassword: '新密码',
      confirmPassword: '确认新密码',
      phoneMatchError: '您输入的用户名和电话号码不匹配',
      otpInvalid: 'OTP 验证码无效',
      passwordMismatch: '密码不一致',
      passwordChangedSuccess: '密码修改成功',
    },
    editProfile: {
      title: '编辑用户资料',
      personalInfo: '个人信息',
      email: '电子邮箱',
      phone: '电话号码',
      address: '地址',
      saveProfile: '保存信息',
      changePasswordSection: '修改密码',
      currentPassword: '当前密码',
      newPassword: '新密码',
      confirmNewPassword: '确认新密码',
      changePasswordBtn: '修改密码',
      emailRequired: '请输入您的电子邮箱',
      emailInvalid: '电子邮箱格式无效',
      phoneRequired: '请输入您的电话号码',
      passwordRequired: '请输入您的密码',
      passwordMinLength: '密码至少需 6 个字符',
      confirmRequired: '请确认您的密码',
      passwordMismatch: '密码不一致',
      saveSuccess: '信息保存成功',
      saveFail: '信息保存失败',
      passwordChangeSuccess: '密码修改成功',
      passwordChangeFail: '密码修改失败',
    },
    msg: {
      required: '请填写所有必填项',
      updated: '更新成功',
      created: '创建成功',
      deleted: '删除成功',
      courseDone: '课程已结课',
      courseDeleted: '课程已删除',
      updateFail: '更新失败，请重试',
      addFail: '添加失败，请重试',
      memberAdded: '成员添加成功',
      memberAddFail: '成员添加失败',
      familyAdded: '家庭成员添加成功',
      familyDuplicate: '该姓名已是您的家庭成员。请联系管理员。',
      familyAddFail: '家庭成员添加失败',
      bookingAdded: '预约添加成功',
      bookingAddFail: '预约失败，请重试',
      bookingSuccess: '课程预约成功！到时见 :)',
      bookingDuplicate: '您在 {date} 已有一个预约。请选择其他日期。',
      noRemaining: '无法预约——课程次数已用完',
      cannotEditDeleted: '无法编辑已删除的学员',
      courseCreated: '课程创建成功',
      courseUpdated: '课程更新成功',
      fileTooLarge: '图片不得超过 4MB',
      uploadSuccess: '图片上传成功',
      uploadFail: '图片上传失败',
      loadFail: '数据加载失败',
      studentDeleted: '学员删除成功',
      studentDeleteFail: '学员删除失败',
      studentListFail: '学员名单加载失败',
      reservationDeleted: '预约删除成功',
      reservationDeleteFail: '预约删除失败',
      familyDeleted: '家庭成员删除成功',
      familyLoadFail: '家庭成员加载失败',
      studentApproved: '学员批准成功',
      approveFail: '学员批准失败',
      bothCredsRequired: '请输入用户名和密码',
      registerSuccess: '注册成功',
      registerFail: '注册失败',
    },
  },
  ja: {
    home: {
      title: 'ホーム',
      familySection: '家族',
      information: '情報',
      courseInfo: 'コース情報',
      reservation: '予約',
      date: '日付',
      classTime: 'クラス時間',
      noBooking: 'まだクラスの予約がありません',
      selectMember: 'メンバーを選択して詳細を表示',
      courseExpired: 'コースの有効期限が切れました!!',
      addFamilyHint: '「家族」メニューから家族メンバーを追加してください',
      monthly: '月謝制',
      expired: '期限切れ',
      noCourse: 'コースなし',
      usedUp: '回数終了',
      bookClass: 'クラスを予約',
      genderAge: '{gender}・年齢 {age}',
      errorSelectFirst: '家族メンバーを選択してください',
      errorNoCourse: '予約できません。コースが登録されていません。管理者にお問い合わせください',
      errorExpired: '予約できません。コースの有効期限が切れています',
      errorNoRemaining: '予約できません。残りの回数がありません',
      ageUnit: '{years}歳 {months}か月 {days}日',
      remainBadge: '残り{n}回',
      remainOf: '残り{n} / {total}回',
      timeLeftLabel: '残り期間',
      daysValue: '{n}日',
      privateBooking: 'プライベートレッスンの予約',
      noPrivateBooking: 'まだプライベートレッスンの予約がありません',
      privateBookingWith: '{names}と一緒に',
      coachName: '{name}コーチ',
    },
    family: {
      title: '家族',
      sectionHeader: '家族メンバー',
      addMember: '家族メンバーを追加',
      confirmDelete: '{name}を家族から削除しますか？',
      editSuccess: 'メンバー情報を更新しました',
      editFail: '更新に失敗しました',
    },
    btn: {
      ok: 'OK',
      cancel: 'キャンセル',
      save: '保存',
      delete: '削除',
      edit: '編集',
      add: '追加',
      close: '閉じる',
      confirm: '確定',
      back: '戻る',
      refresh: '更新',
      copy: 'コピー',
      create: '作成',
      search: '検索',
      newCourse: '新規コース',
      newBooking: '新規予約',
      newStudent: '新規生徒',
      approve: '承認',
      finish: 'コース終了',
      reset: 'リセット',
      newClass: '新規クラス',
      newHoliday: '新規休講日',
    },
    grid: {
      perPage: '件/ページ',
      range: '{total}件中 {from}–{to}件',
    },
    table: {
      profileImage: 'プロフィール写真',
      courseRef: 'コース番号',
      courseName: 'コース名',
      courseShortName: '略称',
      courseType: '種類',
      price: '料金',
      startDate: '開始日',
      expireDate: '有効期限',
      remaining: '残り',
      courseUser: '利用者',
      payment: '支払い',
      edit: '編集',
      delete: '削除',
      finish: 'コース終了',
      name: '名前',
      time: '時間',
      view: '表示',
      history: '編集履歴',
      checkin: 'チェックイン',
      date: '日付',
      studentId: '生徒ID',
      class: 'クラス',
      classDay: '曜日',
      classTime: 'クラス時間',
      maxStudent: '定員',
      gender: '性別',
      age: '年齢',
      school: '学校',
      parentUsername: '保護者ユーザー名',
      phone: '電話番号',
      holidayDate: '休講日',
      description: '説明',
      nickname: 'ニックネーム',
      level: 'Level',
      studentInfo: '生徒情報',
      courseUsageHistory: 'コース利用履歴',
      expired: '期限切れ',
      yearAbbr: '歳',
      monthAbbr: 'か月',
      dayAbbr: '日',
      firstname: '名',
      middlename: 'ミドルネーム',
      lastname: '姓',
      dob: '生年月日',
      shortNote: '備考',
      courseRefer: 'コース番号',
      continueCourseRefer: '継続コース番号',
      createBy: '作成者',
      createDate: '作成日時',
      updateBy: '最終編集者',
      editDate: '最終編集日時',
      deleteBy: '削除者',
    },
    role: {
      head: '統括マネージャー',
      admin: '管理者',
      coach: 'コーチ',
      customer: '保護者',
    },
    nav: {
      mainMenu: 'メインメニュー',
      home: 'ホーム',
      family: '家族',
      checkingMenu: 'チェックメニュー',
      viewClasses: 'クラス一覧',
      adminMenu: '管理者メニュー',
      dashboard: 'ダッシュボード',
      insightView: 'インサイト',
      opsChecklist: '日次チェック',
      chatbot: 'AI アシスタント',
      gymnasts: '選手リスト',
      gymnastsAll: '全生徒',
      bookingManagement: 'クラス予約',
      privateBookingManagement: 'プライベート予約',
      eventManager: '大会/イベント',
      customerCourse: '顧客コース',
      courseHistory: 'コース履歴',
      managementMenu: '管理メニュー',
      holidays: '休講日管理',
      accountManagement: 'ユーザーアカウント',
      theme: 'テーマ',
      editProfile: 'ユーザー情報の編集',
      language: '言語：日本語',
      logout: 'ログアウト',
      groupMine: 'マイエリア',
      groupOverview: '概要',
      groupSchedule: 'クラスと予約',
      groupCoach: 'コーチ',
      groupStudents: '生徒', groupCourses: '顧客コース管理',
      groupSetup: '設定',
      groupFinance: '会計',
      groupAccount: 'アカウント',
      paymentDocs: '入出金書類',
      financeReport: '売上・財務レポート',
    },
    auth: {
      loginTitle: 'ログイン',
      welcome: 'iStar Gymnasticsへようこそ、',
      welcomeSub: '素敵な一日をお過ごしください :D...',
      heroTag: 'クラス予約・チェックイン<br />コース管理<br />すべてひとつに',
      heroBlurb: '保護者はスマホでお子様のクラスを予約でき、管理者は1画面でスケジュール確認とチェックインができます',
      username: 'ユーザー名',
      password: 'パスワード',
      loginBtn: 'ログイン',
      registerBtn: '会員登録',
      forgotBtn: 'パスワードをお忘れですか？',
      logoutConfirm: 'ログアウトしますか？',
    },
    common: {
      yes: 'はい',
      no: 'いいえ',
      close: '閉じる',
      confirm: '確定',
      ok: 'OK',
      required: 'この項目は必須です',
      male: '男の子',
      female: '女の子',
      loading: '読み込み中... お待ちください',
      nextCourse: '次のコース',
      times: '回',
      noCourseData: 'コースデータがありません',
      noStudentData: '生徒データがありません',
      noClassData: 'クラスデータがありません',
      noStudentList: '生徒リストがありません',
      invalidDob: '生年月日が正しくありません',
      serverError: 'サーバーとの通信エラー',
      noServerResponse: 'サーバーから応答がありません',
      errorPrefix: 'エラー',
      hoursUnit: '時間',
    },
    dialog: {
      error: 'エラー',
      success: '成功',
      selectTheme: 'テーマを選択',
      themeNote: '選択したテーマはすべてのユーザーに適用されます',
      themeDarkNote: 'この端末はダークモードのため、選択したテーマではなくダークパレットを表示しています。ライトモードの端末では通常どおりテーマが表示されます。',
    },
    theme: {
      default: 'デフォルト',
      defaultSub: 'iStar ピンク',
      mothersday: '母の日',
      mothersdaySub: '空色とジャスミン',
      loykrathong: 'ローイクラトン',
      loykrathongSub: 'ろうそくの灯りと灯籠',
      newyear: 'お正月',
      newyearSub: '花火とシャンパンゴールド',
      songkran: 'ソンクラーン',
      songkranSub: '水と夏の陽差し',
      halloween: 'ハロウィン',
      halloweenSub: 'かぼちゃとコウモリ',
      christmas: 'クリスマス',
      christmasSub: '雪とイルミネーション',
      fathersday: '父の日',
      fathersdaySub: '黄色いカンナの花',
      muaythai: 'ムエタイ',
      muaythaiSub: '深紅・青・金',

      saveFailed: '全員へのテーマ保存に失敗しました — この端末のみ変更されました',
    },
    validation: {
      usernameRequired: 'ユーザー名を入力してください',
      usernameNoSpaces: 'ユーザー名に空白を含めることはできません',
      usernameEnglishOnly: 'ユーザー名は英字・数字・記号のみ使用できます',

      usernameHint: '4〜20文字、英数字と . _ - のみ',
      passwordRequired: 'パスワードを入力してください',
      nameRequired: '名前を入力してください',
      mobileRequired: '携帯電話番号を入力してください',
      emailRequired: 'メールアドレスを入力してください',
      emailInvalid: 'メールアドレスの形式が正しくありません',
      newPasswordRequired: '新しいパスワードを入力してください',
      newPasswordMaxLength: '新しいパスワードは10文字以内で入力してください',
      phoneRequired: '電話番号を入力してください',
      otpRequired: 'OTPを入力してください',
      otpLength: 'OTPは6桁で入力してください',
    },
    bookingList: {
      classBooking: 'クラス予約',
      menuCheckin: 'チェックイン',
      menuUndoCheckin: 'チェックインを取り消す',
      menuEdit: '表示／編集',
      menuCheckedInBadge: 'チェックイン済み',
      notCheckedIn: '未チェックイン',
      legendTrial: '体験レッスン',
      legendPerSession: '回数制',
      legendPayment: '要支払い／回数終了',
      legendBlind: '他の保護者に名前を非表示',
      checkinFail: 'チェックインに失敗しました',
      undoCheckinFail: 'チェックインの取り消しに失敗しました',
      menuCancel: '予約をキャンセル',
      eventRowNote: 'イベント行 — 移動やキャンセルはイベント画面で',
      confirmCancelBooking: '"{name}"の予約をキャンセルしますか？',
      cancelBookingFail: '予約のキャンセルに失敗しました',
    },
    customerCourse: {
      period: '期間（か月）',
      payDate: '支払日',
      uploadSlip: 'スリップをアップロード',
      slipTitle: '振込スリップ',
      viewSlip: 'アップロード済みスリップを表示',
      doubleBookingNote: 'このコースは',
      doubleBookingMore: '1日に複数回',
      doubleBookingUnit: '受講できます',
      paid: '支払済み',
      unpaid: '未払い',
      shortNote: '備考',
      noCourseList: '顧客のコース一覧がありません',
      loadFail: 'コース情報の読み込みに失敗しました',
      deleteInUse: 'このコースは{names}が利用中です。削除しますか？',
      priceCatalog: '価格表を管理',
      priceCatalogSub: '新しいパッケージの自動入力にのみ使用されます。販売済みのパッケージには影響しません',
      priceSaved: '価格を保存しました',
      noPriceSet: '未設定',
      groupPricing: 'グループコースの料金',
      privatePricing: 'プライベートレッスンの料金（1時間あたり）',
      quantitySessions: '回数',
      quantityOrPeriod: '数量（回数／月数）',
      pricePerHour: '料金／時間',
      privateType: 'プライベート種別',
      private1on1: 'マンツーマン（1:1）',
      private2on1: '少人数（2:1）',
      private3on1: '少人数（3:1）',
      slipVerifyChecking: '確認結果を読み込み中…',
      slipVerifyNone: 'このスリップの確認結果はまだありません',
      slipVerified: '本物のスリップ — 銀行で確認済み',
      slipDuplicate: '重複したスリップ — すでに使用済み',
      slipAmountMismatch: 'スリップの金額が料金と一致しません',
      slipWrongReceiver: '受取口座が店舗の口座と一致しません',
      slipFailed: '確認に失敗しました — 読み取り不可、または本物のスリップではありません',
      slipSkipped: 'まだ銀行で確認していません',
      slipReverify: '再確認',
      slipReverifying: '確認中…',
      slipReverifyFail: '再確認に失敗しました。もう一度お試しください',
      slipAmount: '振込金額',
      slipWhen: '振込日時',
      slipFrom: '振込人',
      slipSaveVerified: 'スリップ確認済み：本物です',
      slipSaveWarn: '保存に成功しましたが、スリップの確認結果は',
    },
    eventMgr: {
      tab: '大会/イベント', pageSubtitle: 'イベントの作成・参加者管理・当日のチェックイン', newEvent: 'イベント作成', addKidsTitle: 'イベントに生徒を追加', addKids: '生徒を追加',

      pastHeadOnly: '過去のイベントはマネージャーのみ操作できます',
      step1: '情報', step2: '生徒選択', step3: '確認', step4: '最終確認',
      date: '日付', datePh: '大会の日付を選択', coursePh: '— コースを選択 —',
      label: 'イベント名', labelPh: '例: KAO Cup', labelHint: 'この名前が当日の予約表の列見出しになります', defaultLabel: 'แข่ง',
      pickKids: '参加する生徒を検索して選択', searchKidPh: '生徒名を入力…', noKidsYet: 'まだ選択されていません', noMatch: '該当なし',
      tagTrial: '体験 — 回数消費なし', tagNoCourse: 'コースなし', tagExpired: 'コース期限切れ', tagQuotaEmpty: '残り回数なし', tagListed: '登録のみ — 消費なし',
      tagMonthly: '月謝制 — 回数消費なし', tagRemaining: '残り {n} 回', tagClockStart: 'コース有効期間は大会日から起算されます', tagAlreadyIn: 'このイベントに登録済み — スキップ',
      conflictInfo: '同日に通常クラスの予約あり（{time}）', keepBoth: '元の予約を残す（授業 + 大会）', moveBooking: '元の予約を大会に振り替える（追加消費なし）',
      modeDeduct: 'コース回数を消費', modeList: '登録のみ・消費なし（参加費別途/コースなし）',
      sumDeduct: '回数消費：{n} 名', sumList: '登録のみ：{n} 名', sumMove: '予約振替：{n} 名',
      back: '戻る', next: '次へ', create: 'イベントを保存',
      kids: '人数', roster: '名簿', checkedinShort: 'チェックイン済', undoCheckin: 'チェックイン取消', removeKid: '除外（回数返還）',
      confirmTitle: '確認', confirmRemove: '{name} をイベントから外しますか？予約はキャンセルされ、回数は通常どおり返還されます。',
      confirmDelete: 'イベント「{name}」を削除しますか？', deleteBlockedHint: '名簿が空の場合のみ削除できます', renameTitle: 'イベント名を変更',
    },
    bookingMgmt: {
      title: 'クラス予約',
      tabBooking: 'クラス予約',
      viewByDate: '日付ごとに予約を表示',
      allBookingsToday: 'すべてのクラス予約',
      noBooking: '予約なし',
      confirmDelete: '{name}の予約を削除しますか？',
      confirmCheckin: '{name}をチェックインしますか？',
      confirmUndoCheckin: '{name}のチェックインを取り消しますか？',
      freeClass: '無料体験',
      courseInfoMonthly: 'コース番号：{ref}・有効期限：{expiry}・月謝制',
      courseInfoLimited: 'コース番号：{ref}・有効期限：{expiry}・残り{remaining}回',
      noCourse: 'この生徒は受講中のコースがありません',
      bookingInfoTitle: '予約情報',
      createBy: '予約者',
      createDate: '予約日時',
      updateBy: '編集者',
      editDate: '編集日時',
      visibility: '名前の表示',
      visPrivate: '非公開（名前を隠す）',
      visPublic: '公開',
      blindBooking: '他の保護者に名前を非表示',
    },
    courses: {
      newCourse: '新規コース',
      editCourse: 'コースを編集',
      confirmDelete: 'このコースを削除しますか？',
    },
    holidays: {
      title: '休講日管理',
      description: '休講日を追加すると、その日は保護者がクラスを予約できなくなります。',
      ourHolidays: '休講日一覧',
      newHoliday: '新規休講日',
      editHoliday: '休講日を編集',
      confirmDelete: '休講日 {date} を削除しますか？',
      holidayDate: '休講日',
      holidayDescription: '説明',
    },
    gymnasts: {
      title: '選手管理',
      listTitle: '選手リスト',
      addStudent: '新規生徒を追加',
      editStudent: '生徒を編集',
      confirmDelete: 'この生徒を削除しますか？',
      confirmFinish: 'コースを終了し、履歴を保存しますか？',
      filterStatus: 'ステータス',
      statusAll: 'すべてのステータス',
      statusActive: '有効なコースあり',
      statusNoCourse: 'コースなし／期限切れ',
      filterGender: '性別',
      genderAll: 'すべての性別',
      filterCourse: 'コース',
      courseAll: 'すべてのコース',
    },
    learningHistory: {
      title: '生徒情報 + 受講履歴',
      tableTitle: '受講履歴（グループ + プライベート）',
      currentCourse: '現在のコース',
      noCourse: 'コースなし',
      monthly: '月額',
      sumTotal: '合計',
      sumGroup: 'グループ',
      sumPrivate: 'プライベート',
      sumFree: '無料',
      colType: '種別',
      colCoach: 'コーチ',
      typeGroup: 'グループ',
      typePrivate: 'プライベート',
      typeEvent: '大会',
      badgeFree: '無料',
      badgeWalkin: '単発',
      noHistory: '受講履歴はまだありません',
      loadFail: '受講履歴の読み込みに失敗しました',
    },
    approve: {
      title: '新規生徒の申請',
      confirmApprove: '{count}名の生徒を承認しますか？',
      confirmDelete: 'この生徒を削除しますか？',
      noData: '承認待ちの新規生徒はいません',
      selectAtLeastOne: '承認する生徒を1名以上選択してください',
    },
    viewClasses: {
      title: 'クラス一覧',
      viewByDate: '日付ごとに予約を表示',
    },
    privateBooking: {
      title: 'プライベートレッスンのスケジュール',
      addNew: 'プライベート予約を追加',
      editTitle: 'プライベート予約を編集',
      groupClassOption: 'グループクラスの予約',
      privateClassOption: 'プライベートレッスンの予約',
      noBooking: '本日はプライベートレッスンの予約がありません',
      coach: 'コーチ',
      type: '種類',
      startTime: '開始時間',
      endTime: '終了時間',
      student1: '生徒1',
      student2: '生徒2',
      student3: '生徒3',
      students: '生徒',
      hours: '時間数',
      price: '料金',
      note: 'メモ',
      othersCount: '他{n}名',
      menuCancel: '予約をキャンセル',
      cancelConfirm: 'コーチ{name}とのこの予約をキャンセルしますか？',
      cancelSuccess: '予約をキャンセルしました',
      cancelFail: '予約のキャンセルに失敗しました。もう一度お試しください',
      invalidClasstime: '時間の形式が正しくありません。もう一度クラス時間を選択してください',
      managementTitle: 'プライベート予約',
      viewByPeriod: '期間ごとに表示',
      viewSubtitle: '日付をタップするとその日を表示、または月全体に切り替えられます',
      periodDay: '日',
      periodMonth: '月',
      today: '今日',
      markLegend: '予約のある日',
      bookingsInMonth: '今月の予約',
      rangeSummary: '{count}件の予約・{coaches}名のコーチ・{days}日',
    },
    courseHistory: {
      title: '顧客のコース履歴',
      ourCourses: '顧客のコース',
      courseInfo: 'コース情報',
      courseRefer: 'コース番号',
    },
    reservation: {
      title: '予約',
      bookingFor: '{name}の予約',
      confirmBooking: '{name}のクラスを{date} {time}に予約しますか？',
      confirmBtn: '予約する！',
      noClassTime: '利用可能なクラス時間がありません',
      blindName: '他の保護者に名前を非表示',
      blindNameHint: 'お子様の名前は他の保護者のクラス時間表でぼかして表示されます',
      blindBadge: '非公開',
    },
    groupbooking: {
      title: '複数の子どもをまとめて予約',
      subtitle: 'クラスを一度選ぶだけで、複数の子どもをまとめて予約できます',
      entryBtn: 'まとめて予約を開始',
      entryNew: '新機能',
      stepCourse: 'クラスの種類を選択',
      stepDate: '日付を選択',
      stepTime: '時間帯を選択',
      stepKids: '予約する子どもを選択',
      kidsEligible: '{n}名予約可能',
      pickCourseFirst: '先にクラスの種類を選択してください',
      pickSlotFirst: '子どもを選ぶ前に日付と時間帯を選択してください',
      notThisCourse: '別のクラス種類',
      expired: 'コース期限切れ',
      usedUp: '残り回数なし',
      alreadyBooked: '本日は予約済み',
      sharedShort: '回数が足りません（共有コース）',
      seatShort: '空き枠が足りません',
      monthly: '月謝制',
      remainN: '残り{n}回',
      summary: '{n}名選択済み・空き{seats}枠',
      bookBtn: '{n}名を予約',
      confirmTitle: '{n}名の予約を確定',
      afterRemain: '残り {a} → {b}',
      allOrNothingNote: '全員まとめて予約されます。1人でも失敗した場合は、誰も予約されません。',
      successMsg: '{n}名全員の予約に成功しました',
    },
    dashboard: {
      title: 'ダッシュボード',
      subtitle: '体操クラス管理の概要',
      btnPlaceholder: 'このボタンには用途が必要です。アイデアがあればぜひ教えてください！',
      totalGymnasts: '選手総数',
      activeGymnasts: 'アクティブな選手',
      todayBooking: '本日の予約',
      tomorrowBooking: '明日の予約',
      vsLastWeek: '先週比',
      studentsUnit: '名',
      bookingsUnit: '件',
    },
    finance: {
      title: '売上・財務レポート',
      subtitle: '販売パッケージ額、入金額、未収金、および残りの授業義務',
      statsSinceBadge: '{date} から集計',
      statsSinceNote: 'このレポートは {date} から集計を開始します — 未収金、前受金（残りの授業義務）、データ整備状況を含め、ページ上のすべての数値はその日以降のデータのみを対象とします。それ以前に販売され未入金のパッケージは「顧客コース」画面でご確認ください。',
      presetBeforeStats: 'この期間は集計開始日 {date} より前のため、表示できるデータがありません。',
      managerOnly: 'マネージャー限定',
      exportCsv: 'CSV ダウンロード',
      permissionDenied: 'このレポートを閲覧する権限がありません',
      fromDate: '開始日',
      toDate: '終了日',
      sectionFlow: '選択期間の動き',
      sectionStock: '本日時点の残高',
      sectionTrend: '月別売上',
      sectionReceivables: '年齢別未収金',
      sectionPrivateCoach: 'プライベートレッスン（コーチ別）',
      privateCoachHint: '実施日で集計 · 金額は手数料を含む顧客支払額です',
      noPrivateInRange: '選択期間にプライベートレッスンはありません',
      privSessions: 'レッスン数',
      privHours: '時間',
      privRevenue: '実施合計',
      privCollected: '入金済み',
      privUnpaidInRange: '未払い（選択期間のみ）',
      privRatePerHour: '1時間あたり平均',
      privFeeUnknown: 'クレジットカード払いで手数料が不明なレッスンが {n} 件あります。実際の金額はこれより多い可能性があります',
      privPriceUnknown: '価格未入力のレッスンが {n} 件あり、実際の収入は表示より多くなります',
      privLoadError: 'このセクションの読み込みに失敗しました',
      privLoadRetry: '再試行',
      privNotProfit: 'これは売上であり利益ではありません（コーチ報酬などの費用は未控除）。「未払い」は選択期間のレッスンのみを数えるため、本日時点・全期間で集計する上の「プライベート未収」カードとは一致しません。',
      viewByMonth: '月別',
      viewByCoach: 'コーチ別',
      viewByType: 'タイプ別',
      colMonth: '月',
      colPrivateType: 'タイプ',
      sectionDataQuality: 'データの完全性',
      asOfToday: '時点',
      salesTile: '売上（販売パッケージ額）',
      collectedNetTile: '純入金額',
      collectedTile: '入金額',
      vatTile: '入金額に含まれる VAT {pct}%',
      vatFrom: '顧客が実際に支払った {amount} ฿ から計算（手数料は差し引かず・税込価格を 7/107 で抽出）',
      vatSeeCollected: '日別で見るには「入金額」カードを開いてください（同じ基準）。',
      salesParts: 'コース {course} ฿ + 手数料 {fee} ฿',
      collectedFeeIncluded: 'カード手数料 {fee} ฿ を含む（ジムの収入）',
      clickDetail: 'クリックで明細を表示',
      clickGoTable: '未収金の表へ移動',
      legendCourse: 'コース料金',
      legendGrossAll: '顧客支払総額（全額入金）',
      colIntoAccount: '入金',
      colFeePart: 'うち手数料',
      colDate: '日付',
      colItem: '項目',
      colCourseAmount: 'コース料金',
      colVatInAmount: '内訳 VAT',
      colStatus: '状態',
      colMethod: '支払方法',
      colSessions: '実施回数',
      colUnitPrice: '1回あたり',
      colRemaining: '残り回数',
      colExpire: '有効期限',
      paidYes: '支払済み', flagYes: 'はい',
      paidNo: '未払い',
      detailTotal: '{count} 件 — 合計',
      receivablePrivateTile: 'Private 未収金（未払い）',
      receivablePrivateCount: '{count} コマ',
      receivablePrivateTaught: '実施済みで未入金 {count} コマ · {amount} ฿',
      colDay: '日付',
      colDayCount: '件数',
      colCoach: 'コーチ',
      colTaughtStatus: '実施状況',
      taughtUnpaid: '実施済み・未払い',
      notYetTaught: '未実施',
      backToDaily: '日次サマリーに戻る',
      detailTotalDays: '{days} 日分 · {count} 件 — 合計',
      earnedTile: '実施済み授業分の収益',
      receivableTile: '未収金（未払い）',
      deferredTile: '前受金（未実施分）',
      breakageTile: '期限切れ未使用回数（30日）',
      vsPrevPeriod: '前期比',
      avgPerPackage: '平均',
      paidAmount: '顧客支払',
      feeAmount: '手数料',
      ofSales: '売上比',
      unitPackages: '件',
      unitDays: '日',
      unitTimes: '回',
      estimatedPart: 'うち推定 {amount} ฿（{count} 件）',
      missingPriceWarn: '{count} 件が価格未入力 — 一覧を見る',
      feeUnknownWarn: 'カード決済 {count} 件の手数料が不明',
      earnedFrom: '実施済み {sessions} 回分',
      earnedUnpriceable: '他 {sessions} 回は金額換算不可（月額／価格不明）',
      receivableUsed: '{count} 件は未払いのまま受講済み',
      deferredSessions: '残り {sessions} 回',
      deferredProgress: '販売 {sold} ฿ · 提供済み {delivered} ฿（{pct}%）',
      salesUnpaid: 'このうち未回収 {amount} ฿（{count} 件）',
      colUsedOfTotal: '消化 / 総回数',
      colDeliveredPct: '提供済み',
      deferredExpiring: '{amount} ฿ が30日以内に期限切れ',
      deferredMonthlyExcluded: '月額 {count} 件を除く（回数換算不可）',
      breakageDetail: '{count} 件・計 {sessions} 回 — 支払済みだが未使用',
      legendActual: '実価格',
      legendEstimated: '標準価格からの推定',
      legendCollected: '純入金',
      legendNet: '実際の入金',
      legendFee: '決済手数料',
      legendGross: '顧客支払合計',
      legendVat: '破線 = 顧客支払額に含まれる VAT {pct}%',
      legendCollectedEstimated: '入金（推定価格による）',
      showEstimates: '過去の推定値を表示',
      eraBefore: '価格未記録',
      eraAfter: '実価格を記録済み',
      trendNoteRealOnly: 'グラフは上で選択した期間に関係なく、常に暦月単位で表示します — 記録された実価格のみを販売日基準で集計し、レポートの対象範囲に合わせて {date} から始まります。緑＋オレンジの合計が顧客支払総額（= 入金額）です。棒をクリックするとその月の明細を表示します。',
      trendNote: '販売価格の入力は {date} から必須になりました。それ以前で価格が未記録のパッケージは現在の標準価格から推定します（破線の棒）。実線の棒は記録された実価格です。傾向の把握には使えますが、推定部分は会計数値として使用しないでください。',
      byProgram: 'プログラム別',
      byMethod: '支払方法別',
      priceAndDiscount: '価格と割引',
      colPaid: '支払額',
      colFee: '手数料',
      colNet: '純額',
      methodUnspecified: '未指定',
      methodPrivate: 'プライベート（支払方法が未入力）',
      promoPackages: 'プロモーション',
      totalDiscount: '割引合計',
      avgDiscountPct: '標準価格比の平均割引',
      comparedAgainstList: '比較可能',
      aging0: '30日以内',
      aging31: '31〜60日',
      aging61: '61〜90日',
      aging90: '90日超',
      colStudents: '生徒',
      colPhone: '保護者の電話',
      colCourse: 'コース',
      colAmount: '金額',
      colOverdue: '滞留',
      colUsedUnpaid: '受講済み',
      colRefer: 'パッケージ番号',
      colCreated: '作成日',
      colSuggested: '推奨標準価格',
      unknownPrice: '価格不明',
      noReceivables: '未収金はありません',
      noData: 'データなし',
      viewList: '一覧を見る',
      dqPriceActual: '実価格のあるパッケージ',
      dqMissingPrice: '価格未入力',
      dqEstimated: '推定価格を使用',
      dqUnknownPrice: '価格不明（推定不可）',
      unknownPriceWarn: '他 {count} 件が価格不明 — 実際の金額は表示より多い',
      unknownPriceExcluded: '価格不明 {count} 件を除く',
      deferredUnknownExcluded: '価格不明 {count} 件（{sessions} 回）を除く',
      dqFeeUnknown: 'カード手数料不明',
      dqNoPaydate: '支払済みだが支払日なし',
      dqMonthly: '月額で換算不可',
      missingPriceTitle: '価格が未入力のパッケージ',
      missingPriceSub: '{date} 以降に作成 — 価格を埋めればレポートはすぐ正確になります',
      notProfitNote: 'すべての数値はスタジオが受け取った収入であり、利益ではありません — システムは費用やコーチ報酬を記録していません。',
      preset: { thisMonth: '今月', lastMonth: '先月', last3Months: '3か月', thisYear: '今年', custom: 'カスタム' },
    },
    insightView: {
      title: 'インサイト',
      subtitle: '週次のサマリー＋フォローすべき保護者',
      generateBtn: '新しいレポートを生成',
      generating: '生成中...',
      generateSuccess: '新しいレポートを生成しました',
      generateFail: 'レポートの生成に失敗しました',
      historyTitle: '履歴',
      emptyReports: 'まだレポートがありません',
      newStudentsTile: '新規生徒（今月）',
      packagesSoldTile: '販売パッケージ数（今月）— 金額ではありません',
      vsPrevMonth: '前月比',
      showMonthly: '月次データを表示',
      hideMonthly: '月次データを非表示',
      unitPeople: '人',
      unitPackages: '件',
      winBackTitle: '再来を促したい保護者',
      atRiskTitle: '期限までに回数を使い切れない恐れあり',
      opsLinkTitle: '対応リストは「日次チェック」ページに移動しました',
      opsLinkBody: '未払い · 残りわずか · 購入後未使用 · 期限切れだが回数が残っている — そちらでは最新データを確認できます（このページはレポート作成時点のスナップショットです）。',
      opsLinkBtn: '日次チェックを開く',
      colNickname: 'ニックネーム',
      colMobile: '携帯番号',
      colEndedOn: 'パッケージ終了日',
      colDaysLapsed: '経過日数',
      colCourse: 'コース',
      colRef: 'コース番号',
      colStudents: '生徒',
      colPhones: '携帯番号',
      colRemaining: '残り（回数）',
      colExpiredate: '有効期限',
      colDaysLeft: '残り日数',
    },
    addFamily: {
      title: 'メンバーを追加',
      firstname: '名',
      middlename: 'ミドルネーム',
      lastname: '姓',
      nickname: 'ニックネーム',
      school: '学校',
      gender: '性別',
      dob: '生年月日',
      submit: '保存',
      clear: 'クリア',
      errorRequired: '必須項目をすべて入力してください',
    },
    register: {
      title: '会員登録',
      username: 'ユーザー名',
      password: 'パスワード',
      firstname: '名',
      middlename: 'ミドルネーム',
      lastname: '姓',
      address: '住所',
      email: 'メールアドレス',
      mobile: '携帯電話番号',
      code: '登録コード',
      privacyConsent: '内容を読み、以下に同意します：',
      privacyPolicy: 'プライバシーポリシー',
      privacyOf: '（iStar Gymnastics）',
      submit: '登録する',
      clear: 'クリア',
      cancel: 'キャンセル',
    },
    accountMgmt: {
      listTitle: 'ユーザーアカウント',
      subtitle: '検索、編集、パスワードのリセット、家族の管理、権限の設定',
      editUser: 'ユーザーアカウントを編集',
      username: 'ユーザー名',
      fullname: '氏名',
      mobileno: '携帯番号',
      roleCol: '権限',
      province: '県',
      status: 'ステータス',
      active: '通常',
      restricted: '制限中',
      noUsers: 'ユーザーが見つかりません',
      roleAll: 'すべての権限',
      loadFail: 'ユーザーの読み込みに失敗しました',
      saveFail: '処理に失敗しました',
      tabPersonal: '個人情報',
      tabPassword: 'パスワード',
      tabFamily: '家族メンバー',
      tabPermissions: '権限',
      personalSection: 'ユーザー情報',
      contactSection: '連絡先',
      addressSection: '住所',
      firstname: '名',
      middlename: 'ミドルネーム',
      lastname: '姓',
      email: 'メールアドレス',
      savedProfile: 'ユーザー情報を保存しました',
      passwordSection: '新しいパスワードを設定',
      newPassword: '新しいパスワード',
      confirmPassword: '新しいパスワード（確認）',
      resetPasswordBtn: 'パスワードをリセット',
      pwMismatch: '2つのパスワードが一致しません',
      pwResetOk: 'パスワードをリセットしました',
      pwSessionNote: 'リセットは即時反映されますが、現在ログイン中のユーザーはセッションが切れるまでログイン状態が維持されます（即座に強制ログアウトすることはできません）。',
      familySection: '家族メンバー',
      childName: 'メンバー',
      childCourse: 'コース',
      transferTo: '別の家族へ移動',
      searchFamily: '移動先の家族のユーザー名を入力…',
      chooseFamily: '— 移動先の家族を選択 —',
      addChild: 'メンバーを追加',
      nickname: 'ニックネーム',
      gender: '性別',
      dob: '生年月日',
      pending: '承認待ち',
      noChildren: 'この家族にはまだメンバーがいません',
      deleteChildTitle: 'メンバーを削除',
      confirmDeleteChild: 'このメンバーを削除しますか？',
      childDeleted: 'メンバーを削除しました',
      childAdded: 'メンバーを追加しました',
      transferOk: 'メンバーを移動しました（コースも一緒に移動しました）',
      roleSection: '権限を変更',
      roleLabel: '権限',
      applyRole: '権限を保存',
      roleChanged: '権限を変更しました',
      cannotChangeSelf: '自分自身の権限は変更できません',
      accessSection: 'システムアクセス',
      unlockAccess: 'アクセスを解除',
      notRestricted: 'このアカウントは制限されていません',
      accessUnlocked: 'アクセスを解除しました',
      adminStaffBlocked: '管理できるのは保護者アカウントのみです。スタッフアカウントは編集できません。',
    },
    addr: {
      no: '番地／ムー／ソイ／通り',
      noPlaceholder: '例：99/1 Moo 2 Soi Sukhumvit 101',
      search: '住所を検索（町・郡・県または郵便番号）',
      searchPlaceholder: 'タイ語で入力してください。例：「สวนหลวง」、または「10250」のような郵便番号',
      subdistrict: '町（タンボン）',
      district: '郡（アンプー）',
      province: '県',
      postalcode: '郵便番号',
      noResult: '該当なし — 町・郡・県の名前で試してください',
      loading: '住所データを読み込み中...',
      clear: '住所をクリア',
      legacyHint: '以前に保存された住所',
      updateHint: '検索ボックスから町・郡・県を選択し、新しい形式に更新してください',
    },
    forgot: {
      title: 'パスワードをお忘れの方',
      subtitle: '登録済みのユーザー名と電話番号を入力してください',
      username: 'ユーザー名',
      phone: '電話番号',
      otp: 'OTPコード',
      requestOTP: 'OTPを取得',
      submit: '送信',
      cancel: 'キャンセル',
      newPassword: '新しいパスワード',
      confirmPassword: '新しいパスワード（確認）',
      phoneMatchError: '入力したユーザー名と電話番号が一致しません',
      otpInvalid: 'OTPが正しくありません',
      passwordMismatch: 'パスワードが一致しません',
      passwordChangedSuccess: 'パスワードを変更しました',
    },
    editProfile: {
      title: 'ユーザー情報の編集',
      personalInfo: '個人情報',
      email: 'メールアドレス',
      phone: '電話番号',
      address: '住所',
      saveProfile: '情報を保存',
      changePasswordSection: 'パスワードを変更',
      currentPassword: '現在のパスワード',
      newPassword: '新しいパスワード',
      confirmNewPassword: '新しいパスワード（確認）',
      changePasswordBtn: 'パスワードを変更',
      emailRequired: 'メールアドレスを入力してください',
      emailInvalid: 'メールアドレスの形式が正しくありません',
      phoneRequired: '電話番号を入力してください',
      passwordRequired: 'パスワードを入力してください',
      passwordMinLength: 'パスワードは6文字以上で入力してください',
      confirmRequired: 'パスワードを確認のため再入力してください',
      passwordMismatch: 'パスワードが一致しません',
      saveSuccess: '情報を保存しました',
      saveFail: '情報の保存に失敗しました',
      passwordChangeSuccess: 'パスワードを変更しました',
      passwordChangeFail: 'パスワードの変更に失敗しました',
    },
    msg: {
      required: '必須項目をすべて入力してください',
      updated: '更新しました',
      created: '作成しました',
      deleted: '削除しました',
      courseDone: 'コースを終了しました',
      courseDeleted: 'コースを削除しました',
      updateFail: '更新に失敗しました。もう一度お試しください',
      addFail: '追加に失敗しました。もう一度お試しください',
      memberAdded: 'メンバーを追加しました',
      memberAddFail: 'メンバーの追加に失敗しました',
      familyAdded: '家族メンバーを追加しました',
      familyDuplicate: 'この名前は既に家族メンバーに登録されています。管理者にお問い合わせください。',
      familyAddFail: '家族メンバーの追加に失敗しました',
      bookingAdded: '予約を追加しました',
      bookingAddFail: '予約に失敗しました。もう一度お試しください',
      bookingSuccess: 'クラスを予約しました！お待ちしています :)',
      bookingDuplicate: '{date}にはすでに予約があります。別の日を選択してください。',
      noRemaining: '予約できません。残りの回数がありません',
      cannotEditDeleted: '削除済みの生徒は編集できません',
      courseCreated: 'コースを作成しました',
      courseUpdated: 'コース情報を更新しました',
      fileTooLarge: '画像は4MB以下にしてください',
      uploadSuccess: '画像をアップロードしました',
      uploadFail: '画像のアップロードに失敗しました',
      loadFail: 'データの読み込みに失敗しました',
      studentDeleted: '生徒を削除しました',
      studentDeleteFail: '生徒の削除に失敗しました',
      studentListFail: '生徒リストの読み込みに失敗しました',
      reservationDeleted: '予約を削除しました',
      reservationDeleteFail: '予約の削除に失敗しました',
      familyDeleted: '家族メンバーを削除しました',
      familyLoadFail: '家族メンバーの読み込みに失敗しました',
      studentApproved: '生徒を承認しました',
      approveFail: '生徒の承認に失敗しました',
      bothCredsRequired: 'ユーザー名とパスワードの両方を入力してください',
      registerSuccess: '会員登録が完了しました',
      registerFail: '会員登録に失敗しました',
    },
  },
  ko: {
    home: {
      title: '홈',
      familySection: '가족',
      information: '정보',
      courseInfo: '수강권 정보',
      reservation: '예약',
      date: '날짜',
      classTime: '수업 시간',
      noBooking: '아직 예약된 수업이 없습니다',
      selectMember: '상세 정보를 보려면 회원을 선택하세요',
      courseExpired: '수강권이 만료되었습니다!!',
      addFamilyHint: '가족 메뉴에서 가족 구성원을 추가해 주세요',
      monthly: '월정액',
      expired: '만료됨',
      noCourse: '수강권 없음',
      usedUp: '모두 사용',
      bookClass: '수업 예약',
      genderAge: '{gender} · {age}세',
      errorSelectFirst: '가족 구성원을 선택해 주세요',
      errorNoCourse: '예약할 수 없습니다 — 등록된 수강권이 없습니다. 관리자에게 문의해 주세요',
      errorExpired: '예약할 수 없습니다 — 수강권이 만료되었습니다',
      errorNoRemaining: '예약할 수 없습니다 — 남은 수업이 없습니다',
      ageUnit: '{years}년 {months}개월 {days}일',
      remainBadge: '{n}회 남음',
      remainOf: '{n} / {total}회 남음',
      timeLeftLabel: '남은 기간',
      daysValue: '{n}일',
      privateBooking: '프라이빗 레슨 예약',
      noPrivateBooking: '아직 프라이빗 레슨 예약이 없습니다',
      privateBookingWith: '{names}와(과) 함께',
      coachName: '{name} 코치',
    },
    family: {
      title: '가족',
      sectionHeader: '가족 구성원',
      addMember: '가족 구성원 추가',
      confirmDelete: '{name}을(를) 가족에서 삭제하시겠습니까?',
      editSuccess: '구성원 정보가 수정되었습니다',
      editFail: '수정에 실패했습니다',
    },
    btn: {
      ok: '확인',
      cancel: '취소',
      save: '저장',
      delete: '삭제',
      edit: '수정',
      add: '추가',
      close: '닫기',
      confirm: '확인',
      back: '뒤로',
      refresh: '새로고침',
      copy: '복사',
      create: '생성',
      search: '검색',
      newCourse: '새 수강권',
      newBooking: '새 예약',
      newStudent: '새 학생',
      approve: '승인',
      finish: '수강 종료',
      reset: '초기화',
      newClass: '새 수업',
      newHoliday: '새 휴일',
    },
    grid: {
      perPage: '페이지당',
      range: '{total}개 중 {from}–{to}',
    },
    table: {
      profileImage: '프로필 사진',
      courseRef: '수강권 번호',
      courseName: '수강권 이름',
      courseShortName: '약칭',
      courseType: '유형',
      price: '가격',
      startDate: '시작일',
      expireDate: '만료일',
      remaining: '잔여',
      courseUser: '수강권 사용자',
      payment: '결제',
      edit: '수정',
      delete: '삭제',
      finish: '수강 종료',
      name: '이름',
      time: '시간',
      view: '보기',
      history: '수정 이력',
      checkin: '체크인',
      date: '날짜',
      studentId: '학생 ID',
      class: '수업',
      classDay: '수업 요일',
      classTime: '수업 시간',
      maxStudent: '최대 인원',
      gender: '성별',
      age: '나이',
      school: '학교',
      parentUsername: '보호자 아이디',
      phone: '전화번호',
      holidayDate: '휴일 날짜',
      description: '설명',
      nickname: '별명',
      level: 'Level',
      studentInfo: '학생 정보',
      courseUsageHistory: '수강권 사용 내역',
      expired: '만료됨',
      yearAbbr: '년',
      monthAbbr: '개월',
      dayAbbr: '일',
      firstname: '이름',
      middlename: '중간 이름',
      lastname: '성',
      dob: '생년월일',
      shortNote: '메모',
      courseRefer: '수강권 번호',
      continueCourseRefer: '연속 수강권 번호',
      createBy: '생성자',
      createDate: '생성일',
      updateBy: '최종 수정자',
      editDate: '최종 수정일',
      deleteBy: '삭제자',
    },
    role: {
      head: '총괄 매니저',
      admin: '관리자',
      coach: '코치',
      customer: '보호자',
    },
    nav: {
      mainMenu: '메인 메뉴',
      home: '홈',
      family: '가족',
      checkingMenu: '확인 메뉴',
      viewClasses: '수업 일정 보기',
      adminMenu: '관리자 메뉴',
      dashboard: '대시보드',
      insightView: '인사이트',
      opsChecklist: '일일 점검',
      chatbot: 'AI 어시스턴트',
      gymnasts: '체조 선수 목록',
      gymnastsAll: '전체 학생',
      bookingManagement: '수업 예약',
      privateBookingManagement: '프라이빗 예약',
      eventManager: '대회/이벤트',
      customerCourse: '고객 수강권',
      courseHistory: '수강권 이력',
      managementMenu: '관리 메뉴',
      holidays: '휴일 관리',
      accountManagement: '사용자 계정',
      theme: '테마',
      editProfile: '사용자 정보 수정',
      language: '언어: 한국어',
      logout: '로그아웃',
      groupMine: '내 영역',
      groupOverview: '개요',
      groupSchedule: '수업 & 예약',
      groupCoach: '코치',
      groupStudents: '학생', groupCourses: '고객 수강권 관리',
      groupSetup: '설정',
      groupFinance: '재무',
      groupAccount: '계정',
      paymentDocs: '결제 서류',
      financeReport: '매출·재무 보고서',
    },
    auth: {
      loginTitle: '로그인',
      welcome: 'iStar Gymnastics에 오신 것을 환영합니다,',
      welcomeSub: '멋진 하루 되세요 :D...',
      heroTag: '수업 예약・체크인<br />코스 관리<br />한 곳에서 모두',
      heroBlurb: '학부모는 모바일로 자녀의 수업을 예약하고, 관리자는 한 화면에서 일정 확인과 체크인을 할 수 있습니다',
      username: '아이디',
      password: '비밀번호',
      loginBtn: '로그인',
      registerBtn: '회원가입',
      forgotBtn: '비밀번호를 잊으셨나요 ?',
      logoutConfirm: '로그아웃 하시겠습니까 ?',
    },
    common: {
      yes: '예',
      no: '아니오',
      close: '닫기',
      confirm: '확인',
      ok: '확인',
      required: '필수 입력 항목입니다',
      male: '남자',
      female: '여자',
      loading: '로딩 중... 잠시만 기다려 주세요',
      nextCourse: '다음 수강권',
      times: '회',
      noCourseData: '수강권 데이터가 없습니다',
      noStudentData: '학생 데이터가 없습니다',
      noClassData: '수업 데이터가 없습니다',
      noStudentList: '학생 목록이 없습니다',
      invalidDob: '생년월일이 올바르지 않습니다',
      serverError: '서버 통신 오류가 발생했습니다',
      noServerResponse: '서버로부터 응답이 없습니다',
      errorPrefix: '오류',
      hoursUnit: '시간',
    },
    dialog: {
      error: '오류',
      success: '성공',
      selectTheme: '테마 선택',
      themeNote: '선택한 테마는 모든 사용자에게 적용됩니다',
      themeDarkNote: '이 기기는 다크 모드이므로 선택한 테마 대신 다크 팔레트가 표시됩니다. 라이트 모드 기기에서는 테마가 정상적으로 표시됩니다.',
    },
    theme: {
      default: '기본',
      defaultSub: 'iStar 핑크',
      mothersday: '어머니의 날',
      mothersdaySub: '하늘색과 자스민',
      loykrathong: '러이끄라통',
      loykrathongSub: '촛불과 등불',
      newyear: '새해',
      newyearSub: '불꽃놀이와 샴페인 골드',
      songkran: '송끄란',
      songkranSub: '물과 여름 햇살',
      halloween: '핼러윈',
      halloweenSub: '호박과 박쥐',
      christmas: '크리스마스',
      christmasSub: '눈과 조명',
      fathersday: '아버지의 날',
      fathersdaySub: '노란 칸나',
      muaythai: '무에타이',
      muaythaiSub: '빨강, 파랑, 금색',

      saveFailed: '모두에게 테마를 저장하지 못했습니다 — 이 기기에서만 변경되었습니다',
    },
    validation: {
      usernameRequired: '아이디를 입력해 주세요',
      usernameNoSpaces: '아이디에는 공백을 포함할 수 없습니다',
      usernameEnglishOnly: '아이디는 영문자, 숫자, 특수문자만 사용할 수 있습니다',

      usernameHint: '4~20자, 영문·숫자와 . _ - 만 사용',
      passwordRequired: '비밀번호를 입력해 주세요',
      nameRequired: '이름을 입력해 주세요',
      mobileRequired: '휴대폰 번호를 입력해 주세요',
      emailRequired: '이메일을 입력해 주세요',
      emailInvalid: '올바른 이메일 형식이어야 합니다',
      newPasswordRequired: '새 비밀번호를 입력해 주세요',
      newPasswordMaxLength: '새 비밀번호는 10자 이하여야 합니다',
      phoneRequired: '전화번호를 입력해 주세요',
      otpRequired: 'OTP를 입력해 주세요',
      otpLength: 'OTP는 6자리여야 합니다',
    },
    bookingList: {
      classBooking: '수업 예약',
      menuCheckin: '체크인',
      menuUndoCheckin: '체크인 취소',
      menuEdit: '보기 / 수정',
      menuCheckedInBadge: '체크인 완료',
      notCheckedIn: '체크인 안 함',
      legendTrial: '체험 수업',
      legendPerSession: '회당',
      legendPayment: '결제 필요 / 수강권 소진',
      legendBlind: '다른 보호자에게 이름 숨김',
      checkinFail: '체크인에 실패했습니다',
      undoCheckinFail: '체크인 취소에 실패했습니다',
      menuCancel: '예약 취소',
      eventRowNote: '이벤트 행 — 이동/취소는 이벤트 화면에서',
      confirmCancelBooking: '"{name}"의 예약을 취소할까요?',
      cancelBookingFail: '예약 취소에 실패했습니다',
    },
    customerCourse: {
      period: '기간 (개월)',
      payDate: '결제일',
      uploadSlip: '입금 확인증 업로드',
      slipTitle: '입금 확인증',
      viewSlip: '업로드한 확인증 보기',
      doubleBookingNote: '이 수강권은 수강 가능',
      doubleBookingMore: '이상',
      doubleBookingUnit: '1일 1회',
      paid: '결제 완료',
      unpaid: '미결제',
      shortNote: '메모',
      noCourseList: '고객 수강권 목록이 없습니다',
      loadFail: '수강권 정보를 불러오지 못했습니다',
      deleteInUse: '이 수강권은 {names}이(가) 사용 중입니다. 삭제하시겠습니까?',
      priceCatalog: '가격표 관리',
      priceCatalogSub: '새 패키지 생성 시 자동 입력용으로만 사용되며, 이미 판매된 패키지에는 영향을 주지 않습니다',
      priceSaved: '가격이 저장되었습니다',
      noPriceSet: '미설정',
      groupPricing: '그룹 수강권 가격',
      privatePricing: '프라이빗 레슨 가격 (시간당)',
      quantitySessions: '횟수',
      quantityOrPeriod: '수량 (횟수/개월)',
      pricePerHour: '시간당 가격',
      privateType: '프라이빗 유형',
      private1on1: '1:1',
      private2on1: '소그룹 (2:1)',
      private3on1: '소그룹 (3:1)',
      slipVerifyChecking: '확인 결과를 불러오는 중…',
      slipVerifyNone: '이 확인증에 대한 검증 결과가 아직 없습니다',
      slipVerified: '정상 확인증 — 은행 검증 완료',
      slipDuplicate: '중복 확인증 — 이미 사용됨',
      slipAmountMismatch: '확인증 금액이 가격과 일치하지 않습니다',
      slipWrongReceiver: '입금 계좌가 매장 계좌와 일치하지 않습니다',
      slipFailed: '검증 실패 — 읽을 수 없거나 실제 확인증이 아닙니다',
      slipSkipped: '아직 은행 검증을 하지 않았습니다',
      slipReverify: '다시 확인',
      slipReverifying: '확인 중…',
      slipReverifyFail: '재확인에 실패했습니다. 다시 시도해 주세요',
      slipAmount: '금액',
      slipWhen: '이체 시각',
      slipFrom: '보낸 사람',
      slipSaveVerified: '확인증 검증 완료: 정상',
      slipSaveWarn: '저장은 완료되었으나 확인증 검증',
    },
    eventMgr: {
      tab: '대회/이벤트', pageSubtitle: '이벤트 생성, 명단 관리, 당일 체크인', newEvent: '이벤트 만들기', addKidsTitle: '이벤트에 학생 추가', addKids: '학생 추가',

      pastHeadOnly: '지난 이벤트는 매니저만 처리할 수 있습니다',
      step1: '정보', step2: '학생 선택', step3: '검토', step4: '확인',
      date: '날짜', datePh: '대회 날짜 선택', coursePh: '— 코스 선택 —',
      label: '이벤트 이름', labelPh: '예: KAO Cup', labelHint: '이 이름이 대회 당일 예약표의 열 제목이 됩니다', defaultLabel: 'แข่ง',
      pickKids: '참가 학생 검색 및 선택', searchKidPh: '학생 이름 입력…', noKidsYet: '아직 선택된 학생이 없습니다', noMatch: '검색 결과 없음',
      tagTrial: '체험 — 횟수 차감 없음', tagNoCourse: '수강권 없음', tagExpired: '수강권 만료', tagQuotaEmpty: '남은 횟수 없음', tagListed: '명단만 — 차감 없음',
      tagMonthly: '월간권 — 횟수 차감 없음', tagRemaining: '{n}회 남음', tagClockStart: '수강권 유효기간이 대회일부터 시작됩니다', tagAlreadyIn: '이미 이 이벤트에 등록됨 — 건너뜀',
      conflictInfo: '같은 날 정규 수업 예약이 있습니다 ({time})', keepBoth: '기존 예약 유지 (수업 + 대회)', moveBooking: '기존 예약을 대회로 이동 (추가 차감 없음)',
      modeDeduct: '수강권 횟수 차감', modeList: '명단만 등록·차감 없음 (참가비 별도/수강권 없음)',
      sumDeduct: '횟수 차감: {n}명', sumList: '명단만: {n}명', sumMove: '예약 이동: {n}명',
      back: '이전', next: '다음', create: '이벤트 저장',
      kids: '인원', roster: '명단', checkedinShort: '체크인', undoCheckin: '체크인 취소', removeKid: '제외 (횟수 반환)',
      confirmTitle: '확인', confirmRemove: '{name}을(를) 이벤트에서 제외할까요? 예약이 취소되고 횟수는 정상적으로 반환됩니다.',
      confirmDelete: '이벤트 "{name}"을(를) 삭제할까요?', deleteBlockedHint: '명단이 비어 있을 때만 삭제 가능', renameTitle: '이벤트 이름 변경',
    },
    bookingMgmt: {
      title: '수업 예약',
      tabBooking: '수업 예약',
      viewByDate: '날짜별 수업 예약 보기',
      allBookingsToday: '전체 수업 예약',
      noBooking: '예약 없음',
      confirmDelete: '{name}의 예약을 삭제하시겠습니까?',
      confirmCheckin: '{name}을(를) 체크인하시겠습니까?',
      confirmUndoCheckin: '{name}의 체크인을 취소하시겠습니까?',
      freeClass: '무료 체험',
      courseInfoMonthly: '수강권 번호: {ref} · 만료: {expiry} · 월정액',
      courseInfoLimited: '수강권 번호: {ref} · 만료: {expiry} · {remaining}회 남음',
      noCourse: '이 학생은 등록된 수강권이 없습니다',
      bookingInfoTitle: '예약 정보',
      createBy: '예약자',
      createDate: '예약 시각',
      updateBy: '수정자',
      editDate: '수정 시각',
      visibility: '이름 표시',
      visPrivate: '비공개 (숨김)',
      visPublic: '공개',
      blindBooking: '다른 보호자에게 이름 숨기기',
    },
    courses: {
      newCourse: '새 수강권',
      editCourse: '수강권 수정',
      confirmDelete: '이 수강권을 삭제하시겠습니까?',
    },
    holidays: {
      title: '휴일 관리',
      description: '휴일을 추가하면 보호자는 해당 날짜에 수업을 예약할 수 없습니다.',
      ourHolidays: '전체 휴일',
      newHoliday: '새 휴일',
      editHoliday: '휴일 수정',
      confirmDelete: '휴일 {date}을(를) 삭제하시겠습니까?',
      holidayDate: '휴일 날짜',
      holidayDescription: '설명',
    },
    gymnasts: {
      title: '체조 선수 관리',
      listTitle: '체조 선수 목록',
      addStudent: '새 학생 추가',
      editStudent: '학생 수정',
      confirmDelete: '이 학생을 삭제하시겠습니까?',
      confirmFinish: '수강을 종료하고 이력을 보관하시겠습니까?',
      filterStatus: '상태',
      statusAll: '모든 상태',
      statusActive: '유효한 수강권 있음',
      statusNoCourse: '수강권 없음/만료',
      filterGender: '성별',
      genderAll: '모든 성별',
      filterCourse: '수강권',
      courseAll: '모든 수강권',
    },
    learningHistory: {
      title: '학생 정보 + 수업 이력',
      tableTitle: '수업 이력 (그룹 + 프라이빗)',
      currentCourse: '현재 수강권',
      noCourse: '수강권 없음',
      monthly: '월간',
      sumTotal: '전체',
      sumGroup: '그룹',
      sumPrivate: '프라이빗',
      sumFree: '무료',
      colType: '유형',
      colCoach: '코치',
      typeGroup: '그룹',
      typePrivate: '프라이빗',
      typeEvent: '대회',
      badgeFree: '무료',
      badgeWalkin: '단회',
      noHistory: '수업 이력이 없습니다',
      loadFail: '수업 이력을 불러오지 못했습니다',
    },
    approve: {
      title: '신규 학생 요청',
      confirmApprove: '{count}명의 학생을 승인하시겠습니까?',
      confirmDelete: '이 학생을 삭제하시겠습니까?',
      noData: '승인 대기 중인 신규 학생이 없습니다',
      selectAtLeastOne: '승인할 학생을 최소 1명 선택해 주세요',
    },
    viewClasses: {
      title: '수업 일정 보기',
      viewByDate: '날짜별 수업 예약 보기',
    },
    privateBooking: {
      title: '프라이빗 레슨 일정',
      addNew: '프라이빗 예약 추가',
      editTitle: '프라이빗 예약 수정',
      groupClassOption: '그룹 수업 예약',
      privateClassOption: '프라이빗 레슨 예약',
      noBooking: '오늘 프라이빗 레슨 예약이 없습니다',
      coach: '코치',
      type: '유형',
      startTime: '시작 시간',
      endTime: '종료 시간',
      student1: '학생 1',
      student2: '학생 2',
      student3: '학생 3',
      students: '학생',
      hours: '시간',
      price: '가격',
      note: '메모',
      othersCount: '외 {n}명',
      menuCancel: '예약 취소',
      cancelConfirm: '{name} 코치와의 이 예약을 취소하시겠습니까?',
      cancelSuccess: '예약이 취소되었습니다',
      cancelFail: '예약 취소에 실패했습니다. 다시 시도해 주세요',
      invalidClasstime: '시간 형식이 올바르지 않습니다 — 수업 시간을 다시 선택해 주세요',
      managementTitle: '프라이빗 예약',
      viewByPeriod: '기간별 보기',
      viewSubtitle: '날짜를 눌러 해당 날짜를 보거나 한 달 전체로 전환하세요',
      periodDay: '일',
      periodMonth: '월',
      today: '오늘',
      markLegend: '예약이 있는 날',
      bookingsInMonth: '이번 달 예약',
      rangeSummary: '예약 {count}건 · 코치 {coaches}명 · {days}일',
    },
    courseHistory: {
      title: '고객 수강권 이력',
      ourCourses: '고객 수강권',
      courseInfo: '수강권 정보',
      courseRefer: '수강권 번호',
    },
    reservation: {
      title: '예약',
      bookingFor: '{name}의 예약',
      confirmBooking: '{name}의 {date} {time} 수업을 예약하시겠습니까?',
      confirmBtn: '예약하기!',
      noClassTime: '예약 가능한 수업 시간이 없습니다',
      blindName: '다른 보호자에게 이름 숨기기',
      blindNameHint: '자녀의 이름이 다른 보호자의 수업 시간표에서 흐리게 표시됩니다',
      blindBadge: '비공개',
    },
    groupbooking: {
      title: '여러 자녀 함께 예약',
      subtitle: '수업을 한 번 선택해 여러 자녀를 함께 예약하세요',
      entryBtn: '단체 예약 시작',
      entryNew: '신규',
      stepCourse: '수업 유형 선택',
      stepDate: '날짜 선택',
      stepTime: '시간대 선택',
      stepKids: '예약할 자녀 선택',
      kidsEligible: '{n}명 예약 가능',
      pickCourseFirst: '먼저 수업 유형을 선택하세요',
      pickSlotFirst: '자녀를 선택하기 전에 날짜와 시간대를 선택하세요',
      notThisCourse: '다른 수업 유형',
      expired: '수강권 만료',
      usedUp: '남은 횟수 없음',
      alreadyBooked: '오늘 이미 예약됨',
      sharedShort: '횟수 부족 (공유 수강권)',
      seatShort: '좌석 부족',
      monthly: '월정액',
      remainN: '{n}회 남음',
      summary: '{n}명 선택 · {seats}석 이용 가능',
      bookBtn: '{n}명 예약',
      confirmTitle: '{n}명 예약 확인',
      afterRemain: '{a} → {b} 남음',
      allOrNothingNote: '모든 자녀를 함께 예약합니다 — 한 명이라도 실패하면 아무도 예약되지 않습니다.',
      successMsg: '{n}명 모두 예약이 완료되었습니다',
    },
    dashboard: {
      title: '대시보드',
      subtitle: '체조 수업 관리 개요',
      btnPlaceholder: '이 버튼은 용도가 필요합니다 — 제안이 있으시면 알려주세요!',
      totalGymnasts: '전체 체조 선수',
      activeGymnasts: '활동 중인 선수',
      todayBooking: "오늘의 예약",
      tomorrowBooking: "내일의 예약",
      vsLastWeek: "지난주 대비",
      studentsUnit: '학생',
      bookingsUnit: '예약',
    },
    finance: {
      title: '매출·재무 보고서',
      subtitle: '판매된 패키지 금액, 수금액, 미수금, 그리고 남은 수업 의무',
      statsSinceBadge: '{date}부터 집계',
      statsSinceNote: '이 리포트는 {date}부터 통계를 집계합니다 — 미수금, 선수금(남은 수업 의무), 데이터 완전성을 포함해 이 페이지의 모든 수치는 해당 날짜 이후 데이터만 반영합니다. 그 이전에 판매되어 아직 미납인 패키지는 고객 코스 화면에서 확인하세요.',
      presetBeforeStats: '이 기간은 집계 시작일 {date} 이전이라 표시할 데이터가 없습니다.',
      managerOnly: '매니저 전용',
      exportCsv: 'CSV 다운로드',
      permissionDenied: '이 보고서에 접근할 권한이 없습니다',
      fromDate: '시작일',
      toDate: '종료일',
      sectionFlow: '선택 기간의 변동',
      sectionStock: '오늘 기준 잔액',
      sectionTrend: '월별 매출',
      sectionReceivables: '연령별 미수금',
      sectionPrivateCoach: '프라이빗 레슨 (코치별)',
      privateCoachHint: '실제 수업일 기준 · 금액은 수수료를 포함한 고객 결제액입니다',
      noPrivateInRange: '선택한 기간에 프라이빗 레슨이 없습니다',
      privSessions: '레슨 수',
      privHours: '시간',
      privRevenue: '수업 합계',
      privCollected: '입금 완료',
      privUnpaidInRange: '미납 (선택한 기간만)',
      privRatePerHour: '시간당 평균',
      privFeeUnknown: '신용카드로 결제했지만 수수료를 알 수 없는 레슨이 {n}건 있습니다. 실제 금액은 더 높을 수 있습니다',
      privPriceUnknown: '가격이 입력되지 않은 레슨이 {n}건 있어 실제 수익은 표시보다 높습니다',
      privLoadError: '이 섹션을 불러오지 못했습니다',
      privLoadRetry: '다시 시도',
      privNotProfit: '이는 매출이며 이익이 아닙니다 — 코치 보수 등 비용은 차감되지 않았습니다. "미납"은 선택한 기간의 레슨만 집계하므로, 오늘 기준 전체 기간을 집계하는 위의 "프라이빗 미수금" 카드와 다릅니다.',
      viewByMonth: '월별',
      viewByCoach: '코치별',
      viewByType: '유형별',
      colMonth: '월',
      colPrivateType: '유형',
      sectionDataQuality: '데이터 완전성',
      asOfToday: '기준일',
      salesTile: '매출 (판매된 패키지 금액)',
      collectedNetTile: '순 입금액',
      collectedTile: '입금액',
      vatTile: '수금액에 포함된 VAT {pct}%',
      vatFrom: '고객이 실제 지불한 {amount} ฿ 기준, 수수료 미차감 (부가세 포함 가격을 7/107로 산출)',
      vatSeeCollected: '일별로 보려면 "입금액" 카드를 여세요(동일 기준).',
      salesParts: '코스 {course} ฿ + 수수료 {fee} ฿',
      collectedFeeIncluded: '카드 수수료 {fee} ฿ 포함 (체육관 수입)',
      clickDetail: '클릭하여 상세 보기',
      clickGoTable: '미수금 표로 이동',
      legendCourse: '코스 요금',
      legendGrossAll: '고객 결제 총액 (전액 입금)',
      colIntoAccount: '입금',
      colFeePart: '그중 수수료',
      colDate: '날짜',
      colItem: '항목',
      colCourseAmount: '코스 요금',
      colVatInAmount: '포함 VAT',
      colStatus: '상태',
      colMethod: '결제 방법',
      colSessions: '수업 횟수',
      colUnitPrice: '회당 단가',
      colRemaining: '남은 횟수',
      colExpire: '만료일',
      paidYes: '결제 완료', flagYes: '예',
      paidNo: '미결제',
      detailTotal: '{count}건 — 합계',
      receivablePrivateTile: 'Private 미수금 (미결제)',
      receivablePrivateCount: '{count}회',
      receivablePrivateTaught: '수업 완료했으나 미수금 {count}회 · {amount} ฿',
      colDay: '날짜',
      colDayCount: '건수',
      colCoach: '코치',
      colTaughtStatus: '수업 상태',
      taughtUnpaid: '수업 완료, 미결제',
      notYetTaught: '수업 전',
      backToDaily: '일별 요약으로 돌아가기',
      detailTotalDays: '{days}일 · {count}건 — 합계',
      earnedTile: '진행된 수업 기준 수익',
      receivableTile: '미수금 (미납)',
      deferredTile: '선수금 (미진행 수업)',
      breakageTile: '만료된 미사용 횟수 (30일)',
      vsPrevPeriod: '이전 기간 대비',
      avgPerPackage: '평균',
      paidAmount: '고객 지불',
      feeAmount: '수수료',
      ofSales: '매출 대비',
      unitPackages: '건',
      unitDays: '일',
      unitTimes: '회',
      estimatedPart: '추정 {amount} ฿ 포함 ({count}건)',
      missingPriceWarn: '{count}건 가격 미입력 — 목록 보기',
      feeUnknownWarn: '카드 결제 {count}건의 수수료 미상',
      earnedFrom: '진행된 {sessions}회 기준',
      earnedUnpriceable: '{sessions}회는 금액 산정 불가 (월정액/가격 미상)',
      receivableUsed: '{count}건은 미납 상태로 수업을 받음',
      deferredSessions: '{sessions}회 남음',
      deferredProgress: '판매 {sold} ฿ · 제공 완료 {delivered} ฿({pct}%)',
      salesUnpaid: '이 중 미수금 {amount} ฿({count}건)',
      colUsedOfTotal: '사용 / 전체',
      colDeliveredPct: '제공 완료',
      deferredExpiring: '{amount} ฿ 30일 내 만료',
      deferredMonthlyExcluded: '월정액 {count}건 제외 (회당 산정 불가)',
      breakageDetail: '{count}건 총 {sessions}회 — 결제했으나 미사용',
      legendActual: '실제 가격',
      legendEstimated: '표준가 기준 추정',
      legendCollected: '순 입금',
      legendNet: '실제 입금',
      legendFee: '결제 수수료',
      legendGross: '고객 결제 총액',
      legendVat: '점선 = 고객 결제액에 포함된 VAT {pct}%',
      legendCollectedEstimated: '입금 (추정 가격 기준)',
      showEstimates: '과거 추정값 표시',
      eraBefore: '가격 미기록',
      eraAfter: '실제 가격 기록됨',
      trendNoteRealOnly: '그래프는 위에서 선택한 기간과 무관하게 항상 달력 월 단위로 표시합니다 — 기록된 실제 가격만 판매일 기준으로 집계하며, 리포트 범위에 맞춰 {date}부터 시작합니다. 초록 + 주황의 합이 고객 결제 총액(= 입금액)입니다. 막대를 클릭하면 해당 월의 명세를 볼 수 있습니다.',
      trendNote: '{date}부터 판매 가격 입력이 필수가 되었습니다. 그 이전에 가격이 기록되지 않은 패키지는 현재 표준가로 추정합니다(점선 막대). 실선 막대는 기록된 실제 가격입니다. 추세 파악에는 쓸 수 있으나 추정 부분은 회계 수치로 사용하지 마세요.',
      byProgram: '프로그램별',
      byMethod: '결제 수단별',
      priceAndDiscount: '가격과 할인',
      colPaid: '지불액',
      colFee: '수수료',
      colNet: '순액',
      methodUnspecified: '미지정',
      methodPrivate: '프라이빗 수업 (결제 수단 미입력)',
      promoPackages: '프로모션 패키지',
      totalDiscount: '총 할인액',
      avgDiscountPct: '표준가 대비 평균 할인',
      comparedAgainstList: '비교 가능',
      aging0: '30일 이내',
      aging31: '31–60일',
      aging61: '61–90일',
      aging90: '90일 초과',
      colStudents: '학생',
      colPhone: '보호자 연락처',
      colCourse: '코스',
      colAmount: '금액',
      colOverdue: '연체',
      colUsedUnpaid: '수업 진행',
      colRefer: '패키지 번호',
      colCreated: '생성일',
      colSuggested: '권장 표준가',
      unknownPrice: '가격 미상',
      noReceivables: '미수금 없음',
      noData: '데이터 없음',
      viewList: '목록 보기',
      dqPriceActual: '실제 가격이 있는 패키지',
      dqMissingPrice: '가격 미입력',
      dqEstimated: '추정 가격 사용',
      dqUnknownPrice: '가격 미상 (추정 불가)',
      unknownPriceWarn: '{count}건 더 가격 미상 — 실제 금액은 표시보다 큽니다',
      unknownPriceExcluded: '가격 미상 {count}건 제외',
      deferredUnknownExcluded: '가격 미상 {count}건({sessions}회) 제외',
      dqFeeUnknown: '카드 수수료 미상',
      dqNoPaydate: '결제됨, 결제일 없음',
      dqMonthly: '월정액 산정 불가',
      missingPriceTitle: '가격이 입력되지 않은 패키지',
      missingPriceSub: '{date} 이후 생성 — 가격을 채우면 보고서가 즉시 정확해집니다',
      notProfitNote: '모든 수치는 스튜디오가 받은 수익이며 이익이 아닙니다 — 시스템은 비용이나 코치 보수를 기록하지 않습니다.',
      preset: { thisMonth: '이번 달', lastMonth: '지난달', last3Months: '3개월', thisYear: '올해', custom: '직접 지정' },
    },
    insightView: {
      title: '인사이트',
      subtitle: '주간 요약 + 후속 관리가 필요한 보호자',
      generateBtn: '새 리포트 생성',
      generating: '생성 중...',
      generateSuccess: '새 리포트가 생성되었습니다',
      generateFail: '리포트 생성에 실패했습니다',
      historyTitle: '이력',
      emptyReports: '아직 리포트가 없습니다',
      newStudentsTile: '신규 학생 (최근 달)',
      packagesSoldTile: '판매된 패키지 (최근 달) — 금액 기준 매출 아님',
      vsPrevMonth: '전월 대비',
      showMonthly: '월별 데이터 보기',
      hideMonthly: '월별 데이터 숨기기',
      unitPeople: '명',
      unitPackages: '건',
      winBackTitle: '다시 초대할 보호자',
      atRiskTitle: '만료 전 잔여 횟수를 다 못 쓸 위험',
      opsLinkTitle: '조치 목록은 「일일 점검」 페이지로 이동했습니다',
      opsLinkBody: '미납 · 잔여 부족 · 구매 후 미사용 · 만료됐지만 횟수 남음 — 그곳에서 실시간 데이터를 확인할 수 있습니다(이 페이지는 리포트 생성 시점의 스냅샷입니다).',
      opsLinkBtn: '일일 점검 열기',
      colNickname: '별명',
      colMobile: '휴대폰',
      colEndedOn: '패키지 종료일',
      colDaysLapsed: '경과 일수',
      colCourse: '수강권',
      colRef: '수강권 번호',
      colStudents: '학생',
      colPhones: '휴대폰',
      colRemaining: '잔여 (횟수)',
      colExpiredate: '만료일',
      colDaysLeft: '남은 일수',
    },
    addFamily: {
      title: '구성원 추가',
      firstname: '이름',
      middlename: '중간 이름',
      lastname: '성',
      nickname: '별명',
      school: '학교',
      gender: '성별',
      dob: '생년월일',
      submit: '저장',
      clear: '지우기',
      errorRequired: '모든 필수 항목을 입력해 주세요',
    },
    register: {
      title: '회원가입',
      username: '아이디',
      password: '비밀번호',
      firstname: '이름',
      middlename: '중간 이름',
      lastname: '성',
      address: '주소',
      email: '이메일',
      mobile: '휴대폰 번호',
      code: '가입 코드',
      privacyConsent: '아래 내용을 읽고 동의함을 확인합니다',
      privacyPolicy: '개인정보 처리방침',
      privacyOf: 'iStar Gymnastics의',
      submit: '제출',
      clear: '지우기',
      cancel: '취소',
    },
    accountMgmt: {
      listTitle: '사용자 계정',
      subtitle: '검색, 수정, 비밀번호 재설정, 가족 관리, 권한 설정',
      editUser: '사용자 계정 수정',
      username: '아이디',
      fullname: '전체 이름',
      mobileno: '휴대폰',
      roleCol: '권한',
      province: '지역',
      status: '상태',
      active: '정상',
      restricted: '제한됨',
      noUsers: '사용자를 찾을 수 없습니다',
      roleAll: '모든 권한',
      loadFail: '사용자 목록을 불러오지 못했습니다',
      saveFail: '작업에 실패했습니다',
      tabPersonal: '개인 정보',
      tabPassword: '비밀번호',
      tabFamily: '가족 구성원',
      tabPermissions: '권한',
      personalSection: '사용자 정보',
      contactSection: '연락처',
      addressSection: '주소',
      firstname: '이름',
      middlename: '중간 이름',
      lastname: '성',
      email: '이메일',
      savedProfile: '사용자 정보가 저장되었습니다',
      passwordSection: '새 비밀번호 설정',
      newPassword: '새 비밀번호',
      confirmPassword: '새 비밀번호 확인',
      resetPasswordBtn: '비밀번호 재설정',
      pwMismatch: '두 비밀번호가 일치하지 않습니다',
      pwResetOk: '비밀번호가 재설정되었습니다',
      pwSessionNote: '재설정은 즉시 적용되지만, 현재 로그인 중인 사용자는 세션이 만료될 때까지 로그인 상태가 유지되며 즉시 강제 종료할 수 없습니다.',
      familySection: '가족 구성원',
      childName: '구성원',
      childCourse: '수강권',
      transferTo: '다른 가족으로 이동',
      searchFamily: '이동할 가족의 아이디를 입력하세요…',
      chooseFamily: '— 이동할 가족 선택 —',
      addChild: '구성원 추가',
      nickname: '별명',
      gender: '성별',
      dob: '생년월일',
      pending: '대기 중',
      noChildren: '아직 이 가족에 구성원이 없습니다',
      deleteChildTitle: '구성원 삭제',
      confirmDeleteChild: '이 구성원을 삭제하시겠습니까?',
      childDeleted: '구성원이 삭제되었습니다',
      childAdded: '구성원이 추가되었습니다',
      transferOk: '구성원이 이동되었습니다 (수강권도 함께 이동됨)',
      roleSection: '권한 변경',
      roleLabel: '권한',
      applyRole: '권한 저장',
      roleChanged: '권한이 변경되었습니다',
      cannotChangeSelf: '자신의 권한은 변경할 수 없습니다',
      accessSection: '시스템 접근',
      unlockAccess: '접근 잠금 해제',
      notRestricted: '이 계정은 제한되어 있지 않습니다',
      accessUnlocked: '접근이 잠금 해제되었습니다',
      adminStaffBlocked: '보호자 계정만 관리할 수 있으며, 직원 계정은 수정할 수 없습니다.',
    },
    addr: {
      no: '번지 / 무 / 소이 / 도로',
      noPlaceholder: '예: 99/1 Moo 2 Soi Sukhumvit 101',
      search: '주소 검색 (동, 구, 도, 또는 우편번호)',
      searchPlaceholder: '태국어로 입력하세요, 예: "สวนหลวง", 또는 "10250" 같은 우편번호',
      subdistrict: '동/읍',
      district: '구/군',
      province: '도',
      postalcode: '우편번호',
      noResult: '일치하는 결과가 없습니다 — 동, 구, 또는 도 이름으로 검색해 보세요',
      loading: '주소 데이터를 불러오는 중...',
      clear: '주소 지우기',
      legacyHint: '이전에 저장된 주소',
      updateHint: '새 형식으로 업데이트하려면 검색창에서 동/구/도를 선택해 주세요',
    },
    forgot: {
      title: '비밀번호 찾기',
      subtitle: '등록한 아이디와 전화번호를 입력하세요',
      username: '아이디',
      phone: '전화번호',
      otp: 'OTP 비밀번호',
      requestOTP: 'OTP 요청',
      submit: '제출',
      cancel: '취소',
      newPassword: '새 비밀번호',
      confirmPassword: '새 비밀번호 확인',
      phoneMatchError: '입력한 아이디와 전화번호가 일치하지 않습니다',
      otpInvalid: 'OTP가 올바르지 않습니다',
      passwordMismatch: '비밀번호가 일치하지 않습니다',
      passwordChangedSuccess: '비밀번호가 변경되었습니다',
    },
    editProfile: {
      title: '사용자 정보 수정',
      personalInfo: '개인 정보',
      email: '이메일',
      phone: '전화번호',
      address: '주소',
      saveProfile: '정보 저장',
      changePasswordSection: '비밀번호 변경',
      currentPassword: '현재 비밀번호',
      newPassword: '새 비밀번호',
      confirmNewPassword: '새 비밀번호 확인',
      changePasswordBtn: '비밀번호 변경',
      emailRequired: '이메일을 입력해 주세요',
      emailInvalid: '올바르지 않은 이메일 형식입니다',
      phoneRequired: '전화번호를 입력해 주세요',
      passwordRequired: '비밀번호를 입력해 주세요',
      passwordMinLength: '비밀번호는 최소 6자 이상이어야 합니다',
      confirmRequired: '비밀번호를 확인해 주세요',
      passwordMismatch: '비밀번호가 일치하지 않습니다',
      saveSuccess: '정보가 저장되었습니다',
      saveFail: '정보 저장에 실패했습니다',
      passwordChangeSuccess: '비밀번호가 변경되었습니다',
      passwordChangeFail: '비밀번호 변경에 실패했습니다',
    },
    msg: {
      required: '모든 필수 항목을 입력해 주세요',
      updated: '수정되었습니다',
      created: '생성되었습니다',
      deleted: '삭제되었습니다',
      courseDone: '수강이 종료되었습니다',
      courseDeleted: '수강권이 삭제되었습니다',
      updateFail: '수정에 실패했습니다. 다시 시도해 주세요',
      addFail: '추가에 실패했습니다. 다시 시도해 주세요',
      memberAdded: '구성원이 추가되었습니다',
      memberAddFail: '구성원 추가에 실패했습니다',
      familyAdded: '가족 구성원이 추가되었습니다',
      familyDuplicate: '이 이름은 이미 가족 구성원으로 등록되어 있습니다. 관리자에게 문의해 주세요.',
      familyAddFail: '가족 구성원 추가에 실패했습니다',
      bookingAdded: '예약이 추가되었습니다',
      bookingAddFail: '예약에 실패했습니다. 다시 시도해 주세요',
      bookingSuccess: '수업 예약 완료! 그때 만나요 :)',
      bookingDuplicate: '{date}에 이미 예약이 있습니다. 다른 날짜를 선택해 주세요.',
      noRemaining: '예약할 수 없습니다 — 남은 수업이 없습니다',
      cannotEditDeleted: '삭제된 학생은 수정할 수 없습니다',
      courseCreated: '수강권이 생성되었습니다',
      courseUpdated: '수강권이 수정되었습니다',
      fileTooLarge: '이미지는 4MB를 초과할 수 없습니다',
      uploadSuccess: '이미지가 업로드되었습니다',
      uploadFail: '이미지 업로드에 실패했습니다',
      loadFail: '데이터를 불러오지 못했습니다',
      studentDeleted: '학생이 삭제되었습니다',
      studentDeleteFail: '학생 삭제에 실패했습니다',
      studentListFail: '학생 목록을 불러오지 못했습니다',
      reservationDeleted: '예약이 삭제되었습니다',
      reservationDeleteFail: '예약 삭제에 실패했습니다',
      familyDeleted: '가족 구성원이 삭제되었습니다',
      familyLoadFail: '가족 구성원을 불러오지 못했습니다',
      studentApproved: '학생이 승인되었습니다',
      approveFail: '학생 승인에 실패했습니다',
      bothCredsRequired: '아이디와 비밀번호를 모두 입력해 주세요',
      registerSuccess: '회원가입이 완료되었습니다',
      registerFail: '회원가입에 실패했습니다',
    },
  },
}

// ---------------------------------------------------------------------------
// i18n additions — keys for UI text that used to be hardcoded Thai in components
// (placeholders, dialog titles, buttons, calendar tooltips, page subtitles, …).
// Kept in one block and merged into `messages` so the big tree above stays intact.
// Generic strings live under `common.*` so many components share one key.
// ---------------------------------------------------------------------------
const extraMessages = {
  th: {
    common: {
      select: '— เลือก —', selectCourse: '— เลือกคอร์ส —', selectStudent: '— เลือกนักเรียน —',
      selectClassTime: '— เลือกรอบเวลา —', selectCoach: '— เลือกครูผู้สอน —', selectType: '— เลือกประเภท —',
      selectStartTime: '— เลือกเวลาเริ่ม —', selectEndTime: '— เลือกเวลาสิ้นสุด —',
      selectDate: 'เลือกวันที่', selectDob: 'เลือกวันเกิด', confirmDeleteTitle: 'ยืนยันการลบ',
      noData: 'ไม่พบข้อมูล', noResults: 'ไม่พบข้อมูลที่ค้นหา', searchPlaceholder: 'ค้นหา...',
      noAccess: 'ไม่มีสิทธิ์เข้าถึงหน้านี้',
      sessionExpired: 'หมดเวลาการใช้งาน กรุณาเข้าสู่ระบบใหม่',
      reservationFailed: 'จองไม่สำเร็จ กรุณาลองใหม่อีกครั้ง',
      coachLeaveConfirmTitle: 'โค้ชมีใบลาวันดังกล่าว',
      privateConflictTitle: 'มีคาบ Private ในช่วงลา',
    },
    reservation: {
      subtitle: 'เลือกวันที่ก่อน แล้วจึงเลือกรอบเวลา', stepTime: 'เลือกรอบเวลา',
      pickDateFirst: 'กรุณาเลือกวันที่ทางซ้ายก่อน<br />จึงจะเลือกรอบเวลาเรียนได้',
      slotsOf: 'รอบเวลาของ', full: 'เต็มแล้ว', unavailable: 'ไม่พร้อมให้บริการ', available: 'ว่าง {n}', bookThisSlot: 'จองรอบนี้',
      bookCutoff: 'จองคลาสของวันนี้ได้ถึง 08:00 น. หลังจากนั้นจองได้ตั้งแต่วันพรุ่งนี้เป็นต้นไป',
      advanceNotice: 'แนะนำให้จองล่วงหน้าอย่างน้อย 1 วัน เพื่อให้โค้ชทราบรายชื่อและจำนวนเด็กที่จะเข้าเรียน และเตรียมแผนการสอนได้อย่างเหมาะสม โค้ชจะได้ดูแลเด็ก ๆ อย่างเต็มที่ในทุกคลาสเรียนนะคะ',
      advanceNoticeCutoff: 'สามารถจองคลาสได้จนถึงเวลา 08:00 น. ของวันที่ต้องการจอง',
      modeSingle: 'จองวันเดียว', modeMulti: 'จองหลายวัน',
      multiHint: 'แตะวันที่ในปฏิทินเพื่อเลือก/เอาออก ได้หลายวัน',
      multiCount: 'เลือกแล้ว {n} วัน (สูงสุด {max} วัน)',
      stepTimeMulti: 'เลือกรอบเวลาของแต่ละวัน',
      pickDatesFirst: 'เลือกวันที่จากปฏิทินก่อน เลือกได้หลายวัน',
      pickSlot: 'ยังไม่ได้เลือกรอบ', removeDay: 'เอาวันนี้ออก',
      multiSummary: 'เลือก {n} วัน',
      multiSummaryUse: 'จะใช้ {n} ครั้ง (คงเหลือ {a} → {b})',
      multiBookBtn: 'ยืนยันการจอง {n} วัน',
      multiConfirmTitle: 'ยืนยันการจอง {n} วัน',
      multiAllOrNothing: 'ระบบจะบันทึกก็ต่อเมื่อจองได้ครบทุกวันเท่านั้น หากวันใดจองไม่ได้ จะยังไม่จองให้เลยและแจ้งเหตุผล',
      multiSuccess: 'จองคลาสสำเร็จทั้ง {n} วัน',
      multiPickAll: 'กรุณาเลือกรอบเวลาให้ครบทุกวัน',
      multiMax: 'เลือกได้สูงสุด {n} วัน',
    },
    groupbooking: { selectedSlot: 'รอบที่เลือก', selectThisSlot: 'เลือกรอบนี้' },
    customerCourse: { allTypes: 'ประเภททั้งหมด', allPayments: 'การชำระทั้งหมด', autoGenerated: '(สร้างอัตโนมัติ)',
      paymentMethod: 'วิธีการชำระเงิน', selectPayment: '— เลือกวิธีชำระเงิน —',
      paymentCash: 'เงินสด', paymentTransfer: 'เงินโอน', paymentCredit: 'บัตรเครดิต',
      paymentFee: 'ค่าธรรมเนียมการชำระเงิน',
      paymentFeeEditBtn: 'แก้ค่าธรรมเนียมเอง',
      paymentFeeResetBtn: 'คืนค่าที่ระบบคำนวณ',
      paymentFeeAutoHint: 'ระบบคำนวณให้อัตโนมัติ {pct}% ของราคา',
      paymentFeeNoneHint: 'วิธีชำระเงินนี้ไม่มีค่าธรรมเนียม',
      paymentFeeManualHint: 'แก้เอง — ระบบคำนวณได้ {amount} ฿',
      paymentFeeConfirmTitle: 'แก้ค่าธรรมเนียมเอง?',
      paymentFeeConfirmBody: 'ระบบคำนวณค่าธรรมเนียมให้แล้วเป็น {amount} ฿ ต้องการแก้เองใช่ไหม',
      paymentFeeConfirmOk: 'ใช่ แก้เอง',
      promotion: 'คอร์สโปรโมชั่นพิเศษ', promotionBadge: 'โปรโมชั่น', allPromotions: 'โปรโมชั่นทั้งหมด', notPromo: 'ไม่ใช่โปรโมชั่น',
      slipVerifyNote: 'จะตรวจสอบกับ Thunder อัตโนมัติ', slipStoreNote: 'เก็บรูปไว้เป็นหลักฐาน (ไม่ตรวจสอบอัตโนมัติ)', slipNeedPaid: 'ติ๊ก "จ่ายแล้ว" ก่อน จึงจะอัปโหลดสลิปได้', unlimited: 'ไม่จำกัด' },
    bookingMgmt: { searchStudentPlaceholder: 'พิมพ์ชื่อนักเรียน…',
      cancelNeedsUndo: 'เช็คชื่อแล้ว — ต้องยกเลิกเช็คชื่อก่อนจึงจะยกเลิกการจองได้',
      cancelAskManager: 'ผ่านมาเกิน 3 วันแล้ว — แจ้งผู้จัดการเพื่อตรวจสอบก่อนยกเลิก',
      perSessionToggle: 'เรียนรายครั้ง (ระบบสร้างแพ็กเกจ 1 ครั้งให้อัตโนมัติ)',
      perSessionHasMainCourse: 'เด็กมีคอร์สติดตัวอยู่แล้ว — การจองรายครั้งจะไม่หักครั้งจากคอร์สหลัก',
      perSessionPaidCancelTitle: 'การจองนี้ชำระเงินแล้ว',
      perSessionPaidCancelBody: 'การจองนี้ได้รับการชำระเงินแล้ว การยกเลิกจะลบใบซื้อรายครั้ง {refer} ออกจากระบบด้วย และยอดนี้จะไม่ถูกนับในรายงานการเงิน ยืนยันยกเลิกจริงหรือไม่?',
    },
    approve: { subtitle: 'รายการรอตรวจสอบ', approveBtn: 'อนุมัติ', rejectBtn: 'ปฏิเสธ' },
    holidays: { subtitle: 'วันที่ปิดทำการ', holidayInfo: 'ข้อมูลวันหยุด' },
    dup: {
      title: 'อาจเป็นเด็กคนเดียวกัน', subtitle: 'ตรวจสอบก่อนสร้างใหม่',
      intro: 'พบนักเรียนที่ข้อมูลตรงกัน {n} คน — ถ้าเป็นคนเดียวกัน ให้ย้ายเข้าครอบครัวนี้แทนการสร้างใหม่ ประวัติการเรียนและคอร์สจะติดตามไปด้วย',
      createAnyway: 'คนละคน — สร้างใหม่', moveHere: 'ย้ายเข้าครอบครัวนี้',
      statWithMatch: 'ซ้ำกับตัวจริง',
      filterAll: 'ทุกสถานะ', filterMatched: 'ซ้ำกับตัวจริง', filterUnmatched: 'ยังไม่มีตัวจริง',
      needMergeHint: 'ซ้ำกับเด็กที่มีอยู่แล้ว — ต้องรวมประวัติ ย้ายเฉย ๆ ไม่ได้',
      assignFamily: 'ย้ายเข้าครอบครัว',
      mergeTitle: 'ซ้ำกับเด็กที่มีอยู่แล้ว', mergeSubtitle: 'ต้องรวมประวัติ ไม่ใช่ย้าย',
      mergeExplain: 'เด็กคนนี้มีแถวจริงอยู่ในครอบครัวลูกค้าแล้ว ถ้าย้ายแถวนี้เข้าไปเฉย ๆ จะกลายเป็น 2 แถวในบ้านเดียวกัน โดยประวัติยังแยกกันอยู่',
      mergeFrom: 'แถวในคิว (ของเก่า)', mergeTo: 'ตัวจริงในระบบ',
      mergeHow: 'ผู้จัดการกด "รวมเข้ากับคนนี้" เพื่อย้ายใบจอง คาบ Private อีเวนต์ กลุ่มเรียน และคอร์สทั้งหมดไปที่แถวจริง แล้วปิดแถวเก่าในขั้นตอนเดียว · ถ้าไม่ใช่ผู้จัดการ ให้แจ้งผู้จัดการ',
      assignTitle: 'ย้ายเข้าครอบครัว', assignBtn: 'ย้ายเข้าครอบครัวนี้',
      assignExplain: 'เด็กคนนี้ยังไม่มีแถวจริงในระบบ จึงย้ายเข้าครอบครัวได้เลย ประวัติการเรียนและคอร์สจะติดตามไปด้วยทั้งหมด',
      pickFamilyFirst: 'เลือก Username ผู้ปกครองในฟอร์มก่อน ปุ่มย้ายถึงจะใช้ได้',
      moved: 'ย้ายเข้าครอบครัวเรียบร้อย ประวัติและคอร์สติดตามมาด้วยทั้งหมด',
      why: { nameDob: 'ชื่อ-นามสกุล และวันเกิด ตรงกัน', name: 'ชื่อ-นามสกุล ตรงกัน', nickDob: 'ชื่อเล่น-นามสกุล และวันเกิด ตรงกัน', nick: 'ชื่อเล่น-นามสกุล ตรงกัน', lastnameDob: 'นามสกุลและวันเกิด ตรงกัน', firstNick: 'ชื่อจริงและชื่อเล่น ตรงกัน (นามสกุลต่างกัน)' },
      conf: { veryhigh: 'ตรงมาก', high: 'ตรง', medium: 'อาจตรง' },
      staffRow: 'แถวที่แอดมินสร้างไว้', noFamily: 'ยังไม่มีครอบครัว', bookings: 'ใบจอง {n}', lastClass: 'เรียนล่าสุด {d}', noClass: 'ยังไม่เคยเรียน',
      tabList: 'รายชื่อนักเรียน', tabUnclaimed: 'ยังไม่มีผู้ปกครอง',
      unclaimedHint: 'เด็กที่ถูกสร้างไว้ใต้บัญชีพนักงาน (ยุคที่แอดมินจองให้) หรือยังไม่มีครอบครัว — ทุกคนในนี้จะกลายเป็นข้อมูลซ้ำทันทีที่ผู้ปกครองสมัครแล้วเพิ่มชื่อลูกเอง',
      colParkedUnder: 'ฝากไว้ใต้บัญชี', colCreated: 'สร้างเมื่อ', colBookings: 'ใบจอง', colLastClass: 'เรียนล่าสุด', colCourse: 'คอร์ส', colMatch: 'แถวที่น่าจะตรงกัน',
      statTotal: 'ทั้งหมด', statNoFamily: 'ไม่มีครอบครัว', statWithCourse: 'ถือคอร์สอยู่', statWithBookings: 'เคยเรียน',
      approveWarn: 'อาจซ้ำกับเด็กที่มีอยู่แล้ว {n} คน', approveWarnHint: 'ตรวจสอบก่อนอนุมัติ — ถ้าเป็นคนเดียวกัน ให้ปฏิเสธใบนี้แล้วย้ายแถวเดิมเข้าครอบครัวแทน',
      headOnlyHint: 'ระบบมั่นใจว่าซ้ำกับเด็กที่มีอยู่แล้ว — ต้องให้ผู้จัดการเป็นคนตรวจสอบและอนุมัติ (ตีกลับใบนี้ได้ตามปกติ)',
      reasonTitle: 'เหตุผลที่อนุมัติ',
      reasonHint: 'ระบบเตือนว่าอาจซ้ำ — ระบุเหตุผลสั้น ๆ ว่าทำไมถึงอนุมัติ เก็บไว้ให้ผู้จัดการตรวจย้อนหลัง',
      reasonPlaceholder: 'เช่น ตรวจแล้วเป็นคนละคน / เป็นฝาแฝด',
      headOnlyCreateHint: 'ระบบมั่นใจว่าซ้ำกับเด็กที่มีอยู่แล้ว — สร้างใหม่ไม่ได้ ต้องให้ผู้จัดการเป็นคนตรวจสอบ (ย้ายแถวเดิมเข้าครอบครัวนี้ยังทำได้ตามปกติ)',
      linkBtn: 'รวมข้อมูลกับเด็กที่มีอยู่แล้วในระบบ',
      linkHint: 'เด็กคนนี้มีอยู่ในระบบแล้ว — ใช้ปุ่มรวมข้อมูลแทนการอนุมัติ จะได้ไม่เกิดเด็กซ้ำ',
      linkTitle: 'รวมข้อมูลกับเด็กที่มีอยู่แล้วในระบบ',
      linkConfirm: 'ย้าย {target} (ตอนนี้อยู่ใต้ {current}) เข้าครอบครัว {family} และใช้ข้อมูลที่ผู้ปกครองกรอกแทนข้อมูลเดิม · ประวัติการเรียนและคอร์สของเด็กคนเดิมอยู่ครบ · ใบรออนุมัตินี้จะถูกปิด',
      linkDone: 'รวมข้อมูลเรียบร้อย',
      linkFail: 'รวมข้อมูลไม่สำเร็จ',
      staffTag: 'แอดมินฝากไว้ตอนทดลองเรียน',
      acctType: { 0: 'บัญชีผู้จัดการ', 1: 'บัญชีแอดมิน', 2: 'บัญชีโค้ช', 10: 'บัญชีลูกค้า' },
      whyLabel: 'เหตุผลที่ระบบคิดว่าซ้ำ',
      cmpPending: 'เด็กที่ผู้ปกครองเพิ่มเอง (รออนุมัติ)',
      cmpExisting: 'เด็กที่มีอยู่แล้วในระบบ',
      fName: 'ชื่อ-นามสกุล',
      fNick: 'ชื่อเล่น',
      fDob: 'วันเกิด',
      fAccount: 'อยู่ในบัญชี',
      fHistory: 'ประวัติการเรียน',
      acctCustomer: 'Username ลูกค้า: {u}',
      acctStaff: 'บัญชีพนักงาน {u} (แอดมินฝากไว้ตอนทดลองเรียน)',
      acctNone: 'ยังไม่อยู่ในบัญชีใด',
      newRequest: 'ใบใหม่ — ยังไม่มีประวัติ',
      historyN: 'จองเรียนแล้ว {n} ครั้ง',
      linkIntro: 'เมื่อกดยืนยัน ระบบจะ:',
      linkStep1: 'ย้ายเด็กเข้าบัญชีผู้ปกครอง {to}',
      linkStep1NoFam: 'ใส่เด็กเข้าบัญชีลูกค้า {to}',
      linkStep2: 'ใช้ข้อมูลที่ผู้ปกครองกรอก (ช่องที่มีป้าย "เปลี่ยน")',
      linkStep3: 'เก็บประวัติเรียน {n} ครั้ง และคอร์สเดิมไว้ครบ',
      linkStep4: 'ปิดใบรออนุมัตินี้ โดยไม่สร้างเด็กใหม่',
      colField: 'ข้อมูล',
      colNow: 'ตอนนี้',
      colAfter: 'หลังรวม',
      changed: 'เปลี่ยน',
      linkErr: { gone: 'ใบนี้ถูกจัดการไปแล้ว', not_candidate: 'เด็กคนนี้ไม่ใช่คู่ที่ระบบเสนอให้ผูก — ตรวจสอบกับผู้จัดการ', shared_course: 'คอร์สของเด็กเดิมใช้ร่วมกับนักเรียนคนอื่นอยู่ ย้ายครอบครัวไม่ได้ — ติดต่อผู้จัดการ', already_in_family: 'ครอบครัวนี้มีเด็กคนนี้อยู่แล้ว — ต้องให้ผู้จัดการรวมประวัติแทนการผูก', bad_family: 'ใบนี้ไม่ได้มาจากครอบครัวลูกค้า — ผูกไม่ได้' },
      mergeBtn: 'รวมเข้ากับคนนี้',
      mergeConfirmTitle: 'ยืนยันการรวมนักเรียน',
      mergeConfirm: 'ย้ายประวัติทั้งหมดของ {from} ({n} ใบจอง รวมคาบ Private อีเวนต์ กลุ่มเรียน และคอร์ส) ไปที่ {to} แล้วปิดแถวเก่า · ย้อนกลับเองไม่ได้',
      mergeCheck: 'ตรวจแล้วว่าเป็นเด็กคนเดียวกัน',
      mergeDone: 'รวมนักเรียนเรียบร้อย',
      mergeFail: 'รวมนักเรียนไม่สำเร็จ',
      mergeErr: { booking_conflict: 'เด็กสองแถวนี้จองคลาสเดียวกันวันเดียวกัน — ยกเลิกใบใดใบหนึ่งในหน้าจองก่อนแล้วค่อยรวม', event_conflict: 'เด็กสองแถวนี้สมัครอีเวนต์เดียวกันทั้งคู่ — ยกเลิกใบหนึ่งก่อนแล้วค่อยรวม', course_slots: 'แถวจริงถือคอร์สครบ 2 ช่องแล้ว ใส่คอร์สของแถวเก่าไม่ลง — จัดการคอร์สก่อนแล้วค่อยรวม', private_conflict: 'เด็กสองแถวนี้อยู่ในคาบ Private เดียวกันทั้งคู่ — เอาชื่อออกหนึ่งที่ก่อนแล้วค่อยรวม', not_found: 'ไม่พบนักเรียน หรือถูกรวม/ลบไปแล้ว — กดรีเฟรชรายการ', direction: 'รวมได้เฉพาะจากแถวใต้บัญชีพนักงาน/ไม่มีครอบครัว เข้าแถวในครอบครัวลูกค้า', not_candidate: 'สองแถวนี้ไม่ได้ถูกจับคู่ว่าซ้ำกันแน่ (เช่นฝาแฝด) — รวมไม่ได้' },
      reasonCreateHint: 'ระบบเตือนว่าอาจซ้ำ — ระบุเหตุผลสั้น ๆ ว่าทำไมถึงสร้างใหม่ เก็บไว้ให้ผู้จัดการตรวจย้อนหลัง',
    },
    gymnasts: { typeUsername: 'พิมพ์ Username…' },
    bookingList: { blindTooltip: 'ลูกค้าซ่อนชื่อนี้จากผู้ปกครองท่านอื่น' },
    family: { yearsOld: 'ขวบ', pendingApproval: 'รออนุมัติ' },
    editProfile: { changePhoto: 'เปลี่ยนรูป', uploadNewPhoto: 'อัปโหลดรูปใหม่', removePhoto: 'ลบรูป' },
    calendar: {
      tooltipBookingClosed: 'หมดเขตรับจองแล้ว (จองได้จนถึง 08:00 น. ของวันที่ต้องการจอง)', tooltipMondayClosed: 'วันจันทร์ — ปิดทำการ',
      tooltipHolidayClosed: 'วันหยุด — ปิดทำการ', legendClosed: 'วันจันทร์และวันหยุด ปิดให้บริการอัตโนมัติ', holidaysThisMonth: 'วันหยุดในเดือนนี้', holidayLabel: 'วันหยุด',
      tooltipBeforeMinDate: 'เลือกวันก่อนหน้านี้ไม่ได้',
    },
    select: { noMatch: 'ไม่พบรายการ', searchPlaceholder: 'พิมพ์เพื่อค้นหา…' },
    pager: { firstPage: 'หน้าแรก', prevPage: 'ก่อนหน้า', nextPage: 'ถัดไป', lastPage: 'หน้าสุดท้าย' },
    classDisable: {
      title: 'ปิดรับจองคลาส', subtitle: 'ปิดรับจองคลาสกลุ่มเป็นรายคลาส เฉพาะบางวัน',
      newClosure: 'ปิดคลาสเพิ่ม', closureInfo: 'ข้อมูลการปิดคลาส', dateLabel: 'วันที่ปิด',
      pickClass: 'เลือกคลาสที่จะปิด', pickClassPlaceholder: '— เลือกคลาส —',
      noClassOnDate: 'ไม่มีคลาสในวันที่เลือก', reason: 'เหตุผล (เช่น วันหยุดพิเศษ / ครูลา)',
      confirmDelete: 'ต้องการเปิดรับจอง {class} วันที่ {date} อีกครั้งใช่หรือไม่?',
      created: 'ปิดรับจองคลาสเรียบร้อย', reopened: 'เปิดรับจองคลาสอีกครั้งเรียบร้อย',
      selectDateFirst: 'กรุณาเลือกวันที่ก่อน',
    },
    closures: {
      title: 'การปิดทำการ', subtitle: 'จัดการวันหยุดของสตูดิโอ และการปิดรับจองรายคลาส',
      tabHoliday: 'วันหยุด (ทั้งวัน)', tabClass: 'ปิดรับจองรายคลาส',
      bookingWarnTitle: 'มีการจองค้างอยู่ในวันนี้',
      bookingWarnLead: 'วันที่ {date} มีการจองอยู่แล้ว {n} รายการ',
      bookingWarnGroup: 'คลาสกลุ่ม ({n})', bookingWarnPrivate: 'คลาส Private ({n})',
      bookingWarnNote: 'ระบบจะไม่ยกเลิกการจองเหล่านี้และไม่คืนโควตาให้อัตโนมัติ กรุณาติดต่อผู้ปกครองและจัดการการจองเอง',
      bookingWarnConfirm: 'ยืนยันดำเนินการต่อ',
    },
    nav: { expandMenu: 'ขยายเมนู', collapseMenu: 'ย่อเมนู', menuPermission: 'สิทธิ์การใช้งานเมนู', closures: 'การปิดทำการ', grouping: 'จัดกลุ่มโค้ช', coachSchedule: 'ตารางสอนโค้ช', coachLeave: 'ยื่นใบลา', leaveApproval: 'อนุมัติการลา', scheduleAdmin: 'จัดการตารางเรียน' },
    scheduleAdmin: {
      title: 'จัดการตารางเรียน', subtitle: 'สร้างประเภทคอร์ส และกำหนดตารางคลาสประจำสัปดาห์ในที่เดียว',
      courseTypes: 'ประเภทคอร์ส', showDisabled: 'แสดงคอร์สที่ปิดอยู่', addCourse: 'เพิ่มคอร์ส',
      legendClickCourse: 'คลิกที่คอร์สเพื่อแก้ไข', legendDirty: 'ขอบเหลือง = แก้ไขที่ยังไม่บันทึก',
      legendNew: 'ขอบเขียว = เพิ่มใหม่', legendAdmin: 'ลายทแยง = คลาสเฉพาะแอดมิน',
      weeklyTable: 'ตารางคลาสประจำสัปดาห์', addClass: 'เพิ่มคลาส',
      hintCreate: 'คลิกช่องว่างเพื่อสร้างคลาส', hintDrag: 'ลากบล็อกเพื่อย้ายวัน/เวลา · ลากขอบเพื่อยืด-หดเวลา', hintEdit: 'คลิกบล็อกเพื่อแก้ไข/ลบ',
      evTitle: 'ลากเพื่อย้าย · ลากขอบเพื่อปรับเวลา · คลิกเพื่อแก้ไข',
      editClass: 'แก้ไขคลาส', newClass: 'เพิ่มคลาสใหม่', classInfo: 'ข้อมูลคลาสเรียน',
      startTime: 'เวลาเริ่ม', endTime: 'เวลาเลิก', validityAndVisibility: 'ช่วงใช้งาน และการมองเห็น',
      startDate: 'เริ่มใช้ตั้งแต่', endDate: 'ใช้ถึงวันที่', adminOnly: 'คลาสเฉพาะแอดมิน', adminOnlyHint: 'ซ่อนจากลูกค้า (adminflag)',
      deleteClass: 'ลบคลาส', deleteCourse: 'ลบคอร์ส', editCourse: 'แก้ไขประเภทคอร์ส', newCourse: 'เพิ่มประเภทคอร์ส', courseInfo: 'ข้อมูลคอร์ส',
      courseNamePh: 'เช่น Gymnastics Activity', shortNamePh: 'เช่น G.A.',
      refercode: 'รหัสอ้างอิง (prefix)', refercodePh: 'เช่น GA',
      refercodeHint: 'ใช้สร้างเลขคอร์สลูกค้า เช่น GA-20260724-0001 — กำหนดได้ครั้งเดียวตอนสร้าง',
      refercodeLocked: 'รหัสอ้างอิงกำหนดตอนสร้างเท่านั้น แก้ไขภายหลังไม่ได้',
      courseColor: 'สีประจำคอร์ส (แสดงในปฏิทิน)', status: 'สถานะ', statusHint: 'เปิดใช้งาน — ปิดแล้วจะซ่อนจากหน้าจอง',
      confirmTitle: 'ยืนยัน', confirmDeleteClass: 'ต้องการลบคลาสนี้ใช่หรือไม่? ประวัติการเรียนที่ผ่านมาจะถูกเก็บไว้ทั้งหมด — หากยังมีการจองล่วงหน้า ระบบจะไม่อนุญาตให้ลบจนกว่าจะยกเลิก/ย้ายการจองก่อน',
      confirmDeleteCourse: 'ต้องการลบคอร์สนี้ใช่หรือไม่? คลาสทั้งหมดของคอร์สจะถูกลบไปด้วย แต่ประวัติการเรียนและคอร์สของลูกค้าที่ผ่านมาจะถูกเก็บไว้ทั้งหมด — ลบได้เมื่อไม่มีการจองล่วงหน้าและคอร์สของลูกค้าทุกใบจบแล้ว',
      confirmProceedHint: 'ยืนยันเพื่อดำเนินการต่อ?',
      unsaved: 'รายการที่ยังไม่บันทึกเข้าระบบ', discardAll: 'ยกเลิกทั้งหมด', saveToSystem: 'บันทึกเข้าระบบ',
      diffNew: 'เพิ่ม {n}', diffEdit: 'แก้ไข {n}', diffDelete: 'ลบ {n}',
      reverted: 'คืนค่าทั้งหมดแล้ว', saved: 'บันทึกตารางเรียนเรียบร้อยแล้ว',
    },
    grouping: {
      title: 'จัดกลุ่มโค้ช', subtitle: 'แบ่งเด็กในแต่ละคลาสให้โค้ชรับผิดชอบ (แทน Google Sheet เดิม)',
      coachTitle: 'ตารางสอนโค้ช', coachSubtitle: 'กลุ่มที่รับผิดชอบในแต่ละคลาส — เปิดดูก่อนเข้าสอน',
      privateTitle: 'ตารางสอน Private', noPrivate: 'ไม่มีคาบสอน Private', privateHours: '{n} ชม.',
      privateCheckinHint: 'เช็คชื่อได้เฉพาะแอดมิน หรือโค้ชที่สอนคาบนี้เท่านั้น',
      modeDay: 'วัน', modeWeek: 'สัปดาห์', today: 'วันนี้', prev: 'ก่อนหน้า', next: 'ถัดไป',
      personUnit: 'คน', unassigned: 'ยังไม่จัดกลุ่ม', allAssigned: 'จัดกลุ่มครบทุกคนแล้ว', emptyGroup: 'ยังไม่มีสมาชิกในกลุ่ม',
      noBooking: 'ยังไม่มีผู้จองคลาสนี้', noSessions: 'ไม่มีคลาสในวันนี้',
      addGroup: 'เพิ่มกลุ่ม', editGroup: 'แก้ไขกลุ่ม', coachesLabel: 'โค้ชประจำกลุ่ม',
      noCoachYet: 'ยังไม่มีรายชื่อโค้ช — เพิ่มได้ที่ปุ่ม "รายชื่อโค้ช"',
      groupName: 'ชื่อกลุ่มพิเศษ (ไม่บังคับ)', groupNamePh: 'เช่น Tax FIG1+L.4 (เว้นว่าง = ใช้ชื่อโค้ช)',
      groupRemark: 'หมายเหตุกลุ่ม', groupRemarkPh: 'เช่น ซ้อมบาร์ต่างระดับ',
      deleteGroup: 'ลบกลุ่ม', confirmDeleteGroup: 'ต้องการลบกลุ่ม "{name}" ใช่หรือไม่? สมาชิกจะกลับไปอยู่ "ยังไม่จัดกลุ่ม"',
      moveAllTitle: 'ย้ายสมาชิกทั้งกลุ่ม ({n} คน)', moveAllTo: '— เลือกกลุ่มปลายทาง —', moveAllBtn: 'ย้ายทั้งกลุ่ม',
      moveTo: 'ย้ายไปกลุ่ม', removeFromGroup: 'นำออกจากกลุ่ม', noGroupYet: 'ยังไม่มีกลุ่มในคลาสนี้ — กด "เพิ่มกลุ่ม" ก่อน',
      sessionNote: 'หมายเหตุประจำคลาส', sessionNotePh: 'เช่น วันนี้รวมกลุ่ม L.3-L.4',
      dayNote: 'หมายเหตุประจำวัน', dayNotePh: 'เพิ่มหมายเหตุสำหรับวันนี้...',
      absentTag: 'ลา', allDayShort: 'ทั้งวัน', absentCoachesToday: 'รายชื่อโค้ชลาวันนี้',
      checkin: 'เช็คอิน', undoCheckin: 'ยกเลิกเช็คอิน',
      absenceBtn: 'ระบุโค้ชลา', absenceTitle: 'บันทึกการลาของโค้ช', absenceCoach: 'โค้ช', absenceDate: 'วันที่ลา',
      absenceAllDay: 'ลาทั้งวัน', absencePickClasses: 'เลือกคลาสที่ลา', absenceReason: 'เหตุผล (ไม่บังคับ)', absenceReasonPh: 'เช่น ลาป่วย',
      absenceCancelBtn: 'ยกเลิกการลา',
      coachManageBtn: 'รายชื่อโค้ช', coachManageTitle: 'รายชื่อโค้ช', coachManageSub: 'โค้ชไม่จำเป็นต้องมีบัญชีล็อกอิน — ผูกบัญชีภายหลังได้',
      autoBtn: 'จัดกลุ่มอัตโนมัติ', autoBtnDay: 'จัดกลุ่มอัตโนมัติทั้งวัน', autoPreviewTitle: 'จัดกลุ่มอัตโนมัติ',
      autoModeUnassigned: 'เฉพาะเด็กที่ยังไม่มีกลุ่ม', autoModeUnassignedHint: 'ไม่แตะกลุ่มที่จัดไว้แล้ว — จัดเฉพาะเด็กที่ยังค้างอยู่',
      autoModeRebuild: 'จัดใหม่ทั้งคาบ', autoModeRebuildHint: 'ล้างสมาชิกทุกกลุ่มในคาบแล้วจัดใหม่ตามกฎ (ตัวกลุ่ม โน้ต และโค้ชยังอยู่)',
      autoNewGroup: 'สร้างใหม่', autoReuseGroup: 'ใช้กลุ่มเดิม', autoSessionCount: '{n} คาบ',
      autoSkipTitle: 'จัดให้ไม่ได้ · {n} คน', autoSkipOutOfRange: 'ไม่เข้าช่วงของกลุ่มไหนเลย',
      autoSkipNoBirthdate: 'ไม่ได้บันทึกวันเกิด', autoSkipNoLevel: 'ไม่ได้กรอกเลเวล',
      autoNothingToDo: 'ไม่มีเด็กที่ต้องจัดในตอนนี้', autoTotal: 'จะจัด {n} คน ใน {g} กลุ่ม', autoApplyBtn: 'ยืนยันจัดกลุ่ม',
      autoRebuildConfirmTitle: 'จัดใหม่ทั้งคาบ?', autoRebuildConfirmBody: 'เด็กที่ย้ายกลุ่มด้วยมือไว้จะถูกจัดใหม่ตามกฎทั้งหมด ยืนยันหรือไม่',
      autoDone: 'จัดกลุ่มเรียบร้อย — {n} คน',
      ruleBtn: 'ตั้งค่ากฎ', ruleTitle: 'กฎการจัดกลุ่มอัตโนมัติ', ruleSub: 'หนึ่งคอร์สต่อหนึ่งชุดกฎ — แก้ได้ที่นี่โดยไม่ต้องแก้โค้ด',
      ruleAdd: 'เพิ่มชุดกฎ', ruleEdit: 'แก้ไขชุดกฎ', ruleDelete: 'ลบชุดกฎ', ruleNone: 'ยังไม่มีชุดกฎ',
      ruleConfirmDelete: 'ลบชุดกฎ "{name}" หรือไม่ (กลุ่มที่จัดไปแล้วจะไม่ถูกลบ)',
      ruleCourse: 'คอร์ส', ruleBasis: 'แบ่งตาม', ruleName: 'ชื่อชุดกฎ', ruleNamePh: 'เช่น G.A. ตามอายุ',
      ruleBuckets: 'กลุ่มย่อย', ruleBucketNamePh: 'ชื่อกลุ่ม เช่น เด็กเล็ก 3-5 ปี', ruleMin: 'ตั้งแต่', ruleMax: 'ถึง',
      ruleMaxPerson: 'สูงสุด/กลุ่ม', ruleOpenEnd: 'ไม่จำกัด', ruleNoLimit: 'ไม่จำกัด', ruleDefaultCoaches: 'โค้ชประจำกลุ่ม (ไม่บังคับ)',
      ruleAddBucket: 'เพิ่มกลุ่มย่อย', basisAge: 'อายุ (ปี)', basisLevel: 'เลเวล',
      ruleHint: 'เว้นช่อง "ตั้งแต่" หรือ "ถึง" ว่างไว้ = ไม่จำกัดด้านนั้น · ช่วงของแต่ละกลุ่มต้องไม่ซ้อนกัน · ตั้งจำนวนสูงสุดแล้วระบบจะแตกกลุ่มเป็น #1 #2 ให้เอง',
      addCoach: 'เพิ่มโค้ช', editCoach: 'แก้ไขโค้ช', coachName: 'ชื่อเรียก', coachColor: 'สีประจำโค้ช', coachSort: 'ลำดับ',
      coachLink: 'ผูกกับบัญชีล็อกอิน', coachLinkNone: '— ไม่ผูกบัญชี —',
      coachLinkHint: 'ผูกแล้วโค้ชคนนั้นจะเห็น "กลุ่มของฉัน" ไฮไลต์ในหน้าตารางสอนโค้ช',
      coachDisable: 'ปิดการใช้งานโค้ช', confirmDisableCoach: 'ปิดการใช้งานโค้ช "{name}" ใช่หรือไม่? กลุ่มที่เคยจัดไว้ยังแสดงชื่อได้ตามปกติ',
      disabledBadge: 'ปิดใช้งาน', notLinkedBadge: 'ยังไม่ผูกบัญชีล็อกอิน',
      highlightMine: 'ไฮไลต์กลุ่มของฉัน', myGroupsOnly: 'เฉพาะของฉัน',
      loadFail: 'โหลดข้อมูลไม่สำเร็จ',
      leaveBtn: 'คำขอลา', leaveReqTitle: 'คำขอลาของพนักงาน', leaveReqSub: 'อนุมัติแล้วระบบจะบันทึกการลาลงตารางให้อัตโนมัติ',
      leavePendingTitle: 'รอดำเนินการ', leaveHistoryTitle: 'ประวัติที่พิจารณาแล้ว', leaveHistorySub: 'รายการที่อนุมัติ ปฏิเสธ หรือยกเลิกไปแล้ว', leaveHistoryCount: '{n} รายการ',
      myLeaveHistory: 'ประวัติการลา', viewGrouped: 'จัดกลุ่มตามประเภท', viewChrono: 'เรียงตามวันที่',
      ovApprovedLabel: 'อนุมัติแล้ว {n} วัน', ovPendingNote: 'กันไว้รออนุมัติ {n} วัน',
      quotaOverLabel: 'เกินโควต้า {over} วัน (อนุมัติแล้ว {used} จากเพดาน {quota} วัน)', quotaNotSetWithUsed: 'ยังไม่กำหนดโควต้าปีนี้ · ยื่นแล้ว {n} วัน',
      leaveOverviewQuotaNote: 'ตัวเลข "คงเหลือ" หักคำขอที่ "รออนุมัติ" ไว้ล่วงหน้าแล้ว เพื่อป้องกันการอนุมัติเกินโควต้าภายหลัง',
      leavePendingCountNote: 'มี {n} คำขอรออนุมัติของพนักงานคนนี้{type}', goToPendingCard: 'ไปที่การ์ด "รอดำเนินการ"',
      daysInYearNote: '({n} วันในปีนี้)',
      myLeaveSubmit: 'ยื่นใบลา', myLeaveList: 'ใบลาของฉัน', leaveSubmitBtn: 'ส่งคำขอ',
      leaveTypeLabel: 'ประเภทการลา', leaveType_sick: 'ลาป่วย', leaveType_personal: 'ลากิจ', leaveType_vacation: 'ลาพักร้อน',
      leaveType_unpaid: 'ลาทั่วไป (ไม่ได้รับเงินเดือน)',
      dayPortionLabel: 'ช่วงวันลา', dayPortion_full: 'เต็มวัน', dayPortion_morning: 'ครึ่งเช้า', dayPortion_afternoon: 'ครึ่งบ่าย',
      createLeaveLabel: 'สร้างใบลา (รออนุมัติ)', createLeaveHint: 'สร้างใบลาสถานะรออนุมัติให้โค้ชคนนี้ — จะขึ้นลาในตารางทันที และตัดโควต้าเมื่อผู้จัดการอนุมัติ (โค้ช Part-time = แค่บันทึกไม่มาสอน)',
      leaveOverviewTitle: 'ภาพรวมการลารายปี', staffName: 'พนักงาน',
      leaveOverviewHint: 'คลิกชื่อพนักงานเพื่อกางดูรายการลารายคน (เลือกกรองตามประเภทได้)',
      leaveTypeAll: 'ทุกประเภท', leaveDetailOf: 'รายการลาของ {name}', submittedAt: 'ส่งคำขอเมื่อ',
      cancelReviewBtn: 'ยกเลิก', cancelReviewTitle: 'ยกเลิกใบลา',
      confirmCancelReview: 'ยกเลิกใบลาของ "{name}" ที่พิจารณาไปแล้วใช่หรือไม่? ระบบจะถอนการลาออกจากตารางและคืนโควต้าให้',
      countAsLeave: 'นับเป็นการลา (ตัดโควต้า)', countAsLeaveHint: 'สร้างใบลาที่อนุมัติแล้วให้โค้ชคนนี้ และตัดโควต้าปีนี้ตามประเภทที่เลือก',
      parttimeNoQuota: 'โค้ช Part-time — บันทึกเป็นการไม่มาสอนเฉย ๆ ไม่ตัดโควต้า',
      employmentType: 'ประเภทการจ้าง', employmentTypeHint: 'Full-time = ตัดโควต้าลาได้ · Part-time = ระบุแค่ว่าไม่มาสอน',
      employmentFulltime: 'ประจำ (Full-time)', employmentParttime: 'พาร์ตไทม์ (Part-time)',
      leaveFrom: 'ตั้งแต่วันที่', leaveTo: 'ถึงวันที่', leaveReason: 'เหตุผล (ไม่บังคับ)', leaveReasonPh: 'เช่น มีธุระครอบครัว',
      leaveMultiDayHint: 'การลาหลายวัน = ลาทั้งวันทุกวันในช่วง (ลาบางคลาสได้เฉพาะลาวันเดียว)',
      leaveStatus_pending: 'รออนุมัติ', leaveStatus_approved: 'อนุมัติแล้ว', leaveStatus_rejected: 'ไม่อนุมัติ', leaveStatus_cancelled: 'ยกเลิกแล้ว',
      approve: 'อนุมัติ', reject: 'ไม่อนุมัติ', reviewNote: 'หมายเหตุถึงโค้ช (ไม่บังคับ)',
      confirmApprove: 'อนุมัติการลาของ "{name}" ใช่หรือไม่? ระบบจะบันทึกการลาลงตารางให้อัตโนมัติ',
      confirmReject: 'ไม่อนุมัติการลาของ "{name}" ใช่หรือไม่?',
      cancelReq: 'ยกเลิกคำขอ', confirmCancelReq: 'ยกเลิกคำขอลานี้ใช่หรือไม่?',
      notLinkedLeave: 'บัญชีของคุณยังไม่ถูกผูกกับรายชื่อโค้ช — กรุณาติดต่อผู้จัดการ', noLeaveReq: 'ยังไม่มีคำขอลา',
      leavePageTitle: 'ยื่นใบลา', leavePageSub: 'ยื่นใบลา ดูโควต้าคงเหลือ และติดตามผลการอนุมัติ',
      leaveApprovalTitle: 'อนุมัติการลา', leaveApprovalSub: 'ตรวจและอนุมัติ/ปฏิเสธคำขอลาของพนักงาน และกำหนดโควต้ารายปี',
      daysUnit: 'วัน', statusAll: 'ทุกสถานะ', quotaRemainLabel: 'คงเหลือ', quotaUsedLabel: 'ใช้ไป',
      quotaPendingNote: 'รออนุมัติ {n} วัน', quotaNotSet: 'ยังไม่กำหนดโควต้าปีนี้', quotaUsedShort: 'ใช้ไป {n} วัน',
      quotaBtn: 'กำหนดโควต้า', quotaTitle: 'โควต้าการลารายปี', quotaSub: 'กำหนดจำนวนวันลาต่อปีของโค้ชแต่ละคน (เฉพาะผู้จัดการ)', quotaYear: 'ปี', saveAllQuota: 'บันทึกทั้งหมด',
      noCoachYetOnLeave: 'ยังไม่มีรายชื่อโค้ช — เพิ่มโค้ชได้ที่หน้า "จัดกลุ่มโค้ช" (ปุ่ม "รายชื่อโค้ช")', goToGrouping: 'ไปหน้าจัดกลุ่มโค้ช',
    },
    menuPerm: {
      title: 'สิทธิ์การใช้งานเมนู', subtitle: 'กำหนดว่าผู้ใช้ประเภทใดเข้าใช้งานเมนูใดได้ (เฉพาะผู้จัดการ)',
      colMenu: 'เมนู', save: 'บันทึกสิทธิ์', saved: 'บันทึกสิทธิ์การใช้งานเมนูเรียบร้อย',
      confirmTitle: 'ยืนยันการบันทึกสิทธิ์', confirmBody: 'รายการที่เปลี่ยนแปลง {n} รายการ:',
      changedCount: 'เปลี่ยนแปลง {n} รายการ', allow: 'เปิด', deny: 'ปิด',
      notConfigured: 'ยังไม่ตั้งค่า — เฉพาะผู้จัดการ', headAlways: 'ผู้จัดการเข้าได้ทุกเมนูเสมอ', headToggleHint: 'คลิกเพื่อซ่อน/แสดงเมนูนี้ในแถบเมนูผู้จัดการ',
      coreAlwaysHint: 'เมนูพื้นฐาน เปิดให้ทุกคนเสมอ', coreHeadHint: 'เฉพาะผู้จัดการเท่านั้น',
      externalHint: 'ระบบภายนอก (SSO) — ระบบเอกสารรับจ่ายตรวจสิทธิ์ผู้จัดการเองอีกชั้น',
      restrictedByCode: 'บางฟังก์ชันในเมนูนี้จำกัดเฉพาะผู้จัดการ/แอดมิน (เช่น ตั้งราคา/ตรวจสลิป) — เปิดสิทธิ์เมนูได้ แต่บางงานจะใช้ไม่ได้',
      restrictedHeadAdmin: 'เมนูนี้จำกัดเฉพาะผู้จัดการ/แอดมินในโค้ด — เปิดให้โค้ช/ลูกค้าไม่ได้',
      lockedHeadAdmin: 'งานทั้งหมดในเมนูนี้ต้องเป็นผู้จัดการ/แอดมิน — เปิดสิทธิ์ให้ role นี้ไม่มีผล',
      loadFail: 'โหลดข้อมูลสิทธิ์ไม่สำเร็จ',
      userTitle: 'สิทธิ์รายบุคคล', userSubtitle: 'เปิดเมนูเพิ่มให้พนักงานบางคนเป็นราย ๆ (ซ้อนบนสิทธิ์ราย role)', pickUser: '— เลือกพนักงาน —', pickUserHint: 'เลือกพนักงานเพื่อกำหนดสิทธิ์เมนูรายบุคคล', userSaved: 'บันทึกสิทธิ์รายบุคคลเรียบร้อย',
    },
    auth: { pleaseLoginAgain: 'กรุณาเข้าสู่ระบบใหม่' },
    noti: {
      title: 'การแจ้งเตือน', upcoming: 'ปัจจุบัน', past: 'ผ่านไปแล้ว',
      empty: 'ยังไม่มีการแจ้งเตือน', markAllRead: 'อ่านทั้งหมด',
      enablePush: 'เปิดการแจ้งเตือนบนเครื่องนี้', pushOn: 'เปิดการแจ้งเตือนแล้ว',
      pushOff: 'ปิดการแจ้งเตือนบนเครื่องนี้',
      pushDesc: 'ให้เด้งเตือนขึ้นหน้าจอเมื่อมีการแจ้งเตือนใหม่ แม้ไม่ได้เปิดเว็บอยู่',
      pushBlocked: 'เบราว์เซอร์บล็อกการแจ้งเตือนไว้ — ต้องไปเปิดในตั้งค่าของเบราว์เซอร์เอง',
      pushUnsupported: 'เบราว์เซอร์นี้ยังไม่รองรับการแจ้งเตือน',
      pushIosHint: 'บน iPhone/iPad ต้องกดปุ่มแชร์ แล้วเลือก "เพิ่มไปยังหน้าจอโฮม" ก่อน จึงจะเปิดการแจ้งเตือนได้',
      pushFail: 'เปิดการแจ้งเตือนไม่สำเร็จ',
    },
    ops: {
      title: 'ตรวจสอบประจำวัน', subtitle: 'รายการที่ตกหล่นและงานค้าง กวาดตาก่อนเลิกงาน',
      managerOnly: 'ผู้จัดการ/แอดมิน', refresh: 'ตรวจใหม่',
      sevUrgent: 'ต้องจัดการวันนี้', sevWatch: 'ควรตามภายในสัปดาห์', sevInfo: 'ผิดปกติ',
      lookback: 'ย้อนหลัง', lookbackDays: '{n} วัน', lookbackAll: 'ทั้งหมด',
      checkedAt: 'ตรวจล่าสุด {time}',
      attendanceLimitNote: 'ระบบไม่มีสถานะ "ขาดเรียน" — คาบที่ค้างเช็คชื่อเคลียร์ได้ 2 ทาง: เด็กมาจริงแต่ลืมกด → กดเช็คชื่อย้อนหลังได้ (ไม่จำกัดวันย้อนหลัง) · เด็กไม่มา → ยกเลิกใบจองให้ ระบบคืนครั้งอัตโนมัติแล้วรายการจะหายไปเอง',
      trendTitle: 'แนวโน้ม {n} วันล่าสุด',
      trendNote: 'ถ่ายภาพอัตโนมัติทุกวัน 21:30 โดยนับด้วยช่วงย้อนหลัง {days} วันเท่ากันทุกวัน',
      trendShowTable: 'ดูตัวเลขรายวัน',
      trendHideTable: 'ซ่อนตัวเลขรายวัน',
      trendColDate: 'วันที่',
      allClear: 'ไม่มีรายการค้าง', allClearSub: 'ตรวจครบทุกหัวข้อแล้ว ไม่พบสิ่งที่ต้องจัดการ',
      goFix: 'ไปหน้าที่แก้ได้', truncated: 'แสดง {shown} จาก {total} รายการ',
      unknownPriceExcluded: 'ยอดเงินยังไม่รวม {n} ใบที่ไม่ได้กรอกราคา',
      countedSince: 'นับตั้งแต่ {date}', passed: 'หัวข้อที่ผ่านแล้ว',
      loadFail: 'โหลดรายการตรวจสอบไม่สำเร็จ',
      paidYes: 'จ่ายแล้ว', paidNo: 'ยังไม่จ่าย', flagYes: 'ใช่', ageDays: '{n} วัน',
      kind: { course: 'คอร์ส', private: 'Private', approve: 'อนุมัติใบรอ', create: 'สร้างเอง' },
      check: {
        eventUnpaid: 'ใบสมัครอีเวนต์ค้างชำระ (กินที่นั่งอยู่)',
        eventRefundPending: 'อีเวนต์ที่ยกเลิกแล้ว รอบันทึกการคืนเงิน',
        eventOrganizerRemit: 'เงินผู้จัดอีเวนต์รอนำส่ง',
        checkinGroup: 'คาบเรียนที่ยังเช็คชื่อไม่ครบ',
        checkinPrivate: 'คาบ Private ที่ยังไม่เช็คชื่อ',
        checkinEvent: 'อีเวนต์ที่ยังเช็คชื่อไม่ครบ',
        packageUnlinked: 'แพ็กเกจที่ยังไม่ผูกกับเด็ก',
        paymentUnpaidTaught: 'ค้างชำระ — เรียนไปแล้ว',
        paymentUnpaid: 'ค้างชำระ — ยังไม่เริ่มเรียน',
        priceMissing: 'จ่ายแล้วแต่ยังไม่ได้กรอกราคา',
        paymentMethodMissing: 'จ่ายแล้วแต่ไม่ได้ระบุวิธีชำระ',
        slipUnverified: 'สลิปที่ตรวจไม่ผ่าน/ตรวจไม่ได้',
        packageExpiringSoon: 'แพ็กเกจใกล้หมด',
        packageStale: 'ซื้อแล้วยังไม่เริ่มใช้',
        leavePending: 'ใบลารออนุมัติ',
        studentPendingApproval: 'นักเรียนใหม่รออนุมัติ',
        conflictCoachLeave: 'คาบ Private ที่โค้ชลาวันนั้น',
        conflictHoliday: 'การจองที่ตรงวันหยุด',
        packageExpiredWithSessions: 'หมดอายุแล้วแต่ยังเหลือครั้ง',
        studentApprovedDuplicate: 'ปล่อยผ่านคำเตือนเด็กซ้ำ',
      },
      hint: {
        eventUnpaid: 'สมัครแล้วยังไม่จ่าย — ที่นั่งถูกจองไว้ · เกินเดทไลน์ (วันปิดรับ) แล้วให้ตัดสินใจตัดชื่อหรือตามเก็บ',
        eventRefundPending: 'งานถูกยกเลิกแต่เงินยังอยู่ในมือยิม — ต้องบันทึกว่าคืนหรือไม่คืน (โอนคืนจริงทำนอกระบบ) จนบันทึกครบรายการนี้จะไม่หาย',
        eventOrganizerRemit: 'ค่าสมัครส่วนของผู้จัดภายนอกที่เก็บจากลูกค้าแล้ว ยังไม่ได้บันทึกนำส่ง (เจ้าหนี้อื่น ไม่ใช่รายได้)',
        checkinGroup: 'คาบที่ผ่านไปแล้วแต่ยังมีเด็กไม่ถูกเช็คชื่อ — มาจริงแต่ลืมกด ให้เช็คชื่อย้อนหลัง · ไม่มา ให้ยกเลิกใบจอง (คืนครั้งให้)',
        checkinPrivate: 'คาบ Private ที่สอนไปแล้วแต่ยังไม่กดเช็คชื่อ — เช็คชื่อย้อนหลังได้ หรือยกเลิกใบจองถ้าไม่ได้สอนจริง',
        checkinEvent: 'งานที่ผ่านไปแล้วแต่ยังมีเด็กไม่ถูกเช็คชื่อ — เช็คชื่อย้อนหลังที่หน้าตารางสอนโค้ช/ตารางเรียน หรือยกเลิกใบสมัครถ้าไม่ได้มาจริง',
        packageUnlinked: 'สร้างแพ็กเกจไว้แต่ยังไม่ได้ระบุว่าเป็นของเด็กคนไหน — เด็กจะจองไม่ได้',
        paymentUnpaidTaught: 'สอนไปแล้วแต่ยังไม่ได้เงิน ยอดนี้โตขึ้นทุกสัปดาห์',
        paymentUnpaid: 'ขายแล้วยังไม่เก็บเงิน และยังไม่ได้เริ่มเรียน',
        priceMissing: 'ไม่มีราคา = รายงานการเงินนับยอดนี้ไม่ได้',
        paymentMethodMissing: 'ไม่รู้ว่าเป็นเงินสด/โอน/บัตร — แยกยอดตามวิธีจ่ายไม่ได้',
        slipUnverified: 'ส่วนใหญ่เกิดจากรูปสลิปไม่มี QR Code ไม่ได้แปลว่าสลิปปลอม ต้องดูด้วยตา',
        packageExpiringSoon: 'เหลือไม่เกิน 2 ครั้ง หรือหมดอายุใน 14 วัน — โอกาสชวนต่อคอร์ส',
        packageStale: 'ซื้อเกิน 14 วันแล้วยังไม่เคยจองเลย',
        leavePending: 'พนักงานยื่นใบลาแล้วยังไม่มีใครพิจารณา',
        studentPendingApproval: 'ผู้ปกครองเพิ่มเด็กใหม่ รออนุมัติเข้าระบบ',
        conflictCoachLeave: 'มีนัด Private แต่โค้ชลาวันนั้น — โทรเลื่อนก่อนถึงวัน',
        conflictHoliday: 'มีการจองค้างอยู่ในวันที่ถูกตั้งเป็นวันหยุดภายหลัง',
        packageExpiredWithSessions: 'ลูกค้าจ่ายแล้วใช้ไม่ครบ — เรื่องร้องเรียนที่รอเกิด',
        studentApprovedDuplicate: 'มีคนอนุมัติใบรออนุมัติ หรือสร้างเด็กใหม่เอง ทั้งที่ระบบเตือนว่าอาจซ้ำกับเด็กที่มีอยู่แล้ว — ตรวจว่าเป็นคนเดียวกันไหม ถ้าใช่ต้องรวมประวัติ',
      },
      col: {
        event: 'อีเวนต์', deadline: 'เดทไลน์ชำระ', pastDeadline: 'เกินเดทไลน์', collected: 'เก็บแล้ว', remitted: 'นำส่งแล้ว', outstanding: 'ค้างนำส่ง',
        paydate: 'วันที่ชำระ', cancelledate: 'วันที่ยกเลิก',
        date: 'วันที่', time: 'เวลา', course: 'คอร์ส', pending: 'ค้าง', age: 'ค้างมา',
        coach: 'โค้ช', students: 'นักเรียน', ref: 'เลขที่', type: 'ประเภท', amount: 'จำนวนเงิน',
        paid: 'ชำระ', created: 'สร้างเมื่อ', by: 'ผู้สร้าง', kind: 'ประเภท', name: 'รายการ',
        sessions: 'เรียนแล้ว', since: 'ตั้งแต่', suggested: 'ราคากลาง', context: 'ประเภท',
        status: 'สถานะ', reason: 'สาเหตุ', sender: 'ผู้โอน', remaining: 'คงเหลือ',
        expire: 'หมดอายุ', staff: 'พนักงาน', leaveType: 'ประเภทลา', from: 'ตั้งแต่', to: 'ถึง',
        requested: 'ยื่นเมื่อ', student: 'นักเรียน', nickname: 'ชื่อเล่น', holiday: 'วันหยุด',
        approver: 'ผู้ดำเนินการ', matched: 'ซ้ำกับ', approvedAt: 'อนุมัติเมื่อ',
      },
      // เหตุผลที่ระบบมองว่าเป็นคนเดียวกัน — backend ส่งมาเป็นโค้ด (matchKey) ไม่ใช่ข้อความ
      dupWhy: {
        nameDob: 'ชื่อ-นามสกุล และวันเกิด ตรงกัน',
        name: 'ชื่อ-นามสกุล ตรงกัน',
        nickDob: 'ชื่อเล่น-นามสกุล และวันเกิด ตรงกัน',
        nick: 'ชื่อเล่น-นามสกุล ตรงกัน',
        lastnameDob: 'นามสกุลและวันเกิด ตรงกัน',
        firstNick: 'ชื่อจริงและชื่อเล่น ตรงกัน (นามสกุลต่างกัน)',
      },
      slipStatus: {
        failed: 'ตรวจไม่ผ่าน', skipped: 'ตรวจไม่ได้', duplicate: 'สลิปซ้ำ',
        amount_mismatch: 'ยอดไม่ตรง', wrong_receiver: 'บัญชีผู้รับไม่ตรง',
      },
    },
    session: {
      expiringIn: 'เซสชันจะหมดอายุใน {n} วินาที',
      stayLoggedIn: 'ใช้งานต่อ',
      endedTitle: 'เซสชันสิ้นสุดแล้ว',
      endedExpired: 'หมดเวลาการใช้งาน กรุณายืนยันตัวตนอีกครั้ง — ข้อมูลที่กรอกค้างไว้ยังอยู่',
      endedLogout: 'ออกจากระบบจากอุปกรณ์อื่นแล้ว กรุณาเข้าสู่ระบบใหม่',
      endedPermission: 'สิทธิ์การใช้งานของคุณถูกเปลี่ยน กรุณาเข้าสู่ระบบใหม่',
      continue: 'เข้าสู่ระบบต่อ',
      logoutInstead: 'ออกจากระบบ',
      loginFailed: 'เข้าสู่ระบบไม่สำเร็จ กรุณาตรวจสอบรหัสผ่าน',
    },
    presence: {
      viewersHint: 'กำลังเปิดหน้านี้อยู่ด้วย: {names}',
      editingHint: '{name} กำลังแก้ไขรายการนี้อยู่',
      alsoEditing: '{name} กำลังแก้ไขรายการนี้อยู่ด้วย — ถ้าบันทึกพร้อมกัน ข้อมูลของอีกฝ่ายจะถูกทับ',
    },
  },
  en: {
    common: {
      select: '— Select —', selectCourse: '— Select course —', selectStudent: '— Select student —',
      selectClassTime: '— Select time slot —', selectCoach: '— Select coach —', selectType: '— Select type —',
      selectStartTime: '— Select start time —', selectEndTime: '— Select end time —',
      selectDate: 'Select date', selectDob: 'Select date of birth', confirmDeleteTitle: 'Confirm deletion',
      noData: 'No data found', noResults: 'No matching results', searchPlaceholder: 'Search...',
      noAccess: 'You do not have access to this page',
      sessionExpired: 'Your session has expired. Please log in again.',
      reservationFailed: 'Reservation failed. Please try again.',
      coachLeaveConfirmTitle: 'Coach has approved leave on that date',
      privateConflictTitle: 'Private lessons during this leave',
    },
    reservation: {
      subtitle: 'Pick a date first, then choose a time slot', stepTime: 'Choose a time slot',
      pickDateFirst: 'Please choose a date on the left first<br />before selecting a class time',
      slotsOf: 'Time slots for', full: 'Full', unavailable: 'Unavailable', available: '{n} available', bookThisSlot: 'Book this slot',
      bookCutoff: 'Same-day booking is open until 8:00 AM — after that, bookings start from tomorrow',
      advanceNotice: 'Please book at least 1 day in advance so our coaches know who is coming, can prepare the right lesson plan, and give every child their full attention in class.',
      advanceNoticeCutoff: 'You can book a class until 8:00 AM of the class date.',
      modeSingle: 'Single day', modeMulti: 'Multiple days',
      multiHint: 'Tap dates on the calendar to select or unselect several days',
      multiCount: '{n} day(s) selected (max {max})',
      stepTimeMulti: 'Pick a time slot for each day',
      pickDatesFirst: 'Pick dates from the calendar first — you can select several',
      pickSlot: 'No slot picked yet', removeDay: 'Remove this day',
      multiSummary: '{n} day(s) selected',
      multiSummaryUse: 'Uses {n} session(s) (remaining {a} → {b})',
      multiBookBtn: 'Confirm booking for {n} day(s)',
      multiConfirmTitle: 'Confirm booking — {n} day(s)',
      multiAllOrNothing: 'All-or-nothing: if any day cannot be booked, nothing is booked and the reason is shown.',
      multiSuccess: 'Booked all {n} day(s) successfully',
      multiPickAll: 'Pick a time slot for every selected day',
      multiMax: 'You can select at most {n} days',
    },
    groupbooking: { selectedSlot: 'Selected slot', selectThisSlot: 'Select this slot' },
    customerCourse: { allTypes: 'All types', allPayments: 'All payments', autoGenerated: '(auto-generated)',
      paymentMethod: 'Payment method', selectPayment: '— Select payment method —',
      paymentCash: 'Cash', paymentTransfer: 'Bank transfer', paymentCredit: 'Credit card',
      paymentFee: 'Payment fee',
      paymentFeeEditBtn: 'Edit the fee manually',
      paymentFeeResetBtn: 'Restore the calculated fee',
      paymentFeeAutoHint: 'Calculated automatically at {pct}% of the price',
      paymentFeeNoneHint: 'This payment method has no fee',
      paymentFeeManualHint: 'Edited manually — calculated value is {amount} ฿',
      paymentFeeConfirmTitle: 'Edit the fee manually?',
      paymentFeeConfirmBody: 'The system already calculated this fee as {amount} ฿. Do you want to change it yourself?',
      paymentFeeConfirmOk: 'Yes, edit it',
      promotion: 'Special promotion course', promotionBadge: 'Promo', allPromotions: 'All promotions', notPromo: 'Non-promotion',
      slipVerifyNote: 'Will be verified automatically with Thunder', slipStoreNote: 'Kept as a receipt (not auto-verified)', slipNeedPaid: 'Tick "Paid" first to upload a slip', unlimited: 'Unlimited' },
    bookingMgmt: { searchStudentPlaceholder: 'Type a student name…',
      cancelNeedsUndo: 'Checked in — undo the check-in before cancelling this booking',
      cancelAskManager: 'More than 3 days past — ask the manager to review before cancelling',
      perSessionToggle: 'Drop-in session (auto-creates a 1-session package)',
      perSessionHasMainCourse: 'This student already has a course — a drop-in booking will not deduct from it',
      perSessionPaidCancelTitle: 'This booking is already paid',
      perSessionPaidCancelBody: 'This booking has been paid. Cancelling will also remove the drop-in purchase {refer} from the system, and it will no longer count in the finance report. Really cancel?',
    },
    approve: { subtitle: 'Pending review', approveBtn: 'Approve', rejectBtn: 'Reject' },
    holidays: { subtitle: 'Closed dates', holidayInfo: 'Holiday information' },
    dup: {
      title: 'Possibly the same child', subtitle: 'Check before creating a new record',
      intro: 'Found {n} student(s) with matching details — if it is the same child, move them into this family instead of creating a new record. Their history and courses come along.',
      createAnyway: 'Different child — create', moveHere: 'Move into this family',
      statWithMatch: 'Duplicates',
      filterAll: 'All', filterMatched: 'Has a duplicate', filterUnmatched: 'No match yet',
      needMergeHint: 'Duplicates an existing child — history must be merged, not moved',
      assignFamily: 'Assign to a family',
      mergeTitle: 'Duplicates an existing child', mergeSubtitle: 'History must be merged, not moved',
      mergeExplain: 'This child already has a real record in a customer family. Moving this row there would leave two rows in one family with their history still split.',
      mergeFrom: 'Queue row (old)', mergeTo: 'Real record',
      mergeHow: 'A manager can press "Merge into this child" to move every booking, private lesson, event, group and course onto the real record and close the old one in one step. If you are not a manager, ask one.',
      assignTitle: 'Assign to a family', assignBtn: 'Move into this family',
      assignExplain: 'This child has no real record yet, so they can be moved straight into a family. All history and courses come along.',
      pickFamilyFirst: 'Pick the parent username in the form first — then the move button works',
      moved: 'Moved into the family — all history and courses came along',
      why: { nameDob: 'Same name and date of birth', name: 'Same first and last name', nickDob: 'Same nickname, last name and date of birth', nick: 'Same nickname and last name', lastnameDob: 'Same last name and date of birth', firstNick: 'Same first name and nickname (different last name)' },
      conf: { veryhigh: 'Strong match', high: 'Match', medium: 'Possible match' },
      staffRow: 'Created by staff', noFamily: 'No family yet', bookings: '{n} bookings', lastClass: 'Last class {d}', noClass: 'Never attended',
      tabList: 'Students', tabUnclaimed: 'No parent yet',
      unclaimedHint: 'Children created under a staff account (from when admins booked on their behalf) or with no family — each becomes a duplicate the moment their parent registers and adds them.',
      colParkedUnder: 'Parked under', colCreated: 'Created', colBookings: 'Bookings', colLastClass: 'Last class', colCourse: 'Course', colMatch: 'Likely match',
      statTotal: 'Total', statNoFamily: 'No family', statWithCourse: 'Holds a course', statWithBookings: 'Has attended',
      approveWarn: 'May duplicate {n} existing student(s)', approveWarnHint: 'Check before approving — if it is the same child, reject this and move the existing record into the family instead.',
      headOnlyHint: 'This almost certainly duplicates an existing student — only the manager may review and approve this (rejecting it still works as usual).',
      reasonTitle: 'Reason for approving',
      reasonHint: 'The system flagged a possible duplicate — give a short reason for approving anyway; the manager reviews these later.',
      reasonPlaceholder: 'e.g. checked, different child / they are twins',
      headOnlyCreateHint: 'This almost certainly duplicates an existing student — you cannot create a new one; the manager must review it (moving the existing record into this family still works).',
      linkBtn: 'Merge with the existing child',
      linkHint: 'This child is already in the system. Use the merge button instead of approving, so no duplicate is created.',
      linkTitle: 'Merge with the existing child',
      linkConfirm: 'Move {target} (currently under {current}) into the {family} family and replace their details with what the parent entered. Class history and courses stay intact. This request will be closed.',
      linkDone: 'Merged with the existing child',
      linkFail: 'Could not merge with the existing child',
      staffTag: 'Parked by an admin during a trial',
      acctType: { 0: 'Manager account', 1: 'Admin account', 2: 'Coach account', 10: 'Customer account' },
      whyLabel: 'Why it looks like a duplicate',
      cmpPending: 'Child added by the parent (pending)',
      cmpExisting: 'Child already in the system',
      fName: 'Full name',
      fNick: 'Nickname',
      fDob: 'Date of birth',
      fAccount: 'Account',
      fHistory: 'Class history',
      acctCustomer: 'Customer username: {u}',
      acctStaff: 'Staff account {u} (parked by an admin during a trial)',
      acctNone: 'Not in any account',
      newRequest: 'New request, no history yet',
      historyN: '{n} bookings',
      linkIntro: 'When you confirm, the system will:',
      linkStep1: 'Move the child into the parent account {to}',
      linkStep1NoFam: 'Put the child into customer account {to}',
      linkStep2: 'Use the details the parent entered (rows marked "changed")',
      linkStep3: 'Keep all {n} bookings and existing courses',
      linkStep4: 'Close this request without creating a new child',
      colField: 'Field',
      colNow: 'Now',
      colAfter: 'After merge',
      changed: 'changed',
      linkErr: { gone: 'This request has already been handled', not_candidate: 'This child is not a match the system suggested for linking. Check with the manager.', shared_course: 'The existing child shares a course with another student, so they cannot change family. Contact the manager.', already_in_family: 'This family already has this child. A manager must merge the records instead of linking.', bad_family: 'This request did not come from a customer family, so it cannot be linked.' },
      mergeBtn: 'Merge into this child',
      mergeConfirmTitle: 'Confirm merge',
      mergeConfirm: 'Move all history of {from} ({n} bookings, plus private lessons, events, groups and courses) to {to} and close the old record. This cannot be undone from the app.',
      mergeCheck: 'I have checked that this is the same child',
      mergeDone: 'Students merged',
      mergeFail: 'Could not merge the students',
      mergeErr: { booking_conflict: 'Both records are booked into the same class on the same day. Cancel one booking first, then merge.', event_conflict: 'Both records are registered for the same event. Cancel one registration first, then merge.', course_slots: 'The real record already holds 2 courses, so the old record courses do not fit. Sort out the courses first, then merge.', private_conflict: 'Both records are in the same private lesson. Remove one of them first, then merge.', not_found: 'Student not found or already merged/deleted. Refresh the list.', direction: 'You can only merge a staff-account or no-family record into a record in a customer family.', not_candidate: 'These two records are not a confident match (for example twins), so they cannot be merged.' },
      reasonCreateHint: 'The system flagged a possible duplicate — give a short reason for creating anyway; the manager reviews these later.',
    },
    gymnasts: { typeUsername: 'Type a username…' },
    bookingList: { blindTooltip: 'This name is hidden from other parents' },
    family: { yearsOld: 'yrs', pendingApproval: 'Pending approval' },
    editProfile: { changePhoto: 'Change photo', uploadNewPhoto: 'Upload new photo', removePhoto: 'Remove photo' },
    calendar: {
      tooltipBookingClosed: 'Booking closed for this date (same-day booking until 8:00 AM)', tooltipMondayClosed: 'Monday — closed',
      tooltipHolidayClosed: 'Holiday — closed', legendClosed: 'Mondays and holidays are automatically closed', holidaysThisMonth: 'Holidays this month', holidayLabel: 'Holiday',
      tooltipBeforeMinDate: 'Earlier dates cannot be selected',
    },
    select: { noMatch: 'No matches', searchPlaceholder: 'Type to search…' },
    pager: { firstPage: 'First page', prevPage: 'Previous', nextPage: 'Next', lastPage: 'Last page' },
    classDisable: {
      title: 'Class Closures', subtitle: 'Close specific group classes on specific dates',
      newClosure: 'Close a Class', closureInfo: 'Closure details', dateLabel: 'Closed date',
      pickClass: 'Select class to close', pickClassPlaceholder: '— Select class —',
      noClassOnDate: 'No classes on the selected date', reason: 'Reason (e.g. special holiday / coach absent)',
      confirmDelete: 'Reopen {class} on {date} for booking?',
      created: 'Class closed for booking', reopened: 'Class reopened for booking',
      selectDateFirst: 'Please select a date first',
    },
    closures: {
      title: 'Closures', subtitle: 'Studio holidays and per-class booking closures',
      tabHoliday: 'Holidays (all-day)', tabClass: 'Per-class closures',
      bookingWarnTitle: 'Existing bookings on this date',
      bookingWarnLead: '{date} already has {n} booking(s)',
      bookingWarnGroup: 'Group classes ({n})', bookingWarnPrivate: 'Private sessions ({n})',
      bookingWarnNote: 'These bookings will NOT be cancelled or refunded automatically — please contact the parents and handle them manually.',
      bookingWarnConfirm: 'Proceed anyway',
    },
    nav: { expandMenu: 'Expand menu', collapseMenu: 'Collapse menu', menuPermission: 'Menu Permissions', closures: 'Closures', grouping: 'Coach Grouping', coachSchedule: 'Coach Schedule', coachLeave: 'Request Leave', leaveApproval: 'Leave Approval', scheduleAdmin: 'Manage Schedule' },
    scheduleAdmin: {
      title: 'Manage Schedule', subtitle: 'Create course types and set the weekly class timetable in one place',
      courseTypes: 'Course Types', showDisabled: 'Show disabled courses', addCourse: 'Add course',
      legendClickCourse: 'Click a course to edit', legendDirty: 'Amber outline = unsaved edit',
      legendNew: 'Green outline = newly added', legendAdmin: 'Striped = admin-only class',
      weeklyTable: 'Weekly Class Timetable', addClass: 'Add class',
      hintCreate: 'Click an empty slot to create a class', hintDrag: 'Drag a block to move day/time · drag edges to resize', hintEdit: 'Click a block to edit/delete',
      evTitle: 'Drag to move · drag edges to resize · click to edit',
      editClass: 'Edit Class', newClass: 'New Class', classInfo: 'Class Details',
      startTime: 'Start time', endTime: 'End time', validityAndVisibility: 'Validity & Visibility',
      startDate: 'Active from', endDate: 'Active until', adminOnly: 'Admin-only class', adminOnlyHint: 'Hidden from customers (adminflag)',
      deleteClass: 'Delete class', deleteCourse: 'Delete course', editCourse: 'Edit Course Type', newCourse: 'New Course Type', courseInfo: 'Course Details',
      courseNamePh: 'e.g. Gymnastics Activity', shortNamePh: 'e.g. G.A.',
      refercode: 'Reference code (prefix)', refercodePh: 'e.g. GA',
      refercodeHint: 'Seeds customer course IDs, e.g. GA-20260724-0001 — set once on create',
      refercodeLocked: 'Reference code is set on create only and cannot be changed later',
      courseColor: 'Course color (shown on calendar)', status: 'Status', statusHint: 'Enabled — disabling hides it from booking',
      confirmTitle: 'Confirm', confirmDeleteClass: 'Delete this class? All past learning history is kept — if future bookings exist, the delete is refused until they are cancelled or moved.',
      confirmDeleteCourse: 'Delete this course? All its classes are deleted with it, but past learning history and customer courses are kept in full — allowed only when there are no future bookings and every customer course is finished.',
      confirmProceedHint: 'Confirm to proceed?',
      unsaved: 'unsaved change(s)', discardAll: 'Discard all', saveToSystem: 'Save to system',
      diffNew: 'add {n}', diffEdit: 'edit {n}', diffDelete: 'delete {n}',
      reverted: 'All changes reverted', saved: 'Schedule saved successfully',
    },
    grouping: {
      title: 'Coach Grouping', subtitle: 'Split each class into coach-led groups (replaces the old Google Sheet)',
      coachTitle: 'Coach Schedule', coachSubtitle: 'Your groups for each class — check before teaching',
      privateTitle: 'Private Sessions', noPrivate: 'No private sessions', privateHours: '{n} hr',
      privateCheckinHint: 'Only admin or the coach teaching this session may check in',
      modeDay: 'Day', modeWeek: 'Week', today: 'Today', prev: 'Previous', next: 'Next',
      personUnit: 'students', unassigned: 'Unassigned', allAssigned: 'Everyone is grouped', emptyGroup: 'No members yet',
      noBooking: 'No bookings for this class yet', noSessions: 'No classes on this day',
      addGroup: 'Add group', editGroup: 'Edit group', coachesLabel: 'Group coaches',
      noCoachYet: 'No coaches yet — add them via the "Coach roster" button',
      groupName: 'Special group name (optional)', groupNamePh: 'e.g. Tax FIG1+L.4 (blank = use coach names)',
      groupRemark: 'Group note', groupRemarkPh: 'e.g. uneven bars practice',
      deleteGroup: 'Delete group', confirmDeleteGroup: 'Delete group "{name}"? Its members go back to "Unassigned".',
      moveAllTitle: 'Move all members ({n})', moveAllTo: '— Select target group —', moveAllBtn: 'Move all',
      moveTo: 'Move to', removeFromGroup: 'Remove from group', noGroupYet: 'No groups in this class yet — add one first',
      sessionNote: 'Class note', sessionNotePh: 'e.g. combine L.3-L.4 today',
      dayNote: 'Day note', dayNotePh: 'Add a note for today...',
      absentTag: 'Absent', allDayShort: 'all day', absentCoachesToday: 'Coaches on leave today',
      checkin: 'Check in', undoCheckin: 'Undo check-in',
      absenceBtn: 'Coach absence', absenceTitle: 'Record coach absence', absenceCoach: 'Coach', absenceDate: 'Date',
      absenceAllDay: 'Absent all day', absencePickClasses: 'Select affected classes', absenceReason: 'Reason (optional)', absenceReasonPh: 'e.g. sick leave',
      absenceCancelBtn: 'Cancel absence',
      coachManageBtn: 'Coach roster', coachManageTitle: 'Coach roster', coachManageSub: 'Coaches do not need a login account — link one later',
      autoBtn: 'Auto-group', autoBtnDay: 'Auto-group whole day', autoPreviewTitle: 'Auto-group',
      autoModeUnassigned: 'Ungrouped students only', autoModeUnassignedHint: 'Leaves existing groups untouched — only places students with no group yet',
      autoModeRebuild: 'Rebuild whole session', autoModeRebuildHint: 'Clears every group\'s members in this session and re-places them by the rules (groups, notes and coaches stay)',
      autoNewGroup: 'New group', autoReuseGroup: 'Existing group', autoSessionCount: '{n} sessions',
      autoSkipTitle: 'Could not place · {n}', autoSkipOutOfRange: 'outside every group\'s range',
      autoSkipNoBirthdate: 'no date of birth on record', autoSkipNoLevel: 'no level set',
      autoNothingToDo: 'Nothing to place right now', autoTotal: 'Will place {n} students in {g} groups', autoApplyBtn: 'Apply grouping',
      autoRebuildConfirmTitle: 'Rebuild whole session?', autoRebuildConfirmBody: 'Students you moved by hand will be re-placed by the rules. Continue?',
      autoDone: 'Grouping done — {n} students',
      ruleBtn: 'Rules', ruleTitle: 'Auto-grouping rules', ruleSub: 'One rule set per course — edit here, no code changes needed',
      ruleAdd: 'Add rule set', ruleEdit: 'Edit rule set', ruleDelete: 'Delete rule set', ruleNone: 'No rule sets yet',
      ruleConfirmDelete: 'Delete rule set "{name}"? (groups already created are kept)',
      ruleCourse: 'Course', ruleBasis: 'Group by', ruleName: 'Rule set name', ruleNamePh: 'e.g. G.A. by age',
      ruleBuckets: 'Groups', ruleBucketNamePh: 'Group name, e.g. Ages 3-5', ruleMin: 'From', ruleMax: 'To',
      ruleMaxPerson: 'Max per group', ruleOpenEnd: 'No limit', ruleNoLimit: 'No limit', ruleDefaultCoaches: 'Default coaches (optional)',
      ruleAddBucket: 'Add group', basisAge: 'Age (years)', basisLevel: 'Level',
      ruleHint: 'Leave "From" or "To" empty for an open end · group ranges must not overlap · set a maximum and the system splits into #1 #2 automatically',
      addCoach: 'Add coach', editCoach: 'Edit coach', coachName: 'Display name', coachColor: 'Coach color', coachSort: 'Order',
      coachLink: 'Link to login account', coachLinkNone: '— No account —',
      coachLinkHint: 'Once linked, that coach sees "my groups" highlighted on the Coach Schedule page',
      coachDisable: 'Disable coach', confirmDisableCoach: 'Disable coach "{name}"? Existing groups keep showing the name.',
      disabledBadge: 'Disabled', notLinkedBadge: 'No login account linked',
      highlightMine: 'Highlight my groups', myGroupsOnly: 'My groups only',
      loadFail: 'Failed to load data',
      leaveBtn: 'Leave requests', leaveReqTitle: 'Staff leave requests', leaveReqSub: 'Approving records the absence on the schedule automatically',
      leavePendingTitle: 'Needs action', leaveHistoryTitle: 'Reviewed history', leaveHistorySub: 'Requests already approved, rejected, or cancelled', leaveHistoryCount: '{n} item(s)',
      myLeaveHistory: 'Leave history', viewGrouped: 'Group by type', viewChrono: 'Sort by date',
      ovApprovedLabel: 'Approved {n} day(s)', ovPendingNote: '{n} day(s) reserved pending',
      quotaOverLabel: 'Over quota by {over} day(s) (approved {used} of {quota} day cap)', quotaNotSetWithUsed: 'No quota set for this year · {n} day(s) submitted',
      leaveOverviewQuotaNote: 'The "remaining" figure already deducts pending requests, to prevent over-approving later.',
      leavePendingCountNote: '{n} pending request(s) from this staff member{type}', goToPendingCard: 'Go to the "Needs action" card',
      daysInYearNote: '({n} day(s) in this year)',
      myLeaveSubmit: 'Request leave', myLeaveList: 'My leave requests', leaveSubmitBtn: 'Submit',
      leaveTypeLabel: 'Leave type', leaveType_sick: 'Sick leave', leaveType_personal: 'Personal leave', leaveType_vacation: 'Vacation',
      leaveType_unpaid: 'General leave (unpaid)',
      dayPortionLabel: 'Leave duration', dayPortion_full: 'Full day', dayPortion_morning: 'Morning half', dayPortion_afternoon: 'Afternoon half',
      createLeaveLabel: 'Create leave (pending approval)', createLeaveHint: 'Creates a pending leave for this coach — the coach shows as on leave in the schedule right away, and quota is deducted once a manager approves it (Part-time = not-teaching marker only)',
      leaveOverviewTitle: 'Yearly leave overview', staffName: 'Staff',
      leaveOverviewHint: 'Click a staff name to expand their individual leave records (filter by type)',
      leaveTypeAll: 'All types', leaveDetailOf: 'Leave records of {name}', submittedAt: 'Submitted',
      cancelReviewBtn: 'Void', cancelReviewTitle: 'Void leave request',
      confirmCancelReview: 'Void the already-reviewed leave of "{name}"? The system will remove it from the schedule and restore the quota.',
      countAsLeave: 'Count as leave (deduct quota)', countAsLeaveHint: 'Creates an approved leave for this coach and deducts this year’s quota for the chosen type',
      parttimeNoQuota: 'Part-time coach — recorded as not teaching only, no quota deducted',
      employmentType: 'Employment type', employmentTypeHint: 'Full-time = leave deducts quota · Part-time = mark not-teaching only',
      employmentFulltime: 'Full-time', employmentParttime: 'Part-time',
      leaveFrom: 'From date', leaveTo: 'To date', leaveReason: 'Reason (optional)', leaveReasonPh: 'e.g. family matters',
      leaveMultiDayHint: 'Multi-day leave = all-day for every date in the range (per-class only for single-day leave)',
      leaveStatus_pending: 'Pending', leaveStatus_approved: 'Approved', leaveStatus_rejected: 'Rejected', leaveStatus_cancelled: 'Cancelled',
      approve: 'Approve', reject: 'Reject', reviewNote: 'Note to coach (optional)',
      confirmApprove: 'Approve "{name}"\'s leave? The absence will be recorded on the schedule automatically.',
      confirmReject: 'Reject "{name}"\'s leave request?',
      cancelReq: 'Cancel request', confirmCancelReq: 'Cancel this leave request?',
      notLinkedLeave: 'Your account is not linked to a coach yet — please contact the manager', noLeaveReq: 'No leave requests yet',
      leavePageTitle: 'Request Leave', leavePageSub: 'Submit leave, see remaining quota, and track approvals',
      leaveApprovalTitle: 'Leave Approval', leaveApprovalSub: 'Review and approve/reject staff leave requests, and set yearly quotas',
      daysUnit: 'days', statusAll: 'All statuses', quotaRemainLabel: 'Remaining', quotaUsedLabel: 'Used',
      quotaPendingNote: '{n} day(s) pending', quotaNotSet: 'No quota set for this year', quotaUsedShort: '{n} day(s) used',
      quotaBtn: 'Set quotas', quotaTitle: 'Yearly leave quotas', quotaSub: 'Set leave days per year for each coach (manager only)', quotaYear: 'Year', saveAllQuota: 'Save all',
      noCoachYetOnLeave: 'No coaches yet — add them on the "Coach Grouping" page ("Coach roster" button)', goToGrouping: 'Go to Coach Grouping',
    },
    menuPerm: {
      title: 'Menu Permissions', subtitle: 'Choose which user types can access each menu (manager only)',
      colMenu: 'Menu', save: 'Save permissions', saved: 'Menu permissions saved',
      confirmTitle: 'Confirm permission changes', confirmBody: '{n} change(s):',
      changedCount: '{n} change(s)', allow: 'Allow', deny: 'Deny',
      notConfigured: 'Not configured — manager only', headAlways: 'The manager always has every menu', headToggleHint: 'Click to hide/show this menu in the manager sidebar',
      coreAlwaysHint: 'Core menu, always available to everyone', coreHeadHint: 'Manager only',
      externalHint: 'External system (SSO) — the payment app re-checks manager rights itself',
      restrictedByCode: 'Some actions in this menu are manager/admin-only (e.g. pricing, slip check) — you can grant the menu, but those actions still won\'t work',
      restrictedHeadAdmin: 'This whole menu is manager/admin-only in code — it can\'t be granted to a coach/customer',
      lockedHeadAdmin: 'Every action here requires manager/admin — granting this role has no effect',
      loadFail: 'Failed to load permissions',
      userTitle: 'Per-user grants', userSubtitle: 'Grant extra menus to specific staff (on top of their role)', pickUser: '— Select staff —', pickUserHint: 'Select a staff member to set individual menu access', userSaved: 'Per-user grants saved',
    },
    auth: { pleaseLoginAgain: 'Please log in again' },
    noti: {
      title: 'Notifications', upcoming: 'Current', past: 'Earlier',
      empty: 'No notifications yet', markAllRead: 'Mark all read',
      enablePush: 'Enable notifications on this device', pushOn: 'Notifications are on',
      pushOff: 'Turn off on this device',
      pushDesc: 'Get an alert on your screen when a new notification arrives, even with the site closed',
      pushBlocked: 'Your browser is blocking notifications — enable them in browser settings',
      pushUnsupported: 'This browser does not support notifications',
      pushIosHint: 'On iPhone/iPad, tap Share then "Add to Home Screen" first — notifications can only be enabled from the installed app',
      pushFail: 'Could not enable notifications',
    },
    ops: {
      title: 'Daily Checks', subtitle: 'Things that slipped through — scan before you close up',
      managerOnly: 'Manager/Admin', refresh: 'Re-check',
      sevUrgent: 'Handle today', sevWatch: 'This week', sevInfo: 'Anomalies',
      lookback: 'Look back', lookbackDays: '{n} days', lookbackAll: 'All',
      checkedAt: 'Checked at {time}',
      attendanceLimitNote: 'There is no "absent" status — a pending check-in can be cleared two ways: the child did come but nobody tapped it → check them in retroactively (no date limit) · the child did not come → cancel the booking, the session is refunded automatically and the row disappears.',
      trendTitle: 'Trend, last {n} days',
      trendNote: 'Snapshot taken automatically at 21:30 daily, always using the same {days}-day look-back',
      trendShowTable: 'Show daily numbers',
      trendHideTable: 'Hide daily numbers',
      trendColDate: 'Date',
      allClear: 'Nothing outstanding', allClearSub: 'All checks ran and found nothing to handle',
      goFix: 'Go fix it', truncated: 'Showing {shown} of {total}',
      unknownPriceExcluded: 'Amount excludes {n} item(s) with no price recorded',
      countedSince: 'Counted since {date}', passed: 'Checks that passed',
      loadFail: 'Failed to load the checklist',
      paidYes: 'Paid', paidNo: 'Unpaid', flagYes: 'Yes', ageDays: '{n} d',
      kind: { course: 'Course', private: 'Private', approve: 'Approved request', create: 'Created directly' },
      check: {
        eventUnpaid: 'Unpaid event sign-ups (holding seats)',
        eventRefundPending: 'Cancelled events awaiting a refund decision',
        eventOrganizerRemit: 'Organizer money awaiting remittance',
        checkinGroup: 'Class sessions not fully checked in',
        checkinPrivate: 'Private lessons not checked in',
        checkinEvent: 'Events not fully checked in',
        packageUnlinked: 'Packages not linked to a child',
        paymentUnpaidTaught: 'Unpaid — already taught',
        paymentUnpaid: 'Unpaid — not started',
        priceMissing: 'Paid but no price entered',
        paymentMethodMissing: 'Paid but no payment method',
        slipUnverified: 'Slips that failed or could not be checked',
        packageExpiringSoon: 'Packages running out',
        packageStale: 'Bought but never started',
        leavePending: 'Leave requests awaiting review',
        studentPendingApproval: 'New students awaiting approval',
        conflictCoachLeave: 'Private lessons on the coach\'s leave day',
        conflictHoliday: 'Bookings that fall on a holiday',
        packageExpiredWithSessions: 'Expired with sessions left',
        studentApprovedDuplicate: 'Let through despite a duplicate warning',
      },
      hint: {
        eventUnpaid: 'Signed up but not paid — the seat is held · past the deadline (closing date), decide to drop or chase payment',
        eventRefundPending: 'The event was cancelled but the money is still with the gym — record whether it was refunded (the transfer itself happens outside the system); this stays until every row is recorded',
        eventOrganizerRemit: 'Organizer share collected from customers but not yet recorded as remitted (a liability, not revenue)',
        checkinGroup: 'Past sessions with students still not checked in — came but not tapped: check in retroactively · did not come: cancel the booking (session is refunded)',
        checkinPrivate: 'Private lessons already taught but not checked in — check in retroactively, or cancel the booking if it never happened',
        checkinEvent: 'Past events with participants still not checked in — check in retroactively from the schedule pages, or cancel the sign-up if they did not attend',
        packageUnlinked: 'A package exists but no child is attached — nobody can book with it',
        paymentUnpaidTaught: 'Service already delivered but not paid for; this grows every week',
        paymentUnpaid: 'Sold but not collected, and not started yet',
        priceMissing: 'No price means the finance report cannot count this sale',
        paymentMethodMissing: 'Cash / transfer / card unknown — the by-method breakdown misses it',
        slipUnverified: 'Usually the photo has no QR code — not proof of a fake slip; needs a human look',
        packageExpiringSoon: '2 sessions or fewer left, or expiring within 14 days — a renewal opening',
        packageStale: 'Bought over 14 days ago and never booked once',
        leavePending: 'Staff filed a leave request that nobody has reviewed',
        studentPendingApproval: 'A parent added a new child, waiting to be approved',
        conflictCoachLeave: 'A private lesson is booked on a day the coach is on leave — call and move it',
        conflictHoliday: 'Bookings still sitting on a date that was later made a holiday',
        packageExpiredWithSessions: 'The customer paid but could not use it all — a complaint waiting to happen',
        studentApprovedDuplicate: 'Someone approved a pending request, or created a student directly, even though the system warned it may duplicate an existing one — check whether it is the same child; if so, the histories must be merged',
      },
      col: {
        event: 'Event', deadline: 'Pay deadline', pastDeadline: 'Past deadline', collected: 'Collected', remitted: 'Remitted', outstanding: 'Outstanding',
        paydate: 'Paid on', cancelledate: 'Cancelled on',
        date: 'Date', time: 'Time', course: 'Course', pending: 'Pending', age: 'Age',
        coach: 'Coach', students: 'Students', ref: 'Ref', type: 'Type', amount: 'Amount',
        paid: 'Payment', created: 'Created', by: 'By', kind: 'Kind', name: 'Item',
        sessions: 'Attended', since: 'Since', suggested: 'List price', context: 'Kind',
        status: 'Status', reason: 'Reason', sender: 'Sender', remaining: 'Remaining',
        expire: 'Expires', staff: 'Staff', leaveType: 'Leave type', from: 'From', to: 'To',
        requested: 'Filed', student: 'Student', nickname: 'Nickname', holiday: 'Holiday',
        approver: 'Actioned by', matched: 'Matches', approvedAt: 'Approved on',
      },
      dupWhy: {
        nameDob: 'Same name and date of birth',
        name: 'Same first and last name',
        nickDob: 'Same nickname, last name and date of birth',
        nick: 'Same nickname and last name',
        lastnameDob: 'Same last name and date of birth',
        firstNick: 'Same first name and nickname (different last name)',
      },
      slipStatus: {
        failed: 'Failed', skipped: 'Not checked', duplicate: 'Duplicate',
        amount_mismatch: 'Amount mismatch', wrong_receiver: 'Wrong receiver',
      },
    },
    session: {
      expiringIn: 'Your session expires in {n} seconds',
      stayLoggedIn: 'Stay signed in',
      endedTitle: 'Session ended',
      endedExpired: 'Your session timed out. Please confirm your identity — anything you typed is still here.',
      endedLogout: 'You signed out on another device. Please sign in again.',
      endedPermission: 'Your permissions changed. Please sign in again.',
      continue: 'Continue',
      logoutInstead: 'Sign out',
      loginFailed: 'Sign-in failed. Please check your password.',
    },
    presence: {
      viewersHint: 'Also viewing this page: {names}',
      editingHint: '{name} is editing this record',
      alsoEditing: '{name} is editing this record too — saving at the same time will overwrite their changes',
    },
  },
  zh: {
    common: {
      select: '— 请选择 —', selectCourse: '— 选择课程 —', selectStudent: '— 选择学员 —',
      selectClassTime: '— 选择时段 —', selectCoach: '— 选择教练 —', selectType: '— 选择类型 —',
      selectStartTime: '— 选择开始时间 —', selectEndTime: '— 选择结束时间 —',
      selectDate: '选择日期', selectDob: '选择出生日期', confirmDeleteTitle: '确认删除',
      noData: '未找到数据', noResults: '未找到匹配结果', searchPlaceholder: '搜索...',
      noAccess: '您无权访问此页面',
      sessionExpired: '登录已过期，请重新登录',
      reservationFailed: '预约失败，请重试',
      coachLeaveConfirmTitle: '教练当天已请假',
      privateConflictTitle: '请假期间已有私教课',
    },
    reservation: {
      subtitle: '请先选择日期，再选择时段', stepTime: '选择时段',
      pickDateFirst: '请先在左侧选择日期<br />才能选择上课时段',
      slotsOf: '时段：', full: '已满', unavailable: '暂不开放', available: '空位 {n}', bookThisSlot: '预约此时段',
      bookCutoff: '当天课程可预约至上午 8:00，之后仅可预约明天及以后的日期',
      advanceNotice: '建议至少提前 1 天预约，让教练提前了解上课名单和人数、妥善安排教学计划，全心照顾每一位上课的孩子。',
      advanceNoticeCutoff: '课程可预约至上课当天上午 8:00。',
      modeSingle: '单日预约', modeMulti: '多日预约',
      multiHint: '点击日历中的日期，可选择/取消多天',
      multiCount: '已选 {n} 天（最多 {max} 天）',
      stepTimeMulti: '为每一天选择时段',
      pickDatesFirst: '请先在日历中选择日期，可选多天',
      pickSlot: '尚未选择时段', removeDay: '移除这一天',
      multiSummary: '已选 {n} 天',
      multiSummaryUse: '将使用 {n} 次课（剩余 {a} → {b}）',
      multiBookBtn: '确认预约 {n} 天',
      multiConfirmTitle: '确认预约 {n} 天',
      multiAllOrNothing: '仅当所有日期都能预约时才会保存：若有任何一天无法预约，将不会预约任何日期并说明原因。',
      multiSuccess: '已成功预约全部 {n} 天',
      multiPickAll: '请为每个已选日期选择时段',
      multiMax: '最多可选择 {n} 天',
    },
    groupbooking: { selectedSlot: '已选时段', selectThisSlot: '选择此时段' },
    customerCourse: { allTypes: '全部类型', allPayments: '全部付款状态', autoGenerated: '(自动生成)',
      paymentMethod: '付款方式', selectPayment: '— 选择付款方式 —',
      paymentCash: '现金', paymentTransfer: '银行转账', paymentCredit: '信用卡',
      paymentFee: '支付手续费',
      paymentFeeEditBtn: '手动修改手续费',
      paymentFeeResetBtn: '恢复系统计算的金额',
      paymentFeeAutoHint: '系统按价格的 {pct}% 自动计算',
      paymentFeeNoneHint: '此支付方式没有手续费',
      paymentFeeManualHint: '已手动修改 — 系统计算值为 {amount} ฿',
      paymentFeeConfirmTitle: '手动修改手续费？',
      paymentFeeConfirmBody: '系统已计算出手续费为 {amount} ฿，确定要自行修改吗？',
      paymentFeeConfirmOk: '是，我要修改',
      promotion: '特别优惠课程', promotionBadge: '优惠', allPromotions: '全部优惠', notPromo: '非优惠',
      slipVerifyNote: '将通过 Thunder 自动核验', slipStoreNote: '仅作凭证保存（不自动核验）', slipNeedPaid: '先勾选“已付款”才能上传凭证', unlimited: '不限' },
    bookingMgmt: { searchStudentPlaceholder: '输入学员姓名…',
      cancelNeedsUndo: '已签到 — 需先取消签到才能取消预约',
      cancelAskManager: '已超过 3 天 — 请先联系经理核实后再取消',
      perSessionToggle: '单次课（系统自动创建 1 次课程包）',
      perSessionHasMainCourse: '该学员已有课程包 — 单次课预约不会扣减原课程包',
      perSessionPaidCancelTitle: '该预约已付款',
      perSessionPaidCancelBody: '该预约已完成付款，取消预约将同时从系统中移除单次课凭证 {refer}，该金额也不再计入财务报表。确定要取消吗？',
    },
    approve: { subtitle: '待审核列表', approveBtn: '批准', rejectBtn: '拒绝' },
    holidays: { subtitle: '休息日', holidayInfo: '假日信息' },
    dup: {
      title: '可能是同一个孩子', subtitle: '创建前请先确认',
      intro: '发现 {n} 名信息相符的学员 — 如果是同一个孩子，请将其转入本家庭，而不是新建记录。上课记录与课程包会一并转移。',
      createAnyway: '不同的孩子 — 新建', moveHere: '转入本家庭',
      statWithMatch: '存在重复',
      filterAll: '全部', filterMatched: '存在重复', filterUnmatched: '尚无匹配',
      needMergeHint: '与已有学员重复 — 需要合并记录，不能直接转入',
      assignFamily: '分配到家庭',
      mergeTitle: '与已有学员重复', mergeSubtitle: '需要合并记录，而不是转入',
      mergeExplain: '该孩子在客户家庭中已有正式记录。若直接把这条记录转入，同一家庭下会出现两条记录，而上课记录仍是分开的。',
      mergeFrom: '队列中的记录（旧）', mergeTo: '系统中的正式记录',
      mergeHow: '负责人点击"合并到此学员"即可一次性将所有预约、私教课、活动、分组和课程移至正式记录并关闭旧记录。如果您不是负责人，请联系负责人。',
      assignTitle: '分配到家庭', assignBtn: '转入本家庭',
      assignExplain: '该孩子在系统中尚无正式记录，可以直接转入家庭，上课记录与课程包会一并转移。',
      pickFamilyFirst: '请先在表单中选择家长账号，转入按钮才可使用',
      moved: '已转入家庭 — 记录与课程包已一并转移',
      why: { nameDob: '姓名与出生日期相同', name: '姓名相同', nickDob: '小名、姓氏与出生日期相同', nick: '小名与姓氏相同', lastnameDob: '姓氏与出生日期相同', firstNick: '名字与小名相同（姓氏不同）' },
      conf: { veryhigh: '高度吻合', high: '吻合', medium: '可能吻合' },
      staffRow: '员工创建的记录', noFamily: '尚无家庭', bookings: '预约 {n} 次', lastClass: '最近上课 {d}', noClass: '尚未上过课',
      tabList: '学员名单', tabUnclaimed: '尚无家长',
      unclaimedHint: '在员工账号下创建的孩子（管理员代为预约的时期），或尚未归属家庭 — 家长注册并添加孩子后，这些都会立即变成重复数据。',
      colParkedUnder: '挂在账号', colCreated: '创建于', colBookings: '预约', colLastClass: '最近上课', colCourse: '课程包', colMatch: '可能匹配',
      statTotal: '全部', statNoFamily: '无家庭', statWithCourse: '持有课程包', statWithBookings: '上过课',
      approveWarn: '可能与 {n} 名现有学员重复', approveWarnHint: '批准前请确认 — 如果是同一个孩子，请拒绝此申请并将原有记录转入该家庭。',
      headOnlyHint: '系统判定与现有学员几乎确定重复 — 只有负责人可以审核并通过（拒绝仍可照常操作）。',
      reasonTitle: '通过理由',
      reasonHint: '系统提示可能重复 — 请简短说明为何仍然通过，负责人会在之后复核。',
      reasonPlaceholder: '例如：已确认是不同的孩子／是双胞胎',
      headOnlyCreateHint: '系统判定与现有学员几乎确定重复 — 无法新建，须由负责人审核（将原有记录转入该家庭仍可照常操作）。',
      linkBtn: '与系统中已有学员合并',
      linkHint: '该学员已在系统中 — 请使用合并按钮代替审核通过，以免产生重复',
      linkTitle: '与系统中已有学员合并',
      linkConfirm: '将 {target}（目前在 {current} 名下）移入 {family} 家庭，并以家长填写的资料替换原资料。该学员的上课记录与课程保持不变。此申请将被关闭。',
      linkDone: '已与现有学员合并',
      linkFail: '与现有学员合并失败',
      staffTag: '试课时由管理员代存',
      acctType: { 0: '经理账户', 1: '管理员账户', 2: '教练账户', 10: '客户账户' },
      whyLabel: '系统判断重复的原因',
      cmpPending: '家长自行添加的学员（待审核）',
      cmpExisting: '系统中已有的学员',
      fName: '姓名',
      fNick: '小名',
      fDob: '出生日期',
      fAccount: '所属账户',
      fHistory: '上课记录',
      acctCustomer: '客户用户名：{u}',
      acctStaff: '员工账户 {u}（试课时由管理员代存）',
      acctNone: '不属于任何账户',
      newRequest: '新申请，尚无记录',
      historyN: '已预约 {n} 次',
      linkIntro: '确认后，系统将：',
      linkStep1: '将学员移入家长账户 {to}',
      linkStep1NoFam: '将学员放入客户账户 {to}',
      linkStep2: '使用家长填写的资料（标有"变更"的行）',
      linkStep3: '保留全部 {n} 次上课记录和原有课程',
      linkStep4: '关闭此申请，不新建学员',
      colField: '项目',
      colNow: '当前',
      colAfter: '合并后',
      changed: '变更',
      linkErr: { gone: '此申请已被处理', not_candidate: '此学员不是系统建议关联的对象 — 请与负责人确认', shared_course: '该学员的课程与其他学员共用，无法更换家庭 — 请联系负责人', already_in_family: '该家庭已有此学员 — 须由负责人合并记录，而不是关联', bad_family: '此申请并非来自客户家庭，无法关联' },
      mergeBtn: '合并到此学员',
      mergeConfirmTitle: '确认合并学员',
      mergeConfirm: '将 {from} 的全部记录（{n} 个预约，及私教课、活动、分组和课程）移至 {to}，并关闭旧记录。无法在系统中撤销。',
      mergeCheck: '我已确认是同一个孩子',
      mergeDone: '学员已合并',
      mergeFail: '合并学员失败',
      mergeErr: { booking_conflict: '两条记录在同一天预约了同一课程 — 请先取消其中一个预约再合并', event_conflict: '两条记录都报名了同一活动 — 请先取消其中一个报名再合并', course_slots: '正式记录已有 2 个课程，旧记录的课程放不下 — 请先处理课程再合并', private_conflict: '两条记录在同一私教课中 — 请先移除其中一个再合并', not_found: '未找到学员或已被合并/删除 — 请刷新列表', direction: '只能将员工账户下或无家庭的记录合并到客户家庭中的记录', not_candidate: '这两条记录并非确定重复（例如双胞胎），无法合并' },
      reasonCreateHint: '系统提示可能重复 — 请简短说明为何仍要新建，负责人会在之后复核。',
    },
    gymnasts: { typeUsername: '输入用户名…' },
    bookingList: { blindTooltip: '该学员姓名对其他家长隐藏' },
    family: { yearsOld: '岁', pendingApproval: '待批准' },
    editProfile: { changePhoto: '更换照片', uploadNewPhoto: '上传新照片', removePhoto: '删除照片' },
    calendar: {
      tooltipBookingClosed: '该日期已停止预约（当天课程可预约至上午 8:00）', tooltipMondayClosed: '周一 — 休息',
      tooltipHolidayClosed: '假日 — 休息', legendClosed: '周一及假日自动休息', holidaysThisMonth: '本月假日', holidayLabel: '假日',
      tooltipBeforeMinDate: '不能选择更早的日期',
    },
    select: { noMatch: '无匹配项', searchPlaceholder: '输入以搜索…' },
    pager: { firstPage: '首页', prevPage: '上一页', nextPage: '下一页', lastPage: '末页' },
    classDisable: {
      title: '关闭班级预约', subtitle: '按班级、按日期关闭团体课预约',
      newClosure: '新增关闭', closureInfo: '关闭信息', dateLabel: '关闭日期',
      pickClass: '选择要关闭的班级', pickClassPlaceholder: '— 选择班级 —',
      noClassOnDate: '所选日期没有班级', reason: '原因（如特殊假日／教练请假）',
      confirmDelete: '确定要重新开放 {class} 在 {date} 的预约吗？',
      created: '已关闭该班级预约', reopened: '已重新开放该班级预约',
      selectDateFirst: '请先选择日期',
    },
    closures: {
      title: '停课管理', subtitle: '管理工作室假日与单个班级停止预约',
      tabHoliday: '假日（全天）', tabClass: '单个班级停止',
      bookingWarnTitle: '该日期已有预约',
      bookingWarnLead: '{date} 已有 {n} 条预约',
      bookingWarnGroup: '团体课（{n}）', bookingWarnPrivate: '私教课（{n}）',
      bookingWarnNote: '系统不会自动取消这些预约或退还课时，请联系家长并手动处理。',
      bookingWarnConfirm: '仍要继续',
    },
    nav: { expandMenu: '展开菜单', collapseMenu: '收起菜单', menuPermission: '菜单权限', closures: '停课管理', grouping: '教练分组', coachSchedule: '教练课表', coachLeave: '请假申请', leaveApproval: '请假审批', scheduleAdmin: '课程表管理' },
    scheduleAdmin: {
      title: '课程表管理', subtitle: '在一处创建课程类型并设置每周班级时间表',
      courseTypes: '课程类型', showDisabled: '显示已停用课程', addCourse: '添加课程',
      legendClickCourse: '点击课程进行编辑', legendDirty: '黄色边框＝未保存的修改',
      legendNew: '绿色边框＝新增', legendAdmin: '斜纹＝仅管理员班级',
      weeklyTable: '每周班级时间表', addClass: '添加班级',
      hintCreate: '点击空白处创建班级', hintDrag: '拖动方块可移动日期/时间 · 拖动边缘可调整时长', hintEdit: '点击方块可编辑/删除',
      evTitle: '拖动移动 · 拖动边缘调整时间 · 点击编辑',
      editClass: '编辑班级', newClass: '新增班级', classInfo: '班级信息',
      startTime: '开始时间', endTime: '结束时间', validityAndVisibility: '有效期与可见性',
      startDate: '生效日期', endDate: '截止日期', adminOnly: '仅管理员班级', adminOnlyHint: '对客户隐藏 (adminflag)',
      deleteClass: '删除班级', deleteCourse: '删除课程', editCourse: '编辑课程类型', newCourse: '新增课程类型', courseInfo: '课程信息',
      courseNamePh: '例如 Gymnastics Activity', shortNamePh: '例如 G.A.',
      refercode: '参考代码 (前缀)', refercodePh: '例如 GA',
      refercodeHint: '用于生成客户课程编号，如 GA-20260724-0001 — 仅创建时设置',
      refercodeLocked: '参考代码仅在创建时设置，之后无法修改',
      courseColor: '课程颜色 (显示在日历上)', status: '状态', statusHint: '已启用 — 停用后将从预约中隐藏',
      confirmTitle: '确认', confirmDeleteClass: '要删除此班级吗？过往的上课记录将全部保留——如果仍有未来的预约，需先取消或移动后才能删除。',
      confirmDeleteCourse: '要删除此课程吗？其所有班级将一并删除，但过往的上课记录和客户课程将全部保留——仅当没有未来预约且所有客户课程均已结束时才能删除。',
      confirmProceedHint: '确认继续？',
      unsaved: '项未保存', discardAll: '全部取消', saveToSystem: '保存到系统',
      diffNew: '新增 {n}', diffEdit: '修改 {n}', diffDelete: '删除 {n}',
      reverted: '已还原所有更改', saved: '课程表已成功保存',
    },
    grouping: {
      title: '教练分组', subtitle: '将每节课的学员分配给各教练负责（取代原 Google 表格）',
      coachTitle: '教练课表', coachSubtitle: '每节课您负责的小组 — 上课前查看',
      privateTitle: '私教课表', noPrivate: '没有私教课', privateHours: '{n} 小时',
      privateCheckinHint: '仅管理员或本节课的授课教练可以签到',
      modeDay: '日', modeWeek: '周', today: '今天', prev: '上一个', next: '下一个',
      personUnit: '人', unassigned: '未分组', allAssigned: '全部已分组', emptyGroup: '暂无组员',
      noBooking: '本节课暂无预约', noSessions: '当天没有课程',
      addGroup: '添加小组', editGroup: '编辑小组', coachesLabel: '小组教练',
      noCoachYet: '还没有教练名单 — 请点击"教练名单"按钮添加',
      groupName: '特殊小组名称（可选）', groupNamePh: '例如 Tax FIG1+L.4（留空则显示教练名）',
      groupRemark: '小组备注', groupRemarkPh: '例如 高低杠练习',
      deleteGroup: '删除小组', confirmDeleteGroup: '确定删除小组"{name}"吗？组员将回到"未分组"。',
      moveAllTitle: '移动全部组员（{n} 人）', moveAllTo: '— 选择目标小组 —', moveAllBtn: '全部移动',
      moveTo: '移至', removeFromGroup: '移出小组', noGroupYet: '本节课还没有小组 — 请先添加',
      sessionNote: '课堂备注', sessionNotePh: '例如 今天 L.3-L.4 合并',
      dayNote: '当日备注', dayNotePh: '添加今天的备注...',
      absentTag: '请假', allDayShort: '全天', absentCoachesToday: '今日请假教练',
      checkin: '签到', undoCheckin: '取消签到',
      absenceBtn: '教练请假', absenceTitle: '记录教练请假', absenceCoach: '教练', absenceDate: '日期',
      absenceAllDay: '全天请假', absencePickClasses: '选择请假的课节', absenceReason: '原因（可选）', absenceReasonPh: '例如 病假',
      absenceCancelBtn: '取消请假',
      coachManageBtn: '教练名单', coachManageTitle: '教练名单', coachManageSub: '教练无需登录账号 — 可以之后再绑定',
      autoBtn: '自动分组', autoBtnDay: '整天自动分组', autoPreviewTitle: '自动分组',
      autoModeUnassigned: '仅未分组的学员', autoModeUnassignedHint: '不改动已有分组 — 只安排还没有分组的学员',
      autoModeRebuild: '重新分配整节课', autoModeRebuildHint: '清空本节课所有分组的成员后按规则重新分配（分组本身、备注和教练保留）',
      autoNewGroup: '新建分组', autoReuseGroup: '使用原分组', autoSessionCount: '{n} 节课',
      autoSkipTitle: '无法分组 · {n} 人', autoSkipOutOfRange: '不在任何分组的范围内',
      autoSkipNoBirthdate: '未填写出生日期', autoSkipNoLevel: '未填写级别',
      autoNothingToDo: '目前没有需要分组的学员', autoTotal: '将安排 {n} 人，分成 {g} 组', autoApplyBtn: '确认分组',
      autoRebuildConfirmTitle: '重新分配整节课？', autoRebuildConfirmBody: '手动调整过的学员将全部按规则重新分配，确认吗？',
      autoDone: '分组完成 — {n} 人',
      ruleBtn: '规则设置', ruleTitle: '自动分组规则', ruleSub: '每门课程一套规则 — 在此修改，无需改代码',
      ruleAdd: '新增规则', ruleEdit: '修改规则', ruleDelete: '删除规则', ruleNone: '还没有规则',
      ruleConfirmDelete: '删除规则「{name}」吗？（已建立的分组不会被删除）',
      ruleCourse: '课程', ruleBasis: '分组依据', ruleName: '规则名称', ruleNamePh: '例如：G.A. 按年龄',
      ruleBuckets: '分组', ruleBucketNamePh: '分组名称，例如：3-5 岁幼儿', ruleMin: '从', ruleMax: '到',
      ruleMaxPerson: '每组上限', ruleOpenEnd: '不限', ruleNoLimit: '不限', ruleDefaultCoaches: '默认教练（选填）',
      ruleAddBucket: '新增分组', basisAge: '年龄（岁）', basisLevel: '级别',
      ruleHint: '「从」或「到」留空表示该端不限 · 各分组的范围不能重叠 · 设定上限后系统会自动拆分为 #1 #2',
      addCoach: '添加教练', editCoach: '编辑教练', coachName: '昵称', coachColor: '教练颜色', coachSort: '排序',
      coachLink: '绑定登录账号', coachLinkNone: '— 不绑定 —',
      coachLinkHint: '绑定后该教练在"教练课表"页面会高亮显示"我的小组"',
      coachDisable: '停用教练', confirmDisableCoach: '停用教练"{name}"吗？已安排的小组仍会正常显示名称。',
      disabledBadge: '已停用', notLinkedBadge: '未绑定登录账号',
      highlightMine: '高亮我的小组', myGroupsOnly: '只看我的',
      loadFail: '数据加载失败',
      leaveBtn: '请假申请', leaveReqTitle: '员工请假申请', leaveReqSub: '批准后系统会自动把请假记录到课表',
      leavePendingTitle: '待处理', leaveHistoryTitle: '已处理记录', leaveHistorySub: '已批准、拒绝或取消的申请', leaveHistoryCount: '{n} 条记录',
      myLeaveHistory: '请假记录', viewGrouped: '按类型分组', viewChrono: '按日期排序',
      ovApprovedLabel: '已批准 {n} 天', ovPendingNote: '预留待审批 {n} 天',
      quotaOverLabel: '超出额度 {over} 天（已批准 {used}／上限 {quota} 天）', quotaNotSetWithUsed: '今年尚未设置额度 · 已提交 {n} 天',
      leaveOverviewQuotaNote: '"剩余"数字已预先扣除"待审批"的申请，以防止之后批准超额。',
      leavePendingCountNote: '该员工有 {n} 个待审批申请{type}', goToPendingCard: '前往"待处理"卡片',
      daysInYearNote: '（今年 {n} 天）',
      myLeaveSubmit: '提交请假', myLeaveList: '我的请假', leaveSubmitBtn: '提交',
      leaveTypeLabel: '请假类型', leaveType_sick: '病假', leaveType_personal: '事假', leaveType_vacation: '年假',
      leaveType_unpaid: '一般请假（无薪）',
      dayPortionLabel: '请假时段', dayPortion_full: '全天', dayPortion_morning: '上午半天', dayPortion_afternoon: '下午半天',
      createLeaveLabel: '创建请假单（待审批）', createLeaveHint: '为该教练创建待审批的请假单 — 教练会立即在课表中显示为请假，额度将在经理批准后扣除（兼职 = 仅记录不授课）',
      leaveOverviewTitle: '年度请假总览', staffName: '员工',
      leaveOverviewHint: '点击员工姓名可展开其个人请假记录（可按类型筛选）',
      leaveTypeAll: '全部类型', leaveDetailOf: '{name} 的请假记录', submittedAt: '提交于',
      cancelReviewBtn: '撤销', cancelReviewTitle: '撤销请假单',
      confirmCancelReview: '撤销 "{name}" 已审批的请假单吗？系统将从课表中移除并返还额度。',
      countAsLeave: '计为请假（扣除额度）', countAsLeaveHint: '为该教练创建一张已批准的请假单，并按所选类型扣除本年度额度',
      parttimeNoQuota: '兼职教练 — 仅记录为不授课，不扣除额度',
      employmentType: '雇佣类型', employmentTypeHint: '全职 = 请假扣额度 · 兼职 = 仅标记不授课',
      employmentFulltime: '全职', employmentParttime: '兼职',
      leaveFrom: '开始日期', leaveTo: '结束日期', leaveReason: '原因（可选）', leaveReasonPh: '例如 家里有事',
      leaveMultiDayHint: '多天请假 = 期间每天全天请假（仅单天请假可选择课节）',
      leaveStatus_pending: '待审批', leaveStatus_approved: '已批准', leaveStatus_rejected: '未批准', leaveStatus_cancelled: '已取消',
      approve: '批准', reject: '拒绝', reviewNote: '给教练的备注（可选）',
      confirmApprove: '批准"{name}"的请假吗？系统会自动记录到课表。',
      confirmReject: '拒绝"{name}"的请假申请吗？',
      cancelReq: '取消申请', confirmCancelReq: '确定取消这条请假申请吗？',
      notLinkedLeave: '您的账号尚未绑定教练名单 — 请联系管理员', noLeaveReq: '暂无请假申请',
      leavePageTitle: '请假申请', leavePageSub: '提交请假、查看剩余额度并跟踪审批结果',
      leaveApprovalTitle: '请假审批', leaveApprovalSub: '审核并批准/驳回员工请假申请，并设置年度额度',
      daysUnit: '天', statusAll: '全部状态', quotaRemainLabel: '剩余', quotaUsedLabel: '已用',
      quotaPendingNote: '待审批 {n} 天', quotaNotSet: '今年尚未设置额度', quotaUsedShort: '已用 {n} 天',
      quotaBtn: '设置额度', quotaTitle: '年度请假额度', quotaSub: '为每位教练设置每年的请假天数（仅管理员）', quotaYear: '年份', saveAllQuota: '全部保存',
      noCoachYetOnLeave: '还没有教练名单 — 请在"教练分组"页面（"教练名单"按钮）添加', goToGrouping: '前往教练分组',
    },
    menuPerm: {
      title: '菜单权限', subtitle: '设置各类用户可访问的菜单（仅限经理）',
      colMenu: '菜单', save: '保存权限', saved: '菜单权限已保存',
      confirmTitle: '确认权限更改', confirmBody: '共 {n} 项更改：',
      changedCount: '{n} 项更改', allow: '允许', deny: '禁止',
      notConfigured: '尚未设置 — 仅限经理', headAlways: '经理始终可访问所有菜单', headToggleHint: '点击以在经理菜单栏中隐藏/显示此菜单',
      coreAlwaysHint: '基础菜单，对所有人开放', coreHeadHint: '仅限经理',
      externalHint: '外部系统（SSO）— 收付款系统会再次验证经理权限',
      restrictedByCode: '此菜单的部分操作仅限经理/管理员（如定价、核对凭证）— 可以授权菜单，但这些操作仍不可用',
      restrictedHeadAdmin: '此菜单在代码中仅限经理/管理员 — 无法授权给教练/客户',
      lockedHeadAdmin: '此菜单的所有操作都需要经理/管理员权限 — 授权此角色无效',
      loadFail: '加载权限数据失败',
      userTitle: '按人授权', userSubtitle: '为特定员工额外开放菜单（在角色权限之上）', pickUser: '— 选择员工 —', pickUserHint: '选择员工以设置其个人菜单权限', userSaved: '按人授权已保存',
    },
    auth: { pleaseLoginAgain: '请重新登录' },
    noti: {
      title: '通知', upcoming: '当前', past: '较早',
      empty: '暂无通知', markAllRead: '全部标记为已读',
      enablePush: '在此设备上开启通知', pushOn: '通知已开启',
      pushOff: '关闭本设备通知',
      pushDesc: '即使未打开网站，有新通知时也会在屏幕上提醒',
      pushBlocked: '浏览器已阻止通知 — 请在浏览器设置中开启',
      pushUnsupported: '此浏览器不支持通知',
      pushIosHint: '在 iPhone/iPad 上，请先点击分享并选择“添加到主屏幕”，之后才能开启通知',
      pushFail: '开启通知失败',
    },
    ops: {
      title: '每日检查', subtitle: '遗漏事项与待办工作，下班前扫一眼',
      managerOnly: '经理/管理员', refresh: '重新检查',
      sevUrgent: '今天必须处理', sevWatch: '本周内跟进', sevInfo: '异常',
      lookback: '回溯', lookbackDays: '{n} 天', lookbackAll: '全部',
      checkedAt: '最近检查 {time}',
      attendanceLimitNote: '系统没有“缺席”状态 — 待点名的课次有两种清除方式：学员确实来了但忘记点名 → 可补点名（不限日期）· 学员没来 → 取消预约，系统会自动返还次数，该条目随即消失。',
      trendTitle: '最近 {n} 天趋势',
      trendNote: '每天 21:30 自动快照，始终使用相同的 {days} 天回溯范围',
      trendShowTable: '显示每日数字',
      trendHideTable: '隐藏每日数字',
      trendColDate: '日期',
      allClear: '没有待办事项', allClearSub: '所有检查项均已通过，无需处理',
      goFix: '前往处理', truncated: '显示 {shown} / 共 {total} 条',
      unknownPriceExcluded: '金额不含 {n} 条未录入价格的记录',
      countedSince: '统计自 {date}', passed: '已通过的检查项',
      loadFail: '加载检查清单失败',
      paidYes: '已付', paidNo: '未付', flagYes: '是', ageDays: '{n} 天',
      kind: { course: '课程', private: '私教', approve: '审核通过', create: '直接创建' },
      check: {
        eventUnpaid: '赛事报名未付款（占用名额）',
        eventRefundPending: '已取消的赛事，待记录退款',
        eventOrganizerRemit: '主办方款项待上缴',
        checkinGroup: '尚未点名完成的课次',
        checkinPrivate: '尚未点名的私教课',
        checkinEvent: '尚未完成点名的活动',
        packageUnlinked: '未绑定学员的课程包',
        paymentUnpaidTaught: '欠款 — 已上课',
        paymentUnpaid: '欠款 — 尚未开始',
        priceMissing: '已付款但未填写价格',
        paymentMethodMissing: '已付款但未选择付款方式',
        slipUnverified: '未通过或无法核验的转账凭证',
        packageExpiringSoon: '即将用完的课程包',
        packageStale: '已购买但从未使用',
        leavePending: '待审批的请假申请',
        studentPendingApproval: '待审核的新学员',
        conflictCoachLeave: '教练请假当天的私教课',
        conflictHoliday: '与假日冲突的预约',
        packageExpiredWithSessions: '已过期但仍有剩余次数',
        studentApprovedDuplicate: '系统提示重复仍被放行',
      },
      hint: {
        eventUnpaid: '已报名未付款 — 名额已被占用 · 超过截止日后请决定除名或催款',
        eventRefundPending: '赛事已取消但款项仍在馆内 — 需记录是否退款（实际转账在系统外进行），未记录完不会消失',
        eventOrganizerRemit: '已向客户收取但尚未记录上缴的主办方款项（负债，非收入）',
        checkinGroup: '课次已过，但仍有学员未点名 — 来了忘点：补点名 · 没来：取消预约（会返还次数）',
        checkinPrivate: '已上完但未点名的私教课 — 可补点名，若实际未上课则取消预约',
        checkinEvent: '已结束但仍有参加者未点名的活动 — 可在课表页面补点名，若实际未参加则取消报名',
        packageUnlinked: '课程包已创建但未指定学员 — 没有人能用它预约',
        paymentUnpaidTaught: '服务已提供但尚未收款，金额每周都在增加',
        paymentUnpaid: '已售出未收款，且尚未开始上课',
        priceMissing: '没有价格，财务报表就无法统计这笔销售',
        paymentMethodMissing: '不清楚是现金/转账/刷卡 — 按付款方式的分类会漏掉',
        slipUnverified: '多数是因为凭证图片没有二维码，并不代表凭证造假，需人工查看',
        packageExpiringSoon: '剩余不超过 2 次，或 14 天内到期 — 续费的好时机',
        packageStale: '购买超过 14 天却从未预约过',
        leavePending: '员工已提交请假申请但无人审批',
        studentPendingApproval: '家长新增了孩子，等待审核入库',
        conflictCoachLeave: '私教课排在教练请假当天 — 请提前致电改期',
        conflictHoliday: '预约仍停留在后来被设为假日的日期',
        packageExpiredWithSessions: '客户已付款却没用完 — 潜在的投诉',
        studentApprovedDuplicate: '系统已提示可能与现有学员重复，仍有人通过了审核或直接创建 — 请确认是否为同一人，若是则需要合并记录',
      },
      col: {
        event: '赛事', deadline: '付款期限', pastDeadline: '已逾期', collected: '已收', remitted: '已上缴', outstanding: '待上缴',
        paydate: '付款日', cancelledate: '取消日',
        date: '日期', time: '时间', course: '课程', pending: '待处理', age: '已积压',
        coach: '教练', students: '学员', ref: '编号', type: '类型', amount: '金额',
        paid: '付款', created: '创建于', by: '创建人', kind: '类型', name: '项目',
        sessions: '已上课', since: '自', suggested: '标准价', context: '类型',
        status: '状态', reason: '原因', sender: '付款人', remaining: '剩余',
        expire: '到期', staff: '员工', leaveType: '请假类型', from: '开始', to: '结束',
        requested: '提交于', student: '学员', nickname: '昵称', holiday: '假日',
        approver: '操作人', matched: '重复对象', approvedAt: '审核时间',
      },
      dupWhy: {
        nameDob: '姓名与出生日期相同',
        name: '姓名相同',
        nickDob: '昵称、姓氏与出生日期相同',
        nick: '昵称与姓氏相同',
        lastnameDob: '姓氏与出生日期相同',
        firstNick: '名字与小名相同（姓氏不同）',
      },
      slipStatus: {
        failed: '核验未通过', skipped: '无法核验', duplicate: '重复凭证',
        amount_mismatch: '金额不符', wrong_receiver: '收款账户不符',
      },
    },
    session: {
      expiringIn: '登录状态将在 {n} 秒后失效',
      stayLoggedIn: '继续使用',
      endedTitle: '登录状态已结束',
      endedExpired: '登录已超时，请重新验证身份 — 您填写的内容仍会保留。',
      endedLogout: '您已在其他设备上退出登录，请重新登录。',
      endedPermission: '您的权限已变更，请重新登录。',
      continue: '继续登录',
      logoutInstead: '退出登录',
      loginFailed: '登录失败，请检查密码。',
    },
    presence: {
      viewersHint: '同时在查看此页面：{names}',
      editingHint: '{name} 正在编辑此记录',
      alsoEditing: '{name} 也在编辑此记录 — 同时保存会覆盖对方的修改',
    },
  },
  ja: {
    common: {
      select: '— 選択 —', selectCourse: '— コースを選択 —', selectStudent: '— 生徒を選択 —',
      selectClassTime: '— 時間帯を選択 —', selectCoach: '— コーチを選択 —', selectType: '— タイプを選択 —',
      selectStartTime: '— 開始時間を選択 —', selectEndTime: '— 終了時間を選択 —',
      selectDate: '日付を選択', selectDob: '生年月日を選択', confirmDeleteTitle: '削除の確認',
      noData: 'データがありません', noResults: '検索結果がありません', searchPlaceholder: '検索...',
      noAccess: 'このページにアクセスする権限がありません',
      sessionExpired: 'セッションの有効期限が切れました。再度ログインしてください',
      reservationFailed: '予約に失敗しました。もう一度お試しください',
      coachLeaveConfirmTitle: 'コーチはその日休暇を取得済みです',
      privateConflictTitle: '休暇期間中にプライベートレッスンがあります',
    },
    reservation: {
      subtitle: 'まず日付を選び、次に時間帯を選択してください', stepTime: '時間帯を選択',
      pickDateFirst: '先に左側で日付を選択してください<br />そのあと時間帯を選べます',
      slotsOf: '時間帯：', full: '満員', unavailable: '受付停止', available: '空き {n}', bookThisSlot: 'この時間帯を予約',
      bookCutoff: '当日クラスの予約は午前8時までです。以降は翌日以降の日付をお選びください',
      advanceNotice: 'コーチが参加するお子さまの名簿と人数を事前に把握し、最適なレッスンプランを準備できるよう、1日前までのご予約をおすすめします。すべてのクラスでお子さまをしっかりサポートいたします。',
      advanceNoticeCutoff: 'クラスの予約は、受講日当日の午前8時まで可能です。',
      modeSingle: '1日予約', modeMulti: '複数日予約',
      multiHint: 'カレンダーの日付をタップして複数日を選択/解除できます',
      multiCount: '{n}日選択中（最大{max}日）',
      stepTimeMulti: '各日の時間帯を選択',
      pickDatesFirst: 'まずカレンダーから日付を選んでください（複数選択可）',
      pickSlot: '時間帯未選択', removeDay: 'この日を外す',
      multiSummary: '{n}日選択中',
      multiSummaryUse: '{n}回分を使用（残り {a} → {b}）',
      multiBookBtn: '{n}日分の予約を確定',
      multiConfirmTitle: '予約の確認 — {n}日分',
      multiAllOrNothing: 'すべての日程が予約できる場合のみ確定します。1日でも予約できない場合は全体を予約せず、理由をお知らせします。',
      multiSuccess: '{n}日分すべての予約が完了しました',
      multiPickAll: 'すべての選択日で時間帯を選んでください',
      multiMax: '選択できるのは最大{n}日です',
    },
    groupbooking: { selectedSlot: '選択中の時間帯', selectThisSlot: 'この時間帯を選択' },
    customerCourse: { allTypes: 'すべてのタイプ', allPayments: 'すべての支払い', autoGenerated: '(自動生成)',
      paymentMethod: '支払い方法', selectPayment: '— 支払い方法を選択 —',
      paymentCash: '現金', paymentTransfer: '銀行振込', paymentCredit: 'クレジットカード',
      paymentFee: '決済手数料',
      paymentFeeEditBtn: '手数料を手動で修正',
      paymentFeeResetBtn: '自動計算の金額に戻す',
      paymentFeeAutoHint: '価格の {pct}% で自動計算されます',
      paymentFeeNoneHint: 'この支払方法に手数料はありません',
      paymentFeeManualHint: '手動で修正済み — 自動計算値は {amount} ฿',
      paymentFeeConfirmTitle: '手数料を手動で修正しますか？',
      paymentFeeConfirmBody: 'システムが手数料を {amount} ฿ と計算しました。ご自身で修正しますか？',
      paymentFeeConfirmOk: 'はい、修正します',
      promotion: '特別プロモーションコース', promotionBadge: 'プロモ', allPromotions: 'すべて（プロモ）', notPromo: '通常',
      slipVerifyNote: 'Thunder で自動照合されます', slipStoreNote: '控えとして保存（自動照合なし）', slipNeedPaid: '「支払い済み」にチェックするとアップロードできます', unlimited: '無制限' },
    bookingMgmt: { searchStudentPlaceholder: '生徒名を入力…',
      cancelNeedsUndo: 'チェックイン済み — 先にチェックインを取り消してから予約をキャンセルしてください',
      cancelAskManager: '3日以上経過 — キャンセル前にマネージャーへ確認を依頼してください',
      perSessionToggle: '単発レッスン（1回分パッケージを自動作成）',
      perSessionHasMainCourse: 'この生徒には既存のコースがあります — 単発予約では既存コースから回数を引きません',
      perSessionPaidCancelTitle: 'この予約は支払済みです',
      perSessionPaidCancelBody: 'この予約は支払いが完了しています。キャンセルすると単発購入 {refer} もシステムから削除され、財務レポートに計上されなくなります。本当にキャンセルしますか？',
    },
    approve: { subtitle: '確認待ちリスト', approveBtn: '承認', rejectBtn: '却下' },
    holidays: { subtitle: '休業日', holidayInfo: '休日情報' },
    dup: {
      title: '同じお子様の可能性があります', subtitle: '新規作成の前にご確認ください',
      intro: '情報が一致する生徒が {n} 名見つかりました — 同じお子様であれば、新規作成せずにこのご家族へ移動してください。受講履歴とコースも引き継がれます。',
      createAnyway: '別のお子様 — 新規作成', moveHere: 'この家族へ移動',
      statWithMatch: '重複あり',
      filterAll: 'すべて', filterMatched: '重複あり', filterUnmatched: '該当なし',
      needMergeHint: '既存のお子様と重複 — 移動ではなく履歴の統合が必要です',
      assignFamily: '家族に割り当て',
      mergeTitle: '既存のお子様と重複', mergeSubtitle: '移動ではなく履歴の統合が必要',
      mergeExplain: 'このお子様は会員のご家族に正式な記録がすでにあります。この行をそのまま移動すると、同じご家族に2件の記録が並び、履歴は分かれたままになります。',
      mergeFrom: 'キューの記録（旧）', mergeTo: 'システム上の正式な記録',
      mergeHow: 'マネージャーが「この生徒に統合」を押すと、予約・プライベートレッスン・イベント・グループ・コースをすべて本来の記録に移し、古い記録を一度に閉じます。マネージャーでない場合はマネージャーに依頼してください。',
      assignTitle: '家族に割り当て', assignBtn: 'この家族へ移動',
      assignExplain: 'このお子様にはまだ正式な記録がないため、そのままご家族へ移動できます。履歴とコースalso引き継がれます。',
      pickFamilyFirst: 'フォームで保護者のユーザー名を選ぶと、移動ボタンが使えます',
      moved: '家族へ移動しました — 履歴とコースもすべて移動しました',
      why: { nameDob: '氏名と生年月日が一致', name: '氏名が一致', nickDob: 'ニックネーム・姓・生年月日が一致', nick: 'ニックネームと姓が一致', lastnameDob: '姓と生年月日が一致', firstNick: '名とニックネームが一致（姓は異なる）' },
      conf: { veryhigh: '一致度が高い', high: '一致', medium: '一致の可能性' },
      staffRow: 'スタッフが作成', noFamily: '家族未設定', bookings: '予約 {n} 件', lastClass: '最終受講 {d}', noClass: '受講履歴なし',
      tabList: '生徒一覧', tabUnclaimed: '保護者未登録',
      unclaimedHint: 'スタッフのアカウント配下に作成されたお子様（管理者が代理予約していた時期）、または家族が未設定のお子様 — 保護者が登録してお子様を追加した時点で重複データになります。',
      colParkedUnder: '登録先アカウント', colCreated: '作成日', colBookings: '予約', colLastClass: '最終受講', colCourse: 'コース', colMatch: '一致候補',
      statTotal: '合計', statNoFamily: '家族なし', statWithCourse: 'コース保有', statWithBookings: '受講あり',
      approveWarn: '既存の生徒 {n} 名と重複の可能性', approveWarnHint: '承認前にご確認ください — 同じお子様の場合は、この申請を却下し、既存の記録を家族へ移動してください。',
      headOnlyHint: '既存の生徒とほぼ確実に重複しています — 承認できるのはマネージャーのみです（却下は通常どおり可能）。',
      reasonTitle: '承認する理由',
      reasonHint: '重複の可能性が検出されました — それでも承認する理由を簡潔にご記入ください。後でマネージャーが確認します。',
      reasonPlaceholder: '例：確認済み、別のお子様／双子です',
      headOnlyCreateHint: '既存の生徒とほぼ確実に重複しています — 新規作成はできません。マネージャーの確認が必要です（既存の記録をこの家族へ移動する操作は通常どおり可能）。',
      linkBtn: 'システム内の既存の生徒と統合',
      linkHint: 'この生徒は既にシステムにいます — 重複を作らないよう、承認ではなく統合ボタンを使ってください',
      linkTitle: 'システム内の既存の生徒と統合',
      linkConfirm: '{target}（現在 {current} の下）を {family} の家族へ移動し、保護者が入力した情報で置き換えます。生徒の受講履歴とコースはそのまま残ります。この申請は終了します。',
      linkDone: '既存の生徒と統合しました',
      linkFail: '既存の生徒との統合に失敗しました',
      staffTag: '体験時に管理者が仮登録',
      acctType: { 0: 'マネージャー', 1: '管理者', 2: 'コーチ', 10: '顧客' },
      whyLabel: '重複と判断した理由',
      cmpPending: '保護者が追加した生徒（承認待ち）',
      cmpExisting: 'システムに既にいる生徒',
      fName: '氏名',
      fNick: 'ニックネーム',
      fDob: '生年月日',
      fAccount: 'アカウント',
      fHistory: '受講履歴',
      acctCustomer: '顧客ユーザー名：{u}',
      acctStaff: 'スタッフアカウント {u}（体験時に管理者が仮登録）',
      acctNone: 'どのアカウントにも属していません',
      newRequest: '新しい申請（履歴なし）',
      historyN: '予約 {n} 件',
      linkIntro: '確定すると、システムは次を行います：',
      linkStep1: '生徒を保護者のアカウント {to} へ移動',
      linkStep1NoFam: '生徒を顧客アカウント {to} に入れる',
      linkStep2: '保護者が入力した情報を使用（「変更」の行）',
      linkStep3: '予約 {n} 件と既存のコースはそのまま残す',
      linkStep4: '新しい生徒は作らず、この申請を終了',
      colField: '項目',
      colNow: '現在',
      colAfter: '統合後',
      changed: '変更',
      linkErr: { gone: 'この申請はすでに処理されています', not_candidate: 'この生徒はシステムが紐付けを提案した相手ではありません — マネージャーに確認してください', shared_course: '既存の生徒は他の生徒とコースを共有しているため家族を変更できません — マネージャーに連絡してください', already_in_family: 'この家族にはすでにこの生徒がいます — 紐付けではなくマネージャーによる統合が必要です', bad_family: 'この申請は顧客の家族からではないため紐付けできません' },
      mergeBtn: 'この生徒に統合',
      mergeConfirmTitle: '生徒の統合を確認',
      mergeConfirm: '{from} のすべての履歴（予約 {n} 件、プライベートレッスン・イベント・グループ・コースを含む）を {to} に移し、古い記録を閉じます。アプリからは元に戻せません。',
      mergeCheck: '同じ子どもであることを確認しました',
      mergeDone: '生徒を統合しました',
      mergeFail: '生徒の統合に失敗しました',
      mergeErr: { booking_conflict: '2つの記録が同じ日の同じクラスを予約しています — 先にどちらかの予約を取り消してから統合してください', event_conflict: '2つの記録が同じイベントに登録しています — 先にどちらかを取り消してから統合してください', course_slots: '本来の記録はすでにコースを2つ持っているため、古い記録のコースを入れられません — 先にコースを整理してから統合してください', private_conflict: '2つの記録が同じプライベートレッスンに入っています — 先に片方を外してから統合してください', not_found: '生徒が見つからないか、すでに統合/削除されています — 一覧を更新してください', direction: 'スタッフアカウント下または家族なしの記録を、顧客の家族の記録へ統合する場合のみ可能です', not_candidate: 'この2つの記録は確実な重複ではありません（双子など）— 統合できません' },
      reasonCreateHint: '重複の可能性が検出されました — それでも新規作成する理由を簡潔にご記入ください。後でマネージャーが確認します。',
    },
    gymnasts: { typeUsername: 'ユーザー名を入力…' },
    bookingList: { blindTooltip: 'この名前は他の保護者に非表示です' },
    family: { yearsOld: '歳', pendingApproval: '承認待ち' },
    editProfile: { changePhoto: '写真を変更', uploadNewPhoto: '新しい写真をアップロード', removePhoto: '写真を削除' },
    calendar: {
      tooltipBookingClosed: 'この日の予約は締め切りました（当日予約は午前8時まで）', tooltipMondayClosed: '月曜日 — 休業',
      tooltipHolidayClosed: '祝日 — 休業', legendClosed: '月曜日と祝日は自動的に休業します', holidaysThisMonth: '今月の休業日', holidayLabel: '休業日',
      tooltipBeforeMinDate: 'これより前の日付は選択できません',
    },
    select: { noMatch: '該当なし', searchPlaceholder: '入力して検索…' },
    pager: { firstPage: '最初のページ', prevPage: '前へ', nextPage: '次へ', lastPage: '最後のページ' },
    classDisable: {
      title: 'クラス予約停止', subtitle: 'グループクラスを特定の日だけ予約停止にします',
      newClosure: '停止を追加', closureInfo: '停止情報', dateLabel: '停止日',
      pickClass: '停止するクラスを選択', pickClassPlaceholder: '— クラスを選択 —',
      noClassOnDate: '選択した日にクラスはありません', reason: '理由（例：特別休講 / 講師欠席）',
      confirmDelete: '{class} の {date} の予約を再開しますか？',
      created: 'クラスの予約を停止しました', reopened: 'クラスの予約を再開しました',
      selectDateFirst: '先に日付を選択してください',
    },
    closures: {
      title: '休講・停止管理', subtitle: 'スタジオの休業日とクラス別の予約停止を管理',
      tabHoliday: '休業日（終日）', tabClass: 'クラス別停止',
      bookingWarnTitle: 'この日にはすでに予約があります',
      bookingWarnLead: '{date} にはすでに {n} 件の予約があります',
      bookingWarnGroup: 'グループクラス（{n}）', bookingWarnPrivate: 'プライベート（{n}）',
      bookingWarnNote: 'これらの予約は自動的にキャンセル・回数返還されません。保護者に連絡のうえ手動で対応してください。',
      bookingWarnConfirm: 'このまま続行',
    },
    nav: { expandMenu: 'メニューを広げる', collapseMenu: 'メニューを畳む', menuPermission: 'メニュー権限', closures: '休講・停止管理', grouping: 'コーチ班分け', coachSchedule: 'コーチ時間割', coachLeave: '休暇申請', leaveApproval: '休暇承認', scheduleAdmin: '時間割管理' },
    scheduleAdmin: {
      title: '時間割管理', subtitle: 'コース種別の作成と週間クラス時間割の設定を一箇所で',
      courseTypes: 'コース種別', showDisabled: '無効なコースを表示', addCourse: 'コースを追加',
      legendClickCourse: 'コースをクリックして編集', legendDirty: '黄色の枠＝未保存の変更',
      legendNew: '緑色の枠＝新規追加', legendAdmin: '斜線＝管理者専用クラス',
      weeklyTable: '週間クラス時間割', addClass: 'クラスを追加',
      hintCreate: '空きスロットをクリックしてクラスを作成', hintDrag: 'ブロックをドラッグで曜日/時間を移動 · 端をドラッグで時間を調整', hintEdit: 'ブロックをクリックして編集/削除',
      evTitle: 'ドラッグで移動 · 端をドラッグで時間調整 · クリックで編集',
      editClass: 'クラスを編集', newClass: '新規クラス', classInfo: 'クラス情報',
      startTime: '開始時刻', endTime: '終了時刻', validityAndVisibility: '有効期間と表示',
      startDate: '開始日', endDate: '終了日', adminOnly: '管理者専用クラス', adminOnlyHint: '顧客に非表示 (adminflag)',
      deleteClass: 'クラスを削除', deleteCourse: 'コースを削除', editCourse: 'コース種別を編集', newCourse: '新規コース種別', courseInfo: 'コース情報',
      courseNamePh: '例: Gymnastics Activity', shortNamePh: '例: G.A.',
      refercode: '参照コード (接頭辞)', refercodePh: '例: GA',
      refercodeHint: '顧客コース番号の生成に使用 例: GA-20260724-0001 — 作成時のみ設定',
      refercodeLocked: '参照コードは作成時のみ設定でき、後から変更できません',
      courseColor: 'コースの色 (カレンダー表示)', status: 'ステータス', statusHint: '有効 — 無効にすると予約から非表示',
      confirmTitle: '確認', confirmDeleteClass: 'このクラスを削除しますか？過去の受講履歴はすべて保持されます。今後の予約が残っている場合は、先にキャンセル/移動しないと削除できません。',
      confirmDeleteCourse: 'このコースを削除しますか？所属クラスも一緒に削除されますが、過去の受講履歴と顧客のコースはすべて保持されます。今後の予約がなく、顧客のコースがすべて終了している場合のみ削除できます。',
      confirmProceedHint: '続行しますか？',
      unsaved: '件の未保存', discardAll: 'すべて取消', saveToSystem: 'システムに保存',
      diffNew: '追加 {n}', diffEdit: '編集 {n}', diffDelete: '削除 {n}',
      reverted: 'すべての変更を元に戻しました', saved: '時間割を保存しました',
    },
    grouping: {
      title: 'コーチ班分け', subtitle: '各クラスの生徒をコーチごとの班に分けます（旧 Google シートの置き換え）',
      coachTitle: 'コーチ時間割', coachSubtitle: '各クラスの担当班 — 授業前にご確認ください',
      privateTitle: 'プライベートレッスン', noPrivate: 'プライベートレッスンなし', privateHours: '{n}時間',
      privateCheckinHint: 'チェックインできるのは管理者またはこのレッスンの担当コーチのみです',
      modeDay: '日', modeWeek: '週', today: '今日', prev: '前へ', next: '次へ',
      personUnit: '名', unassigned: '未振り分け', allAssigned: '全員振り分け済み', emptyGroup: 'メンバーがいません',
      noBooking: 'このクラスの予約はまだありません', noSessions: 'この日はクラスがありません',
      addGroup: '班を追加', editGroup: '班を編集', coachesLabel: '担当コーチ',
      noCoachYet: 'コーチ名簿が空です —「コーチ名簿」ボタンから追加してください',
      groupName: '特別班名（任意）', groupNamePh: '例：Tax FIG1+L.4（空欄ならコーチ名を表示）',
      groupRemark: '班メモ', groupRemarkPh: '例：段違い平行棒の練習',
      deleteGroup: '班を削除', confirmDeleteGroup: '班「{name}」を削除しますか？メンバーは「未振り分け」に戻ります。',
      moveAllTitle: 'メンバー全員を移動（{n}名）', moveAllTo: '— 移動先の班を選択 —', moveAllBtn: '全員移動',
      moveTo: '移動：', removeFromGroup: '班から外す', noGroupYet: 'このクラスにはまだ班がありません — 先に追加してください',
      sessionNote: 'クラスメモ', sessionNotePh: '例：本日は L.3-L.4 合同',
      dayNote: '本日のメモ', dayNotePh: '本日のメモを追加...',
      absentTag: '欠勤', allDayShort: '終日', absentCoachesToday: '本日休暇のコーチ',
      checkin: 'チェックイン', undoCheckin: 'チェックイン取消',
      absenceBtn: 'コーチ欠勤', absenceTitle: 'コーチの欠勤を記録', absenceCoach: 'コーチ', absenceDate: '日付',
      absenceAllDay: '終日欠勤', absencePickClasses: '欠勤するクラスを選択', absenceReason: '理由（任意）', absenceReasonPh: '例：病欠',
      absenceCancelBtn: '欠勤を取り消す',
      coachManageBtn: 'コーチ名簿', coachManageTitle: 'コーチ名簿', coachManageSub: 'コーチはログインアカウント不要 — 後から連携できます',
      autoBtn: '自動グループ分け', autoBtnDay: '一日分を自動グループ分け', autoPreviewTitle: '自動グループ分け',
      autoModeUnassigned: '未所属の生徒のみ', autoModeUnassignedHint: '既存のグループには触れず、まだ所属していない生徒だけを振り分けます',
      autoModeRebuild: 'コマ全体をやり直す', autoModeRebuildHint: 'このコマの全グループのメンバーを外し、ルールに従って割り当て直します（グループ・メモ・コーチは残ります）',
      autoNewGroup: '新規作成', autoReuseGroup: '既存グループ', autoSessionCount: '{n} コマ',
      autoSkipTitle: '振り分け不可 · {n} 名', autoSkipOutOfRange: 'どのグループの範囲にも入りません',
      autoSkipNoBirthdate: '生年月日が未登録', autoSkipNoLevel: 'レベルが未入力',
      autoNothingToDo: '今のところ振り分ける生徒はいません', autoTotal: '{n} 名を {g} グループに振り分けます', autoApplyBtn: 'グループ分けを確定',
      autoRebuildConfirmTitle: 'コマ全体をやり直しますか？', autoRebuildConfirmBody: '手動で移動した生徒もすべてルールに従って割り当て直されます。よろしいですか？',
      autoDone: 'グループ分けが完了しました — {n} 名',
      ruleBtn: 'ルール設定', ruleTitle: '自動グループ分けルール', ruleSub: '1コースにつき1セット — コードを変更せずここで編集できます',
      ruleAdd: 'ルールを追加', ruleEdit: 'ルールを編集', ruleDelete: 'ルールを削除', ruleNone: 'ルールがまだありません',
      ruleConfirmDelete: 'ルール「{name}」を削除しますか？（作成済みのグループは残ります）',
      ruleCourse: 'コース', ruleBasis: '分け方', ruleName: 'ルール名', ruleNamePh: '例：G.A. 年齢別',
      ruleBuckets: 'グループ', ruleBucketNamePh: 'グループ名（例：3〜5歳）', ruleMin: '下限', ruleMax: '上限',
      ruleMaxPerson: '1グループ上限', ruleOpenEnd: '制限なし', ruleNoLimit: '制限なし', ruleDefaultCoaches: '担当コーチ（任意）',
      ruleAddBucket: 'グループを追加', basisAge: '年齢（歳）', basisLevel: 'レベル',
      ruleHint: '「下限」「上限」を空欄にするとその側は無制限 · 各グループの範囲は重複できません · 上限を設定すると #1 #2 に自動分割されます',
      addCoach: 'コーチを追加', editCoach: 'コーチを編集', coachName: '表示名', coachColor: 'カラー', coachSort: '並び順',
      coachLink: 'ログインアカウントと連携', coachLinkNone: '— 連携しない —',
      coachLinkHint: '連携すると「コーチ時間割」で自分の班がハイライト表示されます',
      coachDisable: 'コーチを無効化', confirmDisableCoach: 'コーチ「{name}」を無効化しますか？既存の班には名前が表示され続けます。',
      disabledBadge: '無効', notLinkedBadge: 'アカウント未連携',
      highlightMine: '自分の班をハイライト', myGroupsOnly: '自分の班のみ',
      loadFail: 'データの読み込みに失敗しました',
      leaveBtn: '休暇申請', leaveReqTitle: '職員の休暇申請', leaveReqSub: '承認すると時間割に欠勤が自動登録されます',
      leavePendingTitle: '対応待ち', leaveHistoryTitle: '処理済み履歴', leaveHistorySub: '承認・却下・取消済みの申請', leaveHistoryCount: '{n} 件',
      myLeaveHistory: '休暇履歴', viewGrouped: '種類ごとにまとめる', viewChrono: '日付順に並べる',
      ovApprovedLabel: '承認済み {n} 日', ovPendingNote: '承認待ちで {n} 日確保',
      quotaOverLabel: '上限超過 {over} 日（承認済み {used}／上限 {quota} 日）', quotaNotSetWithUsed: '今年の付与日数は未設定です · 申請済み {n} 日',
      leaveOverviewQuotaNote: '「残り」の数字は「承認待ち」の申請をあらかじめ差し引いています。後で上限を超えて承認するのを防ぐためです。',
      leavePendingCountNote: 'このスタッフには {n} 件の承認待ち申請があります{type}', goToPendingCard: '「対応待ち」カードへ',
      daysInYearNote: '（今年は {n} 日）',
      myLeaveSubmit: '休暇を申請', myLeaveList: '自分の申請', leaveSubmitBtn: '送信',
      leaveTypeLabel: '休暇の種類', leaveType_sick: '病気休暇', leaveType_personal: '私用休暇', leaveType_vacation: '有給休暇',
      leaveType_unpaid: '一般休暇（無給）',
      dayPortionLabel: '休暇の時間帯', dayPortion_full: '終日', dayPortion_morning: '午前半休', dayPortion_afternoon: '午後半休',
      createLeaveLabel: '休暇を作成（承認待ち）', createLeaveHint: 'このコーチに承認待ちの休暇を作成します — スケジュールにすぐ休暇として表示され、マネージャーが承認すると枠が消費されます（パートタイム = 不在の記録のみ）',
      leaveOverviewTitle: '年間休暇の概要', staffName: '従業員',
      leaveOverviewHint: '従業員名をクリックすると個別の休暇記録を展開できます（種類で絞り込み可）',
      leaveTypeAll: 'すべての種類', leaveDetailOf: '{name} の休暇記録', submittedAt: '申請日時',
      cancelReviewBtn: '取り消し', cancelReviewTitle: '休暇申請を取り消す',
      confirmCancelReview: '審査済みの "{name}" の休暇を取り消しますか？時間割から削除し、枠を戻します。',
      countAsLeave: '休暇として計上（枠を消費）', countAsLeaveHint: 'このコーチに承認済みの休暇を作成し、選択した種類の今年の枠を消費します',
      parttimeNoQuota: 'パートタイムのコーチ — 「不在」の記録のみ、枠は消費しません',
      employmentType: '雇用形態', employmentTypeHint: 'フルタイム = 休暇で枠を消費 · パートタイム = 不在の記録のみ',
      employmentFulltime: 'フルタイム', employmentParttime: 'パートタイム',
      leaveFrom: '開始日', leaveTo: '終了日', leaveReason: '理由（任意）', leaveReasonPh: '例：家庭の用事',
      leaveMultiDayHint: '複数日の休暇は期間中すべて終日扱いです（クラス指定は1日のみの場合に可能）',
      leaveStatus_pending: '承認待ち', leaveStatus_approved: '承認済み', leaveStatus_rejected: '却下', leaveStatus_cancelled: '取消済み',
      approve: '承認', reject: '却下', reviewNote: 'コーチへのメモ（任意）',
      confirmApprove: '「{name}」の休暇を承認しますか？時間割に自動登録されます。',
      confirmReject: '「{name}」の休暇申請を却下しますか？',
      cancelReq: '申請を取り消す', confirmCancelReq: 'この休暇申請を取り消しますか？',
      notLinkedLeave: 'アカウントがコーチ名簿と連携されていません — 管理者にご連絡ください', noLeaveReq: '休暇申請はまだありません',
      leavePageTitle: '休暇申請', leavePageSub: '休暇の申請・残りの日数の確認・承認状況の確認',
      leaveApprovalTitle: '休暇承認', leaveApprovalSub: '従業員の休暇申請を確認して承認/却下し、年間の日数を設定',
      daysUnit: '日', statusAll: 'すべての状態', quotaRemainLabel: '残り', quotaUsedLabel: '使用済み',
      quotaPendingNote: '承認待ち {n} 日', quotaNotSet: '今年の付与日数は未設定です', quotaUsedShort: '使用 {n} 日',
      quotaBtn: '付与日数を設定', quotaTitle: '年間休暇付与日数', quotaSub: 'コーチごとの年間休暇日数を設定します（マネージャーのみ）', quotaYear: '年', saveAllQuota: 'すべて保存',
      noCoachYetOnLeave: 'コーチ名簿が空です — 「コーチ班分け」ページ（「コーチ名簿」ボタン）で追加してください', goToGrouping: 'コーチ班分けへ',
    },
    menuPerm: {
      title: 'メニュー権限', subtitle: 'ユーザー種別ごとに利用できるメニューを設定します（マネージャー専用）',
      colMenu: 'メニュー', save: '権限を保存', saved: 'メニュー権限を保存しました',
      confirmTitle: '権限変更の確認', confirmBody: '変更 {n} 件：',
      changedCount: '変更 {n} 件', allow: '許可', deny: '不可',
      notConfigured: '未設定 — マネージャーのみ', headAlways: 'マネージャーは常に全メニューを利用できます', headToggleHint: 'クリックしてこのメニューをマネージャーのサイドバーで表示/非表示',
      coreAlwaysHint: '基本メニュー（全員に常時開放）', coreHeadHint: 'マネージャー専用',
      externalHint: '外部システム（SSO）— 決済システム側でもマネージャー権限を再確認します',
      restrictedByCode: 'このメニューの一部操作はマネージャー/管理者専用です（料金設定・スリップ確認など）— メニューは許可できますが、それらの操作は使えません',
      restrictedHeadAdmin: 'このメニューはコード上でマネージャー/管理者専用です — コーチ/顧客には許可できません',
      lockedHeadAdmin: 'このメニューの全操作はマネージャー/管理者が必要です — このロールに許可しても効果がありません',
      loadFail: '権限データの読み込みに失敗しました',
      userTitle: '個人別の権限', userSubtitle: '特定の職員にメニューを追加で開放（ロール権限に上乗せ）', pickUser: '— 職員を選択 —', pickUserHint: '職員を選んで個別のメニュー権限を設定します', userSaved: '個人別の権限を保存しました',
    },
    auth: { pleaseLoginAgain: '再度ログインしてください' },
    noti: {
      title: 'お知らせ', upcoming: '現在', past: '過去',
      empty: 'お知らせはありません', markAllRead: 'すべて既読にする',
      enablePush: 'この端末で通知をオンにする', pushOn: '通知はオンです',
      pushOff: 'この端末の通知をオフにする',
      pushDesc: 'サイトを開いていなくても、新しいお知らせが届くと画面に通知します',
      pushBlocked: 'ブラウザが通知をブロックしています — ブラウザの設定で許可してください',
      pushUnsupported: 'このブラウザは通知に対応していません',
      pushIosHint: 'iPhone/iPad では、まず共有から「ホーム画面に追加」を選んでください。インストール後にのみ通知を有効にできます',
      pushFail: '通知を有効にできませんでした',
    },
    ops: {
      title: '日次チェック', subtitle: '抜け漏れと未処理の作業 — 退勤前にひと通り確認',
      managerOnly: 'マネージャー/管理者', refresh: '再チェック',
      sevUrgent: '本日中に対応', sevWatch: '今週中に対応', sevInfo: '異常',
      lookback: 'さかのぼり', lookbackDays: '{n} 日', lookbackAll: 'すべて',
      checkedAt: '最終チェック {time}',
      attendanceLimitNote: '「欠席」ステータスはありません — 未出欠の回は2つの方法で解消できます：実際に来たが押し忘れた → さかのぼって出欠を付けられます（日付制限なし）· 来なかった → 予約を取り消すと回数が自動で戻り、項目も消えます。',
      trendTitle: '直近 {n} 日の推移',
      trendNote: '毎日 21:30 に自動でスナップショットを取得（常に同じ {days} 日間のさかのぼり範囲で集計）',
      trendShowTable: '日別の数値を表示',
      trendHideTable: '日別の数値を隠す',
      trendColDate: '日付',
      allClear: '未処理の項目はありません', allClearSub: 'すべてのチェックが完了し、対応が必要なものはありません',
      goFix: '対応ページへ', truncated: '{total} 件中 {shown} 件を表示',
      unknownPriceExcluded: '金額には価格未入力の {n} 件が含まれていません',
      countedSince: '{date} 以降を集計', passed: '問題なしの項目',
      loadFail: 'チェックリストを読み込めませんでした',
      paidYes: '支払済', paidNo: '未払い', flagYes: 'はい', ageDays: '{n} 日',
      kind: { course: 'コース', private: 'プライベート', approve: '申請を承認', create: '直接作成' },
      check: {
        eventUnpaid: 'イベント申込みの未払い（枠を占有中）',
        eventRefundPending: '中止したイベント — 返金の記録待ち',
        eventOrganizerRemit: '主催者金の未送金',
        checkinGroup: '出欠が未完了のクラス',
        checkinPrivate: '出欠未入力のプライベートレッスン',
        checkinEvent: '出欠が未完了のイベント',
        packageUnlinked: '生徒に紐づいていないパッケージ',
        paymentUnpaidTaught: '未収金 — 受講済み',
        paymentUnpaid: '未収金 — 未開始',
        priceMissing: '支払済だが金額が未入力',
        paymentMethodMissing: '支払済だが支払方法が未選択',
        slipUnverified: '確認できなかった振込明細',
        packageExpiringSoon: '残りわずかなパッケージ',
        packageStale: '購入済みだが未使用',
        leavePending: '承認待ちの休暇申請',
        studentPendingApproval: '承認待ちの新規生徒',
        conflictCoachLeave: 'コーチが休暇の日のプライベートレッスン',
        conflictHoliday: '休業日と重なる予約',
        packageExpiredWithSessions: '期限切れだが回数が残っている',
        studentApprovedDuplicate: '重複の警告が出たまま通された',
      },
      hint: {
        eventUnpaid: '申込み済みで未払い — 枠は確保中 · 期限（締切日）超過後は除名か督促を判断',
        eventRefundPending: 'イベントは中止したが入金はジムに残っている — 返金の有無を記録（実際の送金はシステム外）· 全件記録するまで表示され続けます',
        eventOrganizerRemit: '顧客から回収済みで送金記録が未登録の主催者分（負債であり収入ではない）',
        checkinGroup: '終了したクラスに出欠未入力の生徒が残っています — 来たのに未入力なら後から出欠入力 · 来なかったなら予約取消（回数は返却）',
        checkinPrivate: '実施済みだが未出欠のプライベート — 後から出欠入力、実施していなければ予約を取り消し',
        checkinEvent: '終了したのに未出欠の参加者が残るイベント — スケジュール画面から後で出欠入力、不参加なら申込を取り消し',
        packageUnlinked: 'パッケージはあるが生徒が未指定 — 誰も予約に使えません',
        paymentUnpaidTaught: 'サービス提供済みで未入金。金額は毎週増えていきます',
        paymentUnpaid: '販売済みで未入金、かつ受講もまだ',
        priceMissing: '金額がないと売上レポートに計上できません',
        paymentMethodMissing: '現金/振込/カードが不明 — 支払方法別の集計から漏れます',
        slipUnverified: '多くは画像に QR コードがないだけで偽造とは限りません。目視確認が必要です',
        packageExpiringSoon: '残り 2 回以下、または 14 日以内に期限切れ — 継続のご案内のタイミング',
        packageStale: '購入から 14 日以上たっても一度も予約されていません',
        leavePending: '申請された休暇が未処理のままです',
        studentPendingApproval: '保護者が追加したお子様が承認待ちです',
        conflictCoachLeave: 'コーチが休暇の日に予約が入っています — 早めに連絡して振替を',
        conflictHoliday: '後から休業日に設定された日に予約が残っています',
        packageExpiredWithSessions: 'お支払い済みなのに使い切れていません — クレームの芽です',
        studentApprovedDuplicate: '既存の生徒と重複する可能性があると警告が出たまま、申請が承認されたか生徒が直接作成されました — 同一人物か確認し、そうであれば記録の統合が必要です',
      },
      col: {
        event: 'イベント', deadline: '支払期限', pastDeadline: '期限超過', collected: '回収済み', remitted: '送金済み', outstanding: '未送金',
        paydate: '入金日', cancelledate: '中止日',
        date: '日付', time: '時間', course: 'コース', pending: '未処理', age: '経過',
        coach: 'コーチ', students: '生徒', ref: '番号', type: '種別', amount: '金額',
        paid: '支払', created: '作成日', by: '作成者', kind: '種別', name: '項目',
        sessions: '受講済', since: '起算日', suggested: '標準価格', context: '種別',
        status: '状態', reason: '理由', sender: '送金者', remaining: '残り',
        expire: '有効期限', staff: 'スタッフ', leaveType: '休暇種別', from: '開始', to: '終了',
        requested: '申請日', student: '生徒', nickname: 'ニックネーム', holiday: '休業日',
        approver: '実施者', matched: '重複相手', approvedAt: '承認日',
      },
      dupWhy: {
        nameDob: '氏名と生年月日が一致',
        name: '氏名が一致',
        nickDob: 'ニックネーム・姓・生年月日が一致',
        nick: 'ニックネームと姓が一致',
        lastnameDob: '姓と生年月日が一致',
        firstNick: '名とニックネームが一致（姓は異なる）',
      },
      slipStatus: {
        failed: '確認不可', skipped: '未確認', duplicate: '重複',
        amount_mismatch: '金額不一致', wrong_receiver: '受取口座が不一致',
      },
    },
    session: {
      expiringIn: 'セッションはあと {n} 秒で終了します',
      stayLoggedIn: '継続する',
      endedTitle: 'セッションが終了しました',
      endedExpired: 'セッションがタイムアウトしました。再度ご本人確認をお願いします — 入力内容は保持されています。',
      endedLogout: '別の端末でログアウトされました。もう一度ログインしてください。',
      endedPermission: '権限が変更されました。もう一度ログインしてください。',
      continue: 'ログインを続ける',
      logoutInstead: 'ログアウト',
      loginFailed: 'ログインに失敗しました。パスワードをご確認ください。',
    },
    presence: {
      viewersHint: 'このページを同時に閲覧中: {names}',
      editingHint: '{name} がこの項目を編集中です',
      alsoEditing: '{name} もこの項目を編集中です — 同時に保存すると相手の変更が上書きされます',
    },
  },
  ko: {
    common: {
      select: '— 선택 —', selectCourse: '— 코스 선택 —', selectStudent: '— 학생 선택 —',
      selectClassTime: '— 시간대 선택 —', selectCoach: '— 코치 선택 —', selectType: '— 유형 선택 —',
      selectStartTime: '— 시작 시간 선택 —', selectEndTime: '— 종료 시간 선택 —',
      selectDate: '날짜 선택', selectDob: '생년월일 선택', confirmDeleteTitle: '삭제 확인',
      noData: '데이터가 없습니다', noResults: '검색 결과가 없습니다', searchPlaceholder: '검색...',
      noAccess: '이 페이지에 접근할 권한이 없습니다',
      sessionExpired: '세션이 만료되었습니다. 다시 로그인해 주세요',
      reservationFailed: '예약에 실패했습니다. 다시 시도해 주세요',
      coachLeaveConfirmTitle: '코치가 해당 날짜에 휴가를 냈습니다',
      privateConflictTitle: '휴가 기간 중 개인 레슨이 있습니다',
    },
    reservation: {
      subtitle: '먼저 날짜를 선택한 후 시간대를 선택하세요', stepTime: '시간대 선택',
      pickDateFirst: '먼저 왼쪽에서 날짜를 선택하세요<br />그 후 수업 시간대를 선택할 수 있습니다',
      slotsOf: '시간대:', full: '마감', unavailable: '이용 불가', available: '여석 {n}', bookThisSlot: '이 시간대 예약',
      bookCutoff: '당일 수업 예약은 오전 8시까지 가능합니다. 이후에는 다음 날부터 예약할 수 있습니다',
      advanceNotice: '코치가 수업에 참여할 아이들의 명단과 인원을 미리 파악하고 알맞은 수업 계획을 준비할 수 있도록 최소 1일 전에 예약해 주세요. 모든 수업에서 아이들을 정성껏 돌보겠습니다.',
      advanceNoticeCutoff: '수업 당일 오전 8시까지 예약할 수 있습니다.',
      modeSingle: '하루 예약', modeMulti: '여러 날 예약',
      multiHint: '달력에서 날짜를 눌러 여러 날을 선택/해제할 수 있습니다',
      multiCount: '{n}일 선택됨 (최대 {max}일)',
      stepTimeMulti: '날짜별 시간대 선택',
      pickDatesFirst: '먼저 달력에서 날짜를 선택하세요 (여러 날 가능)',
      pickSlot: '시간대 미선택', removeDay: '이 날짜 빼기',
      multiSummary: '{n}일 선택됨',
      multiSummaryUse: '{n}회 사용 (잔여 {a} → {b})',
      multiBookBtn: '{n}일 예약 확정',
      multiConfirmTitle: '예약 확인 — {n}일',
      multiAllOrNothing: '모든 날짜가 예약 가능할 때만 저장됩니다. 하루라도 불가하면 전체를 예약하지 않고 사유를 안내합니다.',
      multiSuccess: '{n}일 모두 예약 완료',
      multiPickAll: '선택한 모든 날짜의 시간대를 선택해 주세요',
      multiMax: '최대 {n}일까지 선택할 수 있습니다',
    },
    groupbooking: { selectedSlot: '선택한 시간대', selectThisSlot: '이 시간대 선택' },
    customerCourse: { allTypes: '전체 유형', allPayments: '전체 결제', autoGenerated: '(자동 생성)',
      paymentMethod: '결제 방법', selectPayment: '— 결제 방법 선택 —',
      paymentCash: '현금', paymentTransfer: '계좌이체', paymentCredit: '신용카드',
      paymentFee: '결제 수수료',
      paymentFeeEditBtn: '수수료 직접 수정',
      paymentFeeResetBtn: '자동 계산 금액으로 되돌리기',
      paymentFeeAutoHint: '가격의 {pct}% 로 자동 계산됩니다',
      paymentFeeNoneHint: '이 결제 방법에는 수수료가 없습니다',
      paymentFeeManualHint: '직접 수정함 — 자동 계산값은 {amount} ฿',
      paymentFeeConfirmTitle: '수수료를 직접 수정할까요?',
      paymentFeeConfirmBody: '시스템이 수수료를 {amount} ฿ 로 계산했습니다. 직접 수정하시겠습니까?',
      paymentFeeConfirmOk: '네, 수정합니다',
      promotion: '특별 프로모션 코스', promotionBadge: '프로모션', allPromotions: '전체 프로모션', notPromo: '일반',
      slipVerifyNote: 'Thunder로 자동 확인됩니다', slipStoreNote: '영수증으로 보관 (자동 확인 안 함)', slipNeedPaid: '"결제 완료"를 선택해야 슬립을 업로드할 수 있습니다', unlimited: '무제한' },
    bookingMgmt: { searchStudentPlaceholder: '학생 이름 입력…',
      cancelNeedsUndo: '출석 체크됨 — 먼저 출석을 취소해야 예약을 취소할 수 있습니다',
      cancelAskManager: '3일 이상 지남 — 취소 전 매니저에게 확인을 요청하세요',
      perSessionToggle: '1회 수업 (1회권을 자동 생성)',
      perSessionHasMainCourse: '이 학생은 이미 수강권이 있습니다 — 1회 수업 예약은 기존 수강권에서 차감되지 않습니다',
      perSessionPaidCancelTitle: '이미 결제된 예약입니다',
      perSessionPaidCancelBody: '이 예약은 결제가 완료되었습니다. 취소하면 1회권 {refer}이(가) 시스템에서 제거되며 재무 보고서에 집계되지 않습니다. 정말 취소하시겠습니까?',
    },
    approve: { subtitle: '검토 대기 목록', approveBtn: '승인', rejectBtn: '거절' },
    holidays: { subtitle: '휴무일', holidayInfo: '휴일 정보' },
    dup: {
      title: '같은 아이일 수 있습니다', subtitle: '새로 만들기 전에 확인하세요',
      intro: '정보가 일치하는 학생을 {n}명 찾았습니다 — 같은 아이라면 새로 만들지 말고 이 가족으로 옮기세요. 수업 기록과 수강권도 함께 이동합니다.',
      createAnyway: '다른 아이 — 새로 만들기', moveHere: '이 가족으로 옮기기',
      statWithMatch: '중복 있음',
      filterAll: '전체', filterMatched: '중복 있음', filterUnmatched: '일치 없음',
      needMergeHint: '기존 학생과 중복 — 옮기기가 아니라 기록 병합이 필요합니다',
      assignFamily: '가족에 배정',
      mergeTitle: '기존 학생과 중복', mergeSubtitle: '옮기기가 아니라 병합이 필요합니다',
      mergeExplain: '이 아이는 고객 가족에 이미 정식 기록이 있습니다. 이 행을 그대로 옮기면 한 가족에 두 개의 행이 생기고 기록은 여전히 나뉜 상태로 남습니다.',
      mergeFrom: '대기열 기록(예전)', mergeTo: '시스템의 정식 기록',
      mergeHow: '관리자가 "이 학생으로 병합"을 누르면 모든 예약·개인 레슨·이벤트·그룹·코스를 실제 기록으로 옮기고 이전 기록을 한 번에 닫습니다. 관리자가 아니면 관리자에게 요청하세요.',
      assignTitle: '가족에 배정', assignBtn: '이 가족으로 옮기기',
      assignExplain: '이 아이는 아직 정식 기록이 없어 바로 가족으로 옮길 수 있습니다. 기록과 수강권도 함께 이동합니다.',
      pickFamilyFirst: '양식에서 보호자 사용자 이름을 먼저 선택하면 옮기기 버튼이 활성화됩니다',
      moved: '가족으로 옮겼습니다 — 기록과 수강권도 모두 함께 이동',
      why: { nameDob: '이름과 생년월일이 같음', name: '이름이 같음', nickDob: '별명·성·생년월일이 같음', nick: '별명과 성이 같음', lastnameDob: '성과 생년월일이 같음', firstNick: '이름과 별명이 같음 (성은 다름)' },
      conf: { veryhigh: '매우 일치', high: '일치', medium: '일치 가능' },
      staffRow: '직원이 만든 기록', noFamily: '가족 없음', bookings: '예약 {n}건', lastClass: '최근 수업 {d}', noClass: '수업 이력 없음',
      tabList: '학생 목록', tabUnclaimed: '보호자 없음',
      unclaimedHint: '직원 계정 아래에 만들어진 아이(관리자가 대신 예약하던 시기) 또는 가족이 없는 아이 — 보호자가 가입해 아이를 추가하는 순간 중복 데이터가 됩니다.',
      colParkedUnder: '등록된 계정', colCreated: '생성일', colBookings: '예약', colLastClass: '최근 수업', colCourse: '수강권', colMatch: '일치 후보',
      statTotal: '전체', statNoFamily: '가족 없음', statWithCourse: '수강권 보유', statWithBookings: '수업 이력',
      approveWarn: '기존 학생 {n}명과 중복될 수 있음', approveWarnHint: '승인 전에 확인하세요 — 같은 아이라면 이 신청을 거절하고 기존 기록을 가족으로 옮기세요.',
      headOnlyHint: '기존 학생과 거의 확실히 중복됩니다 — 관리자만 확인 후 승인할 수 있습니다 (거절은 평소대로 가능).',
      reasonTitle: '승인 사유',
      reasonHint: '중복 가능성이 감지됐습니다 — 그래도 승인하는 이유를 간단히 적어 주세요. 관리자가 나중에 확인합니다.',
      reasonPlaceholder: '예: 확인 결과 다른 아이 / 쌍둥이입니다',
      headOnlyCreateHint: '기존 학생과 거의 확실히 중복됩니다 — 새로 만들 수 없으며 관리자 확인이 필요합니다 (기존 기록을 이 가족으로 옮기는 것은 평소대로 가능).',
      linkBtn: '시스템에 있는 기존 학생과 병합',
      linkHint: '이 학생은 이미 시스템에 있습니다 — 중복이 생기지 않도록 승인 대신 병합 버튼을 사용하세요',
      linkTitle: '시스템에 있는 기존 학생과 병합',
      linkConfirm: '{target}(현재 {current} 아래)을(를) {family} 가족으로 옮기고 보호자가 입력한 정보로 바꿉니다. 학생의 수업 기록과 코스는 그대로 유지됩니다. 이 요청은 종료됩니다.',
      linkDone: '기존 학생과 병합했습니다',
      linkFail: '기존 학생과 병합하지 못했습니다',
      staffTag: '체험 수업 때 관리자가 임시 등록',
      acctType: { 0: '매니저 계정', 1: '관리자 계정', 2: '코치 계정', 10: '고객 계정' },
      whyLabel: '중복으로 판단한 이유',
      cmpPending: '보호자가 직접 추가한 학생 (승인 대기)',
      cmpExisting: '시스템에 이미 있는 학생',
      fName: '이름',
      fNick: '별명',
      fDob: '생년월일',
      fAccount: '계정',
      fHistory: '수업 기록',
      acctCustomer: '고객 사용자명: {u}',
      acctStaff: '직원 계정 {u} (체험 수업 때 관리자가 임시 등록)',
      acctNone: '어느 계정에도 없음',
      newRequest: '새 요청, 아직 기록 없음',
      historyN: '예약 {n}건',
      linkIntro: '확인하면 시스템이 다음을 합니다:',
      linkStep1: '학생을 보호자 계정 {to}(으)로 이동',
      linkStep1NoFam: '학생을 고객 계정 {to}에 넣기',
      linkStep2: '보호자가 입력한 정보 사용 ("변경" 표시된 행)',
      linkStep3: '예약 {n}건과 기존 코스는 그대로 유지',
      linkStep4: '새 학생을 만들지 않고 이 요청 종료',
      colField: '항목',
      colNow: '현재',
      colAfter: '병합 후',
      changed: '변경',
      linkErr: { gone: '이 요청은 이미 처리되었습니다', not_candidate: '이 학생은 시스템이 연결을 제안한 대상이 아닙니다 — 관리자에게 확인하세요', shared_course: '기존 학생이 다른 학생과 코스를 공유하고 있어 가족을 바꿀 수 없습니다 — 관리자에게 문의하세요', already_in_family: '이 가족에는 이미 이 학생이 있습니다 — 연결 대신 관리자가 기록을 병합해야 합니다', bad_family: '이 요청은 고객 가족에서 온 것이 아니므로 연결할 수 없습니다' },
      mergeBtn: '이 학생으로 병합',
      mergeConfirmTitle: '학생 병합 확인',
      mergeConfirm: '{from}의 모든 기록(예약 {n}건, 개인 레슨·이벤트·그룹·코스 포함)을 {to}(으)로 옮기고 이전 기록을 닫습니다. 앱에서 되돌릴 수 없습니다.',
      mergeCheck: '같은 아이임을 확인했습니다',
      mergeDone: '학생을 병합했습니다',
      mergeFail: '학생 병합에 실패했습니다',
      mergeErr: { booking_conflict: '두 기록이 같은 날 같은 수업을 예약했습니다 — 먼저 한 예약을 취소한 뒤 병합하세요', event_conflict: '두 기록이 같은 이벤트에 등록되어 있습니다 — 먼저 하나를 취소한 뒤 병합하세요', course_slots: '실제 기록이 이미 코스 2개를 보유하고 있어 이전 기록의 코스를 넣을 수 없습니다 — 먼저 코스를 정리한 뒤 병합하세요', private_conflict: '두 기록이 같은 개인 레슨에 있습니다 — 먼저 한쪽을 뺀 뒤 병합하세요', not_found: '학생을 찾을 수 없거나 이미 병합/삭제되었습니다 — 목록을 새로고침하세요', direction: '직원 계정 아래 또는 가족 없는 기록을 고객 가족의 기록으로만 병합할 수 있습니다', not_candidate: '두 기록은 확실한 중복이 아닙니다(예: 쌍둥이) — 병합할 수 없습니다' },
      reasonCreateHint: '중복 가능성이 감지됐습니다 — 그래도 새로 만드는 이유를 간단히 적어 주세요. 관리자가 나중에 확인합니다.',
    },
    gymnasts: { typeUsername: '사용자 이름 입력…' },
    bookingList: { blindTooltip: '이 이름은 다른 학부모에게 숨겨져 있습니다' },
    family: { yearsOld: '세', pendingApproval: '승인 대기' },
    editProfile: { changePhoto: '사진 변경', uploadNewPhoto: '새 사진 업로드', removePhoto: '사진 삭제' },
    calendar: {
      tooltipBookingClosed: '해당 날짜의 예약이 마감되었습니다 (당일 예약은 오전 8시까지)', tooltipMondayClosed: '월요일 — 휴무',
      tooltipHolidayClosed: '휴일 — 휴무', legendClosed: '월요일과 휴일은 자동으로 휴무입니다', holidaysThisMonth: '이번 달 휴무일', holidayLabel: '휴일',
      tooltipBeforeMinDate: '이전 날짜는 선택할 수 없습니다',
    },
    select: { noMatch: '일치 항목 없음', searchPlaceholder: '입력하여 검색…' },
    pager: { firstPage: '첫 페이지', prevPage: '이전', nextPage: '다음', lastPage: '마지막 페이지' },
    classDisable: {
      title: '수업 예약 마감', subtitle: '특정 그룹 수업을 특정 날짜에 예약 마감',
      newClosure: '마감 추가', closureInfo: '마감 정보', dateLabel: '마감일',
      pickClass: '마감할 수업 선택', pickClassPlaceholder: '— 수업 선택 —',
      noClassOnDate: '선택한 날짜에 수업이 없습니다', reason: '사유 (예: 특별 휴일 / 강사 부재)',
      confirmDelete: '{class} 의 {date} 예약을 다시 열까요?',
      created: '수업 예약을 마감했습니다', reopened: '수업 예약을 다시 열었습니다',
      selectDateFirst: '먼저 날짜를 선택하세요',
    },
    closures: {
      title: '휴무·마감 관리', subtitle: '스튜디오 휴무일과 수업별 예약 마감 관리',
      tabHoliday: '휴무일 (종일)', tabClass: '수업별 마감',
      bookingWarnTitle: '해당 날짜에 이미 예약이 있습니다',
      bookingWarnLead: '{date}에 이미 {n}건의 예약이 있습니다',
      bookingWarnGroup: '그룹 수업 ({n})', bookingWarnPrivate: '개인 레슨 ({n})',
      bookingWarnNote: '이 예약들은 자동으로 취소되거나 횟수가 반환되지 않습니다. 학부모에게 연락하여 직접 처리해 주세요.',
      bookingWarnConfirm: '계속 진행',
    },
    nav: { expandMenu: '메뉴 펼치기', collapseMenu: '메뉴 접기', menuPermission: '메뉴 권한', closures: '휴무·마감 관리', grouping: '코치 조 편성', coachSchedule: '코치 시간표', coachLeave: '휴가 신청', leaveApproval: '휴가 승인', scheduleAdmin: '수업 시간표 관리' },
    scheduleAdmin: {
      title: '수업 시간표 관리', subtitle: '코스 유형 생성과 주간 수업 시간표 설정을 한 곳에서',
      courseTypes: '코스 유형', showDisabled: '비활성 코스 표시', addCourse: '코스 추가',
      legendClickCourse: '코스를 클릭하여 편집', legendDirty: '노란색 테두리＝저장 안 된 수정',
      legendNew: '초록색 테두리＝새로 추가', legendAdmin: '빗금＝관리자 전용 수업',
      weeklyTable: '주간 수업 시간표', addClass: '수업 추가',
      hintCreate: '빈 칸을 클릭하여 수업 생성', hintDrag: '블록을 드래그하여 요일/시간 이동 · 가장자리를 드래그하여 시간 조정', hintEdit: '블록을 클릭하여 편집/삭제',
      evTitle: '드래그로 이동 · 가장자리 드래그로 시간 조정 · 클릭하여 편집',
      editClass: '수업 편집', newClass: '새 수업', classInfo: '수업 정보',
      startTime: '시작 시간', endTime: '종료 시간', validityAndVisibility: '유효 기간 및 표시',
      startDate: '시작일', endDate: '종료일', adminOnly: '관리자 전용 수업', adminOnlyHint: '고객에게 숨김 (adminflag)',
      deleteClass: '수업 삭제', deleteCourse: '코스 삭제', editCourse: '코스 유형 편집', newCourse: '새 코스 유형', courseInfo: '코스 정보',
      courseNamePh: '예: Gymnastics Activity', shortNamePh: '예: G.A.',
      refercode: '참조 코드 (접두사)', refercodePh: '예: GA',
      refercodeHint: '고객 코스 번호 생성에 사용 예: GA-20260724-0001 — 생성 시 한 번만 설정',
      refercodeLocked: '참조 코드는 생성 시에만 설정되며 나중에 변경할 수 없습니다',
      courseColor: '코스 색상 (달력에 표시)', status: '상태', statusHint: '활성화 — 비활성화하면 예약에서 숨겨짐',
      confirmTitle: '확인', confirmDeleteClass: '이 수업을 삭제하시겠습니까? 지난 수강 기록은 모두 보존됩니다. 앞으로의 예약이 남아 있으면 먼저 취소/이동해야 삭제할 수 있습니다.',
      confirmDeleteCourse: '이 코스를 삭제하시겠습니까? 소속 수업도 함께 삭제되지만 지난 수강 기록과 고객 수강권은 모두 보존됩니다. 앞으로의 예약이 없고 모든 고객 수강권이 종료된 경우에만 삭제할 수 있습니다.',
      confirmProceedHint: '계속하시겠습니까?',
      unsaved: '개의 저장 안 됨', discardAll: '모두 취소', saveToSystem: '시스템에 저장',
      diffNew: '추가 {n}', diffEdit: '수정 {n}', diffDelete: '삭제 {n}',
      reverted: '모든 변경 사항을 되돌렸습니다', saved: '시간표가 저장되었습니다',
    },
    grouping: {
      title: '코치 조 편성', subtitle: '각 수업의 학생을 코치별 조로 나눕니다 (기존 Google 시트 대체)',
      coachTitle: '코치 시간표', coachSubtitle: '수업별 담당 조 — 수업 전에 확인하세요',
      privateTitle: '프라이빗 레슨', noPrivate: '프라이빗 레슨 없음', privateHours: '{n}시간',
      privateCheckinHint: '체크인은 관리자 또는 이 수업을 담당하는 코치만 가능합니다',
      modeDay: '일', modeWeek: '주', today: '오늘', prev: '이전', next: '다음',
      personUnit: '명', unassigned: '미배정', allAssigned: '전원 배정 완료', emptyGroup: '조원이 없습니다',
      noBooking: '이 수업에는 아직 예약이 없습니다', noSessions: '이 날에는 수업이 없습니다',
      addGroup: '조 추가', editGroup: '조 편집', coachesLabel: '담당 코치',
      noCoachYet: '코치 명단이 비어 있습니다 — "코치 명단" 버튼에서 추가하세요',
      groupName: '특별 조 이름 (선택)', groupNamePh: '예: Tax FIG1+L.4 (비우면 코치 이름 표시)',
      groupRemark: '조 메모', groupRemarkPh: '예: 이단평행봉 연습',
      deleteGroup: '조 삭제', confirmDeleteGroup: '"{name}" 조를 삭제할까요? 조원은 "미배정"으로 돌아갑니다.',
      moveAllTitle: '조원 전체 이동 ({n}명)', moveAllTo: '— 이동할 조 선택 —', moveAllBtn: '전체 이동',
      moveTo: '이동:', removeFromGroup: '조에서 제외', noGroupYet: '이 수업에는 아직 조가 없습니다 — 먼저 추가하세요',
      sessionNote: '수업 메모', sessionNotePh: '예: 오늘은 L.3-L.4 합반',
      dayNote: '오늘의 메모', dayNotePh: '오늘의 메모 추가...',
      absentTag: '휴가', allDayShort: '종일', absentCoachesToday: '오늘 휴가 코치',
      checkin: '체크인', undoCheckin: '체크인 취소',
      absenceBtn: '코치 휴가', absenceTitle: '코치 휴가 기록', absenceCoach: '코치', absenceDate: '날짜',
      absenceAllDay: '종일 휴가', absencePickClasses: '휴가인 수업 선택', absenceReason: '사유 (선택)', absenceReasonPh: '예: 병가',
      absenceCancelBtn: '휴가 취소',
      coachManageBtn: '코치 명단', coachManageTitle: '코치 명단', coachManageSub: '코치는 로그인 계정이 없어도 됩니다 — 나중에 연결할 수 있어요',
      autoBtn: '자동 그룹 편성', autoBtnDay: '하루 전체 자동 편성', autoPreviewTitle: '자동 그룹 편성',
      autoModeUnassigned: '그룹 없는 학생만', autoModeUnassignedHint: '기존 그룹은 그대로 두고 아직 배정되지 않은 학생만 편성합니다',
      autoModeRebuild: '수업 전체 다시 편성', autoModeRebuildHint: '이 수업의 모든 그룹 구성원을 비우고 규칙대로 다시 배정합니다 (그룹·메모·코치는 유지)',
      autoNewGroup: '새 그룹', autoReuseGroup: '기존 그룹', autoSessionCount: '{n}개 수업',
      autoSkipTitle: '편성 불가 · {n}명', autoSkipOutOfRange: '어느 그룹 범위에도 들어가지 않음',
      autoSkipNoBirthdate: '생년월일이 등록되지 않음', autoSkipNoLevel: '레벨이 입력되지 않음',
      autoNothingToDo: '지금 편성할 학생이 없습니다', autoTotal: '{n}명을 {g}개 그룹으로 편성합니다', autoApplyBtn: '편성 확정',
      autoRebuildConfirmTitle: '수업 전체를 다시 편성할까요?', autoRebuildConfirmBody: '직접 옮긴 학생도 모두 규칙대로 다시 배정됩니다. 계속할까요?',
      autoDone: '그룹 편성 완료 — {n}명',
      ruleBtn: '규칙 설정', ruleTitle: '자동 편성 규칙', ruleSub: '코스당 규칙 한 세트 — 코드 수정 없이 여기서 변경할 수 있어요',
      ruleAdd: '규칙 추가', ruleEdit: '규칙 수정', ruleDelete: '규칙 삭제', ruleNone: '아직 규칙이 없습니다',
      ruleConfirmDelete: '규칙 "{name}"을(를) 삭제할까요? (이미 만들어진 그룹은 유지됩니다)',
      ruleCourse: '코스', ruleBasis: '분류 기준', ruleName: '규칙 이름', ruleNamePh: '예: G.A. 나이별',
      ruleBuckets: '그룹', ruleBucketNamePh: '그룹 이름, 예: 3-5세', ruleMin: '이상', ruleMax: '이하',
      ruleMaxPerson: '그룹당 최대', ruleOpenEnd: '제한 없음', ruleNoLimit: '제한 없음', ruleDefaultCoaches: '기본 코치 (선택)',
      ruleAddBucket: '그룹 추가', basisAge: '나이 (세)', basisLevel: '레벨',
      ruleHint: '"이상" 또는 "이하"를 비우면 그쪽은 제한 없음 · 그룹 범위는 겹칠 수 없습니다 · 최대 인원을 정하면 #1 #2로 자동 분할됩니다',
      addCoach: '코치 추가', editCoach: '코치 편집', coachName: '표시 이름', coachColor: '코치 색상', coachSort: '순서',
      coachLink: '로그인 계정 연결', coachLinkNone: '— 연결 안 함 —',
      coachLinkHint: '연결하면 해당 코치의 "코치 시간표"에서 내 조가 강조 표시됩니다',
      coachDisable: '코치 비활성화', confirmDisableCoach: '"{name}" 코치를 비활성화할까요? 기존 조에는 이름이 계속 표시됩니다.',
      disabledBadge: '비활성', notLinkedBadge: '계정 미연결',
      highlightMine: '내 조 강조', myGroupsOnly: '내 조만 보기',
      loadFail: '데이터를 불러오지 못했습니다',
      leaveBtn: '휴가 신청', leaveReqTitle: '직원 휴가 신청', leaveReqSub: '승인하면 시간표에 자동으로 기록됩니다',
      leavePendingTitle: '처리 대기중', leaveHistoryTitle: '처리 완료 내역', leaveHistorySub: '승인, 반려 또는 취소된 신청', leaveHistoryCount: '{n}건',
      myLeaveHistory: '휴가 내역', viewGrouped: '종류별로 묶기', viewChrono: '날짜순 정렬',
      ovApprovedLabel: '승인됨 {n}일', ovPendingNote: '승인 대기로 {n}일 보류',
      quotaOverLabel: '한도 초과 {over}일 (승인 {used}／한도 {quota}일)', quotaNotSetWithUsed: '올해 할당량 미설정 · 신청 {n}일',
      leaveOverviewQuotaNote: '"잔여" 수치는 "승인 대기" 신청을 미리 차감한 값입니다. 나중에 한도를 초과해 승인하는 것을 방지하기 위함입니다.',
      leavePendingCountNote: '이 직원에게 승인 대기 중인 신청이 {n}건 있습니다{type}', goToPendingCard: '"처리 대기중" 카드로 이동',
      daysInYearNote: '(올해 {n}일)',
      myLeaveSubmit: '휴가 신청하기', myLeaveList: '내 신청 내역', leaveSubmitBtn: '제출',
      leaveTypeLabel: '휴가 종류', leaveType_sick: '병가', leaveType_personal: '개인 사유', leaveType_vacation: '연차',
      leaveType_unpaid: '일반 휴가 (무급)',
      dayPortionLabel: '휴가 시간대', dayPortion_full: '종일', dayPortion_morning: '오전 반차', dayPortion_afternoon: '오후 반차',
      createLeaveLabel: '휴가 생성 (승인 대기)', createLeaveHint: '이 코치에게 승인 대기 휴가를 생성합니다 — 시간표에 즉시 휴가로 표시되고, 매니저가 승인하면 할당량이 차감됩니다 (파트타임 = 미출근 기록만)',
      leaveOverviewTitle: '연간 휴가 개요', staffName: '직원',
      leaveOverviewHint: '직원 이름을 클릭하면 개인별 휴가 내역을 펼칠 수 있습니다 (종류별 필터 가능)',
      leaveTypeAll: '전체 종류', leaveDetailOf: '{name}의 휴가 내역', submittedAt: '신청 일시',
      cancelReviewBtn: '취소', cancelReviewTitle: '휴가 신청 취소',
      confirmCancelReview: '이미 처리된 "{name}"의 휴가를 취소할까요? 시간표에서 제거하고 할당량을 돌려줍니다.',
      countAsLeave: '휴가로 처리 (할당량 차감)', countAsLeaveHint: '이 코치에게 승인된 휴가를 생성하고 선택한 종류의 올해 할당량을 차감합니다',
      parttimeNoQuota: '파트타임 코치 — 미출근으로만 기록, 할당량 차감 없음',
      employmentType: '고용 형태', employmentTypeHint: '정규직 = 휴가 시 할당량 차감 · 파트타임 = 미출근 기록만',
      employmentFulltime: '정규직 (Full-time)', employmentParttime: '파트타임 (Part-time)',
      leaveFrom: '시작일', leaveTo: '종료일', leaveReason: '사유 (선택)', leaveReasonPh: '예: 집안일',
      leaveMultiDayHint: '여러 날 휴가는 기간 내 매일 종일 처리됩니다 (수업 선택은 하루 휴가만 가능)',
      leaveStatus_pending: '승인 대기', leaveStatus_approved: '승인됨', leaveStatus_rejected: '반려됨', leaveStatus_cancelled: '취소됨',
      approve: '승인', reject: '반려', reviewNote: '코치에게 메모 (선택)',
      confirmApprove: '"{name}"의 휴가를 승인할까요? 시간표에 자동 기록됩니다.',
      confirmReject: '"{name}"의 휴가 신청을 반려할까요?',
      cancelReq: '신청 취소', confirmCancelReq: '이 휴가 신청을 취소할까요?',
      notLinkedLeave: '계정이 아직 코치 명단과 연결되지 않았습니다 — 관리자에게 문의하세요', noLeaveReq: '휴가 신청이 없습니다',
      leavePageTitle: '휴가 신청', leavePageSub: '휴가 신청, 잔여 일수 확인, 승인 결과 추적',
      leaveApprovalTitle: '휴가 승인', leaveApprovalSub: '직원 휴가 신청 검토 및 승인/반려, 연간 할당량 설정',
      daysUnit: '일', statusAll: '전체 상태', quotaRemainLabel: '잔여', quotaUsedLabel: '사용',
      quotaPendingNote: '승인 대기 {n}일', quotaNotSet: '올해 할당량 미설정', quotaUsedShort: '사용 {n}일',
      quotaBtn: '할당량 설정', quotaTitle: '연간 휴가 할당량', quotaSub: '코치별 연간 휴가 일수를 설정합니다 (매니저 전용)', quotaYear: '연도', saveAllQuota: '전체 저장',
      noCoachYetOnLeave: '코치 명단이 비어 있습니다 — "코치 조 편성" 페이지("코치 명단" 버튼)에서 추가하세요', goToGrouping: '코치 조 편성으로',
    },
    menuPerm: {
      title: '메뉴 권한', subtitle: '사용자 유형별로 이용 가능한 메뉴를 설정합니다 (매니저 전용)',
      colMenu: '메뉴', save: '권한 저장', saved: '메뉴 권한이 저장되었습니다',
      confirmTitle: '권한 변경 확인', confirmBody: '변경 {n}건:',
      changedCount: '변경 {n}건', allow: '허용', deny: '차단',
      notConfigured: '미설정 — 매니저 전용', headAlways: '매니저는 항상 모든 메뉴를 이용할 수 있습니다', headToggleHint: '클릭하여 이 메뉴를 매니저 메뉴 바에서 숨김/표시',
      coreAlwaysHint: '기본 메뉴 (모두에게 항상 공개)', coreHeadHint: '매니저 전용',
      externalHint: '외부 시스템(SSO) — 결제 시스템에서 매니저 권한을 다시 확인합니다',
      restrictedByCode: '이 메뉴의 일부 기능은 매니저/관리자 전용입니다 (예: 가격 설정, 슬립 확인) — 메뉴는 허용할 수 있지만 해당 기능은 사용할 수 없습니다',
      restrictedHeadAdmin: '이 메뉴는 코드에서 매니저/관리자 전용입니다 — 코치/고객에게는 허용할 수 없습니다',
      lockedHeadAdmin: '이 메뉴의 모든 기능은 매니저/관리자가 필요합니다 — 이 역할에 허용해도 효과가 없습니다',
      loadFail: '권한 데이터를 불러오지 못했습니다',
      userTitle: '개인별 권한', userSubtitle: '특정 직원에게 메뉴를 추가로 개방 (역할 권한에 더해)', pickUser: '— 직원 선택 —', pickUserHint: '직원을 선택하여 개별 메뉴 권한을 설정하세요', userSaved: '개인별 권한을 저장했습니다',
    },
    auth: { pleaseLoginAgain: '다시 로그인해 주세요' },
    noti: {
      title: '알림', upcoming: '현재 알림', past: '지난 알림',
      empty: '알림이 없습니다', markAllRead: '모두 읽음 처리',
      enablePush: '이 기기에서 알림 켜기', pushOn: '알림이 켜져 있습니다',
      pushOff: '이 기기 알림 끄기',
      pushDesc: '사이트를 열지 않아도 새 알림이 오면 화면에 알려 드립니다',
      pushBlocked: '브라우저가 알림을 차단했습니다 — 브라우저 설정에서 허용해 주세요',
      pushUnsupported: '이 브라우저는 알림을 지원하지 않습니다',
      pushIosHint: 'iPhone/iPad에서는 공유 → "홈 화면에 추가"를 먼저 해야 알림을 켤 수 있습니다',
      pushFail: '알림을 켜지 못했습니다',
    },
    ops: {
      title: '일일 점검', subtitle: '누락된 항목과 미처리 업무 — 퇴근 전에 한 번 훑어보세요',
      managerOnly: '매니저/관리자', refresh: '다시 점검',
      sevUrgent: '오늘 처리 필요', sevWatch: '이번 주 내 처리', sevInfo: '이상',
      lookback: '조회 기간', lookbackDays: '{n}일', lookbackAll: '전체',
      checkedAt: '최근 점검 {time}',
      attendanceLimitNote: '"결석" 상태는 없습니다 — 미출석 수업은 두 가지로 해결됩니다: 실제로 왔지만 누르지 못함 → 소급해서 출석 처리 가능(날짜 제한 없음) · 오지 않음 → 예약을 취소하면 횟수가 자동 반환되고 항목도 사라집니다.',
      trendTitle: '최근 {n}일 추이',
      trendNote: '매일 21:30 자동 스냅샷 — 항상 동일한 {days}일 조회 기간으로 집계합니다',
      trendShowTable: '일별 수치 보기',
      trendHideTable: '일별 수치 숨기기',
      trendColDate: '날짜',
      allClear: '미처리 항목이 없습니다', allClearSub: '모든 점검을 마쳤고 처리할 항목이 없습니다',
      goFix: '처리 화면으로', truncated: '{total}건 중 {shown}건 표시',
      unknownPriceExcluded: '금액에는 가격 미입력 {n}건이 포함되지 않았습니다',
      countedSince: '{date}부터 집계', passed: '통과한 점검 항목',
      loadFail: '점검 목록을 불러오지 못했습니다',
      paidYes: '결제완료', paidNo: '미결제', flagYes: '예', ageDays: '{n}일',
      kind: { course: '코스', private: '프라이빗', approve: '신청 승인', create: '직접 생성' },
      check: {
        eventUnpaid: '이벤트 신청 미결제 (좌석 점유 중)',
        eventRefundPending: '취소된 이벤트 — 환불 기록 대기',
        eventOrganizerRemit: '주최측 금액 송금 대기',
        checkinGroup: '출석 체크가 끝나지 않은 수업',
        checkinPrivate: '출석 체크를 하지 않은 프라이빗 수업',
        checkinEvent: '출석 체크가 끝나지 않은 이벤트',
        packageUnlinked: '학생과 연결되지 않은 패키지',
        paymentUnpaidTaught: '미수금 — 이미 수업함',
        paymentUnpaid: '미수금 — 아직 시작 안 함',
        priceMissing: '결제했지만 금액 미입력',
        paymentMethodMissing: '결제했지만 결제수단 미선택',
        slipUnverified: '확인되지 않은 입금 전표',
        packageExpiringSoon: '곧 소진되는 패키지',
        packageStale: '구매 후 한 번도 사용 안 함',
        leavePending: '승인 대기 중인 휴가 신청',
        studentPendingApproval: '승인 대기 중인 신규 학생',
        conflictCoachLeave: '코치가 휴가인 날의 프라이빗 수업',
        conflictHoliday: '휴무일과 겹치는 예약',
        packageExpiredWithSessions: '만료됐지만 횟수가 남음',
        studentApprovedDuplicate: '중복 경고에도 통과됨',
      },
      hint: {
        eventUnpaid: '신청 후 미결제 — 좌석이 확보된 상태 · 기한(마감일) 경과 시 제명 또는 수금을 결정하세요',
        eventRefundPending: '이벤트는 취소됐지만 금액은 아직 체육관에 있습니다 — 환불 여부를 기록하세요 (실제 송금은 시스템 외부) · 전부 기록할 때까지 계속 표시됩니다',
        eventOrganizerRemit: '고객에게서 수금했지만 아직 송금 기록이 없는 주최측 몫 (부채이며 수익 아님)',
        checkinGroup: '이미 지난 수업인데 출석 체크가 안 된 학생이 있습니다 — 왔는데 안 눌렀으면 소급 출석 · 안 왔으면 예약 취소(횟수 반환)',
        checkinPrivate: '이미 진행했지만 출석 처리되지 않은 프라이빗 — 소급 출석하거나, 실제로 안 했으면 예약 취소',
        checkinEvent: '끝났는데 출석 처리되지 않은 참가자가 남은 이벤트 — 시간표 화면에서 소급 출석하거나, 불참이면 신청 취소',
        packageUnlinked: '패키지는 있는데 학생이 지정되지 않아 아무도 예약에 쓸 수 없습니다',
        paymentUnpaidTaught: '서비스는 제공했는데 아직 못 받은 금액. 매주 늘어납니다',
        paymentUnpaid: '판매했지만 미수금이고 수업도 아직 시작 전입니다',
        priceMissing: '금액이 없으면 매출 보고서에 잡히지 않습니다',
        paymentMethodMissing: '현금/이체/카드를 알 수 없어 결제수단별 집계에서 빠집니다',
        slipUnverified: '대부분 전표 이미지에 QR 코드가 없어서이며 위조를 뜻하지 않습니다. 육안 확인이 필요합니다',
        packageExpiringSoon: '2회 이하 남았거나 14일 내 만료 — 재등록을 권할 시점',
        packageStale: '구매한 지 14일이 넘었는데 한 번도 예약하지 않았습니다',
        leavePending: '직원이 낸 휴가 신청을 아무도 처리하지 않았습니다',
        studentPendingApproval: '학부모가 추가한 자녀가 승인 대기 중입니다',
        conflictCoachLeave: '코치가 휴가인 날에 프라이빗 수업이 잡혀 있습니다 — 미리 연락해 일정을 옮기세요',
        conflictHoliday: '나중에 휴무일로 지정된 날짜에 예약이 남아 있습니다',
        packageExpiredWithSessions: '결제했는데 다 쓰지 못했습니다 — 민원이 될 수 있습니다',
        studentApprovedDuplicate: '기존 학생과 중복될 수 있다는 경고에도 신청이 승인되거나 학생이 직접 생성됐습니다 — 동일인인지 확인하고, 맞다면 기록을 병합해야 합니다',
      },
      col: {
        event: '이벤트', deadline: '결제 기한', pastDeadline: '기한 경과', collected: '수금됨', remitted: '송금됨', outstanding: '미송금',
        paydate: '결제일', cancelledate: '취소일',
        date: '날짜', time: '시간', course: '코스', pending: '미처리', age: '경과',
        coach: '코치', students: '학생', ref: '번호', type: '유형', amount: '금액',
        paid: '결제', created: '생성일', by: '생성자', kind: '유형', name: '항목',
        sessions: '수강함', since: '기준일', suggested: '기준가', context: '유형',
        status: '상태', reason: '사유', sender: '송금인', remaining: '잔여',
        expire: '만료일', staff: '직원', leaveType: '휴가 유형', from: '시작', to: '종료',
        requested: '신청일', student: '학생', nickname: '별명', holiday: '휴무일',
        approver: '처리자', matched: '중복 대상', approvedAt: '승인일',
      },
      dupWhy: {
        nameDob: '이름과 생년월일이 동일',
        name: '이름과 성이 동일',
        nickDob: '별명·성·생년월일이 동일',
        nick: '별명과 성이 동일',
        lastnameDob: '성과 생년월일이 동일',
        firstNick: '이름과 별명이 동일 (성은 다름)',
      },
      slipStatus: {
        failed: '확인 실패', skipped: '확인 불가', duplicate: '중복 전표',
        amount_mismatch: '금액 불일치', wrong_receiver: '수취 계좌 불일치',
      },
    },
    session: {
      expiringIn: '세션이 {n}초 후에 만료됩니다',
      stayLoggedIn: '계속 사용',
      endedTitle: '세션이 종료되었습니다',
      endedExpired: '세션이 만료되었습니다. 본인 확인을 다시 해주세요 — 입력하신 내용은 그대로 남아 있습니다.',
      endedLogout: '다른 기기에서 로그아웃되었습니다. 다시 로그인해 주세요.',
      endedPermission: '권한이 변경되었습니다. 다시 로그인해 주세요.',
      continue: '계속 로그인',
      logoutInstead: '로그아웃',
      loginFailed: '로그인에 실패했습니다. 비밀번호를 확인해 주세요.',
    },
    presence: {
      viewersHint: '이 페이지를 함께 보는 중: {names}',
      editingHint: '{name} 님이 이 항목을 수정 중입니다',
      alsoEditing: '{name} 님도 이 항목을 수정 중입니다 — 동시에 저장하면 상대방의 변경이 덮어써집니다',
    },
  },
}

// merge the additions into the main tree (new keys appended per section; existing keys untouched)
for (const loc of Object.keys(extraMessages)) {
  const dst = messages[loc] || (messages[loc] = {})
  for (const sec of Object.keys(extraMessages[loc])) {
    dst[sec] = Object.assign({}, dst[sec], extraMessages[loc][sec])
  }
}

// per-date seat limit (ClassDisableManagement.vue) — CJK translations are AI-produced; a native speaker should review them.
const classLimitMessages = {
  th: { classLimit: {
    listTitle: 'จำกัดจำนวนเด็กเฉพาะวัน', colDate: 'วันที่', pickClass: 'เลือกคลาส', holidayDate: 'วันที่เลือกเป็นวันหยุด (ปิดทุกคลาสอยู่แล้ว)', newLimit: 'จำกัดจำนวนเพิ่ม', info: 'จำกัดจำนวนรับสูงสุดของคลาสในวันที่เลือก (วันอื่นยังรับตามปกติ)',
    maxLabel: 'จำนวนรับสูงสุดในวันนี้', usualHint: 'ปกติคลาสนี้รับ {n} คน · ผู้ปกครองจองเกินไม่ได้ แต่แอดมินยังจองเกินได้',
    reason: 'เหตุผล (เช่น ครูไม่ครบ / ซ่อมอุปกรณ์)', colMax: 'รับได้', colUsual: 'ปกติ', colBooked: 'จองแล้ว',
    edit: 'แก้ไขจำนวน', remove: 'ยกเลิกการจำกัด', confirmRemove: 'ต้องการยกเลิกการจำกัดจำนวน {class} วันที่ {date} ใช่หรือไม่?',
    saved: 'ตั้งจำนวนรับสูงสุดเรียบร้อย', savedOver: 'ตั้งแล้ว แต่วันนั้นมีการจองอยู่ {n} คน เกินจำนวนใหม่ — ระบบไม่ยกเลิกการจองเดิมให้',
    removed: 'ยกเลิกการจำกัดจำนวนเรียบร้อย',
  } },
  en: { classLimit: {
    listTitle: 'Seat limit for a single date', colDate: 'Date', pickClass: 'Select class', holidayDate: 'The chosen date is a holiday (all classes are already closed)', newLimit: 'Add seat limit', info: 'Cap the seats of this class on the chosen date only (other dates stay as usual)',
    maxLabel: 'Max students on this date', usualHint: 'This class normally takes {n} · parents cannot exceed the cap, admins still can',
    reason: 'Reason (e.g. short on coaches / equipment repair)', colMax: 'Limit', colUsual: 'Usual', colBooked: 'Booked',
    edit: 'Edit limit', remove: 'Remove limit', confirmRemove: 'Remove the seat limit for {class} on {date}?',
    saved: 'Seat limit saved', savedOver: 'Saved, but {n} are already booked that day (over the new limit) — existing bookings are not cancelled',
    removed: 'Seat limit removed',
  } },
  zh: { classLimit: {
    listTitle: '单日人数上限', colDate: '日期', pickClass: '选择班级', holidayDate: '所选日期为假日(所有班级已关闭)', newLimit: '新增人数上限', info: '仅限制所选日期该班级的最大人数(其他日期照常)',
    maxLabel: '当天最多人数', usualHint: '该班级通常可容纳 {n} 人 · 家长不能超出上限,管理员仍可超额预约',
    reason: '原因(如教练不足 / 器材维修)', colMax: '上限', colUsual: '通常', colBooked: '已预约',
    edit: '修改上限', remove: '取消上限', confirmRemove: '确定取消 {class} 在 {date} 的人数上限吗?',
    saved: '已设置人数上限', savedOver: '已设置,但当天已有 {n} 人预约,超过新上限 — 系统不会取消已有预约',
    removed: '已取消人数上限',
  } },
  ja: { classLimit: {
    listTitle: '特定日の定員制限', colDate: '日付', pickClass: 'クラスを選択', holidayDate: '選択した日は休業日です(全クラスが既に休み)', newLimit: '定員制限を追加', info: '選択した日付のみ、このクラスの定員を制限します(他の日は通常どおり)',
    maxLabel: 'この日の最大人数', usualHint: '通常このクラスは {n} 名 · 保護者は上限を超えて予約できませんが、管理者は可能です',
    reason: '理由(例:コーチ不足 / 器具の修理)', colMax: '上限', colUsual: '通常', colBooked: '予約済み',
    edit: '上限を編集', remove: '制限を解除', confirmRemove: '{date} の {class} の定員制限を解除しますか?',
    saved: '定員を設定しました', savedOver: '設定しましたが、その日は既に {n} 名の予約があり新しい上限を超えています — 既存の予約は取り消されません',
    removed: '定員制限を解除しました',
  } },
  ko: { classLimit: {
    listTitle: '특정 날짜 인원 제한', colDate: '날짜', pickClass: '클래스 선택', holidayDate: '선택한 날짜는 휴일입니다(모든 클래스가 이미 휴무)', newLimit: '인원 제한 추가', info: '선택한 날짜에만 이 클래스의 최대 인원을 제한합니다(다른 날짜는 그대로)',
    maxLabel: '이 날짜의 최대 인원', usualHint: '이 클래스는 보통 {n}명 · 학부모는 제한을 초과할 수 없고 관리자는 초과 예약 가능',
    reason: '사유(예: 코치 부족 / 장비 수리)', colMax: '제한', colUsual: '기본', colBooked: '예약됨',
    edit: '제한 수정', remove: '제한 해제', confirmRemove: '{date} {class}의 인원 제한을 해제하시겠습니까?',
    saved: '인원 제한을 설정했습니다', savedOver: '설정했지만 그날 이미 {n}명이 예약되어 새 제한을 초과합니다 — 기존 예약은 취소되지 않습니다',
    removed: '인원 제한을 해제했습니다',
  } },
}
for (const loc of Object.keys(classLimitMessages)) Object.assign(messages[loc], classLimitMessages[loc])

// event v2 — registration/pricing config form (EventConfigForm.vue, phase 2)
// CJK translations are AI-produced; a native speaker should review them.
const evCfgMessages = {
  th: {
    section: 'การรับสมัคร & ราคา', priceSection: 'ค่าสมัคร (ราคา)', regSection: 'ช่วงรับสมัคร',
    priceOffHint: 'อีเวนต์นี้ไม่มีค่าสมัคร — เปิดสวิตช์เพื่อกำหนดราคา (แอดมินเก็บเงินเองได้โดยไม่ต้องเปิดรับสมัคร)',
    regOffHint: 'ยังไม่เปิดช่วงรับสมัคร — แอดมินเพิ่มรายชื่อเองได้ตามปกติ',
    twoLegHint: 'ค่าธรรมเนียมยิม = รายได้ของยิม (ฐาน VAT) · ค่าสมัครผู้จัด = เก็บแทนผู้จัดภายนอกเพื่อนำส่งต่อ (ไม่ใช่รายได้)', disabledHint: 'ยังไม่ได้ตั้งค่ารับสมัคร/ราคา — เปิดสวิตช์เพื่อกำหนด (อีเวนต์แบบเดิมใช้งานได้ตามปกติ)',
    regOpen: 'วันเปิดรับสมัคร', regClose: 'วันปิดรับสมัคร', regCloseHint: 'วันปิดรับ = เดทไลน์ชำระเงินด้วย (ต้องไม่เกินวันจัดงาน)',
    selfRegister: 'เปิดให้ผู้ปกครองสมัครเอง', selfRegisterHint: 'บันทึกไว้ก่อน — จะมีผลจริงเมื่อเฟสผู้ปกครองเปิดใช้',
    programRestricted: 'จำกัดเฉพาะผู้ถือคอร์สโปรแกรมเดียวกัน',
    priceMode: 'รูปแบบราคา', mode_flat: 'ราคาเดียวทั้งงาน', mode_age: 'ตามช่วงอายุ (ณ วันงาน)', mode_level: 'ตาม Level',
    flatLabel: 'ผู้เข้าร่วม', everyone: 'ทุกคน', ageRange: 'ช่วงอายุ (ปี)', ageMin: 'ต่ำสุด', ageMax: 'สูงสุด',
    level: 'Level', levelPh: 'เช่น 1 (ตัวเลขเท่านั้น)', gymFee: 'ค่าธรรมเนียมยิม', organizerFee: 'ค่าสมัครของผู้จัด', total: 'รวมที่จ่าย',
    addTier: 'เพิ่มแถวราคา', fallbackGym: 'นอกเกณฑ์ — ค่าธรรมเนียมยิม', fallbackOrganizer: 'นอกเกณฑ์ — ค่าสมัครของผู้จัด',
    fallbackHint: 'ราคาสำหรับเด็กที่ไม่เข้าเกณฑ์ใดเลย — ต้องกรอกทั้งสองช่องคู่กัน (ใส่ 0 ได้) หรือเว้นว่างทั้งคู่ = นอกเกณฑ์ต้องติดต่อแอดมิน',
  },
  en: {
    section: 'Registration & Pricing', priceSection: 'Entry fee (pricing)', regSection: 'Registration window',
    priceOffHint: 'This event has no entry fee — turn on to set pricing (admins can still collect payment without opening registration)',
    regOffHint: 'Registration window is off — admins can still add participants manually',
    twoLegHint: 'Gym fee = the gym’s own revenue (VAT base) · Organizer fee = collected on behalf of an external organizer to remit (not revenue)', disabledHint: 'No registration/pricing set — turn on the switch to configure (classic events keep working as before)',
    regOpen: 'Registration opens', regClose: 'Registration closes', regCloseHint: 'Closing date doubles as the payment deadline (must not be after the event date)',
    selfRegister: 'Allow parents to sign up themselves', selfRegisterHint: 'Stored for now — takes effect when the parent phase launches',
    programRestricted: 'Same-program course holders only',
    priceMode: 'Price mode', mode_flat: 'Single price', mode_age: 'By age (at event date)', mode_level: 'By level',
    flatLabel: 'Participants', everyone: 'Everyone', ageRange: 'Age range (years)', ageMin: 'Min', ageMax: 'Max',
    level: 'Level', levelPh: 'e.g. 1 (digits only)', gymFee: 'Gym fee', organizerFee: 'Organizer fee', total: 'Total paid',
    addTier: 'Add price row', fallbackGym: 'Out-of-range — gym fee', fallbackOrganizer: 'Out-of-range — organizer fee',
    fallbackHint: 'Price for kids matching no tier — fill both fields together (0 allowed), or leave both blank = out-of-range must contact admin',
  },
  zh: {
    section: '报名与价格', priceSection: '报名费（价格）', regSection: '报名时间',
    priceOffHint: '此赛事无报名费 — 打开开关设置价格（管理员无需开放报名也可收款）',
    regOffHint: '未开放报名时间 — 管理员仍可手动添加名单',
    twoLegHint: '场馆费 = 场馆自身收入（VAT 计税基础）· 主办方报名费 = 代收后上缴（非收入）', disabledHint: '尚未设置报名/价格 — 打开开关进行配置（原有赛事照常使用）',
    regOpen: '报名开始日', regClose: '报名截止日', regCloseHint: '截止日同时是付款期限（不得晚于活动日期）',
    selfRegister: '允许家长自行报名', selfRegisterHint: '先保存 — 家长阶段上线后生效',
    programRestricted: '仅限同课程项目的学员',
    priceMode: '价格模式', mode_flat: '统一价格', mode_age: '按年龄（活动当日）', mode_level: '按级别',
    flatLabel: '参加者', everyone: '所有人', ageRange: '年龄范围（岁）', ageMin: '最小', ageMax: '最大',
    level: '级别', levelPh: '如 1(仅数字)', gymFee: '场馆费', organizerFee: '主办方报名费', total: '合计支付',
    addTier: '添加价格行', fallbackGym: '范围外 — 场馆费', fallbackOrganizer: '范围外 — 主办方报名费',
    fallbackHint: '不符合任何档位的孩子的价格 — 两个字段需同时填写（可为 0），或都留空 = 范围外须联系管理员',
  },
  ja: {
    section: '受付 & 料金', priceSection: '参加費（料金）', regSection: '受付期間',
    priceOffHint: 'このイベントは参加費なし — スイッチをオンで料金設定（受付を開かなくても集金可）',
    regOffHint: '受付期間は未設定 — 管理者による手動追加は可能です',
    twoLegHint: 'ジム手数料 = ジムの収入（消費税の課税基礎）· 主催者参加費 = 代理徴収して送金（収入ではない）', disabledHint: '受付/料金は未設定 — スイッチをオンにして設定（従来のイベントはそのまま使えます）',
    regOpen: '受付開始日', regClose: '受付締切日', regCloseHint: '締切日は支払期限を兼ねます（イベント当日以前）',
    selfRegister: '保護者による申込みを許可', selfRegisterHint: '保存のみ — 保護者フェーズ開始後に有効',
    programRestricted: '同プログラム受講者のみ',
    priceMode: '料金モード', mode_flat: '一律料金', mode_age: '年齢別（当日時点）', mode_level: 'レベル別',
    flatLabel: '参加者', everyone: '全員', ageRange: '年齢範囲（歳）', ageMin: '最小', ageMax: '最大',
    level: 'レベル', levelPh: '例: 1(数字のみ)', gymFee: 'ジム手数料', organizerFee: '主催者参加費', total: '支払合計',
    addTier: '料金行を追加', fallbackGym: '範囲外 — ジム手数料', fallbackOrganizer: '範囲外 — 主催者参加費',
    fallbackHint: 'どの区分にも該当しない子の料金 — 2 つの欄をセットで入力（0 可）、両方空欄 = 範囲外は管理者に連絡',
  },
  ko: {
    section: '접수 & 가격', priceSection: '참가비 (가격)', regSection: '접수 기간',
    priceOffHint: '이 이벤트는 참가비 없음 — 스위치를 켜서 가격 설정 (접수를 열지 않아도 수금 가능)',
    regOffHint: '접수 기간 미설정 — 관리자가 직접 명단 추가 가능',
    twoLegHint: '체육관 수수료 = 체육관 수익 (VAT 과세 기준) · 주최측 참가비 = 대리 수금 후 송금 (수익 아님)', disabledHint: '접수/가격 미설정 — 스위치를 켜서 설정하세요 (기존 이벤트는 그대로 사용 가능)',
    regOpen: '접수 시작일', regClose: '접수 마감일', regCloseHint: '마감일은 결제 기한을 겸합니다 (행사일 이전이어야 함)',
    selfRegister: '보호자 직접 신청 허용', selfRegisterHint: '지금은 저장만 — 보호자 단계 오픈 시 적용',
    programRestricted: '동일 프로그램 수강생만',
    priceMode: '가격 모드', mode_flat: '단일 가격', mode_age: '나이별 (행사일 기준)', mode_level: '레벨별',
    flatLabel: '참가자', everyone: '전원', ageRange: '나이 범위 (세)', ageMin: '최소', ageMax: '최대',
    level: '레벨', levelPh: '예: 1 (숫자만)', gymFee: '체육관 수수료', organizerFee: '주최측 참가비', total: '총 결제액',
    addTier: '가격 행 추가', fallbackGym: '범위 외 — 체육관 수수료', fallbackOrganizer: '범위 외 — 주최측 참가비',
    fallbackHint: '어느 구간에도 해당하지 않는 아이의 가격 — 두 칸을 함께 입력 (0 가능), 둘 다 비우면 = 범위 외는 관리자에게 문의',
  },
}
for (const loc of Object.keys(evCfgMessages)) {
  messages[loc].evCfg = Object.assign({}, messages[loc].evCfg, evCfgMessages[loc])
}

// event v2 phase 3 — admin money layer on the roster (EventManager.vue)
const evRegMessages = {
  th: {
    paid: 'จ่ายแล้ว', unpaid: 'ค้างชำระ', overridden: 'ราคากำหนดเอง', gymPart: 'ยิม', orgPart: 'ผู้จัด', lvShort: 'เลเวล', remitLocked: 'นำส่งเงินผู้จัดแล้ว — แก้ไข/ยกเลิกไม่ได้', resetNote: 'ราคาจะถูกคำนวณใหม่ตามเลเวลปัจจุบันของเด็ก — ยอดอาจเปลี่ยนจากที่ชำระไว้', entryLevel: 'เลเวลที่ส่งแข่ง', entryLevelNote: 'ราคาจะถูกคำนวณใหม่ตามเลเวลนี้ — ยอดอาจเปลี่ยนจากที่ชำระไว้', nowLevel: 'ปัจจุบัน {n}',
    addWithMoney: 'เพิ่มชื่อ + เก็บเงิน', addTitle: 'เพิ่มชื่อพร้อมชั้นเงิน', editTitle: 'แก้ไขการชำระของใบสมัคร',
    autoPriceHint: 'ระบบคำนวณราคาอัตโนมัติตามเกณฑ์ของอีเวนต์ — เด็กนอกเกณฑ์จะให้กำหนดราคาเอง',
    overrideToggle: 'กำหนดราคาเอง (override)', markPaid: 'ชำระเงินแล้ว', paydate: 'วันที่ชำระ',
    editMoney: 'แก้การชำระ', attachSlip: 'แนบสลิป', slipSaved: 'บันทึกสลิปเรียบร้อย',
    cancelTitle: 'ยกเลิกใบสมัครอีเวนต์', refundToggle: 'คืนเงิน (บันทึกยอดและวันที่)',
    refundAmount: 'ยอดเงินคืน', refundDate: 'วันที่คืน',
    cancelPaidMsg: 'ใบของ {name} ชำระแล้ว {amount} — เลือกว่าจะคืนเงินหรือไม่ก่อนยืนยัน (โอนคืนจริงทำนอกระบบ ระบบเก็บบันทึก)',
    cancelUnpaidMsg: 'ยกเลิกใบสมัครของ {name}? (ใบยังไม่ชำระ ที่นั่งจะถูกคืน)',
  },
  en: {
    paid: 'Paid', unpaid: 'Unpaid', overridden: 'Price overridden', gymPart: 'Gym', orgPart: 'Organizer', lvShort: 'Level', remitLocked: 'Already remitted to the organizer — locked', resetNote: 'The price will be recalculated from the current level of the child — it may differ from what was paid', entryLevel: 'Level entered', entryLevelNote: 'The price will be recalculated from this level — it may differ from what was paid', nowLevel: 'now {n}',
    addWithMoney: 'Add + collect', addTitle: 'Add sign-up with payment', editTitle: 'Edit sign-up payment',
    autoPriceHint: 'Price is computed from the event pricing rules — out-of-range kids can be priced manually',
    overrideToggle: 'Set price manually (override)', markPaid: 'Paid', paydate: 'Payment date',
    editMoney: 'Edit payment', attachSlip: 'Attach slip', slipSaved: 'Slip saved',
    cancelTitle: 'Cancel event sign-up', refundToggle: 'Refund (record amount and date)',
    refundAmount: 'Refund amount', refundDate: 'Refund date',
    cancelPaidMsg: "{name}'s sign-up is paid ({amount}) — choose whether to refund before confirming (the actual transfer happens outside; the system keeps the record)",
    cancelUnpaidMsg: "Cancel {name}'s sign-up? (unpaid — the seat is released)",
  },
  zh: {
    paid: '已付款', unpaid: '未付款', overridden: '手动定价', gymPart: '场馆', orgPart: '主办方', lvShort: '级别', remitLocked: '已向主办方转款 — 无法修改', resetNote: '价格将按孩子当前级别重新计算 — 可能与已付金额不同', entryLevel: '参赛级别', entryLevelNote: '价格将按此级别重新计算 — 可能与已付金额不同', nowLevel: '当前 {n}',
    addWithMoney: '添加并收款', addTitle: '添加报名并收款', editTitle: '编辑报名付款',
    autoPriceHint: '价格按赛事规则自动计算 — 不符合条件的孩子可手动定价',
    overrideToggle: '手动定价 (override)', markPaid: '已付款', paydate: '付款日期',
    editMoney: '编辑付款', attachSlip: '附上转账凭证', slipSaved: '凭证已保存',
    cancelTitle: '取消赛事报名', refundToggle: '退款（记录金额和日期）',
    refundAmount: '退款金额', refundDate: '退款日期',
    cancelPaidMsg: '{name} 的报名已付款（{amount}）— 确认前请选择是否退款（实际转账在系统外进行，系统仅记录）',
    cancelUnpaidMsg: '取消 {name} 的报名？（未付款 — 名额将被释放）',
  },
  ja: {
    paid: '支払済み', unpaid: '未払い', overridden: '手動価格', gymPart: 'ジム', orgPart: '主催者', lvShort: 'レベル', remitLocked: '主催者へ送金済み — 変更できません', resetNote: '価格は現在のレベルで再計算されます — 支払済みの金額と異なる場合があります', entryLevel: 'エントリーレベル', entryLevelNote: '価格はこのレベルで再計算されます — 支払済みの金額と異なる場合があります', nowLevel: '現在 {n}',
    addWithMoney: '追加＋集金', addTitle: '申込みを追加（支払い付き）', editTitle: '申込みの支払いを編集',
    autoPriceHint: '価格はイベントの規則から自動計算 — 対象外の子は手動で設定できます',
    overrideToggle: '価格を手動設定 (override)', markPaid: '支払済み', paydate: '支払日',
    editMoney: '支払いを編集', attachSlip: '振込明細を添付', slipSaved: '明細を保存しました',
    cancelTitle: 'イベント申込みをキャンセル', refundToggle: '返金（金額と日付を記録）',
    refundAmount: '返金額', refundDate: '返金日',
    cancelPaidMsg: '{name} の申込みは支払済み（{amount}）— 確認前に返金の有無を選択してください（実際の振込はシステム外、記録のみ）',
    cancelUnpaidMsg: '{name} の申込みをキャンセルしますか？（未払い — 枠は解放されます）',
  },
  ko: {
    paid: '결제됨', unpaid: '미결제', overridden: '수동 가격', gymPart: '체육관', orgPart: '주최측', lvShort: '레벨', remitLocked: '주최측에 송금 완료 — 수정 불가', resetNote: '가격이 현재 레벨 기준으로 다시 계산됩니다 — 결제한 금액과 다를 수 있습니다', entryLevel: '출전 레벨', entryLevelNote: '가격이 이 레벨 기준으로 다시 계산됩니다 — 결제한 금액과 다를 수 있습니다', nowLevel: '현재 {n}',
    addWithMoney: '추가 + 수금', addTitle: '신청 추가 (결제 포함)', editTitle: '신청 결제 수정',
    autoPriceHint: '가격은 이벤트 규칙에 따라 자동 계산 — 범위 외 아이는 수동으로 지정 가능',
    overrideToggle: '가격 수동 지정 (override)', markPaid: '결제 완료', paydate: '결제일',
    editMoney: '결제 수정', attachSlip: '이체증 첨부', slipSaved: '이체증 저장됨',
    cancelTitle: '이벤트 신청 취소', refundToggle: '환불 (금액과 날짜 기록)',
    refundAmount: '환불 금액', refundDate: '환불 날짜',
    cancelPaidMsg: '{name}의 신청은 결제 완료({amount}) — 확인 전 환불 여부를 선택하세요 (실제 이체는 시스템 밖, 기록만 저장)',
    cancelUnpaidMsg: '{name}의 신청을 취소할까요? (미결제 — 좌석이 해제됩니다)',
  },
}
for (const loc of Object.keys(evRegMessages)) {
  messages[loc].evReg = Object.assign({}, messages[loc].evReg, evRegMessages[loc])
}

// event v3 split — หน้าอีเวนต์รุ่นแยกตาราง (EventManager.vue) · CJK แปลด้วย AI ควรให้เจ้าของภาษาตรวจ
const evV3Messages = {
  th: {
    legacyBadge: 'รุ่นเก่า', dayCount: '{n} วัน', legacyHint: 'อีเวนต์รุ่นเก่า (ยังอยู่บนรางเดิม) — ดูรายชื่อ/เช็คชื่อได้ แต่แก้ไขไม่ได้',
    legacyRosterHint: 'อีเวนต์รุ่นเก่า — รายชื่อยังอยู่บนรางการจองคลาสกลุ่มเดิม เช็คชื่อ/เอาชื่อออกได้ตามปกติ',
    hasPrice: 'มีค่าสมัคร', regOpen: 'เปิดรับสมัคร',
    allPrograms: 'ทุกโปรแกรม (อีเวนต์รวม)', program: 'โปรแกรม',
    programHint: 'เว้นว่าง = อีเวนต์รวม เด็กคอร์สไหนก็เข้าร่วมได้ · เลือกโปรแกรม = ใช้แสดงบนตารางของโปรแกรมนั้น',
    programBlocked: 'คนละโปรแกรม', maxperson: 'จำนวนรับสูงสุด',
    starttime: 'เวลา (ไม่บังคับ)', starttimePh: 'เช่น 09:00-16:00', note: 'หมายเหตุ',
    filterYear: 'ปี', filterProgram: 'โปรแกรม', unpaidCol: 'ค้างชำระ', amountCol: 'ยอดรวม',
    editEvent: 'แก้ไขอีเวนต์', addParticipants: 'เพิ่มผู้เข้าร่วม',
    previewBtn: 'ตรวจสอบรายชื่อ', saveParticipants: 'บันทึก {n} คน',
    modeFree: 'ลงชื่อ ไม่หักโควต้า', priceNeedOverride: 'ต้องกำหนดราคาเอง',
    deducted: 'หักโควต้าแล้ว', deductHint: 'ใช้ครั้งเรียนของคอร์สเด็ก 1 ครั้ง',
    cancelUnpaidMsg: 'ยกเลิกใบสมัครของ {name}? {quota}', willRefundQuota: '(ระบบจะคืนครั้งเรียนให้ 1 ครั้ง)',
  },
  en: {
    legacyBadge: 'Legacy', dayCount: '{n} days', legacyHint: 'Legacy event (still on the old rails) — roster and check-in work, editing does not',
    legacyRosterHint: 'Legacy event — this roster still lives on the group-booking rails; check-in and removal work as before',
    hasPrice: 'Has fee', regOpen: 'Registration open',
    allPrograms: 'All programs (open event)', program: 'Program',
    programHint: 'Leave empty = open event, any course holder can join · Pick a program = shows on that program’s timetable',
    programBlocked: 'Different program', maxperson: 'Capacity',
    starttime: 'Time (optional)', starttimePh: 'e.g. 09:00-16:00', note: 'Note',
    filterYear: 'Year', filterProgram: 'Program', unpaidCol: 'Unpaid', amountCol: 'Total',
    editEvent: 'Edit event', addParticipants: 'Add participants',
    previewBtn: 'Review list', saveParticipants: 'Save {n}',
    modeFree: 'Sign up, no quota deduction', priceNeedOverride: 'Needs manual price',
    deducted: 'Quota used', deductHint: 'Uses one session from the kid’s course',
    cancelUnpaidMsg: 'Cancel {name}’s sign-up? {quota}', willRefundQuota: '(the session will be returned)',
  },
  zh: {
    legacyBadge: '旧版', dayCount: '{n} 天', legacyHint: '旧版赛事（仍在原有结构上）— 可查看名单和签到，但无法编辑',
    legacyRosterHint: '旧版赛事 — 名单仍在团课预约结构上，签到与移除照常可用',
    hasPrice: '有报名费', regOpen: '开放报名',
    allPrograms: '所有项目（综合赛事）', program: '项目',
    programHint: '留空 = 综合赛事，任何课程的孩子都可参加 · 选择项目 = 在该项目课表上显示',
    programBlocked: '项目不符', maxperson: '人数上限',
    starttime: '时间（选填）', starttimePh: '如 09:00-16:00', note: '备注',
    filterYear: '年份', filterProgram: '项目', unpaidCol: '未付款', amountCol: '合计',
    editEvent: '编辑赛事', addParticipants: '添加参加者',
    previewBtn: '检查名单', saveParticipants: '保存 {n} 人',
    modeFree: '仅报名，不扣课时', priceNeedOverride: '需手动定价',
    deducted: '已扣课时', deductHint: '使用孩子课程的 1 次课时',
    cancelUnpaidMsg: '取消 {name} 的报名？{quota}', willRefundQuota: '（系统会退回 1 次课时）',
  },
  ja: {
    legacyBadge: '旧版', dayCount: '{n} 日間', legacyHint: '旧版イベント（従来の仕組みのまま）— 名簿・チェックインは可能、編集は不可',
    legacyRosterHint: '旧版イベント — 名簿はグループ予約の仕組みのままです。チェックイン・削除は従来どおり',
    hasPrice: '参加費あり', regOpen: '受付中',
    allPrograms: '全プログラム（合同イベント）', program: 'プログラム',
    programHint: '空欄 = 合同イベント。どのコースの子でも参加可 · プログラム選択 = その時間割に表示',
    programBlocked: 'プログラム不一致', maxperson: '定員',
    starttime: '時間（任意）', starttimePh: '例: 09:00-16:00', note: '備考',
    filterYear: '年', filterProgram: 'プログラム', unpaidCol: '未払い', amountCol: '合計',
    editEvent: 'イベントを編集', addParticipants: '参加者を追加',
    previewBtn: '名簿を確認', saveParticipants: '{n} 名を保存',
    modeFree: '登録のみ（回数を消費しない）', priceNeedOverride: '手動価格が必要',
    deducted: '回数消費済み', deductHint: '子どものコースから 1 回分を消費',
    cancelUnpaidMsg: '{name} の申込みをキャンセルしますか？{quota}', willRefundQuota: '（1 回分は返却されます）',
  },
  ko: {
    legacyBadge: '구버전', dayCount: '{n}일', legacyHint: '구버전 이벤트 (기존 구조 유지) — 명단/체크인은 가능하지만 수정은 불가',
    legacyRosterHint: '구버전 이벤트 — 명단이 그룹 예약 구조에 남아 있습니다. 체크인과 삭제는 그대로 가능',
    hasPrice: '참가비 있음', regOpen: '접수 중',
    allPrograms: '전체 프로그램 (통합 이벤트)', program: '프로그램',
    programHint: '비워두면 = 통합 이벤트, 어떤 수업의 아이도 참가 가능 · 프로그램 선택 = 해당 시간표에 표시',
    programBlocked: '프로그램 불일치', maxperson: '정원',
    starttime: '시간 (선택)', starttimePh: '예: 09:00-16:00', note: '비고',
    filterYear: '연도', filterProgram: '프로그램', unpaidCol: '미결제', amountCol: '합계',
    editEvent: '이벤트 수정', addParticipants: '참가자 추가',
    previewBtn: '명단 확인', saveParticipants: '{n}명 저장',
    modeFree: '등록만, 횟수 차감 없음', priceNeedOverride: '수동 가격 필요',
    deducted: '횟수 차감됨', deductHint: '아이의 수업에서 1회 차감',
    cancelUnpaidMsg: '{name}의 신청을 취소할까요? {quota}', willRefundQuota: '(1회가 반환됩니다)',
  },
}
for (const loc of Object.keys(evV3Messages)) {
  messages[loc].evV3 = Object.assign({}, messages[loc].evV3, evV3Messages[loc])
}

// event v3 — การ์ดอีเวนต์ในหน้ารายงานการเงิน (FinanceReport.vue) · CJK แปลด้วย AI
const evFinanceMessages = {
  th: {
    eventRevenueTile: 'รายได้จากอีเวนต์ (ส่วนของยิม)',
    eventSalesCount: 'ใบสมัคร {count} ใบ', eventCollected: 'เก็บเงินแล้ว {amount} ฿',
    eventUnpaidInSales: 'ยังไม่จ่าย {count} ใบ ({amount} ฿)',
    eventRefunds: 'คืนเงินในช่วงนี้ {count} ใบ ({amount} ฿)',
    eventGymOnlyNote: 'นับเฉพาะค่าธรรมเนียมยิม — ค่าสมัครของผู้จัดภายนอกแยกเป็นเจ้าหนี้อื่น',
    eventReceivableTile: 'ค้างรับค่าอีเวนต์',
    eventReceivableCount: 'ใบสมัครค้างชำระ {count} ใบ (กินที่นั่งอยู่)',
    eventReceivableSplit: 'ในนั้นเป็นของยิม {gym} ฿ · ของผู้จัด {organizer} ฿',
    organizerTile: 'ค้างนำส่งผู้จัดภายนอก',
    organizerCollected: 'เก็บแล้ว {amount} ฿', organizerRemitted: 'นำส่งแล้ว {amount} ฿',
    organizerNotRevenue: 'เงินก้อนนี้เป็นเจ้าหนี้อื่น ไม่ใช่รายได้ของยิม และไม่มี VAT',
  },
  en: {
    eventRevenueTile: 'Event revenue (gym share)',
    eventSalesCount: '{count} sign-up(s)', eventCollected: 'collected {amount} THB',
    eventUnpaidInSales: 'unpaid: {count} ({amount} THB)',
    eventRefunds: 'refunded this period: {count} ({amount} THB)',
    eventGymOnlyNote: 'Gym fee only — the external organizer share is a liability, not revenue',
    eventReceivableTile: 'Event receivables',
    eventReceivableCount: '{count} unpaid sign-up(s) (holding seats)',
    eventReceivableSplit: 'of which gym {gym} THB · organizer {organizer} THB',
    organizerTile: 'Owed to external organizer',
    organizerCollected: 'collected {amount} THB', organizerRemitted: 'remitted {amount} THB',
    organizerNotRevenue: 'This is a liability, not gym revenue, and carries no VAT',
  },
  zh: {
    eventRevenueTile: '赛事收入（场馆部分）',
    eventSalesCount: '报名 {count} 份', eventCollected: '已收 {amount} 泰铢',
    eventUnpaidInSales: '未付款 {count} 份（{amount} 泰铢）',
    eventRefunds: '本期退款 {count} 份（{amount} 泰铢）',
    eventGymOnlyNote: '仅计场馆费 — 外部主办方部分列为负债，非收入',
    eventReceivableTile: '赛事应收款',
    eventReceivableCount: '未付款报名 {count} 份（占用名额）',
    eventReceivableSplit: '其中场馆 {gym} 泰铢 · 主办方 {organizer} 泰铢',
    organizerTile: '待上缴主办方',
    organizerCollected: '已收 {amount} 泰铢', organizerRemitted: '已上缴 {amount} 泰铢',
    organizerNotRevenue: '此款项为负债，非场馆收入，且不计 VAT',
  },
  ja: {
    eventRevenueTile: 'イベント収入（ジム分）',
    eventSalesCount: '申込み {count} 件', eventCollected: '回収済み {amount} バーツ',
    eventUnpaidInSales: '未払い {count} 件（{amount} バーツ）',
    eventRefunds: '当期の返金 {count} 件（{amount} バーツ）',
    eventGymOnlyNote: 'ジム手数料のみ計上 — 外部主催者分は負債であり収入ではありません',
    eventReceivableTile: 'イベント未収金',
    eventReceivableCount: '未払いの申込み {count} 件（枠を占有中）',
    eventReceivableSplit: 'うちジム {gym} バーツ · 主催者 {organizer} バーツ',
    organizerTile: '主催者への未送金',
    organizerCollected: '回収済み {amount} バーツ', organizerRemitted: '送金済み {amount} バーツ',
    organizerNotRevenue: 'この資金は負債であり、ジムの収入ではなく消費税も対象外です',
  },
  ko: {
    eventRevenueTile: '이벤트 수익 (체육관 몫)',
    eventSalesCount: '신청 {count}건', eventCollected: '수금 {amount} 바트',
    eventUnpaidInSales: '미결제 {count}건 ({amount} 바트)',
    eventRefunds: '이 기간 환불 {count}건 ({amount} 바트)',
    eventGymOnlyNote: '체육관 수수료만 집계 — 외부 주최측 몫은 부채이며 수익이 아님',
    eventReceivableTile: '이벤트 미수금',
    eventReceivableCount: '미결제 신청 {count}건 (좌석 점유 중)',
    eventReceivableSplit: '이 중 체육관 {gym} 바트 · 주최측 {organizer} 바트',
    organizerTile: '주최측 미송금액',
    organizerCollected: '수금 {amount} 바트', organizerRemitted: '송금 {amount} 바트',
    organizerNotRevenue: '이 금액은 부채이며 체육관 수익이 아니고 VAT 대상도 아닙니다',
  },
}
for (const loc of Object.keys(evFinanceMessages)) {
  messages[loc].finance = Object.assign({}, messages[loc].finance, evFinanceMessages[loc])
}

// event v3 เฟส 4 — อีเวนต์ฝั่งผู้ปกครอง (EventSignup.vue ในหน้าแรก) · CJK แปลด้วย AI ควรให้เจ้าของภาษาตรวจ
const evSignupMessages = {
  th: {
    openTitle: 'อีเวนต์ที่เปิดรับสมัคร', mineTitle: 'การสมัครของฉัน',
    seatsLeft: 'เหลือ {n} ที่', full: 'เต็มแล้ว', fullHint: 'ที่นั่งเต็มแล้ว กรุณาติดต่อแอดมิน',
    payBy: 'ชำระภายใน {date}', perPerson: '{amount} ฿ / คน', free: 'ไม่มีค่าสมัคร',
    priceAskAdmin: 'ค่าสมัคร — กรุณาติดต่อแอดมิน',
    signupBtn: 'สมัครเข้าร่วม', dialogTitle: 'สมัครอีเวนต์',
    pickChildren: 'เลือกลูกที่จะสมัคร', payment: 'การชำระเงิน', total: 'ยอดรวมที่ต้องชำระ',
    transferOnly: 'รับชำระด้วยการโอนเท่านั้น — แนบสลิปตอนนี้ หรือชำระทีหลังก็ได้',
    slipOptional: 'สลิปการโอน (ไม่บังคับ)', pickSlipFile: 'เลือกรูปสลิป',
    slipLaterHint: 'ยังไม่แนบก็สมัครได้ ที่นั่งจะถูกจองไว้ให้ แล้วแนบสลิปได้ถึงวันปิดรับสมัคร',
    confirmSignup: 'ยืนยันการสมัคร',
    alreadyRegistered: 'สมัครไว้แล้ว', alreadyPaid: 'สมัครและชำระแล้ว',
    programBlocked: 'อีเวนต์นี้จำกัดเฉพาะเด็กที่เรียนโปรแกรมเดียวกัน',
    needAdmin: 'คิดค่าสมัครอัตโนมัติไม่ได้ — กรุณาติดต่อแอดมิน',
    allRegistered: 'ลูกทุกคนสมัครอีเวนต์นี้แล้ว',
    noEligibleChild: 'ยังไม่มีลูกที่สมัครอีเวนต์นี้ได้ — กรุณาติดต่อแอดมิน',
    notEnoughSeats: 'ที่นั่งเหลือ {n} ที่ กรุณาเลือกใหม่',
    paid: 'ชำระแล้ว', unpaid: 'ค้างชำระ', checkedin: 'เข้าร่วมแล้ว',
    uploadSlip: 'แนบสลิป', uploadSlipTitle: 'แนบสลิปการโอน', sendSlip: 'ส่งสลิป',
    slip: 'สลิปการโอน', totalDue: 'ยอดค้างชำระ',
    coversAll: 'สลิปใบนี้ครอบทุกใบที่ค้างของอีเวนต์นี้: {names}',
    cancelTitle: 'ยกเลิกการสมัคร',
    cancelConfirm: 'ยกเลิกการสมัครของ {name} ในอีเวนต์ "{event}" ใช่ไหม',
    cancelBtn: 'ยกเลิกการสมัคร',
  },
  en: {
    openTitle: 'Events open for sign-up', mineTitle: 'My sign-ups',
    seatsLeft: '{n} seats left', full: 'Full', fullHint: 'No seats left — please contact an admin',
    payBy: 'Pay by {date}', perPerson: '{amount} B / person', free: 'No fee',
    priceAskAdmin: 'Fee — please contact an admin',
    signupBtn: 'Sign up', dialogTitle: 'Event sign-up',
    pickChildren: 'Choose who is joining', payment: 'Payment', total: 'Total due',
    transferOnly: 'Bank transfer only — attach the slip now or pay later',
    slipOptional: 'Transfer slip (optional)', pickSlipFile: 'Choose slip image',
    slipLaterHint: 'You can sign up without a slip; the seat is held and you may attach it until the closing date',
    confirmSignup: 'Confirm sign-up',
    alreadyRegistered: 'Already signed up', alreadyPaid: 'Signed up and paid',
    programBlocked: 'This event is limited to children in the same program',
    needAdmin: 'The fee cannot be calculated automatically — please contact an admin',
    allRegistered: 'All your children are already signed up',
    noEligibleChild: 'None of your children can sign up for this event — please contact an admin',
    notEnoughSeats: 'Only {n} seats left — please choose again',
    paid: 'Paid', unpaid: 'Unpaid', checkedin: 'Attended',
    uploadSlip: 'Attach slip', uploadSlipTitle: 'Attach transfer slip', sendSlip: 'Send slip',
    slip: 'Transfer slip', totalDue: 'Outstanding',
    coversAll: 'This slip covers every unpaid sign-up for this event: {names}',
    cancelTitle: 'Cancel sign-up',
    cancelConfirm: 'Cancel the sign-up of {name} for "{event}"?',
    cancelBtn: 'Cancel sign-up',
  },
  zh: {
    openTitle: '开放报名的赛事', mineTitle: '我的报名',
    seatsLeft: '剩余 {n} 个名额', full: '已满', fullHint: '名额已满，请联系管理员',
    payBy: '请在 {date} 前付款', perPerson: '{amount} ฿ / 人', free: '免费',
    priceAskAdmin: '报名费 — 请联系管理员',
    signupBtn: '报名参加', dialogTitle: '赛事报名',
    pickChildren: '选择要报名的孩子', payment: '付款', total: '应付合计',
    transferOnly: '仅支持转账 — 可现在上传凭证，也可稍后付款',
    slipOptional: '转账凭证（选填）', pickSlipFile: '选择凭证图片',
    slipLaterHint: '未上传凭证也可报名，名额会保留，可在截止日前上传',
    confirmSignup: '确认报名',
    alreadyRegistered: '已报名', alreadyPaid: '已报名并付款',
    programBlocked: '本赛事仅限同一项目的孩子参加',
    needAdmin: '无法自动计算报名费 — 请联系管理员',
    allRegistered: '所有孩子都已报名',
    noEligibleChild: '暂无可报名的孩子 — 请联系管理员',
    notEnoughSeats: '仅剩 {n} 个名额，请重新选择',
    paid: '已付款', unpaid: '未付款', checkedin: '已参加',
    uploadSlip: '上传凭证', uploadSlipTitle: '上传转账凭证', sendSlip: '发送凭证',
    slip: '转账凭证', totalDue: '未付金额',
    coversAll: '此凭证涵盖本赛事所有未付款报名：{names}',
    cancelTitle: '取消报名',
    cancelConfirm: '确定取消 {name} 参加 "{event}" 的报名吗？',
    cancelBtn: '取消报名',
  },
  ja: {
    openTitle: '受付中のイベント', mineTitle: '申込み状況',
    seatsLeft: '残り {n} 名', full: '満員', fullHint: '満員です。管理者にご連絡ください',
    payBy: '{date} までにお支払いください', perPerson: '{amount} ฿ / 名', free: '無料',
    priceAskAdmin: '参加費 — 管理者にご連絡ください',
    signupBtn: '申し込む', dialogTitle: 'イベント申込み',
    pickChildren: '参加するお子さまを選択', payment: 'お支払い', total: 'お支払い合計',
    transferOnly: '振込のみ — 今すぐ明細を添付、または後払いも可能です',
    slipOptional: '振込明細（任意）', pickSlipFile: '明細の画像を選択',
    slipLaterHint: '明細なしでも申込みできます。席は確保され、受付終了日までに添付できます',
    confirmSignup: '申込みを確定',
    alreadyRegistered: '申込み済み', alreadyPaid: '申込み・支払い済み',
    programBlocked: 'このイベントは同じプログラムのお子さま限定です',
    needAdmin: '参加費を自動計算できません — 管理者にご連絡ください',
    allRegistered: 'お子さま全員が申込み済みです',
    noEligibleChild: '申込みできるお子さまがいません — 管理者にご連絡ください',
    notEnoughSeats: '残り {n} 名です。選び直してください',
    paid: '支払い済み', unpaid: '未払い', checkedin: '参加済み',
    uploadSlip: '明細を添付', uploadSlipTitle: '振込明細を添付', sendSlip: '明細を送信',
    slip: '振込明細', totalDue: '未払い額',
    coversAll: 'この明細はこのイベントの未払い申込みすべてに適用されます：{names}',
    cancelTitle: '申込みのキャンセル',
    cancelConfirm: '{name} の "{event}" への申込みをキャンセルしますか？',
    cancelBtn: '申込みをキャンセル',
  },
  ko: {
    openTitle: '접수 중인 이벤트', mineTitle: '나의 신청',
    seatsLeft: '{n}자리 남음', full: '마감', fullHint: '자리가 모두 찼습니다. 관리자에게 문의해 주세요',
    payBy: '{date}까지 결제', perPerson: '{amount} ฿ / 1인', free: '무료',
    priceAskAdmin: '참가비 — 관리자에게 문의해 주세요',
    signupBtn: '신청하기', dialogTitle: '이벤트 신청',
    pickChildren: '참가할 자녀 선택', payment: '결제', total: '결제 합계',
    transferOnly: '계좌 이체만 가능 — 지금 입금 확인증을 첨부하거나 나중에 결제할 수 있습니다',
    slipOptional: '입금 확인증 (선택)', pickSlipFile: '확인증 이미지 선택',
    slipLaterHint: '확인증 없이도 신청할 수 있습니다. 자리는 유지되며 접수 마감일까지 첨부하면 됩니다',
    confirmSignup: '신청 확정',
    alreadyRegistered: '이미 신청함', alreadyPaid: '신청 및 결제 완료',
    programBlocked: '이 이벤트는 같은 프로그램 자녀만 참가할 수 있습니다',
    needAdmin: '참가비를 자동으로 계산할 수 없습니다 — 관리자에게 문의해 주세요',
    allRegistered: '자녀 모두 이미 신청했습니다',
    noEligibleChild: '신청 가능한 자녀가 없습니다 — 관리자에게 문의해 주세요',
    notEnoughSeats: '{n}자리만 남았습니다. 다시 선택해 주세요',
    paid: '결제 완료', unpaid: '미결제', checkedin: '참가 완료',
    uploadSlip: '확인증 첨부', uploadSlipTitle: '입금 확인증 첨부', sendSlip: '확인증 보내기',
    slip: '입금 확인증', totalDue: '미결제 금액',
    coversAll: '이 확인증은 이 이벤트의 모든 미결제 신청에 적용됩니다: {names}',
    cancelTitle: '신청 취소',
    cancelConfirm: '{name}의 "{event}" 신청을 취소할까요?',
    cancelBtn: '신청 취소',
  },
}
for (const loc of Object.keys(evSignupMessages)) {
  messages[loc].evSignup = Object.assign({}, messages[loc].evSignup, evSignupMessages[loc])
}

// event v3 เฟส 5 — เลื่อนวัน / ยกเลิกทั้งงาน / คิวบันทึกการคืนเงิน · CJK แปลด้วย AI ควรให้เจ้าของภาษาตรวจ
const evV5Messages = {
  th: {
    cancelWhole: 'ยกเลิกทั้งงาน',
    cancelWholeTitle: 'ยกเลิกอีเวนต์ทั้งงาน',
    cancelWholeWarn: 'ใบสมัครทุกใบจะถูกยกเลิกพร้อมกัน และย้อนกลับไม่ได้',
    cancelWholeConfirm: 'ยืนยันยกเลิกทั้งงาน',
    cancelWholeNote: 'ระบบจะคืนครั้งเรียนให้ใบที่หักโควตา · ใบที่ชำระเงินแล้วจะเข้าคิว "รอบันทึกการคืนเงิน" ให้บันทึกทีละใบ · ผู้ปกครองทุกคนได้รับการ์ดแจ้งเตือน',
    sumRegs: 'ใบสมัครที่จะถูกยกเลิก', sumPaid: 'ในนั้นชำระเงินแล้ว', sumQuota: 'ครั้งเรียนที่จะคืนเข้าคอร์ส',
    refundQueueTitle: 'รอบันทึกการคืนเงิน',
    refundQueueTotal: 'รวม {amount} ฿',
    refundQueueHint: 'งานถูกยกเลิกแล้วแต่เงินยังอยู่กับยิม — บันทึกว่าคืนหรือไม่คืนให้ครบทุกใบ (การโอนคืนจริงทำนอกระบบ)',
    recordRefund: 'บันทึกการคืนเงิน',
    recordRefundTitle: 'บันทึกผลการคืนเงิน',
    paidAmount: 'ยอดที่ลูกค้าชำระไว้', paidOn: 'ชำระ {date}',
    refundDecision: 'ผลการตัดสิน',
    refundNo: 'ไม่คืนเงิน', refundYes: 'คืนเงิน',
    refundNoHint: 'บันทึกว่าไม่คืนเงิน — ใบนี้จะหลุดจากคิวและหน้าตรวจสอบประจำวัน',
    refundOutsideHint: 'ระบบเก็บเฉพาะบันทึก การโอนคืนจริงทำนอกระบบ',
  },
  en: {
    cancelWhole: 'Cancel whole event',
    cancelWholeTitle: 'Cancel the entire event',
    cancelWholeWarn: 'Every sign-up will be cancelled at once, and this cannot be undone',
    cancelWholeConfirm: 'Confirm cancelling the event',
    cancelWholeNote: 'Sessions deducted from courses are returned · sign-ups that were paid go into the "awaiting refund decision" queue to be recorded one by one · every parent receives a notification card',
    sumRegs: 'Sign-ups to be cancelled', sumPaid: 'Of those, already paid', sumQuota: 'Sessions returned to courses',
    refundQueueTitle: 'Awaiting a refund decision',
    refundQueueTotal: 'Total {amount} ฿',
    refundQueueHint: 'The event was cancelled but the money is still with the gym — record refunded or not for every row (the transfer itself happens outside the system)',
    recordRefund: 'Record refund',
    recordRefundTitle: 'Record the refund decision',
    paidAmount: 'Amount the customer paid', paidOn: 'paid {date}',
    refundDecision: 'Decision',
    refundNo: 'No refund', refundYes: 'Refund',
    refundNoHint: 'Recorded as no refund — this row leaves the queue and the daily checklist',
    refundOutsideHint: 'The system only keeps the record; the transfer itself happens outside',
  },
  zh: {
    cancelWhole: '取消整场赛事',
    cancelWholeTitle: '取消整场赛事',
    cancelWholeWarn: '所有报名将同时被取消，且无法撤销',
    cancelWholeConfirm: '确认取消整场赛事',
    cancelWholeNote: '已扣的课时会退回课程 · 已付款的报名将进入“待记录退款”队列逐笔记录 · 所有家长都会收到通知卡片',
    sumRegs: '将被取消的报名', sumPaid: '其中已付款', sumQuota: '将退回课程的课时',
    refundQueueTitle: '待记录退款',
    refundQueueTotal: '合计 {amount} ฿',
    refundQueueHint: '赛事已取消但款项仍在馆内 — 请逐笔记录是否退款（实际转账在系统外进行）',
    recordRefund: '记录退款',
    recordRefundTitle: '记录退款结果',
    paidAmount: '客户已付金额', paidOn: '{date} 付款',
    refundDecision: '处理结果',
    refundNo: '不退款', refundYes: '退款',
    refundNoHint: '记录为不退款 — 该笔将从队列和每日检查中移除',
    refundOutsideHint: '系统仅保存记录，实际转账在系统外进行',
  },
  ja: {
    cancelWhole: 'イベントを全体中止',
    cancelWholeTitle: 'イベント全体の中止',
    cancelWholeWarn: 'すべての申込みが一括でキャンセルされ、元に戻せません',
    cancelWholeConfirm: '全体中止を確定',
    cancelWholeNote: '消費した回数はコースに戻ります · 入金済みの申込みは「返金の記録待ち」に入り1件ずつ記録します · 保護者全員に通知カードが届きます',
    sumRegs: 'キャンセルされる申込み', sumPaid: 'うち入金済み', sumQuota: 'コースへ戻る回数',
    refundQueueTitle: '返金の記録待ち',
    refundQueueTotal: '合計 {amount} ฿',
    refundQueueHint: 'イベントは中止しましたが入金はジムに残っています — 1件ずつ返金の有無を記録してください（実際の送金はシステム外）',
    recordRefund: '返金を記録',
    recordRefundTitle: '返金結果の記録',
    paidAmount: 'お客さまの入金額', paidOn: '{date} 入金',
    refundDecision: '判断',
    refundNo: '返金しない', refundYes: '返金する',
    refundNoHint: '返金なしとして記録 — この件は待ち一覧と日次チェックから外れます',
    refundOutsideHint: 'システムは記録のみ保持します。実際の送金はシステム外です',
  },
  ko: {
    cancelWhole: '이벤트 전체 취소',
    cancelWholeTitle: '이벤트 전체 취소',
    cancelWholeWarn: '모든 신청이 한꺼번에 취소되며 되돌릴 수 없습니다',
    cancelWholeConfirm: '전체 취소 확정',
    cancelWholeNote: '차감된 횟수는 수업으로 반환됩니다 · 결제된 신청은 "환불 기록 대기"에 들어가 한 건씩 기록합니다 · 모든 학부모에게 알림 카드가 전송됩니다',
    sumRegs: '취소될 신청', sumPaid: '그중 결제 완료', sumQuota: '수업으로 반환될 횟수',
    refundQueueTitle: '환불 기록 대기',
    refundQueueTotal: '합계 {amount} ฿',
    refundQueueHint: '이벤트는 취소됐지만 금액은 체육관에 있습니다 — 건별로 환불 여부를 기록하세요 (실제 송금은 시스템 외부)',
    recordRefund: '환불 기록',
    recordRefundTitle: '환불 결과 기록',
    paidAmount: '고객이 결제한 금액', paidOn: '{date} 결제',
    refundDecision: '결정',
    refundNo: '환불 안 함', refundYes: '환불',
    refundNoHint: '환불하지 않음으로 기록 — 이 건은 대기 목록과 일일 점검에서 제외됩니다',
    refundOutsideHint: '시스템은 기록만 보관하며 실제 송금은 외부에서 진행합니다',
  },
}
for (const loc of Object.keys(evV5Messages)) {
  messages[loc].evV5 = Object.assign({}, messages[loc].evV5, evV5Messages[loc])
}

// event v3 เฟส 6 — เจตนาการยกเลิกใบสมัคร 3 ทาง + แยกขาผู้จัด (เจ้าของเคาะ 2026-08-12 จาก mockup)
// CJK แปลด้วย AI ควรให้เจ้าของภาษาตรวจ
const evV6Messages = {
  th: {
    cancelPaidMsg: 'ใบของ {name} ชำระแล้ว {amount} — เลือกเหตุผลการยกเลิกก่อน',
    refundFullOnly: 'คืนเต็มยอดที่ชำระเท่านั้น (ไม่มีคืนบางส่วน) — ถ้าตั้งใจไม่คืน เลือก "ไม่คืนเงิน"',
    tabActive: 'ผู้เข้าร่วม ({n})', tabCancelled: 'ประวัติการยกเลิก ({n})',
    kindRefund: 'คืนเงินแล้ว', kindForfeit: 'ไม่คืนเงิน', kindPending: 'รอบันทึกผลเงิน',
    refunded: 'คืน {amount} · {date}',
    cancelledMeta: 'ยกเลิก {date} โดย {by}', recordedBy: 'บันทึกผลเงินโดย {by}',
    kind_mistake: 'กรอกผิด / ลงชื่อผิด — ลบเหมือนไม่เคยมี',
    kindHint_mistake: 'สำหรับ "ลบแล้วลงใหม่" · ไม่ถามเรื่องเงิน ไม่กระทบรายงาน',
    kind_refund: 'ยกเลิกจริง — คืนเงินให้ลูกค้า',
    kindHint_refund: 'กรอกยอดคืน + วันที่คืน (โอนคืนจริงทำนอกระบบ)',
    kind_forfeit: 'ยกเลิกจริง — ไม่คืนเงิน',
    kindHint_forfeit: 'เงินที่รับไว้นับเป็นรายได้ของยิม',
    organizerSection: 'ส่วนของผู้จัดภายนอก ({amount} ฿) จะทำอย่างไร',
    orgRemit: 'ยังต้องนำส่ง / นำส่งผู้จัดไปแล้ว',
    orgRemitHint: 'ผู้จัดยังได้ส่วนของเขา — ยิมเก็บเฉพาะค่ายิม {amount} ฿',
    orgKeep: 'ไม่ต้องนำส่งผู้จัดแล้ว',
    orgKeepHint: 'ยิมเก็บทั้งก้อน {amount} ฿ เป็นรายได้ + ตัดออกจากยอดค้างนำส่ง',
    editPaymentTip: 'แค่ติ๊ก "จ่ายแล้ว" ผิดใบ แต่ชื่อถูก? ไม่ต้องยกเลิก — ใช้ปุ่ม "แก้การชำระ" แก้กลับได้เลย',
    forfeitTile: 'ในยอดด้านบนมีเงินจากใบที่ยกเลิกแบบไม่คืนเงิน',
    forfeitBreakdown: 'ค่ายิม {gym} ฿ · ขาผู้จัดที่เก็บไว้ {org} ฿',
    forfeitCount: '{count} ใบ',
  },
  en: {
    cancelPaidMsg: '{name} paid {amount} — choose the reason for cancelling first',
    refundFullOnly: 'Full refund of the amount paid only (no partial refunds) — choose "No refund" if you intend to keep it',
    tabActive: 'Participants ({n})', tabCancelled: 'Cancellation history ({n})',
    kindRefund: 'Refunded', kindForfeit: 'No refund', kindPending: 'Awaiting money decision',
    refunded: 'Refunded {amount} · {date}',
    cancelledMeta: 'Cancelled {date} by {by}', recordedBy: 'Recorded by {by}',
    kind_mistake: 'Data entry mistake — remove as if it never existed',
    kindHint_mistake: 'For "delete and re-enter" · no money questions, no report impact',
    kind_refund: 'Real cancellation — refund the customer',
    kindHint_refund: 'Enter the refund amount and date (the transfer happens outside the system)',
    kind_forfeit: 'Real cancellation — no refund',
    kindHint_forfeit: 'The money received counts as gym revenue',
    organizerSection: 'What about the external organizer share ({amount} ฿)',
    orgRemit: 'Still owed / already remitted to the organizer',
    orgRemitHint: 'The organizer keeps their share — the gym keeps only its own fee {amount} ฿',
    orgKeep: 'No longer owed to the organizer',
    orgKeepHint: 'The gym keeps the whole {amount} ฿ as revenue and it leaves the remittance balance',
    editPaymentTip: 'Ticked "paid" on the wrong row but the name is right? No need to cancel — use "Edit payment" to undo it',
    forfeitTile: 'Included above: money from cancelled sign-ups (not refunded)',
    forfeitBreakdown: 'Gym fee {gym} ฿ · organizer share kept {org} ฿',
    forfeitCount: '{count} sign-ups',
  },
  zh: {
    cancelPaidMsg: '{name} 已付款 {amount} — 请先选择取消原因',
    refundFullOnly: '仅可全额退还已付金额（不支持部分退款）— 若打算不退，请选择"不退款"',
    tabActive: '参加者 ({n})', tabCancelled: '取消记录 ({n})',
    kindRefund: '已退款', kindForfeit: '不退款', kindPending: '待记录款项处理',
    refunded: '退款 {amount} · {date}',
    cancelledMeta: '{date} 由 {by} 取消', recordedBy: '款项由 {by} 记录',
    kind_mistake: '录入错误 / 报错人 — 视为从未存在',
    kindHint_mistake: '适用于“删除后重新登记” · 不询问款项，不影响报表',
    kind_refund: '真实取消 — 退款给客户',
    kindHint_refund: '填写退款金额与日期（实际转账在系统外进行）',
    kind_forfeit: '真实取消 — 不退款',
    kindHint_forfeit: '已收款项计为馆内收入',
    organizerSection: '外部主办方部分（{amount} ฿）如何处理',
    orgRemit: '仍需上缴 / 已上缴主办方',
    orgRemitHint: '主办方仍得其份额 — 馆内只保留自己的费用 {amount} ฿',
    orgKeep: '无需再上缴主办方',
    orgKeepHint: '馆内保留全部 {amount} ฿ 作为收入，并从待上缴中扣除',
    editPaymentTip: '只是勾错“已付款”但姓名正确？无需取消 — 用“修改付款”即可改回',
    forfeitTile: '上述金额中包含已取消（未退款）报名的款项',
    forfeitBreakdown: '馆内费用 {gym} ฿ · 保留的主办方部分 {org} ฿',
    forfeitCount: '{count} 份',
  },
  ja: {
    cancelPaidMsg: '{name} は {amount} を支払済み — まずキャンセル理由を選択してください',
    refundFullOnly: '支払済み金額の全額返金のみ（一部返金は不可）— 返金しない場合は「返金しない」を選択',
    tabActive: '参加者 ({n})', tabCancelled: 'キャンセル履歴 ({n})',
    kindRefund: '返金済み', kindForfeit: '返金なし', kindPending: '入金処理の記録待ち',
    refunded: '返金 {amount} · {date}',
    cancelledMeta: '{date} に {by} がキャンセル', recordedBy: '入金処理の記録者 {by}',
    kind_mistake: '入力ミス / 登録間違い — 元からなかったものとして削除',
    kindHint_mistake: '「削除して再登録」用 · 入金について質問せず、レポートにも影響しません',
    kind_refund: '本当にキャンセル — お客さまへ返金',
    kindHint_refund: '返金額と返金日を入力（実際の送金はシステム外）',
    kind_forfeit: '本当にキャンセル — 返金しない',
    kindHint_forfeit: '受け取った入金はジムの収益として計上',
    organizerSection: '外部主催者分（{amount} ฿）はどうしますか',
    orgRemit: 'まだ送金が必要 / すでに送金済み',
    orgRemitHint: '主催者は自分の分を受け取ります — ジムは自分の参加費 {amount} ฿ のみ',
    orgKeep: '主催者への送金は不要になった',
    orgKeepHint: 'ジムが全額 {amount} ฿ を収益として保持し、未送金額から外れます',
    editPaymentTip: '「入金済み」を別の件に付けただけで名前は正しい？キャンセル不要 — 「入金を修正」で戻せます',
    forfeitTile: '上記の金額にキャンセル分（返金なし）の入金を含みます',
    forfeitBreakdown: 'ジム参加費 {gym} ฿ · 保持した主催者分 {org} ฿',
    forfeitCount: '{count} 件',
  },
  ko: {
    cancelPaidMsg: '{name}은 {amount}을 결제했습니다 — 먼저 취소 사유를 선택하세요',
    refundFullOnly: '결제 금액 전액 환불만 가능 (부분 환불 없음) — 환불하지 않으려면 "환불 없음" 선택',
    tabActive: '참가자 ({n})', tabCancelled: '취소 이력 ({n})',
    kindRefund: '환불 완료', kindForfeit: '환불 없음', kindPending: '금액 처리 기록 대기',
    refunded: '환불 {amount} · {date}',
    cancelledMeta: '{date} {by} 취소', recordedBy: '금액 처리 기록: {by}',
    kind_mistake: '입력 실수 / 잘못 등록 — 없던 것처럼 삭제',
    kindHint_mistake: '"삭제 후 다시 등록"용 · 금액을 묻지 않고 보고서에도 영향 없음',
    kind_refund: '실제 취소 — 고객에게 환불',
    kindHint_refund: '환불 금액과 날짜 입력 (실제 송금은 시스템 외부)',
    kind_forfeit: '실제 취소 — 환불 없음',
    kindHint_forfeit: '받은 금액은 체육관 수익으로 계상',
    organizerSection: '외부 주최자 몫({amount} ฿)은 어떻게 할까요',
    orgRemit: '아직 송금해야 함 / 이미 송금함',
    orgRemitHint: '주최자는 자기 몫을 받습니다 — 체육관은 자체 참가비 {amount} ฿만 보유',
    orgKeep: '주최자에게 송금할 필요 없음',
    orgKeepHint: '체육관이 전액 {amount} ฿을 수익으로 보유하고 미송금액에서 제외됩니다',
    editPaymentTip: '"결제 완료"를 다른 건에 잘못 체크했지만 이름은 맞나요? 취소하지 않고 "결제 수정"으로 되돌리세요',
    forfeitTile: '위 금액에 취소된 신청(환불 없음) 금액이 포함되어 있습니다',
    forfeitBreakdown: '체육관 참가비 {gym} ฿ · 보유한 주최자 몫 {org} ฿',
    forfeitCount: '{count}건',
  },
}
for (const loc of Object.keys(evV6Messages)) {
  messages[loc].evV6 = Object.assign({}, messages[loc].evV6, evV6Messages[loc])
}

// ประวัติการแก้ไข (EditHistoryTimeline.vue — ไทม์ไลน์จาก taction_log ใน dialog ปุ่มประวัติ 4 จอ)
// field labels ใช้คีย์เดิมของระบบเป็นหลัก (table.* / customerCourse.*) — ที่นี่มีเฉพาะคีย์ที่ไม่เคยมี
// CJK แปลด้วย AI ควรให้เจ้าของภาษาตรวจ
const editHistoryMessages = {
  th: {
    title: 'ประวัติการแก้ไข',
    empty: 'ยังไม่มีประวัติการแก้ไข',
    since: 'มีข้อมูลตั้งแต่ 29 ก.ค. 2569 เป็นต้นไป',
    fieldPaid: 'สถานะชำระเงิน', fieldFinish: 'สถานะคอร์ส', fieldCancelled: 'สถานะใบจอง', fieldNote: 'หมายเหตุ',
    fieldPromotion: 'คอร์สโปรโมชั่น', fieldDoubleBooking: 'จองซ้อนได้', fieldSlip: 'สลิป',
    fieldFirstname: 'ชื่อจริง', fieldMiddlename: 'ชื่อกลาง', fieldLastname: 'นามสกุล', fieldNickname: 'ชื่อเล่น', fieldGender: 'เพศ', fieldDob: 'วันเกิด', fieldSchool: 'โรงเรียน', fieldFamily: 'ครอบครัว', fieldCourseRef2: 'คอร์สถัดไป',
    fieldEmail: 'อีเมล', fieldAddress: 'ที่อยู่', fieldRole: 'สิทธิ์', fieldAccess: 'สถานะบัญชี', valRestricted: 'ถูกจำกัด', roleHead: 'ผู้จัดการ', roleAdmin: 'แอดมิน', roleCoach: 'โค้ช', roleCustomer: 'ลูกค้า',
    valChecked: 'เช็คชื่อแล้ว', valNotChecked: 'ยังไม่เช็คชื่อ',
    valActive: 'ใช้งานอยู่', valFinished: 'จบคอร์ส', valCancelled: 'ยกเลิก',
    valYes: 'ใช่', valNo: 'ไม่ใช่',
  },
  en: {
    title: 'Edit history',
    empty: 'No edit history yet',
    since: 'Records available from 29 Jul 2026 onward',
    fieldPaid: 'Payment status', fieldFinish: 'Course status', fieldCancelled: 'Booking status', fieldNote: 'Note',
    fieldPromotion: 'Promotion course', fieldDoubleBooking: 'Double booking', fieldSlip: 'Slip',
    fieldFirstname: 'First name', fieldMiddlename: 'Middle name', fieldLastname: 'Last name', fieldNickname: 'Nickname', fieldGender: 'Gender', fieldDob: 'Date of birth', fieldSchool: 'School', fieldFamily: 'Family', fieldCourseRef2: 'Next course',
    fieldEmail: 'Email', fieldAddress: 'Address', fieldRole: 'Role', fieldAccess: 'Account status', valRestricted: 'Restricted', roleHead: 'Manager', roleAdmin: 'Admin', roleCoach: 'Coach', roleCustomer: 'Customer',
    valChecked: 'Checked in', valNotChecked: 'Not checked in',
    valActive: 'Active', valFinished: 'Finished', valCancelled: 'Cancelled',
    valYes: 'Yes', valNo: 'No',
  },
  zh: {
    title: '修改历史',
    empty: '暂无修改记录',
    since: '记录自2026年7月29日起可用',
    fieldPaid: '付款状态', fieldFinish: '课程状态', fieldCancelled: '预约状态', fieldNote: '备注',
    fieldPromotion: '促销课程', fieldDoubleBooking: '可重复预约', fieldSlip: '付款凭证',
    fieldFirstname: '名', fieldMiddlename: '中间名', fieldLastname: '姓', fieldNickname: '昵称', fieldGender: '性别', fieldDob: '出生日期', fieldSchool: '学校', fieldFamily: '家庭', fieldCourseRef2: '下一课程',
    fieldEmail: '邮箱', fieldAddress: '地址', fieldRole: '权限', fieldAccess: '账户状态', valRestricted: '受限', roleHead: '经理', roleAdmin: '管理员', roleCoach: '教练', roleCustomer: '客户',
    valChecked: '已签到', valNotChecked: '未签到',
    valActive: '使用中', valFinished: '已结课', valCancelled: '已取消',
    valYes: '是', valNo: '否',
  },
  ja: {
    title: '編集履歴',
    empty: '編集履歴はまだありません',
    since: '2026年7月29日以降の記録が閲覧できます',
    fieldPaid: '支払い状態', fieldFinish: 'コース状態', fieldCancelled: '予約状態', fieldNote: 'メモ',
    fieldPromotion: 'プロモーションコース', fieldDoubleBooking: '重複予約可', fieldSlip: '振込明細',
    fieldFirstname: '名', fieldMiddlename: 'ミドルネーム', fieldLastname: '姓', fieldNickname: 'ニックネーム', fieldGender: '性別', fieldDob: '生年月日', fieldSchool: '学校', fieldFamily: '家族', fieldCourseRef2: '次のコース',
    fieldEmail: 'メール', fieldAddress: '住所', fieldRole: '権限', fieldAccess: 'アカウント状態', valRestricted: '制限中', roleHead: 'マネージャー', roleAdmin: '管理者', roleCoach: 'コーチ', roleCustomer: '顧客',
    valChecked: '出席済み', valNotChecked: '未出席',
    valActive: '利用中', valFinished: '終了', valCancelled: 'キャンセル',
    valYes: 'はい', valNo: 'いいえ',
  },
  ko: {
    title: '수정 이력',
    empty: '수정 이력이 없습니다',
    since: '2026년 7월 29일 이후의 기록을 볼 수 있습니다',
    fieldPaid: '결제 상태', fieldFinish: '수강권 상태', fieldCancelled: '예약 상태', fieldNote: '메모',
    fieldPromotion: '프로모션 수강권', fieldDoubleBooking: '중복 예약 가능', fieldSlip: '이체 영수증',
    fieldFirstname: '이름', fieldMiddlename: '중간 이름', fieldLastname: '성', fieldNickname: '별명', fieldGender: '성별', fieldDob: '생년월일', fieldSchool: '학교', fieldFamily: '가족', fieldCourseRef2: '다음 수강권',
    fieldEmail: '이메일', fieldAddress: '주소', fieldRole: '권한', fieldAccess: '계정 상태', valRestricted: '제한됨', roleHead: '매니저', roleAdmin: '관리자', roleCoach: '코치', roleCustomer: '고객',
    valChecked: '출석 완료', valNotChecked: '미출석',
    valActive: '사용 중', valFinished: '종료', valCancelled: '취소됨',
    valYes: '예', valNo: '아니요',
  },
}
for (const loc of Object.keys(editHistoryMessages)) {
  messages[loc].editHistory = Object.assign({}, messages[loc].editHistory, editHistoryMessages[loc])
}

// กติกาสิทธิ์แก้กำหนดการของใบ (period/startdate/expiredate — เจ้าของเคาะ 17 ส.ค.)
// CJK แปลด้วย AI ควรให้เจ้าของภาษาตรวจ
const scheduleLockMessages = {
  th: { scheduleLockedHint: 'ใบนี้ถูกจองไปแล้ว — ระยะเวลา วันเริ่มต้น และวันหมดอายุ แก้ได้โดยผู้จัดการเท่านั้น' },
  en: { scheduleLockedHint: 'This package already has bookings — period, start date, and expiry date can only be changed by a manager' },
  zh: { scheduleLockedHint: '该课程包已有预约——期限、开始日期和到期日期仅经理可修改' },
  ja: { scheduleLockedHint: 'このパッケージには既に予約があります — 期間・開始日・有効期限はマネージャーのみ変更できます' },
  ko: { scheduleLockedHint: '이 수강권은 이미 예약이 있습니다 — 기간, 시작일, 만료일은 매니저만 수정할 수 있습니다' },
}
for (const loc of Object.keys(scheduleLockMessages)) {
  messages[loc].customerCourse = Object.assign({}, messages[loc].customerCourse, scheduleLockMessages[loc])
}

// เหตุผลที่เปลี่ยนวันหมดอายุคอร์ส (ต่อท้ายการ์ดแจ้งผู้ปกครอง) · CJK แปลด้วย AI ควรให้เจ้าของภาษาตรวจ
const expiryReasonMessages = {
  th: { expiryReason: 'เหตุผลที่เปลี่ยนวันหมดอายุ (ไม่บังคับ)', expiryReasonPh: 'เช่น ชดเชยวันหยุดของยิม', expiryReasonHint: 'ผู้ปกครองจะได้รับแจ้งการเปลี่ยนวันหมดอายุ พร้อมเหตุผลนี้' },
  en: { expiryReason: 'Reason for the expiry date change (optional)', expiryReasonPh: 'e.g. compensation for a gym closure', expiryReasonHint: 'Parents will be notified of the change together with this reason' },
  zh: { expiryReason: '更改到期日的原因（可选）', expiryReasonPh: '例如：补偿场馆休息日', expiryReasonHint: '家长将收到到期日变更通知及此原因' },
  ja: { expiryReason: '有効期限を変更する理由（任意）', expiryReasonPh: '例：ジムの休業日の振替', expiryReasonHint: '保護者には変更の通知とこの理由が届きます' },
  ko: { expiryReason: '만료일 변경 사유 (선택)', expiryReasonPh: '예: 체육관 휴무일 보상', expiryReasonHint: '학부모에게 변경 알림과 이 사유가 전달됩니다' },
}
for (const loc of Object.keys(expiryReasonMessages)) {
  messages[loc].customerCourse = Object.assign({}, messages[loc].customerCourse, expiryReasonMessages[loc])
}

// ขอเลื่อนวันหมดอายุคอร์สหลายใบ + ผู้จัดการอนุมัติ (COURSE_EXPIRY_ADJUST_DESIGN.md) · CJK แปลด้วย AI ควรให้เจ้าของภาษาตรวจ
const expiryReqMessages = {
  th: { expiryReq: {
    mondayPick: 'ช่วงที่เพิ่มมีวันจันทร์ {n} วัน ({dates}) ซึ่งยิมปิด — เลือกจำนวนวันชดเชยที่จะบวกเพิ่ม (สูงสุด {max} วัน)', extraNone: 'ไม่บวกเพิ่ม', extraOption: 'บวกเพิ่ม {n} วัน', extraMax: 'เลือกได้สูงสุด {max} วัน',
    previewFailed: 'ตรวจรหัสไม่สำเร็จ — ลองเพิ่มใหม่', badCodes: 'รหัสที่ไม่ถูกต้อง: {codes}',
    openDialog: 'ขอเลื่อนวันหมดอายุ', openList: 'คำขอเลื่อนวันหมดอายุ',
    dialogTitle: 'ขอเลื่อนวันหมดอายุคอร์ส', pickCourses: 'เลือกคอร์ส',
    codesLabel: 'รหัสคอร์ส (พิมพ์ทีละรหัส แล้วกด Enter หรือวางหลายรหัสได้ คั่นด้วยเว้นวรรค หรือเครื่องหมาย , )', expiryDate: 'วันหมดอายุ', expiryOld: 'วันหมดอายุเดิม', expiryDrifted: 'วันหมดอายุของคอร์สนี้ถูกแก้เป็น {date} หลังยื่นคำขอ — ถ้าอนุมัติ ระบบจะเลื่อนให้ไม่ได้ (ต้องให้แอดมินยื่นใหม่)', expiryNew: 'วันหมดอายุที่เลื่อน', codesPh: 'เช่น GA-20260916-0001',
    addCodes: 'เพิ่มคอร์ส', daysAll: 'ชดเชยกี่วัน', applyAll: 'ใช้กับทุกใบ', days: 'วัน', removeRow: 'เอาคอร์สนี้ออก',
    mondayBulk: 'มี {n} ใบที่ช่วงชดเชยมีวันจันทร์ (ยิมปิด)', addMondayAll: 'บวกวันชดเชยให้ทุกใบ',
    mondayWarn: 'ช่วงที่เพิ่มมีวันจันทร์ {n} วัน ({dates}) ซึ่งยิมปิด — จะบวกวันชดเชยเพิ่มไหม',
    addExtra: 'บวกเพิ่ม {n} วัน', extraAdded: 'บวกเพิ่ม {n} วันแล้ว (ชดเชยวันจันทร์)', undoExtra: 'ไม่บวก',
    attachSlip: 'แนบสลิป', slipMax: 'แนบสลิปได้สูงสุด 3 ใบต่อคอร์ส', attachMedical: 'แนบใบรับรองแพทย์', medicalMax: 'แนบใบรับรองแพทย์ได้สูงสุด 3 ใบต่อคอร์ส', medicalTag: 'ใบรับรองแพทย์', slipCheckWarn: 'ยื่นคำขอแล้ว แต่สลิป {n} ใบไม่ผ่านการตรวจหรือตรวจไม่ได้ — ผู้จัดการจะเห็นผลตรวจ',
    reasonTitle: 'เหตุผล', reason: 'เหตุผลที่เลื่อน', reasonPh: 'เช่น ชดเชยวันหยุดของยิม',
    hintHead: 'คุณเป็นผู้จัดการ — เลื่อนทันทีและแจ้งผู้ปกครองพร้อมเหตุผลนี้', hintAdmin: 'ส่งให้ผู้จัดการอนุมัติก่อน — ยังไม่เลื่อนและยังไม่แจ้งผู้ปกครองจนกว่าจะอนุมัติ',
    submitHead: 'เลื่อนทันที', submitAdmin: 'ส่งขออนุมัติ',
    appliedMsg: 'เลื่อนวันหมดอายุและแจ้งผู้ปกครองแล้ว', pendingMsg: 'ส่งคำขอให้ผู้จัดการแล้ว — รออนุมัติ',
    listTitle: 'คำขอเลื่อนวันหมดอายุ', detailTitle: 'รายละเอียดคำขอ', noRequests: 'ยังไม่มีคำขอ', backToList: 'กลับไปรายการ',
    status: { pending: 'รออนุมัติ', approved: 'อนุมัติแล้ว', partial: 'อนุมัติบางส่วน', rejected: 'ไม่อนุมัติ', failed: 'อนุมัติแล้วแต่เลื่อนไม่สำเร็จ', cancelled: 'ยกเลิกแล้ว' },
    itemStatus: { pending: 'รอ', approved: 'เลื่อนแล้ว', rejected: 'ไม่อนุมัติ', failed: 'เลื่อนไม่สำเร็จ', cancelled: 'ยกเลิก' },
    hasSlip: 'สลิป {n}', newSlip: 'มีสลิปใหม่', courses: 'คอร์ส', decideNote: 'หมายเหตุผู้อนุมัติ', includesExtra: 'รวมชดเชยวันจันทร์ {n} วัน',
    months: 'เดือน', sessions: 'จำนวนครั้ง', currentExpiry: 'หมดอายุตอนนี้', users: 'ผู้ใช้คอร์ส', viewSlip: 'ดูสลิป',
    approve: 'อนุมัติ', reject: 'ไม่อนุมัติ', note: 'หมายเหตุ (ไม่บังคับ)', rejectAll: 'ไม่อนุมัติทั้งหมด', saveChoices: 'บันทึกที่เลือก ({n})',
    requestReason: 'เหตุผลที่ขอเลื่อน (จากผู้ยื่น)', selectAll: 'เลือกทั้งหมด', selectedCount: 'เลือกแล้ว {n} จาก {total} ใบ', selectItem: 'เลือก {code}', approveSelected: 'อนุมัติที่เลือก ({n})', rejectSelected: 'ไม่อนุมัติที่เลือก ({n})', noteLabel: 'หมายเหตุจากผู้อนุมัติ (ไม่บังคับ)', noteHint: 'ข้อความนี้ส่งกลับให้ผู้ยื่นคำขอ — ไม่ใช่เหตุผลที่ขอเลื่อน และผู้ปกครองไม่เห็น',
    editRequest: 'แก้ไขคำขอ', editDialogTitle: 'แก้ไขคำขอ #{id}', saveEdit: 'บันทึกการแก้ไข', hintEdit: 'แก้ไขแล้วยังรอผู้จัดการอนุมัติ — วันใหม่คำนวณจากวันหมดอายุปัจจุบันของแต่ละคอร์ส ผู้จัดการได้รับการแจ้งเตือนว่าคำขอถูกแก้ไข', updatedMsg: 'แก้ไขคำขอแล้ว — ยังรอผู้จัดการอนุมัติ',
    approveAll: 'อนุมัติทั้งหมด', cancelRequest: 'ยกเลิกคำขอ', decided: 'บันทึกการตัดสินแล้ว', decidedWithFail: 'บันทึกแล้ว แต่ {n} ใบเลื่อนไม่สำเร็จ (ดูเหตุผลในรายละเอียด)',
  } },
  en: { expiryReq: {
    mondayPick: 'The added period includes {n} Monday(s) ({dates}) when the gym is closed — choose how many compensation days to add (up to {max})', extraNone: 'Add none', extraOption: 'Add {n} day(s)', extraMax: 'up to {max} day(s)',
    previewFailed: 'Could not check this code — add it again', badCodes: 'Invalid codes: {codes}',
    openDialog: 'Extend expiry', openList: 'Expiry requests',
    dialogTitle: 'Request an expiry extension', pickCourses: 'Choose courses',
    codesLabel: 'Course code (type one, then press Enter — or paste several separated by spaces or commas)', expiryDate: 'Expiry date', expiryOld: 'Expiry when requested', expiryDrifted: 'This course\'s expiry was changed to {date} after the request was filed — approving will fail (the admin must refile)', expiryNew: 'Extended expiry', codesPh: 'e.g. GA-20260916-0001',
    addCodes: 'Add courses', daysAll: 'Compensation days', applyAll: 'Apply to all', days: 'days', removeRow: 'Remove this course',
    mondayBulk: '{n} course(s) have a Monday (gym closed) in the compensation window', addMondayAll: 'Add the extra days to all',
    mondayWarn: 'The added period includes {n} Monday(s) ({dates}) when the gym is closed — add extra compensation days?',
    addExtra: 'Add {n} more day(s)', extraAdded: '{n} extra day(s) added (Monday compensation)', undoExtra: "Don't add",
    attachSlip: 'Attach slip', slipMax: 'At most 3 slips per course', attachMedical: 'Attach medical certificate', medicalMax: 'At most 3 medical certificates per course', medicalTag: 'Medical certificate', slipCheckWarn: 'Request filed, but {n} slip(s) failed verification or could not be checked — the manager will see the result',
    reasonTitle: 'Reason', reason: 'Reason for the extension', reasonPh: 'e.g. compensation for a gym closure',
    hintHead: 'You are a manager — this takes effect now and parents are notified with this reason', hintAdmin: 'Sent to a manager for approval — nothing changes and parents are not notified until it is approved',
    submitHead: 'Extend now', submitAdmin: 'Send for approval',
    appliedMsg: 'Expiry dates extended and parents notified', pendingMsg: 'Request sent to the manager — awaiting approval',
    listTitle: 'Expiry requests', detailTitle: 'Request details', noRequests: 'No requests yet', backToList: 'Back to list',
    status: { pending: 'Pending', approved: 'Approved', partial: 'Partly approved', rejected: 'Rejected', failed: 'Approved but not applied', cancelled: 'Cancelled' },
    itemStatus: { pending: 'Pending', approved: 'Extended', rejected: 'Rejected', failed: 'Failed', cancelled: 'Cancelled' },
    hasSlip: '{n} slip(s)', newSlip: 'New slip', courses: 'course(s)', decideNote: "Manager's note", includesExtra: 'incl. {n} Monday day(s)',
    months: 'months', sessions: 'Sessions', currentExpiry: 'Expires now', users: 'Used by', viewSlip: 'View slip',
    approve: 'Approve', reject: 'Reject', note: 'Note (optional)', rejectAll: 'Reject all', saveChoices: 'Save selected ({n})',
    requestReason: 'Reason for the request (from the requester)', selectAll: 'Select all', selectedCount: '{n} of {total} selected', selectItem: 'Select {code}', approveSelected: 'Approve selected ({n})', rejectSelected: 'Reject selected ({n})', noteLabel: "Manager's note (optional)", noteHint: 'Sent back to the requester — not the reason for the extension, and parents do not see it',
    editRequest: 'Edit request', editDialogTitle: 'Edit request #{id}', saveEdit: 'Save changes', hintEdit: 'Still pending the manager — new dates are recalculated from each course\'s current expiry, and the managers are notified that the request was edited', updatedMsg: 'Request updated — awaiting approval',
    approveAll: 'Approve all', cancelRequest: 'Cancel request', decided: 'Decision saved', decidedWithFail: 'Saved, but {n} course(s) could not be extended (see details)',
  } },
  zh: { expiryReq: {
    mondayPick: '新增的期间包含 {n} 个周一（{dates}），场馆休息——请选择追加几天补偿（最多 {max} 天）', extraNone: '不追加', extraOption: '追加 {n} 天', extraMax: '最多 {max} 天',
    previewFailed: '无法检查此编号——请重新添加', badCodes: '无效的编号：{codes}',
    openDialog: '申请延长有效期', openList: '延期申请',
    dialogTitle: '申请延长课程有效期', pickCourses: '选择课程',
    codesLabel: '课程编号（输入一个后按 Enter——也可粘贴多个，用空格或逗号分隔）', expiryDate: '到期日', expiryOld: '申请时到期日', expiryDrifted: '提交申请后，该课程的到期日已被改为 {date}——批准将无法执行（需管理员重新提交）', expiryNew: '延期后到期日', codesPh: '例如 GA-20260916-0001',
    addCodes: '添加课程', daysAll: '补偿天数', applyAll: '应用于全部', days: '天', removeRow: '移除此课程',
    mondayBulk: '有 {n} 个课程的补偿期内含周一（场馆休息）', addMondayAll: '为全部追加补偿天数',
    mondayWarn: '新增的期间包含 {n} 个周一（{dates}），场馆休息——是否追加补偿天数？',
    addExtra: '追加 {n} 天', extraAdded: '已追加 {n} 天（周一补偿）', undoExtra: '不追加',
    attachSlip: '附上凭证', slipMax: '每个课程最多 3 张凭证', attachMedical: '附上医生证明', medicalMax: '每个课程最多 3 份医生证明', medicalTag: '医生证明', slipCheckWarn: '申请已提交，但有 {n} 张凭证未通过验证或无法验证——经理将看到验证结果',
    reasonTitle: '原因', reason: '延期原因', reasonPh: '例如：补偿场馆休息日',
    hintHead: '您是经理——将立即生效，并连同此原因通知家长', hintAdmin: '已提交经理审批——批准前不会更改，也不会通知家长',
    submitHead: '立即延期', submitAdmin: '提交审批',
    appliedMsg: '已延长有效期并通知家长', pendingMsg: '申请已发送给经理，等待审批',
    listTitle: '延期申请', detailTitle: '申请详情', noRequests: '暂无申请', backToList: '返回列表',
    status: { pending: '待审批', approved: '已批准', partial: '部分批准', rejected: '未批准', failed: '已批准但未能延期', cancelled: '已取消' },
    itemStatus: { pending: '待定', approved: '已延期', rejected: '未批准', failed: '延期失败', cancelled: '已取消' },
    hasSlip: '{n} 张凭证', newSlip: '新凭证', courses: '个课程', decideNote: '审批备注', includesExtra: '含周一补偿 {n} 天',
    months: '个月', sessions: '总次数', currentExpiry: '当前到期', users: '使用者', viewSlip: '查看凭证',
    approve: '批准', reject: '不批准', note: '备注（可选）', rejectAll: '全部不批准', saveChoices: '保存所选（{n}）',
    requestReason: '申请原因（申请人填写）', selectAll: '全选', selectedCount: '已选 {n} / {total}', selectItem: '选择 {code}', approveSelected: '批准所选（{n}）', rejectSelected: '不批准所选（{n}）', noteLabel: '审批备注（可选）', noteHint: '此内容回复给申请人——不是延期原因，家长看不到',
    editRequest: '编辑申请', editDialogTitle: '编辑申请 #{id}', saveEdit: '保存修改', hintEdit: '仍待经理审批——新日期按各课程当前到期日重新计算，并通知经理申请已被修改', updatedMsg: '申请已更新——等待审批',
    approveAll: '全部批准', cancelRequest: '取消申请', decided: '已保存审批结果', decidedWithFail: '已保存，但有 {n} 个课程延期失败（详见详情）',
  } },
  ja: { expiryReq: {
    mondayPick: '追加期間に月曜日が {n} 日（{dates}）含まれます（ジム休業）— 追加する振替日数を選んでください（最大 {max} 日）', extraNone: '追加しない', extraOption: '{n} 日追加', extraMax: '最大 {max} 日',
    previewFailed: 'このコードを確認できませんでした — 追加し直してください', badCodes: '無効なコード：{codes}',
    openDialog: '有効期限の延長申請', openList: '延長申請一覧',
    dialogTitle: 'コースの有効期限延長を申請', pickCourses: 'コースを選択',
    codesLabel: 'コースコード（1件入力して Enter — 複数貼り付けも可。スペースまたはカンマ区切り）', expiryDate: '有効期限', expiryOld: '申請時の有効期限', expiryDrifted: '申請後にこのコースの有効期限が {date} に変更されました — 承認しても延長できません（再申請が必要）', expiryNew: '延長後の有効期限', codesPh: '例：GA-20260916-0001',
    addCodes: 'コースを追加', daysAll: '振替日数', applyAll: '全てに適用', days: '日', removeRow: 'このコースを外す',
    mondayBulk: '振替期間に月曜日（ジム休業）を含むコースが {n} 件あります', addMondayAll: '全てに振替日数を追加',
    mondayWarn: '追加期間に月曜日が {n} 日（{dates}）含まれます（ジム休業）— 振替日数を追加しますか？',
    addExtra: '{n} 日追加', extraAdded: '{n} 日を追加済み（月曜日の振替）', undoExtra: '追加しない',
    attachSlip: '明細を添付', slipMax: 'コースごとに最大3枚', attachMedical: '診断書を添付', medicalMax: 'コースごとに最大3枚', medicalTag: '診断書', slipCheckWarn: '申請しましたが、{n} 件の明細が確認に失敗または確認できませんでした — マネージャーに結果が表示されます',
    reasonTitle: '理由', reason: '延長の理由', reasonPh: '例：ジム休業日の振替',
    hintHead: 'マネージャーなので即時に反映され、この理由とともに保護者へ通知されます', hintAdmin: 'マネージャーの承認待ち — 承認まで変更も保護者への通知も行われません',
    submitHead: '今すぐ延長', submitAdmin: '承認を申請',
    appliedMsg: '有効期限を延長し、保護者に通知しました', pendingMsg: '申請をマネージャーに送りました。承認待ちです',
    listTitle: '延長申請', detailTitle: '申請の詳細', noRequests: '申請はありません', backToList: '一覧に戻る',
    status: { pending: '承認待ち', approved: '承認済み', partial: '一部承認', rejected: '却下', failed: '承認済みだが延長できず', cancelled: '取消済み' },
    itemStatus: { pending: '待機', approved: '延長済み', rejected: '却下', failed: '失敗', cancelled: '取消' },
    hasSlip: '明細 {n} 枚', newSlip: '新しい明細', courses: '件', decideNote: '承認者メモ', includesExtra: '月曜日の振替 {n} 日を含む',
    months: 'か月', sessions: '回数', currentExpiry: '現在の期限', users: '利用者', viewSlip: '明細を見る',
    approve: '承認', reject: '却下', note: 'メモ（任意）', rejectAll: '全て却下', saveChoices: '選択を保存（{n}）',
    requestReason: '申請の理由（申請者より）', selectAll: 'すべて選択', selectedCount: '{total} 件中 {n} 件選択', selectItem: '{code} を選択', approveSelected: '選択を承認（{n}）', rejectSelected: '選択を却下（{n}）', noteLabel: '承認者メモ（任意）', noteHint: '申請者に返信されます — 延長の理由ではなく、保護者には表示されません',
    editRequest: '申請を編集', editDialogTitle: '申請 #{id} を編集', saveEdit: '変更を保存', hintEdit: 'マネージャーの承認待ちのまま — 新しい日付は各コースの現在の有効期限から再計算され、マネージャーに編集が通知されます', updatedMsg: '申請を更新しました — 承認待ち',
    approveAll: '全て承認', cancelRequest: '申請を取り消す', decided: '判断を保存しました', decidedWithFail: '保存しましたが、{n} 件は延長できませんでした（詳細を確認）',
  } },
  ko: { expiryReq: {
    mondayPick: '추가 기간에 월요일이 {n}일({dates}) 포함됩니다(체육관 휴무) — 더할 보상 일수를 선택하세요 (최대 {max}일)', extraNone: '추가 안 함', extraOption: '{n}일 추가', extraMax: '최대 {max}일',
    previewFailed: '이 코드를 확인하지 못했습니다 — 다시 추가해 주세요', badCodes: '잘못된 코드: {codes}',
    openDialog: '만료일 연장 신청', openList: '연장 신청 목록',
    dialogTitle: '수강권 만료일 연장 신청', pickCourses: '수강권 선택',
    codesLabel: '수강권 코드 (하나 입력 후 Enter — 여러 개 붙여넣기도 가능, 공백 또는 쉼표로 구분)', expiryDate: '만료일', expiryOld: '신청 시 만료일', expiryDrifted: '신청 후 이 수강권의 만료일이 {date}(으)로 변경되었습니다 — 승인해도 연장되지 않습니다 (재신청 필요)', expiryNew: '연장된 만료일', codesPh: '예: GA-20260916-0001',
    addCodes: '수강권 추가', daysAll: '보상 일수', applyAll: '모두 적용', days: '일', removeRow: '이 수강권 제외',
    mondayBulk: '보상 기간에 월요일(체육관 휴무)이 포함된 수강권이 {n}건 있습니다', addMondayAll: '모두에 보상 일수 추가',
    mondayWarn: '추가 기간에 월요일이 {n}일({dates}) 포함됩니다(체육관 휴무) — 보상 일수를 더 추가할까요?',
    addExtra: '{n}일 추가', extraAdded: '{n}일 추가됨 (월요일 보상)', undoExtra: '추가 안 함',
    attachSlip: '영수증 첨부', slipMax: '수강권당 최대 3장', attachMedical: '진단서 첨부', medicalMax: '수강권당 최대 3장', medicalTag: '진단서', slipCheckWarn: '신청했지만 이체증 {n}장이 확인에 실패했거나 확인할 수 없습니다 — 매니저가 결과를 확인합니다',
    reasonTitle: '사유', reason: '연장 사유', reasonPh: '예: 체육관 휴무일 보상',
    hintHead: '매니저이므로 즉시 적용되며 이 사유와 함께 학부모에게 알림이 갑니다', hintAdmin: '매니저 승인 대기 — 승인 전에는 변경도 학부모 알림도 없습니다',
    submitHead: '즉시 연장', submitAdmin: '승인 요청',
    appliedMsg: '만료일을 연장하고 학부모에게 알렸습니다', pendingMsg: '매니저에게 요청을 보냈습니다. 승인 대기 중입니다',
    listTitle: '연장 신청', detailTitle: '신청 상세', noRequests: '신청이 없습니다', backToList: '목록으로',
    status: { pending: '승인 대기', approved: '승인됨', partial: '일부 승인', rejected: '거절됨', failed: '승인됐지만 연장 실패', cancelled: '취소됨' },
    itemStatus: { pending: '대기', approved: '연장됨', rejected: '거절', failed: '실패', cancelled: '취소' },
    hasSlip: '영수증 {n}장', newSlip: '새 영수증', courses: '건', decideNote: '승인자 메모', includesExtra: '월요일 보상 {n}일 포함',
    months: '개월', sessions: '횟수', currentExpiry: '현재 만료일', users: '사용자', viewSlip: '영수증 보기',
    approve: '승인', reject: '거절', note: '메모 (선택)', rejectAll: '모두 거절', saveChoices: '선택 저장 ({n})',
    requestReason: '신청 사유 (신청자 작성)', selectAll: '전체 선택', selectedCount: '{total}건 중 {n}건 선택', selectItem: '{code} 선택', approveSelected: '선택 승인 ({n})', rejectSelected: '선택 거절 ({n})', noteLabel: '승인자 메모 (선택)', noteHint: '신청자에게 전달됩니다 — 연장 사유가 아니며 학부모에게는 보이지 않습니다',
    editRequest: '신청 수정', editDialogTitle: '신청 #{id} 수정', saveEdit: '변경 저장', hintEdit: '여전히 매니저 승인 대기 — 새 날짜는 각 수강권의 현재 만료일 기준으로 다시 계산되며 매니저에게 수정 알림이 갑니다', updatedMsg: '신청을 수정했습니다 — 승인 대기 중',
    approveAll: '모두 승인', cancelRequest: '신청 취소', decided: '결정을 저장했습니다', decidedWithFail: '저장했지만 {n}건은 연장하지 못했습니다 (상세 확인)',
  } },
}
for (const loc of Object.keys(expiryReqMessages)) {
  Object.assign(messages[loc], expiryReqMessages[loc])
}

// ใบเช็คชื่อแล้วห้ามย้าย/แก้ (เจ้าของเคาะ 18 ส.ค. — กติกาเดียวกับปุ่มยกเลิก) · CJK แปลด้วย AI
const editLockMessages = {
  th: { editNeedsUndo: 'เช็คชื่อแล้ว — ต้องเอาเช็คชื่อออกก่อนจึงจะย้าย/แก้ไขได้' },
  en: { editNeedsUndo: 'Checked in — undo check-in before moving or editing' },
  zh: { editNeedsUndo: '已签到——需先取消签到才能移动或修改' },
  ja: { editNeedsUndo: '出席済み — 移動・編集するには先に出席を取り消してください' },
  ko: { editNeedsUndo: '출석 완료 — 이동·수정하려면 먼저 출석을 취소하세요' },
}
for (const loc of Object.keys(editLockMessages)) {
  messages[loc].bookingMgmt = Object.assign({}, messages[loc].bookingMgmt, editLockMessages[loc])
}

// Private เช็คชื่อแล้ว: ล็อกเฉพาะกำหนดการ เรื่องเงินยังบันทึกได้ (จ่ายทีหลังเป็นงานปกติ) · CJK แปลด้วย AI
const pvScheduleLockMessages = {
  th: { scheduleLockedCheckin: 'เช็คชื่อแล้ว — แก้ได้เฉพาะข้อมูลการชำระเงิน/หมายเหตุ การย้ายคาบต้องเอาเช็คชื่อออกก่อน' },
  en: { scheduleLockedCheckin: 'Checked in — only payment details and notes can be edited; undo check-in to reschedule' },
  zh: { scheduleLockedCheckin: '已签到——仅可编辑付款信息和备注；如需改期请先取消签到' },
  ja: { scheduleLockedCheckin: '出席済み — 支払い情報とメモのみ編集できます。日時変更は先に出席を取り消してください' },
  ko: { scheduleLockedCheckin: '출석 완료 — 결제 정보와 메모만 수정할 수 있습니다. 일정 변경은 먼저 출석을 취소하세요' },
}
for (const loc of Object.keys(pvScheduleLockMessages)) {
  messages[loc].privateBooking = Object.assign({}, messages[loc].privateBooking, pvScheduleLockMessages[loc])
}

// แนบสลิปได้หลายใบต่อรายการ (multi-slip — เจ้าของเคาะ 2026-08-19) · ดู MULTI_SLIP_DESIGN.md
// ⚠️ กลุ่มยอด/วันที่ (slipAmount* / slipDateMismatch*) เป็นการเช็ค "ของระบบเราเอง" ว่าสลิปตรงกับ
// ข้อมูลที่แอดมินกรอกไหม — คนละเรื่องกับสถานะ SlipOK (slipVerified/slipFailed/…) อย่าปนกัน
// CJK แปลด้วย AI ควรให้เจ้าของภาษาตรวจ
const multiSlipMessages = {
  th: {
    slipList: 'รายการสลิป', slipAdd: 'เพิ่มสลิป', slipEmpty: 'ยังไม่มีสลิป',
    slipMax: 'แนบได้สูงสุด {n} ใบ — ลบใบเดิมก่อนจึงจะเพิ่มได้',
    slipUploading: 'กำลังอัพโหลด…',
    slipDelete: 'ลบสลิป', slipUndoDelete: 'ยกเลิกการลบ', slipMarkedDelete: 'รอลบตอนบันทึก',
    slipDeletePending: 'จะลบ {n} ใบเมื่อกดบันทึก — ไฟล์ยังเก็บไว้ในระบบเพื่อการตรวจสอบ',
    slipLegacy: 'สลิปเดิม (ลบไม่ได้)',
    slipAmountOk: 'ยอดครบ', slipAmountUnder: 'ขาด {n} บาท', slipAmountOver: 'เกิน {n} บาท',
    slipAmountUnknown: 'ยังอ่านยอดจากสลิปไม่ได้',
    slipAmountPaidOf: 'โอนแล้ว {paid} / {price} บาท',
    slipUnknownCount: 'อีก {n} ใบยังอ่านยอดไม่ได้',
    slipDateMismatch: 'วันที่ไม่ตรง',
    slipDateMismatchDetail: 'วันที่ในสลิป {slip} ไม่ตรงกับวันที่ชำระในระบบ {paydate}',
    slipQueued: 'รอแนบตอนบันทึก',
    slipPendingHint: 'จะอัพโหลดและตรวจอัตโนมัติเมื่อกด "บันทึก"',
    slipLoadFail: 'โหลดรายการสลิปไม่สำเร็จ',
    slipUploadFail: 'อัพโหลดสลิปไม่สำเร็จ', slipDeleteFail: 'ลบสลิปไม่สำเร็จ',
    slipDeletedAnyway: 'ลบสลิปเดิมไปแล้ว แต่บันทึกไม่สำเร็จ กรุณาตรวจสอบรายการสลิปอีกครั้ง',
  },
  en: {
    slipList: 'Slips', slipAdd: 'Add slip', slipEmpty: 'No slip yet',
    slipMax: 'Up to {n} slips — delete one before adding another',
    slipUploading: 'Uploading…',
    slipDelete: 'Delete slip', slipUndoDelete: 'Undo delete', slipMarkedDelete: 'Deleted on save',
    slipDeletePending: '{n} slip(s) will be deleted on save — the files stay in the system for auditing',
    slipLegacy: 'Existing slip (cannot delete)',
    slipAmountOk: 'Amount matches', slipAmountUnder: '{n} THB short', slipAmountOver: '{n} THB over',
    slipAmountUnknown: 'Amount not readable yet',
    slipAmountPaidOf: 'transferred {paid} / {price} THB',
    slipUnknownCount: '{n} more slip(s) with unreadable amount',
    slipDateMismatch: 'Date mismatch',
    slipDateMismatchDetail: 'Slip date {slip} does not match the recorded pay date {paydate}',
    slipQueued: 'Attached on save',
    slipPendingHint: 'Uploaded and verified automatically when you press Save',
    slipLoadFail: 'Could not load the slip list',
    slipUploadFail: 'Slip upload failed', slipDeleteFail: 'Could not delete the slip',
    slipDeletedAnyway: 'The old slip was already deleted but saving failed — please re-check the slip list',
  },
  zh: {
    slipList: '转账凭证', slipAdd: '添加凭证', slipEmpty: '暂无凭证',
    slipMax: '最多 {n} 张——请先删除旧凭证再添加',
    slipUploading: '上传中…',
    slipDelete: '删除凭证', slipUndoDelete: '撤销删除', slipMarkedDelete: '保存时删除',
    slipDeletePending: '保存时将删除 {n} 张——文件仍保留在系统中以备查核',
    slipLegacy: '原有凭证（无法删除）',
    slipAmountOk: '金额相符', slipAmountUnder: '少 {n} 泰铢', slipAmountOver: '多 {n} 泰铢',
    slipAmountUnknown: '暂时无法读取金额',
    slipAmountPaidOf: '已转 {paid} / {price} 泰铢',
    slipUnknownCount: '还有 {n} 张无法读取金额',
    slipDateMismatch: '日期不符',
    slipDateMismatchDetail: '凭证日期 {slip} 与系统记录的付款日期 {paydate} 不符',
    slipQueued: '保存时上传',
    slipPendingHint: '按“保存”后自动上传并核验',
    slipLoadFail: '无法加载凭证列表',
    slipUploadFail: '凭证上传失败', slipDeleteFail: '无法删除凭证',
    slipDeletedAnyway: '旧凭证已删除但保存失败，请重新检查凭证列表',
  },
  ja: {
    slipList: '振込明細', slipAdd: '明細を追加', slipEmpty: '明細はまだありません',
    slipMax: '最大 {n} 件です — 追加するには既存の明細を削除してください',
    slipUploading: 'アップロード中…',
    slipDelete: '明細を削除', slipUndoDelete: '削除を取り消す', slipMarkedDelete: '保存時に削除',
    slipDeletePending: '保存時に {n} 件を削除します — ファイルは監査のためシステムに残ります',
    slipLegacy: '既存の明細（削除不可）',
    slipAmountOk: '金額一致', slipAmountUnder: '{n} バーツ不足', slipAmountOver: '{n} バーツ超過',
    slipAmountUnknown: '金額をまだ読み取れません',
    slipAmountPaidOf: '振込済み {paid} / {price} バーツ',
    slipUnknownCount: '他 {n} 件は金額を読み取れません',
    slipDateMismatch: '日付不一致',
    slipDateMismatchDetail: '明細の日付 {slip} が登録された支払日 {paydate} と一致しません',
    slipQueued: '保存時に添付',
    slipPendingHint: '「保存」を押すと自動でアップロード・照合します',
    slipLoadFail: '明細一覧を読み込めませんでした',
    slipUploadFail: '明細のアップロードに失敗しました', slipDeleteFail: '明細を削除できませんでした',
    slipDeletedAnyway: '旧いスリップは削除済みですが保存に失敗しました。スリップ一覧を再確認してください',
  },
  ko: {
    slipList: '이체 영수증', slipAdd: '영수증 추가', slipEmpty: '아직 영수증이 없습니다',
    slipMax: '최대 {n}장입니다 — 추가하려면 기존 영수증을 먼저 삭제하세요',
    slipUploading: '업로드 중…',
    slipDelete: '영수증 삭제', slipUndoDelete: '삭제 취소', slipMarkedDelete: '저장 시 삭제',
    slipDeletePending: '저장 시 {n}장을 삭제합니다 — 파일은 감사를 위해 시스템에 남습니다',
    slipLegacy: '기존 영수증 (삭제 불가)',
    slipAmountOk: '금액 일치', slipAmountUnder: '{n} 바트 부족', slipAmountOver: '{n} 바트 초과',
    slipAmountUnknown: '아직 금액을 읽을 수 없습니다',
    slipAmountPaidOf: '이체됨 {paid} / {price} 바트',
    slipUnknownCount: '{n}장은 금액을 읽을 수 없습니다',
    slipDateMismatch: '날짜 불일치',
    slipDateMismatchDetail: '영수증 날짜 {slip}이(가) 등록된 결제일 {paydate}과(와) 다릅니다',
    slipQueued: '저장 시 첨부',
    slipPendingHint: '"저장"을 누르면 자동으로 업로드하고 검증합니다',
    slipLoadFail: '영수증 목록을 불러오지 못했습니다',
    slipUploadFail: '영수증 업로드에 실패했습니다', slipDeleteFail: '영수증을 삭제하지 못했습니다',
    slipDeletedAnyway: '이전 슬립은 이미 삭제되었지만 저장에 실패했습니다. 슬립 목록을 다시 확인하세요',
  },
}
for (const loc of Object.keys(multiSlipMessages)) {
  messages[loc].customerCourse = Object.assign({}, messages[loc].customerCourse, multiSlipMessages[loc])
}

// การ์ดใหม่ในหน้าตรวจสอบประจำวัน: "สลิปไม่สอดคล้องกับรายการ" (multi-slip §5.1) · CJK แปลด้วย AI
// ⚠️ ops มีคีย์ซ้อนชั้น (check / hint / col / slipReason) — ต้อง merge ทีละชั้น
// Object.assign ชั้นเดียวจะ "แทนที่" ทั้งก้อน check เดิม = การ์ดอื่นชื่อหายหมด
const opsSlipMessages = {
  th: {
    check: { slipInconsistent: 'สลิปไม่สอดคล้องกับรายการ' },
    hint: { slipInconsistent: 'เช็คเฉพาะรายการที่ติ๊ก "จ่ายแล้ว" — ยอดรวมสลิปเทียบราคา และวันที่โอนเทียบวันที่ชำระ (คนละเรื่องกับผลตรวจสลิปของ Thunder)' },
    col: { slipTotal: 'สลิปรวม', price: 'ราคา' },
    slipReason: {
      under: 'ยอดขาด {n}', over: 'ยอดเกิน {n}',
      date: 'วันที่โอน {slip} ≠ วันที่ชำระ {paydate}',
    },
    slipPartialNote: 'อีก {n} รายการกำลังทยอยโอน (เพิ่งแนบสลิปไม่เกิน 7 วัน) — ไม่นับรวมในการ์ดนี้',
  },
  en: {
    check: { slipInconsistent: 'Slips inconsistent with the record' },
    hint: { slipInconsistent: 'Only records marked paid — slip total vs price, and transfer date vs the recorded pay date (separate from the Thunder verdict)' },
    col: { slipTotal: 'Slip total', price: 'Price' },
    slipReason: {
      under: '{n} short', over: '{n} over',
      date: 'transfer {slip} ≠ pay date {paydate}',
    },
    slipPartialNote: '{n} more record(s) paying in instalments (slip within 7 days) — not counted in this card',
  },
  zh: {
    check: { slipInconsistent: '凭证与记录不符' },
    hint: { slipInconsistent: '仅检查已标记付款的记录——凭证合计与价格、转账日期与记录的付款日期（与 Thunder 核验结果无关）' },
    col: { slipTotal: '凭证合计', price: '价格' },
    slipReason: {
      under: '少 {n}', over: '多 {n}',
      date: '转账 {slip} ≠ 付款日 {paydate}',
    },
    slipPartialNote: '另有 {n} 笔正在分期转账（7 天内上传凭证）——不计入本卡片',
  },
  ja: {
    check: { slipInconsistent: '明細と記録の不一致' },
    hint: { slipInconsistent: '「支払済み」の記録のみ対象 — 明細合計と価格、振込日と登録支払日を照合（Thunder の判定とは別）' },
    col: { slipTotal: '明細合計', price: '価格' },
    slipReason: {
      under: '{n} 不足', over: '{n} 超過',
      date: '振込 {slip} ≠ 支払日 {paydate}',
    },
    slipPartialNote: '他に {n} 件が分割振込中です（7日以内に明細添付）— このカードには数えません',
  },
  ko: {
    check: { slipInconsistent: '영수증과 기록 불일치' },
    hint: { slipInconsistent: '"결제됨"으로 표시된 건만 확인 — 영수증 합계와 금액, 이체일과 등록된 결제일 비교(Thunder 판정과는 별개)' },
    col: { slipTotal: '영수증 합계', price: '금액' },
    slipReason: {
      under: '{n} 부족', over: '{n} 초과',
      date: '이체 {slip} ≠ 결제일 {paydate}',
    },
    slipPartialNote: '추가로 {n}건이 분할 이체 중입니다(7일 이내 영수증 첨부) — 이 카드 수에는 포함되지 않습니다',
  },
}
for (const loc of Object.keys(opsSlipMessages)) {
  const dst = messages[loc].ops || (messages[loc].ops = {})
  for (const sec of Object.keys(opsSlipMessages[loc])) {
    dst[sec] = typeof opsSlipMessages[loc][sec] === 'object'
      ? Object.assign({}, dst[sec], opsSlipMessages[loc][sec])
      : opsSlipMessages[loc][sec]
  }
}

// การ์ด "ชำระแล้วแต่ยังไม่แนบสลิป" ในหน้าตรวจสอบประจำวัน (เจ้าของสั่ง 2026-10-12) · CJK แปลด้วย AI
// merge ทีละชั้นเหมือน opsSlipMessages ข้างบน — ops มีคีย์ซ้อน
const opsSlipMissingMessages = {
  th: {
    check: { slipMissing: 'ชำระแล้วแต่ยังไม่แนบสลิป' },
    hint: { slipMissing: 'ติ๊ก "จ่ายแล้ว" ด้วยเงินโอนหรือบัตรเครดิต แต่ยังไม่มีรูปสลิปแนบเลย — เมนูลงบัญชี Peak จะหาสลิปไม่เจอ (สลิปบัตรที่ส่งเข้าแชท LINE ต้องแนบในหน้ารายการด้วย)' },
    col: { method: 'วิธีชำระ' },
    method: { transfer: 'เงินโอน', credit: 'บัตรเครดิต' },
    kind: { event: 'อีเวนต์' },
  },
  en: {
    check: { slipMissing: 'Paid but no slip attached' },
    hint: { slipMissing: 'Marked paid by transfer or credit card, but no slip image is attached — Peak accounting cannot find a slip (card slips sent in the LINE chat must be attached on the record too)' },
    col: { method: 'Method' },
    method: { transfer: 'Transfer', credit: 'Credit card' },
    kind: { event: 'Event' },
  },
  zh: {
    check: { slipMissing: '已付款但未上传凭证' },
    hint: { slipMissing: '已标记为转账或信用卡付款，但没有上传凭证图片——Peak 记账找不到凭证（在 LINE 聊天中发送的刷卡凭证也必须上传到记录中）' },
    col: { method: '付款方式' },
    method: { transfer: '转账', credit: '信用卡' },
    kind: { event: '活动' },
  },
  ja: {
    check: { slipMissing: '支払済みだが明細未添付' },
    hint: { slipMissing: '振込またはクレジットカードで「支払済み」だが明細画像が未添付 — Peak 記帳で明細が見つかりません（LINE チャットで送ったカード明細も記録に添付が必要）' },
    col: { method: '支払方法' },
    method: { transfer: '振込', credit: 'クレジットカード' },
    kind: { event: 'イベント' },
  },
  ko: {
    check: { slipMissing: '결제했지만 영수증 미첨부' },
    hint: { slipMissing: '이체 또는 신용카드로 "결제됨" 표시했지만 영수증 이미지가 없습니다 — Peak 회계에서 영수증을 찾을 수 없습니다(LINE 채팅으로 보낸 카드 영수증도 기록에 첨부해야 함)' },
    col: { method: '결제 방법' },
    method: { transfer: '이체', credit: '신용카드' },
    kind: { event: '이벤트' },
  },
}
for (const loc of Object.keys(opsSlipMissingMessages)) {
  const dst = messages[loc].ops || (messages[loc].ops = {})
  for (const sec of Object.keys(opsSlipMissingMessages[loc])) {
    dst[sec] = Object.assign({}, dst[sec], opsSlipMissingMessages[loc][sec])
  }
}

// หัว dialog หน้าประวัติคอร์ส (ดูอย่างเดียว — เจ้าของเคาะ 18 ส.ค.) · CJK แปลด้วย AI
const courseViewMessages = {
  th: { viewCourse: 'รายละเอียดคอร์ส' },
  en: { viewCourse: 'Course Details' },
  zh: { viewCourse: '课程详情' },
  ja: { viewCourse: 'コース詳細' },
  ko: { viewCourse: '수강권 상세' },
}
for (const loc of Object.keys(courseViewMessages)) {
  messages[loc].courses = Object.assign({}, messages[loc].courses, courseViewMessages[loc])
}

// แท็บ "คอร์สที่ถูกลบ" ในหน้าประวัติคอร์ส (ผู้จัดการเท่านั้น) · CJK แปลด้วย AI
const deletedCourseMessages = {
  th: { tabFinished: 'คอร์สที่จบแล้ว', tabDeleted: 'คอร์สที่ถูกลบ', deleteDate: 'วันที่ลบ', noDeletedList: 'ไม่พบคอร์สที่ถูกลบ' },
  en: { tabFinished: 'Finished courses', tabDeleted: 'Deleted courses', deleteDate: 'Deleted on', noDeletedList: 'No deleted courses found' },
  zh: { tabFinished: '已结课课程', tabDeleted: '已删除课程', deleteDate: '删除日期', noDeletedList: '未找到已删除课程' },
  ja: { tabFinished: '修了したコース', tabDeleted: '削除されたコース', deleteDate: '削除日', noDeletedList: '削除されたコースはありません' },
  ko: { tabFinished: '종료된 수강권', tabDeleted: '삭제된 수강권', deleteDate: '삭제일', noDeletedList: '삭제된 수강권이 없습니다' },
}
for (const loc of Object.keys(deletedCourseMessages)) {
  messages[loc].courseHistory = Object.assign({}, messages[loc].courseHistory, deletedCourseMessages[loc])
}

// ปุ่มดาวน์โหลด (ตัวดูรูปสลิป) · CJK แปลด้วย AI
const downloadBtnMessages = {
  th: { download: 'ดาวน์โหลด' },
  en: { download: 'Download' },
  zh: { download: '下载' },
  ja: { download: 'ダウンロード' },
  ko: { download: '다운로드' },
}
for (const loc of Object.keys(downloadBtnMessages)) {
  messages[loc].btn = Object.assign({}, messages[loc].btn, downloadBtnMessages[loc])
}
const slipDownloadMessages = {
  th: { slipDownloadFail: 'ดาวน์โหลดสลิปไม่สำเร็จ ลองใหม่อีกครั้ง' },
  en: { slipDownloadFail: 'Could not download the slip — please try again' },
  zh: { slipDownloadFail: '下载转账凭证失败，请重试' },
  ja: { slipDownloadFail: '振込明細のダウンロードに失敗しました。もう一度お試しください' },
  ko: { slipDownloadFail: '입금 전표를 내려받지 못했습니다. 다시 시도해 주세요' },
}
for (const loc of Object.keys(slipDownloadMessages)) {
  messages[loc].customerCourse = Object.assign({}, messages[loc].customerCourse, slipDownloadMessages[loc])
}

// "ใครใช้แพ็กเกจคอร์สนี้" — บรรทัดในหัว dialog ของ 3 จอ (common/CourseHoldersLine.vue)
// current/past แยกกันโดยตั้งใจ: owner ไม่ลบชื่อคนที่ถอดคอร์สไปแล้ว รวมเป็นบรรทัดเดียว
// จะอ่านเหมือนมีคนใช้มากกว่าจริง · คำแปล zh/ja/ko สร้างด้วย AI ยังไม่ผ่านเจ้าของภาษา
const courseHoldersMessages = {
  th: {
    current: 'ผู้ใช้งานปัจจุบัน', past: 'เคยใช้แพ็กเกจนี้', none: 'ยังไม่มีใครใช้',
    nextSlot: '(คอร์สถัดไป)', shareCount: 'ใช้ร่วมกัน {count} คน', familyCount: '{count} ครอบครัว',
  },
  en: {
    current: 'Currently used by', past: 'Previously used by', none: 'Not in use yet',
    nextSlot: '(next course)', shareCount: 'shared by {count}', familyCount: '{count} families',
  },
  zh: {
    current: '当前使用者', past: '曾经使用', none: '尚无人使用',
    nextSlot: '（下一期课程）', shareCount: '{count} 人共用', familyCount: '{count} 个家庭',
  },
  ja: {
    current: '現在の利用者', past: '過去の利用者', none: 'まだ利用者はいません',
    nextSlot: '（次のコース）', shareCount: '{count}名で共有', familyCount: '{count}家族',
  },
  ko: {
    current: '현재 사용자', past: '이전 사용자', none: '아직 사용자가 없습니다',
    nextSlot: '(다음 수강권)', shareCount: '{count}명이 함께 사용', familyCount: '{count}가구',
  },
}
// คำอธิบายใต้ช่องเลือกคอร์ส (Student.vue → describeCourse) — เจ้าของขอให้อยู่ข้าง/ใต้ฟิลด์
// ไม่ใช่ในดร็อปดาวน์ · คำแปล zh/ja/ko สร้างด้วย AI ยังไม่ผ่านเจ้าของภาษา
const courseDescMessages = {
  th: {
    freeToUse: 'ยังไม่มีนักเรียนคนไหนใช้แพ็กเกจนี้',
    sharedWithCount: 'ใช้ร่วมกับอีก {count} คน — รวมคนนี้เป็น {count} คน',
    monthlyTakenCount: 'คอร์สรายเดือนแชร์ไม่ได้ — แพ็กเกจนี้มีผู้ใช้อยู่แล้ว {count} คน',
    capLast: 'เหลือที่ว่างที่นี่เป็นคนสุดท้าย (เพดาน {max} คน)',
    sharedWith: 'ใช้ร่วมกับ {names} — รวมคนนี้เป็น {count} คน',
    capReached: 'ครบเพดาน {max} คนแล้ว',
    monthlyTaken: 'คอร์สรายเดือนแชร์ไม่ได้ — แพ็กเกจนี้มี {names} ใช้อยู่แล้ว',
    monthlyType: 'รายเดือน (ไม่จำกัดครั้ง)',
    remaining: 'เหลือ {n} ครั้ง',
    remainingShared: 'เหลือ {n} ครั้ง (นับรวมกัน)',
    expires: 'หมดอายุ {date}',
  },
  en: {
    freeToUse: 'No student is using this package yet',
    sharedWithCount: 'Shared with {count} others — {count} in total including this student',
    monthlyTakenCount: 'Monthly courses cannot be shared — {count} student(s) already use this package',
    capLast: 'this is the last free slot (limit {max})',
    sharedWith: 'Shared with {names} — {count} in total including this student',
    capReached: 'limit of {max} reached',
    monthlyTaken: 'Monthly courses cannot be shared — {names} already uses this package',
    monthlyType: 'Monthly (unlimited)',
    remaining: '{n} sessions left',
    remainingShared: '{n} sessions left (shared pool)',
    expires: 'expires {date}',
  },
  zh: {
    freeToUse: '尚无学生使用此课程包',
    sharedWithCount: '与其他 {count} 人共用 — 含此学生共 {count} 人',
    monthlyTakenCount: '月卡不可共用 — 此课程包已有 {count} 人使用',
    capLast: '这是最后一个名额（上限 {max} 人）',
    sharedWith: '与 {names} 共用 — 含此学生共 {count} 人',
    capReached: '已达 {max} 人上限',
    monthlyTaken: '月卡不可共用 — {names} 已在使用此课程包',
    monthlyType: '月卡（不限次数）',
    remaining: '剩余 {n} 次',
    remainingShared: '剩余 {n} 次（共用）',
    expires: '{date} 到期',
  },
  ja: {
    freeToUse: 'このパッケージはまだ誰も使用していません',
    sharedWithCount: '他 {count} 名と共用 — この生徒を含めて {count} 名',
    monthlyTakenCount: '月額コースは共用できません — このパッケージは既に {count} 名が使用中です',
    capLast: '残り枠はこれが最後です（上限 {max} 名）',
    sharedWith: '{names} と共用 — この生徒を含めて {count} 名',
    capReached: '上限 {max} 名に達しました',
    monthlyTaken: '月額コースは共用できません — {names} が既に使用中です',
    monthlyType: '月額（回数無制限）',
    remaining: '残り {n} 回',
    remainingShared: '残り {n} 回（共用）',
    expires: '{date} まで',
  },
  ko: {
    freeToUse: '아직 이 수강권을 사용하는 학생이 없습니다',
    sharedWithCount: '다른 {count}명과 함께 사용 — 이 학생 포함 {count}명',
    monthlyTakenCount: '월간 수강권은 공유할 수 없습니다 — 이미 {count}명이 사용 중입니다',
    capLast: '마지막 남은 자리입니다 (최대 {max}명)',
    sharedWith: '{names} 와 함께 사용 — 이 학생 포함 {count}명',
    capReached: '최대 {max}명에 도달했습니다',
    monthlyTaken: '월간 수강권은 공유할 수 없습니다 — {names} 이(가) 이미 사용 중입니다',
    monthlyType: '월간 (횟수 무제한)',
    remaining: '{n}회 남음',
    remainingShared: '{n}회 남음 (함께 사용)',
    expires: '{date} 만료',
  },
}
// การ์ดคอร์สในหน้าแรกของผู้ปกครอง — บอกว่าใช้แพ็กเกจร่วมกับใคร
// เจ้าของเคาะ 2026-09-06: **บอกแค่ชื่อ ไม่ต้องอธิบายเรื่องโควตาต่อท้าย**
// (ร่างแรกมี "ครั้งคงเหลือนับรวมกัน" — ตัดออกเพราะ "ใช้ร่วมกับ" สื่ออยู่แล้ว)
// คำแปล zh/ja/ko สร้างด้วย AI ยังไม่ผ่านเจ้าของภาษา
const homeSharedMessages = {
  th: { sharedWith: 'ใช้ร่วมกับ {names}' },
  en: { sharedWith: 'Shared with {names}' },
  zh: { sharedWith: '与 {names} 共用' },
  ja: { sharedWith: '{names} と共用' },
  ko: { sharedWith: '{names} 와(과) 함께 사용' },
}
for (const loc of Object.keys(homeSharedMessages)) {
  messages[loc].home = Object.assign({}, messages[loc].home, homeSharedMessages[loc])
}

for (const loc of Object.keys(courseDescMessages)) {
  messages[loc].courseHolders = Object.assign({}, messages[loc].courseHolders, courseDescMessages[loc])
}

for (const loc of Object.keys(courseHoldersMessages)) {
  messages[loc].courseHolders = Object.assign({}, messages[loc].courseHolders, courseHoldersMessages[loc])
}

// ปุ่มกู้คืน (undo) แพ็กเกจในแท็บ "คอร์สที่ถูกลบ" — เจ้าของเคาะ 2026-09-08 (PR-2 lite) · CJK แปลด้วย AI
const restoreCourseMessages = {
  th: {
    restoreBtn: 'กู้คืน',
    confirmRestoreTitle: 'ยืนยันกู้คืนแพ็กเกจ',
    confirmRestore: 'ต้องการกู้คืนแพ็กเกจ {ref} ใช่หรือไม่?',
    confirmRestoreNote: 'หมายเหตุ: แพ็กเกจจะยังไม่ถูกผูกกับนักเรียนคนใด ต้องไปผูกใหม่ด้วยตนเองถ้าจำเป็น',
  },
  en: {
    restoreBtn: 'Restore',
    confirmRestoreTitle: 'Confirm restore package',
    confirmRestore: 'Restore package {ref}?',
    confirmRestoreNote: 'Note: the package will not be re-linked to any student automatically — link it manually if needed.',
  },
  zh: {
    restoreBtn: '恢复',
    confirmRestoreTitle: '确认恢复套餐',
    confirmRestore: '确定要恢复套餐 {ref} 吗？',
    confirmRestoreNote: '注意：恢复后不会自动关联到任何学生，如有需要请手动重新关联。',
  },
  ja: {
    restoreBtn: '復元',
    confirmRestoreTitle: 'パッケージの復元確認',
    confirmRestore: 'パッケージ {ref} を復元しますか？',
    confirmRestoreNote: '注意：復元後は生徒に自動で紐付けされません。必要であれば手動で紐付けしてください。',
  },
  ko: {
    restoreBtn: '복구',
    confirmRestoreTitle: '패키지 복구 확인',
    confirmRestore: '패키지 {ref}을(를) 복구하시겠습니까?',
    confirmRestoreNote: '참고: 복구 후 학생과 자동으로 연결되지 않습니다. 필요하면 직접 다시 연결하세요.',
  },
}
for (const loc of Object.keys(restoreCourseMessages)) {
  messages[loc].courseHistory = Object.assign({}, messages[loc].courseHistory, restoreCourseMessages[loc])
}

// ปุ่มยกเลิกการจบคอร์ส (undo) ในแท็บ "คอร์สที่จบแล้ว" — เจ้าของเคาะ 2026-09-10 · CJK แปลด้วย AI
const unfinishCourseMessages = {
  th: {
    unfinishBtn: 'ยกเลิกการจบคอร์ส',
    confirmUnfinishTitle: 'ยืนยันยกเลิกการจบคอร์ส',
    confirmUnfinish: 'ต้องการยกเลิกการจบคอร์สแพ็กเกจ {ref} ใช่หรือไม่?',
    confirmUnfinishNote: 'หมายเหตุ: แพ็กเกจจะยังไม่ถูกผูกกับนักเรียนคนใด ต้องไปผูกใหม่ด้วยตนเองถ้าจำเป็น',
  },
  en: {
    unfinishBtn: 'Undo finish',
    confirmUnfinishTitle: 'Confirm undo finish',
    confirmUnfinish: 'Undo finishing package {ref}?',
    confirmUnfinishNote: 'Note: the package will not be re-linked to any student automatically — link it manually if needed.',
  },
  zh: {
    unfinishBtn: '取消结课',
    confirmUnfinishTitle: '确认取消结课',
    confirmUnfinish: '确定要取消套餐 {ref} 的结课状态吗？',
    confirmUnfinishNote: '注意：取消后不会自动关联到任何学生，如有需要请手动重新关联。',
  },
  ja: {
    unfinishBtn: '修了取り消し',
    confirmUnfinishTitle: '修了取り消しの確認',
    confirmUnfinish: 'パッケージ {ref} の修了を取り消しますか？',
    confirmUnfinishNote: '注意：取り消し後は生徒に自動で紐付けされません。必要であれば手動で紐付けしてください。',
  },
  ko: {
    unfinishBtn: '종료 취소',
    confirmUnfinishTitle: '종료 취소 확인',
    confirmUnfinish: '패키지 {ref}의 종료를 취소하시겠습니까?',
    confirmUnfinishNote: '참고: 취소 후 학생과 자동으로 연결되지 않습니다. 필요하면 직접 다시 연결하세요.',
  },
}
for (const loc of Object.keys(unfinishCourseMessages)) {
  messages[loc].courseHistory = Object.assign({}, messages[loc].courseHistory, unfinishCourseMessages[loc])
}

// ลงบัญชี Peak (AccountingSync.vue) — เมนูผู้จัดการ · ACCOUNTING_SYNC_DESIGN.md
const accountingSyncMessages = {
  "th": {
    "openRun": "เปิดดูงานนี้",
    "pickNone": "ไม่เลือกทั้งหมด",
    "title": "ลงบัญชี Peak",
    "subtitle": "สร้างใบเสร็จใน Peak จากชีตรายรับทีละวัน — ดูแผนก่อน แล้วค่อยยืนยัน",
    "pickDate": "วันที่ในชีต",
    "start": "เริ่มงานบัญชี",
    "modeLabel": "สร้างใบเสร็จเป็น",
    "modeDraft": "ร่าง (Draft)",
    "modeApprove": "ใบจริง (อนุมัติแล้ว)",
    "modeDraftShort": "ร่าง",
    "modeApproveShort": "ใบจริง",
    "modeApproveWarn": "ใบจริงแก้ไขใน Peak ไม่ได้ ทำได้แค่ยกเลิก — แนะนำให้ใช้ร่างจนมั่นใจ ยืนยันเปลี่ยนเป็นใบจริง?",
    "modeDraftNote": "เปลี่ยนกลับเป็นสร้างเป็นร่าง?",
    "recentRuns": "งานล่าสุด",
    "noRuns": "ยังไม่มีงาน — เลือกวันที่แล้วกด \"เริ่มงานบัญชี\"",
    "colDate": "วันที่",
    "colStatus": "สถานะ",
    "colMode": "โหมด",
    "colResult": "ผล",
    "colCustomer": "ลูกค้า (ตามชีต)",
    "colLines": "รายการ",
    "colTotal": "ยอด",
    "colContact": "ผู้ติดต่อ Peak",
    "colNote": "หมายเหตุ",
    "runTitle": "งาน #{id} · {date}",
    "rows": "แถว",
    "setProject": "ต้องใส่โครงการ {project} เองใน Peak",
    "downloadReport": "ดาวน์โหลดรายงาน",
    "cancelRun": "ยกเลิกงาน",
    "workingNote": "ระบบกำลังทำงาน (ขั้นแรกอาจใช้ 2–5 นาที) — ปิดหน้านี้ได้ งานยังทำต่อ",
    "sheetTotal": "ยอดรวมวันในชีต",
    "sheetTotalUnreadable": "อ่านไม่ได้",
    "pickAll": "เลือกทั้งหมด",
    "createN": "สร้าง {n} ใบ แบบ{mode}",
    "nothingToCreate": "ไม่มีใบที่สร้างได้ในวันนี้",
    "confirmText": "ยืนยันสร้างใบเสร็จ {n} ใบ แบบ{mode} ของวันที่ {date} ใน Peak?",
    "custTitle": "ผู้ติดต่อที่ระบบเสนอ รอยืนยัน",
    "custNote": "ระบบจับคู่ชื่อในชีตกับผู้ติดต่อ Peak จากใบที่ลงไว้แล้ว — ใบที่ใช้ชื่อเหล่านี้จะสร้างได้ก็ต่อเมื่อผู้จัดการยืนยัน",
    "custConfirmedCount": "ยืนยันแล้ว {n} ชื่อ",
    "colSheetName": "ชื่อในชีต",
    "colPeakContact": "ผู้ติดต่อ Peak ที่เสนอ",
    "colEvidence": "อ้างอิงจาก",
    "custConflict": "ประวัติชี้ไปคนละผู้ติดต่อ — ปฏิเสธได้อย่างเดียว",
    "custConfirmN": "ยืนยัน {n} ชื่อ",
    "custRejectN": "ปฏิเสธ {n} ชื่อ",
    "custConfirmText": "ยืนยันว่า {n} ชื่อที่เลือกจับคู่ผู้ติดต่อ Peak ถูกต้อง? ใบของชื่อเหล่านี้จะสร้างได้",
    "custRejectText": "ปฏิเสธ {n} ชื่อที่เลือก? ระบบจะเลิกใช้คู่นี้ (อาจเสนอใหม่ถ้าเจอหลักฐานอีก)",
    "custReplanHint": "ยืนยันผู้ติดต่อแล้ว — งานที่รอยืนยันอยู่ยังใช้แผนเดิม ยกเลิกแล้วเริ่มงานใหม่เพื่อให้ใบเหล่านั้นสร้างได้",
    "byName": "ผู้ติดต่อจากชื่อ",
    "byNameHint": "ระบบรู้ผู้ติดต่อจากชื่อในชีตที่จำไว้เท่านั้น (ไม่มีเบอร์ยืนยัน) — ตรวจว่าเป็นคนเดียวกันแล้วติ๊กเอง ปุ่ม \"เลือกทั้งหมด\" จะไม่เลือกใบนี้ให้",
    "pickContact": "เลือกผู้ติดต่อ",
    "newContact": "สร้างผู้ติดต่อใหม่",
    "byManual": "เลือกเอง",
    "byNew": "ผู้ติดต่อใหม่",
    "byNewHint": "ระบบจะสร้างผู้ติดต่อนี้ใน Peak ตอนกดยืนยัน — ถ้าตอนนั้นมีคนใน Peak ใช้เบอร์นี้แล้ว จะไม่สร้างและไม่ลงใบนี้",
    "pickContactTitle": "เลือกผู้ติดต่อใน Peak",
    "pickContactSearch": "ค้นชื่อ เบอร์ หรือรหัส (เช่น C00565)",
    "pickContactHint": "รายชื่อจาก Peak ณ ตอนทำแผนงานนี้ · ระบบจะจำชื่อนี้ไว้ใช้ครั้งหน้าหลังสร้างใบสำเร็จ",
    "pickContactNone": "ไม่พบผู้ติดต่อที่ตรงกัน",
    "newContactTitle": "สร้างผู้ติดต่อใหม่ใน Peak",
    "newContactText": "จะสร้างผู้ติดต่อ \"{name}\" (บุคคลธรรมดา) ใน Peak ตอนกดยืนยันสร้างใบเสร็จ",
    "newContactNote": "ก่อนสร้าง ระบบจะค้นเบอร์นี้ใน Peak อีกครั้ง ถ้ามีคนใช้แล้วจะไม่สร้างซ้ำ",
    "newContactPhone": "เบอร์โทรผู้ปกครอง",
    "newContactPhonePh": "เช่น 086-959-1849 (ดูจากโน้ตในแชท LINE)",
    "pickProduct": "ระบุสินค้า",
    "productChange": "เปลี่ยนสินค้า",
    "productTitle": "ระบุสินค้าให้แถวในชีต",
    "productAmount": "ยอดสินค้า (ไม่รวมค่าธรรมเนียมบัตร)",
    "productGroupGoods": "สินค้า",
    "productGroupServices": "บริการ",
    "productSearch": "ค้นชื่อหรือรหัสสินค้า",
    "productNone": "ไม่พบสินค้าที่ตรงกัน",
    "productEmpty": "ยังไม่มีทะเบียนสินค้าจาก Peak — กด \"ทำแผนใหม่\" หนึ่งครั้งให้ระบบโหลด",
    "productQty": "จำนวน (ทีละ 0.5)",
    "productUnit": "ราคาต่อหน่วย {price}",
    "productUnitBad": "ยอดหารด้วยจำนวนนี้ไม่ลงตัวถึงสตางค์",
    "productPeakDiff": "ราคาใน Peak คือ {price} — ไม่ตรงกับยอดในชีต จึงบันทึกไม่ได้ ตรวจจำนวนหรือยอดในชีต",
    "productRemember": "จำข้อความ \"{text}\" — ครั้งหน้าระบบเลือกสินค้านี้ให้เอง (ยังตรวจยอดกับราคาทุกครั้ง)",
    "productMultiHint": "เลือกได้มากกว่า 1 รายการ เพื่อแบ่งยอดของแถวนี้เป็นหลายสินค้า (เช่น ค่าแข่งส่วน iStar + ส่วนนำส่งผู้จัดแข่ง)",
    "productLineAmount": "ยอดของรายการนี้",
    "productLineRemove": "เอารายการนี้ออก",
    "productSplitSum": "แบ่งแล้ว {sum} จาก {total}",
    "productSplitLeft": "ยังเหลือ {amount}",
    "productSplitOver": "เกินมา {amount}",
    "replan": "ทำแผนใหม่",
    "replanHint": "ระบุสินค้าแล้ว {n} แถว — กด \"ทำแผนใหม่\" ให้ระบบคิดใบเหล่านั้นใหม่",
    "replanAutoHint": "ระบุสินค้าแล้ว {n} แถว · เหลืออีก {left} แถว — ระบุครบแล้วระบบจะทำแผนใหม่ให้เอง",
    "replanText": "ยกเลิกงานนี้แล้วทำแผนวันเดิมใหม่ (ประมาณ 2 นาที)? ผู้ติดต่อที่เลือกเองในงานนี้ต้องเลือกใหม่",
    "fixTitle": "สินค้าที่ระบุเอง",
    "fixNote": "แถวในชีตที่ผู้จัดการเลือกสินค้าให้ — \"ใบนี้\" ใช้กับแถวนั้นแถวเดียว · \"จำข้อความ\" ใช้กับข้อความเดียวกันทุกครั้ง · เลือกผิดลบได้ แผนครั้งหน้าจะถามใหม่",
    "fixKindOnce": "ใบนี้",
    "fixKindRule": "จำข้อความ",
    "fixDeleteHint": "ลบ (แผนครั้งหน้าจะถามใหม่)",
    "colWhere": "ใช้กับ",
    "colSheetText": "ข้อความในชีต",
    "colProduct": "สินค้า Peak",
    "colUnitPrice": "ราคาต่อหน่วย",
    "reconTitle": "กระทบยอด statement กสิกร",
    "reconNote": "เทียบรายวัน: เงินที่เข้าบัญชี (statement + PDF ค่าธรรมเนียมบัตร) ↔ ชีตรายรับ ↔ ใบเสร็จใน Peak — อ่านอย่างเดียว ไม่เขียนอะไรลง Peak · ระบบอ่านไฟล์จากโฟลเดอร์ \"iStar ทำบัญชี\" ใน Google Drive",
    "reconCancel": "ยกเลิกงาน",
    "reconStart": "เริ่มกระทบยอด",
    "reconMonth": "เดือน",
    "reconFinished": "เสร็จเมื่อ",
    "reconResult": "ตรง {ok} วัน · ต้องตาม {bad} วัน",
    "reconRunTitle": "กระทบยอด {month}",
    "reconWorking": "ระบบกำลังอ่าน statement และเทียบยอด (ใช้เวลาไม่กี่นาที) — ปิดหน้านี้ได้ งานยังทำต่อ",
    "reconCheckedAt": "ตรวจเมื่อ {at} · ตรงทุกข้อ {ok} จาก {days} วัน",
    "reconBad": "ต้องตามแก้ ({n} วัน)",
    "reconAllGood": "ตรงทุกวัน ไม่มีอะไรต้องตาม",
    "reconExplained": "อธิบายได้ ไม่ต้องแก้ ({n} วัน)",
    "reconNotes": "หมายเหตุ",
    "reconStatus": {
      "queued": "รอคิว",
      "running": "กำลังตรวจ",
      "done": "เสร็จ",
      "failed": "มีปัญหา",
      "cancelled": "ยกเลิกแล้ว"
    },
    "reconTotal": {
      "qr_in": "เงิน QR เข้า",
      "sheet_bank": "ชีต บช.ยิม",
      "card_in": "เงินบัตรเข้า (สุทธิ)",
      "sheet_credit": "ชีต เครดิต (รวม 3%)",
      "sheet_cash": "เงินสดในชีต",
      "peak": "Peak รวม (อนุมัติแล้ว)",
      "fee": "ค่าธรรมเนียมบัตร",
      "vat": "VAT ค่าธรรมเนียม",
      "wht": "ภาษีหัก ณ ที่จ่าย",
      "groupBank": "โอน / QR: ชีตเทียบกับเงินเข้าจริง",
      "groupCard": "บัตรเครดิต: ชีตหักค่าธรรมเนียม = เงินเข้าจริง",
      "groupPeak": "Peak: ชีตทั้งหมดเทียบกับใบเสร็จ",
      "cardExpected": "ยอดที่ควรเข้าบัญชี",
      "sheetSum": "รวมทั้งชีต",
      "match": "ตรงกัน",
      "diff": "ต่างกัน {amount} — ดูรายวันด้านล่าง",
      "peakDiff": "ต่างกัน {amount} — ปกติคือเงินสดค่าคอร์ส/Private ที่ไม่ได้ลง Peak (ดูรายวันด้านล่าง)",
      "whtNote": "ภาษีหัก ณ ที่จ่าย {amount}: ธนาคารนำส่งแทน ไม่ได้หักจากเงินที่เข้าบัญชี เก็บไว้ใช้ตอนยื่นภาษี"
    },
    "status": {
      "queued": "รอคิว",
      "planning": "กำลังทำแผน",
      "awaiting_confirm": "รอยืนยัน",
      "confirmed": "ยืนยันแล้ว รอสร้าง",
      "creating": "กำลังสร้างใน Peak",
      "done": "เสร็จ",
      "failed": "มีปัญหา",
      "cancelled": "ยกเลิกแล้ว"
    },
    "item": {
      "CREATE": "สร้างได้",
      "CREATED": "สร้างแล้ว",
      "IN_PEAK": "มีใน Peak แล้ว",
      "NO_SLIP": "ไม่มีสลิป",
      "NO_CONTACT": "ไม่พบผู้ติดต่อ",
      "CONTACT_AMBIGUOUS": "ผู้ติดต่อไม่ชัด",
      "POSSIBLE_DUPLICATE": "อาจซ้ำ",
      "HELD": "ติดข้อยกเว้น",
      "FAILED": "สร้างไม่สำเร็จ",
      "CONTACT_UNCONFIRMED": "ผู้ติดต่อรอยืนยัน",
      "CHANGED": "ชีตเปลี่ยนหลังยืนยัน",
      "GONE": "ไม่พบในชีตแล้ว",
      "CREATING": "กำลังสร้าง"
    }
  },
  "en": {
    "openRun": "Open this run",
    "pickNone": "Select none",
    "title": "Peak accounting",
    "subtitle": "Create receipts in Peak from the income sheet one day at a time — review the plan, then confirm",
    "pickDate": "Sheet date",
    "start": "Start",
    "modeLabel": "Create receipts as",
    "modeDraft": "Draft",
    "modeApprove": "Approved",
    "modeDraftShort": "draft",
    "modeApproveShort": "approved",
    "modeApproveWarn": "Approved receipts cannot be edited in Peak, only voided. Keep drafts until you are sure. Switch to approved?",
    "modeDraftNote": "Switch back to drafts?",
    "recentRuns": "Recent runs",
    "noRuns": "No runs yet — pick a date and press Start",
    "colDate": "Date",
    "colStatus": "Status",
    "colMode": "Mode",
    "colResult": "Result",
    "colCustomer": "Customer (sheet)",
    "colLines": "Lines",
    "colTotal": "Total",
    "colContact": "Peak contact",
    "colNote": "Note",
    "runTitle": "Run #{id} · {date}",
    "rows": "rows",
    "setProject": "Set project {project} in Peak yourself",
    "downloadReport": "Download report",
    "cancelRun": "Cancel run",
    "workingNote": "Working (the first step can take 2–5 minutes) — you can close this page, the run continues",
    "sheetTotal": "Sheet day total",
    "sheetTotalUnreadable": "unreadable",
    "pickAll": "Select all",
    "createN": "Create {n} {mode} receipts",
    "nothingToCreate": "Nothing can be created for this day",
    "confirmText": "Create {n} {mode} receipts for {date} in Peak?",
    "custTitle": "Suggested contacts awaiting confirmation",
    "custNote": "The system matched sheet names to Peak contacts from receipts already entered — receipts using these names can only be created once a manager confirms them",
    "custConfirmedCount": "{n} names confirmed",
    "colSheetName": "Sheet name",
    "colPeakContact": "Suggested Peak contact",
    "colEvidence": "Based on",
    "custConflict": "History points to different contacts — reject only",
    "custConfirmN": "Confirm {n}",
    "custRejectN": "Reject {n}",
    "custConfirmText": "Confirm that the {n} selected names match their Peak contacts? Their receipts become creatable",
    "custRejectText": "Reject the {n} selected names? The pairing is dropped (it may be suggested again if new evidence appears)",
    "custReplanHint": "Contacts confirmed — a run awaiting confirmation still uses its old plan. Cancel it and start a new run so those receipts can be created",
    "byName": "Contact by name",
    "byNameHint": "The contact comes only from a remembered sheet name (no phone to confirm it) — check it is the same person and tick it yourself; \"Select all\" skips this receipt",
    "pickContact": "Pick contact",
    "newContact": "New contact",
    "byManual": "Picked by hand",
    "byNew": "New contact",
    "byNewHint": "This contact is created in Peak when you confirm — if someone in Peak has this phone by then, nothing is created for this receipt",
    "pickContactTitle": "Pick a Peak contact",
    "pickContactSearch": "Search name, phone or code (e.g. C00565)",
    "pickContactHint": "Contacts as of when this plan was made · the name is remembered once the receipt is created",
    "pickContactNone": "No matching contact",
    "newContactTitle": "Create a new Peak contact",
    "newContactText": "Contact \"{name}\" (individual) will be created in Peak when you confirm the receipts",
    "newContactNote": "Before creating it, the phone is searched in Peak again — an existing one is never duplicated",
    "newContactPhone": "Parent's phone",
    "newContactPhonePh": "e.g. 086-959-1849 (see the LINE chat note)",
    "pickProduct": "Set product",
    "productChange": "Change product",
    "productTitle": "Set the product for a sheet row",
    "productAmount": "Product amount (card fee excluded)",
    "productGroupGoods": "Goods",
    "productGroupServices": "Services",
    "productSearch": "Search product name or code",
    "productNone": "No matching product",
    "productEmpty": "No product list from Peak yet — press \"Re-plan\" once to load it",
    "productQty": "Quantity (steps of 0.5)",
    "productUnit": "Unit price {price}",
    "productUnitBad": "The amount does not divide into this quantity to the satang",
    "productPeakDiff": "Peak's price is {price} — it does not match the sheet amount, so this cannot be saved. Check the quantity or the sheet",
    "productRemember": "Remember \"{text}\" — next time this product is picked automatically (amount is still checked against the price)",
    "productMultiHint": "You can pick more than one item to split this row's amount across several products (e.g. iStar's share + the organiser's share of a competition fee)",
    "productLineAmount": "Amount for this item",
    "productLineRemove": "Remove this item",
    "productSplitSum": "Split {sum} of {total}",
    "productSplitLeft": "{amount} left",
    "productSplitOver": "{amount} over",
    "replan": "Re-plan",
    "replanHint": "{n} row(s) have a product set — press \"Re-plan\" to recalculate those receipts",
    "replanAutoHint": "Products set for {n} row(s) · {left} left — the plan is redone automatically once all are set",
    "replanText": "Cancel this run and plan the same day again (about 2 minutes)? Contacts picked by hand in this run must be picked again",
    "fixTitle": "Products set by hand",
    "fixNote": "Sheet rows a manager picked a product for — \"This receipt\" applies to that one row · \"Remember text\" applies to the same text every time · Delete a wrong one and the next plan asks again",
    "fixKindOnce": "This receipt",
    "fixKindRule": "Remember text",
    "fixDeleteHint": "Delete (the next plan asks again)",
    "colWhere": "Applies to",
    "colSheetText": "Sheet text",
    "colProduct": "Peak product",
    "colUnitPrice": "Unit price",
    "reconTitle": "Kasikorn statement reconciliation",
    "reconNote": "Day by day: money received (statement + card fee PDFs) ↔ income sheet ↔ Peak receipts — read-only, nothing is written to Peak · files are read from the \"iStar ทำบัญชี\" Google Drive folder",
    "reconCancel": "Cancel job",
    "reconStart": "Start reconciliation",
    "reconMonth": "Month",
    "reconFinished": "Finished",
    "reconResult": "{ok} days match · {bad} to follow up",
    "reconRunTitle": "Reconciliation {month}",
    "reconWorking": "Reading the statement and comparing (a few minutes) — you can close this page, the job continues",
    "reconCheckedAt": "Checked {at} · {ok} of {days} days fully match",
    "reconBad": "To follow up ({n} days)",
    "reconAllGood": "Every day matches — nothing to follow up",
    "reconExplained": "Explained, no action needed ({n} days)",
    "reconNotes": "Notes",
    "reconStatus": {
      "queued": "Queued",
      "running": "Checking",
      "done": "Done",
      "failed": "Problem",
      "cancelled": "Cancelled"
    },
    "reconTotal": {
      "qr_in": "QR received",
      "sheet_bank": "Sheet bank",
      "card_in": "Card received (net)",
      "sheet_credit": "Sheet card (incl. 3%)",
      "sheet_cash": "Sheet cash",
      "peak": "Peak total (approved)",
      "fee": "Card fees",
      "vat": "VAT on fees",
      "wht": "Withholding tax",
      "groupBank": "Transfer / QR: sheet vs money received",
      "groupCard": "Card: sheet minus fees = money received",
      "groupPeak": "Peak: whole sheet vs receipts",
      "cardExpected": "Should arrive",
      "sheetSum": "Sheet total",
      "match": "Matches",
      "diff": "Differs by {amount} — see the days below",
      "peakDiff": "Differs by {amount} — usually cash for courses/Private not entered in Peak (see the days below)",
      "whtNote": "Withholding tax {amount}: remitted by the bank, not deducted from the deposit; keep for tax filing"
    },
    "status": {
      "queued": "Queued",
      "planning": "Planning",
      "awaiting_confirm": "Awaiting confirmation",
      "confirmed": "Confirmed",
      "creating": "Creating in Peak",
      "done": "Done",
      "failed": "Problem",
      "cancelled": "Cancelled"
    },
    "item": {
      "CREATE": "Ready",
      "CREATED": "Created",
      "IN_PEAK": "Already in Peak",
      "NO_SLIP": "No slip",
      "NO_CONTACT": "Contact not found",
      "CONTACT_AMBIGUOUS": "Contact unclear",
      "POSSIBLE_DUPLICATE": "Possible duplicate",
      "HELD": "Held",
      "FAILED": "Failed",
      "CONTACT_UNCONFIRMED": "Contact unconfirmed",
      "CHANGED": "Sheet changed after confirm",
      "GONE": "No longer in sheet",
      "CREATING": "Creating"
    }
  },
  "zh": {
    "openRun": "查看此任务",
    "pickNone": "全不选",
    "title": "Peak 记账",
    "subtitle": "按天从收入表在 Peak 中创建收据 — 先查看计划再确认",
    "pickDate": "表格日期",
    "start": "开始",
    "modeLabel": "收据创建为",
    "modeDraft": "草稿",
    "modeApprove": "已批准",
    "modeDraftShort": "草稿",
    "modeApproveShort": "已批准",
    "modeApproveWarn": "已批准的收据在 Peak 中无法修改，只能作废。建议先用草稿。确定改为已批准？",
    "modeDraftNote": "改回草稿？",
    "recentRuns": "最近任务",
    "noRuns": "暂无任务 — 选择日期后点击开始",
    "colDate": "日期",
    "colStatus": "状态",
    "colMode": "模式",
    "colResult": "结果",
    "colCustomer": "客户（表格）",
    "colLines": "项目",
    "colTotal": "金额",
    "colContact": "Peak 联系人",
    "colNote": "备注",
    "runTitle": "任务 #{id} · {date}",
    "rows": "行",
    "setProject": "请在 Peak 中自行设置项目 {project}",
    "downloadReport": "下载报告",
    "cancelRun": "取消任务",
    "workingNote": "处理中（第一步可能需要 2–5 分钟）— 可以关闭页面，任务会继续",
    "sheetTotal": "表格当日合计",
    "sheetTotalUnreadable": "无法读取",
    "pickAll": "全选",
    "createN": "创建 {n} 张{mode}收据",
    "nothingToCreate": "当天没有可创建的收据",
    "confirmText": "确定在 Peak 中为 {date} 创建 {n} 张{mode}收据？",
    "custTitle": "系统建议的联系人（待确认）",
    "custNote": "系统根据已录入的收据将表格中的姓名与 Peak 联系人配对——使用这些姓名的收据须经经理确认后才能创建",
    "custConfirmedCount": "已确认 {n} 个姓名",
    "colSheetName": "表格姓名",
    "colPeakContact": "建议的 Peak 联系人",
    "colEvidence": "依据",
    "custConflict": "历史记录指向不同联系人——只能拒绝",
    "custConfirmN": "确认 {n} 个",
    "custRejectN": "拒绝 {n} 个",
    "custConfirmText": "确认所选 {n} 个姓名与 Peak 联系人匹配正确？这些姓名的收据将可以创建",
    "custRejectText": "拒绝所选 {n} 个姓名？系统将不再使用此配对（若出现新证据可能会再次建议）",
    "custReplanHint": "联系人已确认——待确认的任务仍使用旧计划。请取消并重新开始任务，以便创建这些收据",
    "byName": "按姓名匹配的联系人",
    "byNameHint": "联系人仅来自记住的表格姓名（没有电话号码确认）——请确认是同一人后手动勾选；“全选”不会选中此收据",
    "pickContact": "选择联系人",
    "newContact": "新建联系人",
    "byManual": "手动选择",
    "byNew": "新联系人",
    "byNewHint": "确认时才会在 Peak 中创建此联系人——如届时 Peak 中已有人使用此电话，则不创建，也不生成此收据",
    "pickContactTitle": "选择 Peak 联系人",
    "pickContactSearch": "搜索姓名、电话或编号（如 C00565）",
    "pickContactHint": "名单来自制定此计划时的 Peak · 收据创建成功后系统会记住此姓名",
    "pickContactNone": "没有匹配的联系人",
    "newContactTitle": "在 Peak 中新建联系人",
    "newContactText": "确认创建收据时，将在 Peak 中创建联系人“{name}”（个人）",
    "newContactNote": "创建前会再次在 Peak 中搜索此电话，已存在则不会重复创建",
    "newContactPhone": "家长电话",
    "newContactPhonePh": "例如 086-959-1849（见 LINE 聊天备注）",
    "pickProduct": "指定商品",
    "productChange": "更换商品",
    "productTitle": "为表格行指定商品",
    "productAmount": "商品金额（不含刷卡手续费）",
    "productGroupGoods": "商品",
    "productGroupServices": "服务",
    "productSearch": "搜索商品名称或编码",
    "productNone": "没有匹配的商品",
    "productEmpty": "尚未从 Peak 获取商品列表 — 请按一次“重新规划”以加载",
    "productQty": "数量（以 0.5 为单位）",
    "productUnit": "单价 {price}",
    "productUnitBad": "金额无法按此数量整除到分",
    "productPeakDiff": "Peak 中的价格为 {price} — 与表格金额不符，无法保存。请检查数量或表格金额",
    "productRemember": "记住“{text}” — 下次自动选择此商品（仍会核对金额与价格）",
    "productMultiHint": "可选择多个项目，将此行金额拆分为多个商品（例如比赛费用的 iStar 部分 + 代收主办方部分）",
    "productLineAmount": "此项金额",
    "productLineRemove": "移除此项",
    "productSplitSum": "已拆分 {sum} / {total}",
    "productSplitLeft": "剩余 {amount}",
    "productSplitOver": "超出 {amount}",
    "replan": "重新规划",
    "replanHint": "已为 {n} 行指定商品 — 请按“重新规划”重新计算这些收据",
    "replanAutoHint": "已指定 {n} 行商品 · 还剩 {left} 行 — 全部指定后系统会自动重新规划",
    "replanText": "取消此任务并重新规划同一天（约 2 分钟）？本任务中手动选择的联系人需要重新选择",
    "fixTitle": "手动指定的商品",
    "fixNote": "经理为表格行选择的商品 — “仅此收据”只用于该行 · “记住文字”用于每次相同的文字 · 选错可删除，下次规划会再次询问",
    "fixKindOnce": "仅此收据",
    "fixKindRule": "记住文字",
    "fixDeleteHint": "删除（下次规划会再次询问）",
    "colWhere": "适用于",
    "colSheetText": "表格文字",
    "colProduct": "Peak 商品",
    "colUnitPrice": "单价",
    "reconTitle": "开泰银行对账单核对",
    "reconNote": "按日核对：入账金额（对账单 + 刷卡手续费 PDF）↔ 收入表 ↔ Peak 收据 —— 只读，不会写入 Peak · 文件从 Google Drive 的 \"iStar ทำบัญชี\" 文件夹读取",
    "reconCancel": "取消任务",
    "reconStart": "开始核对",
    "reconMonth": "月份",
    "reconFinished": "完成时间",
    "reconResult": "一致 {ok} 天 · 需跟进 {bad} 天",
    "reconRunTitle": "核对 {month}",
    "reconWorking": "正在读取对账单并比对（需几分钟）—— 可关闭此页，任务会继续",
    "reconCheckedAt": "核对于 {at} · {days} 天中 {ok} 天完全一致",
    "reconBad": "需跟进（{n} 天）",
    "reconAllGood": "每天都一致，无需跟进",
    "reconExplained": "可解释，无需处理（{n} 天）",
    "reconNotes": "备注",
    "reconStatus": {
      "queued": "排队中",
      "running": "核对中",
      "done": "完成",
      "failed": "有问题",
      "cancelled": "已取消"
    },
    "reconTotal": {
      "qr_in": "QR 入账",
      "sheet_bank": "表格 银行转账",
      "card_in": "刷卡入账（净额）",
      "sheet_credit": "表格 信用卡（含 3%）",
      "sheet_cash": "表格 现金",
      "peak": "Peak 合计（已审批）",
      "fee": "刷卡手续费",
      "vat": "手续费增值税",
      "wht": "预扣税",
      "groupBank": "转账 / QR：表格对比实际入账",
      "groupCard": "信用卡：表格减手续费 = 实际入账",
      "groupPeak": "Peak：表格合计对比收据",
      "cardExpected": "应入账金额",
      "sheetSum": "表格合计",
      "match": "一致",
      "diff": "相差 {amount} — 请查看下方每日明细",
      "peakDiff": "相差 {amount} — 通常是未录入 Peak 的课程/私教现金（见下方每日明细）",
      "whtNote": "预扣税 {amount}：由银行代缴，不从入账中扣除，报税时使用"
    },
    "status": {
      "queued": "排队中",
      "planning": "计划中",
      "awaiting_confirm": "待确认",
      "confirmed": "已确认",
      "creating": "正在 Peak 中创建",
      "done": "完成",
      "failed": "有问题",
      "cancelled": "已取消"
    },
    "item": {
      "CREATE": "可创建",
      "CREATED": "已创建",
      "IN_PEAK": "已在 Peak 中",
      "NO_SLIP": "无转账凭证",
      "NO_CONTACT": "未找到联系人",
      "CONTACT_AMBIGUOUS": "联系人不明确",
      "POSSIBLE_DUPLICATE": "可能重复",
      "HELD": "暂缓",
      "FAILED": "创建失败",
      "CONTACT_UNCONFIRMED": "联系人待确认",
      "CHANGED": "确认后表格已更改",
      "GONE": "表格中已不存在",
      "CREATING": "正在创建"
    }
  },
  "ja": {
    "openRun": "このジョブを開く",
    "pickNone": "選択を解除",
    "title": "Peak 記帳",
    "subtitle": "収入シートから 1 日ずつ Peak に領収書を作成 — 計画を確認してから確定",
    "pickDate": "シートの日付",
    "start": "開始",
    "modeLabel": "領収書の作成方法",
    "modeDraft": "下書き",
    "modeApprove": "承認済み",
    "modeDraftShort": "下書き",
    "modeApproveShort": "承認済み",
    "modeApproveWarn": "承認済みの領収書は Peak で編集できず、取消のみ可能です。慣れるまで下書きを推奨します。承認済みに変更しますか？",
    "modeDraftNote": "下書きに戻しますか？",
    "recentRuns": "最近のジョブ",
    "noRuns": "ジョブはまだありません — 日付を選んで開始を押してください",
    "colDate": "日付",
    "colStatus": "状態",
    "colMode": "モード",
    "colResult": "結果",
    "colCustomer": "顧客（シート）",
    "colLines": "明細",
    "colTotal": "金額",
    "colContact": "Peak 取引先",
    "colNote": "備考",
    "runTitle": "ジョブ #{id} · {date}",
    "rows": "行",
    "setProject": "Peak でプロジェクト {project} を設定してください",
    "downloadReport": "レポートをダウンロード",
    "cancelRun": "ジョブを取消",
    "workingNote": "処理中（最初の段階は 2〜5 分かかることがあります）— このページを閉じても処理は続きます",
    "sheetTotal": "シートの日計",
    "sheetTotalUnreadable": "読み取れません",
    "pickAll": "すべて選択",
    "createN": "{mode}で {n} 件作成",
    "nothingToCreate": "この日に作成できる領収書はありません",
    "confirmText": "{date} の領収書 {n} 件を{mode}で Peak に作成しますか？",
    "custTitle": "システムが提案した取引先（確認待ち）",
    "custNote": "入力済みの領収書からシートの名前と Peak の取引先を照合しました。これらの名前の領収書はマネージャーが確認するまで作成できません",
    "custConfirmedCount": "確認済み {n} 件",
    "colSheetName": "シートの名前",
    "colPeakContact": "提案された Peak 取引先",
    "colEvidence": "根拠",
    "custConflict": "履歴が別の取引先を示しています — 却下のみ可能",
    "custConfirmN": "{n} 件を確認",
    "custRejectN": "{n} 件を却下",
    "custConfirmText": "選択した {n} 件の名前と Peak 取引先の対応が正しいことを確認しますか？これらの領収書が作成可能になります",
    "custRejectText": "選択した {n} 件を却下しますか？この対応は使われなくなります（新しい根拠があれば再提案される場合があります）",
    "custReplanHint": "取引先を確認しました — 確認待ちの処理は古いプランのままです。取り消して新しく開始すると、それらの領収書を作成できます",
    "byName": "名前で特定した取引先",
    "byNameHint": "取引先は記憶したシートの名前だけで特定しています（電話番号での確認なし）。同一人物か確認して手動でチェックしてください。「すべて選択」ではこの領収書は選ばれません",
    "pickContact": "取引先を選択",
    "newContact": "新しい取引先",
    "byManual": "手動で選択",
    "byNew": "新しい取引先",
    "byNewHint": "確定時に Peak でこの取引先を作成します。その時点でこの電話番号の取引先が Peak にあれば作成せず、この領収書も作りません",
    "pickContactTitle": "Peak の取引先を選択",
    "pickContactSearch": "名前・電話番号・コード（例: C00565）で検索",
    "pickContactHint": "この計画を作成した時点の Peak の一覧です · 領収書の作成後、この名前を記憶します",
    "pickContactNone": "該当する取引先がありません",
    "newContactTitle": "Peak に新しい取引先を作成",
    "newContactText": "領収書の作成を確定すると、Peak に取引先「{name}」（個人）を作成します",
    "newContactNote": "作成前にこの電話番号を Peak で再検索し、既にあれば重複して作成しません",
    "newContactPhone": "保護者の電話番号",
    "newContactPhonePh": "例: 086-959-1849（LINE チャットのメモ参照）",
    "pickProduct": "商品を指定",
    "productChange": "商品を変更",
    "productTitle": "シートの行に商品を指定",
    "productAmount": "商品金額（カード手数料を除く）",
    "productGroupGoods": "商品",
    "productGroupServices": "サービス",
    "productSearch": "商品名またはコードで検索",
    "productNone": "該当する商品がありません",
    "productEmpty": "Peak の商品一覧がまだありません — 「再計画」を一度押して読み込んでください",
    "productQty": "数量（0.5 単位）",
    "productUnit": "単価 {price}",
    "productUnitBad": "金額がこの数量で銭単位まで割り切れません",
    "productPeakDiff": "Peak の価格は {price} です — シートの金額と一致しないため保存できません。数量またはシートを確認してください",
    "productRemember": "「{text}」を記憶 — 次回からこの商品を自動で選択します（金額と価格は毎回確認します）",
    "productMultiHint": "複数の項目を選ぶと、この行の金額を複数の商品に分けられます（例：大会参加費の iStar 分 + 主催者へ納める分）",
    "productLineAmount": "この項目の金額",
    "productLineRemove": "この項目を外す",
    "productSplitSum": "{total} のうち {sum} を配分済み",
    "productSplitLeft": "残り {amount}",
    "productSplitOver": "{amount} 超過",
    "replan": "再計画",
    "replanHint": "{n} 行に商品を指定しました — 「再計画」を押してそれらの領収書を再計算してください",
    "replanAutoHint": "{n} 行の商品を指定済み · 残り {left} 行 — すべて指定すると自動で計画をやり直します",
    "replanText": "この処理を取り消して同じ日を再計画しますか（約 2 分）？この処理で手動選択した取引先は選び直しが必要です",
    "fixTitle": "手動で指定した商品",
    "fixNote": "マネージャーが商品を選んだシートの行 — 「この領収書」はその行のみ · 「文字を記憶」は同じ文字に毎回適用 · 誤りは削除でき、次回の計画で再度確認します",
    "fixKindOnce": "この領収書",
    "fixKindRule": "文字を記憶",
    "fixDeleteHint": "削除（次回の計画で再度確認）",
    "colWhere": "適用先",
    "colSheetText": "シートの文字",
    "colProduct": "Peak 商品",
    "colUnitPrice": "単価",
    "reconTitle": "カシコン銀行明細の照合",
    "reconNote": "日ごとに照合：入金（明細 + カード手数料 PDF）↔ 売上シート ↔ Peak の領収書 — 読み取りのみで Peak には書き込みません · ファイルは Google Drive の「iStar ทำบัญชี」フォルダーから読みます",
    "reconCancel": "ジョブを取消",
    "reconStart": "照合を開始",
    "reconMonth": "月",
    "reconFinished": "完了",
    "reconResult": "一致 {ok} 日 · 要確認 {bad} 日",
    "reconRunTitle": "照合 {month}",
    "reconWorking": "明細を読み取り照合中（数分）— このページを閉じても処理は続きます",
    "reconCheckedAt": "{at} に確認 · {days} 日中 {ok} 日が完全一致",
    "reconBad": "要確認（{n} 日）",
    "reconAllGood": "全日一致 — 確認事項なし",
    "reconExplained": "説明可能・対応不要（{n} 日）",
    "reconNotes": "備考",
    "reconStatus": {
      "queued": "待機中",
      "running": "照合中",
      "done": "完了",
      "failed": "問題あり",
      "cancelled": "取消"
    },
    "reconTotal": {
      "qr_in": "QR 入金",
      "sheet_bank": "シート 振込",
      "card_in": "カード入金（純額）",
      "sheet_credit": "シート カード（3% 込み）",
      "sheet_cash": "シート 現金",
      "peak": "Peak 合計（承認済み）",
      "fee": "カード手数料",
      "vat": "手数料の VAT",
      "wht": "源泉徴収税",
      "groupBank": "振込 / QR：シートと実際の入金",
      "groupCard": "カード：シート − 手数料 = 実際の入金",
      "groupPeak": "Peak：シート合計と領収書",
      "cardExpected": "入金予定額",
      "sheetSum": "シート合計",
      "match": "一致",
      "diff": "{amount} の差 — 下の日別を確認",
      "peakDiff": "{amount} の差 — 通常は Peak に入力していないコース/プライベートの現金（下の日別を確認）",
      "whtNote": "源泉徴収税 {amount}：銀行が代理納付、入金からは差し引かれません。税務申告用"
    },
    "status": {
      "queued": "待機中",
      "planning": "計画中",
      "awaiting_confirm": "確認待ち",
      "confirmed": "確定済み",
      "creating": "Peak に作成中",
      "done": "完了",
      "failed": "問題あり",
      "cancelled": "取消済み"
    },
    "item": {
      "CREATE": "作成可能",
      "CREATED": "作成済み",
      "IN_PEAK": "Peak に登録済み",
      "NO_SLIP": "振込票なし",
      "NO_CONTACT": "取引先なし",
      "CONTACT_AMBIGUOUS": "取引先が不明確",
      "POSSIBLE_DUPLICATE": "重複の可能性",
      "HELD": "保留",
      "FAILED": "作成失敗",
      "CONTACT_UNCONFIRMED": "取引先未確認",
      "CHANGED": "確認後にシート変更",
      "GONE": "シートに存在しない",
      "CREATING": "作成中"
    }
  },
  "ko": {
    "openRun": "이 작업 열기",
    "pickNone": "선택 해제",
    "title": "Peak 회계",
    "subtitle": "수입 시트에서 하루씩 Peak 영수증을 만듭니다 — 계획을 확인한 뒤 확정",
    "pickDate": "시트 날짜",
    "start": "시작",
    "modeLabel": "영수증 생성 방식",
    "modeDraft": "임시 저장",
    "modeApprove": "승인됨",
    "modeDraftShort": "임시",
    "modeApproveShort": "승인",
    "modeApproveWarn": "승인된 영수증은 Peak에서 수정할 수 없고 취소만 가능합니다. 익숙해질 때까지 임시 저장을 권장합니다. 승인으로 바꿀까요?",
    "modeDraftNote": "임시 저장으로 되돌릴까요?",
    "recentRuns": "최근 작업",
    "noRuns": "작업이 없습니다 — 날짜를 고르고 시작을 누르세요",
    "colDate": "날짜",
    "colStatus": "상태",
    "colMode": "방식",
    "colResult": "결과",
    "colCustomer": "고객(시트)",
    "colLines": "항목",
    "colTotal": "금액",
    "colContact": "Peak 거래처",
    "colNote": "메모",
    "runTitle": "작업 #{id} · {date}",
    "rows": "행",
    "setProject": "Peak에서 프로젝트 {project}를 직접 지정하세요",
    "downloadReport": "보고서 다운로드",
    "cancelRun": "작업 취소",
    "workingNote": "처리 중(첫 단계는 2~5분 걸릴 수 있음) — 페이지를 닫아도 작업은 계속됩니다",
    "sheetTotal": "시트 일 합계",
    "sheetTotalUnreadable": "읽을 수 없음",
    "pickAll": "모두 선택",
    "createN": "{mode} 영수증 {n}건 만들기",
    "nothingToCreate": "이 날짜에 만들 수 있는 영수증이 없습니다",
    "confirmText": "{date}의 영수증 {n}건을 {mode}(으)로 Peak에 만들까요?",
    "custTitle": "시스템이 제안한 거래처 (확인 대기)",
    "custNote": "이미 입력된 영수증을 근거로 시트 이름과 Peak 거래처를 짝지었습니다 — 이 이름의 영수증은 관리자가 확인해야 생성할 수 있습니다",
    "custConfirmedCount": "확인됨 {n}개",
    "colSheetName": "시트 이름",
    "colPeakContact": "제안된 Peak 거래처",
    "colEvidence": "근거",
    "custConflict": "기록이 서로 다른 거래처를 가리킵니다 — 거부만 가능",
    "custConfirmN": "{n}개 확인",
    "custRejectN": "{n}개 거부",
    "custConfirmText": "선택한 {n}개 이름이 Peak 거래처와 맞다고 확인할까요? 해당 영수증을 생성할 수 있게 됩니다",
    "custRejectText": "선택한 {n}개 이름을 거부할까요? 이 짝은 더 이상 사용되지 않습니다 (새 근거가 있으면 다시 제안될 수 있음)",
    "custReplanHint": "거래처를 확인했습니다 — 확인 대기 중인 작업은 이전 계획을 그대로 씁니다. 취소 후 새로 시작해야 해당 영수증을 생성할 수 있습니다",
    "byName": "이름으로 찾은 거래처",
    "byNameHint": "거래처를 기억된 시트 이름으로만 찾았습니다(전화번호 확인 없음) — 같은 사람인지 확인한 뒤 직접 체크하세요. \"모두 선택\"은 이 영수증을 선택하지 않습니다",
    "pickContact": "거래처 선택",
    "newContact": "새 거래처",
    "byManual": "직접 선택",
    "byNew": "새 거래처",
    "byNewHint": "확정할 때 Peak에 이 거래처를 만듭니다. 그때 이 전화번호를 쓰는 거래처가 Peak에 있으면 만들지 않고 이 영수증도 만들지 않습니다",
    "pickContactTitle": "Peak 거래처 선택",
    "pickContactSearch": "이름, 전화번호 또는 코드(예: C00565) 검색",
    "pickContactHint": "이 계획을 만들 때의 Peak 목록입니다 · 영수증이 만들어지면 이 이름을 기억합니다",
    "pickContactNone": "일치하는 거래처가 없습니다",
    "newContactTitle": "Peak에 새 거래처 만들기",
    "newContactText": "영수증 생성을 확정하면 Peak에 거래처 \"{name}\"(개인)을 만듭니다",
    "newContactNote": "만들기 전에 이 전화번호를 Peak에서 다시 검색하며, 이미 있으면 중복으로 만들지 않습니다",
    "newContactPhone": "보호자 전화번호",
    "newContactPhonePh": "예: 086-959-1849 (LINE 채팅 메모 참고)",
    "pickProduct": "상품 지정",
    "productChange": "상품 변경",
    "productTitle": "시트 행에 상품 지정",
    "productAmount": "상품 금액 (카드 수수료 제외)",
    "productGroupGoods": "상품",
    "productGroupServices": "서비스",
    "productSearch": "상품명 또는 코드 검색",
    "productNone": "일치하는 상품이 없습니다",
    "productEmpty": "Peak 상품 목록이 아직 없습니다 — \"다시 계획\"을 한 번 눌러 불러오세요",
    "productQty": "수량 (0.5 단위)",
    "productUnit": "단가 {price}",
    "productUnitBad": "금액이 이 수량으로 사땅 단위까지 나누어지지 않습니다",
    "productPeakDiff": "Peak 가격은 {price}입니다 — 시트 금액과 맞지 않아 저장할 수 없습니다. 수량 또는 시트를 확인하세요",
    "productRemember": "\"{text}\" 기억 — 다음부터 이 상품을 자동으로 선택합니다 (금액과 가격은 매번 확인)",
    "productMultiHint": "여러 항목을 선택해 이 행의 금액을 여러 상품으로 나눌 수 있습니다 (예: 대회 참가비의 iStar 몫 + 주최 측 전달분)",
    "productLineAmount": "이 항목 금액",
    "productLineRemove": "이 항목 빼기",
    "productSplitSum": "{total} 중 {sum} 배분",
    "productSplitLeft": "{amount} 남음",
    "productSplitOver": "{amount} 초과",
    "replan": "다시 계획",
    "replanHint": "{n}개 행에 상품을 지정했습니다 — \"다시 계획\"을 눌러 해당 영수증을 다시 계산하세요",
    "replanAutoHint": "{n}개 행 상품 지정 완료 · {left}개 남음 — 모두 지정하면 자동으로 다시 계획합니다",
    "replanText": "이 작업을 취소하고 같은 날을 다시 계획할까요 (약 2분)? 이 작업에서 직접 선택한 거래처는 다시 선택해야 합니다",
    "fixTitle": "직접 지정한 상품",
    "fixNote": "관리자가 상품을 고른 시트 행 — \"이 영수증\"은 그 행에만 · \"문구 기억\"은 같은 문구에 매번 적용 · 잘못 고른 것은 삭제하면 다음 계획에서 다시 묻습니다",
    "fixKindOnce": "이 영수증",
    "fixKindRule": "문구 기억",
    "fixDeleteHint": "삭제 (다음 계획에서 다시 묻기)",
    "colWhere": "적용 대상",
    "colSheetText": "시트 문구",
    "colProduct": "Peak 상품",
    "colUnitPrice": "단가",
    "reconTitle": "카시콘 은행 명세서 대사",
    "reconNote": "일별 대사: 입금액(명세서 + 카드 수수료 PDF) ↔ 매출 시트 ↔ Peak 영수증 — 읽기 전용, Peak에 아무것도 쓰지 않습니다 · 파일은 Google Drive의 \"iStar ทำบัญชี\" 폴더에서 읽습니다",
    "reconCancel": "작업 취소",
    "reconStart": "대사 시작",
    "reconMonth": "월",
    "reconFinished": "완료 시각",
    "reconResult": "일치 {ok}일 · 확인 필요 {bad}일",
    "reconRunTitle": "대사 {month}",
    "reconWorking": "명세서를 읽고 비교하는 중(몇 분 소요) — 이 페이지를 닫아도 작업은 계속됩니다",
    "reconCheckedAt": "{at} 확인 · {days}일 중 {ok}일 완전 일치",
    "reconBad": "확인 필요 ({n}일)",
    "reconAllGood": "모든 날짜가 일치 — 확인할 항목 없음",
    "reconExplained": "설명 가능, 조치 불필요 ({n}일)",
    "reconNotes": "비고",
    "reconStatus": {
      "queued": "대기 중",
      "running": "확인 중",
      "done": "완료",
      "failed": "문제 있음",
      "cancelled": "취소됨"
    },
    "reconTotal": {
      "qr_in": "QR 입금",
      "sheet_bank": "시트 계좌이체",
      "card_in": "카드 입금(순액)",
      "sheet_credit": "시트 카드(3% 포함)",
      "sheet_cash": "시트 현금",
      "peak": "Peak 합계(승인됨)",
      "fee": "카드 수수료",
      "vat": "수수료 VAT",
      "wht": "원천징수세",
      "groupBank": "이체 / QR: 시트 vs 실제 입금",
      "groupCard": "카드: 시트 − 수수료 = 실제 입금",
      "groupPeak": "Peak: 시트 합계 vs 영수증",
      "cardExpected": "입금 예정액",
      "sheetSum": "시트 합계",
      "match": "일치",
      "diff": "{amount} 차이 — 아래 일별 내역 확인",
      "peakDiff": "{amount} 차이 — 보통 Peak에 입력하지 않은 코스/개인레슨 현금 (아래 일별 내역 확인)",
      "whtNote": "원천징수세 {amount}: 은행이 대신 납부, 입금액에서 차감되지 않음. 세금 신고용"
    },
    "status": {
      "queued": "대기",
      "planning": "계획 중",
      "awaiting_confirm": "확인 대기",
      "confirmed": "확정됨",
      "creating": "Peak에 생성 중",
      "done": "완료",
      "failed": "문제 있음",
      "cancelled": "취소됨"
    },
    "item": {
      "CREATE": "생성 가능",
      "CREATED": "생성됨",
      "IN_PEAK": "이미 Peak에 있음",
      "NO_SLIP": "이체 증빙 없음",
      "NO_CONTACT": "거래처 없음",
      "CONTACT_AMBIGUOUS": "거래처 불명확",
      "POSSIBLE_DUPLICATE": "중복 가능",
      "HELD": "보류",
      "FAILED": "생성 실패",
      "CONTACT_UNCONFIRMED": "거래처 확인 대기",
      "CHANGED": "확인 후 시트 변경됨",
      "GONE": "시트에 더 이상 없음",
      "CREATING": "생성 중"
    }
  }
}
for (const loc of Object.keys(accountingSyncMessages)) {
  messages[loc].accountingSync = accountingSyncMessages[loc]
}
messages.th.nav.accountingSync = "ลงบัญชี Peak"
messages.en.nav.accountingSync = "Peak accounting"
messages.zh.nav.accountingSync = "Peak 记账"
messages.ja.nav.accountingSync = "Peak 記帳"
messages.ko.nav.accountingSync = "Peak 회계"

// ปุ่ม ↗ เปิดหน้าเมนูในหน้าต่างแยก (App.vue popOut) — 2026-10-07 · CJK แปลด้วย AI
messages.th.nav.popOut = "เปิดในหน้าต่างแยก"
messages.en.nav.popOut = "Open in a separate window"
messages.zh.nav.popOut = "在新窗口中打开"
messages.ja.nav.popOut = "別ウィンドウで開く"
messages.ko.nav.popOut = "새 창에서 열기"

export const i18nState = reactive({
  locale: localStorage.getItem('istar_locale') || 'th',
})

export const LOCALES = [
  { code: 'th', native: 'ไทย' },
  { code: 'en', native: 'English' },
  { code: 'zh', native: '中文' },
  { code: 'ja', native: '日本語' },
  { code: 'ko', native: '한국어' },
]

export function setLocale(lang) {
  i18nState.locale = lang
  localStorage.setItem('istar_locale', lang)
}

export function t(key, params) {
  const keys = key.split('.')
  let result = messages[i18nState.locale]
  for (const k of keys) {
    if (result == null) return key
    result = result[k]
  }
  if (result != null && params) {
    return result.replace(/\{(\w+)\}/g, (_, k) => (params[k] !== undefined ? params[k] : ''))
  }
  return result != null ? result : key
}

// ไทม์ไลน์การใช้คอร์ส (CourseUsageTimeline.vue) + คอลัมน์ "จองโดย" (BookedByCell.vue)
// CJK แปลด้วย AI ควรให้เจ้าของภาษาตรวจ
const courseUsageMessages = {
  th: {
    title: 'การใช้คอร์ส', filterAll: 'ทั้งหมด', filterLive: 'ใบที่ยังใช้อยู่', empty: 'ยังไม่มีการใช้คอร์สนี้',
    book: 'จอง', move: 'ย้ายวัน', cancel: 'ยกเลิก', checkin: 'เช็คชื่อ', checkinUndo: 'ยกเลิกเช็คชื่อ', event: 'ลงอีเวนต์',
    free: 'ฟรี', bookedBy: 'จองโดย',
    since: 'การยกเลิก/ย้ายวัน/เช็คชื่อ มีให้ดูตั้งแต่ปลาย ก.ค. 2569 · อีเวนต์ที่ยกเลิกแล้วไม่แสดง',
  },
  en: {
    title: 'Course usage', filterAll: 'All', filterLive: 'Active bookings', empty: 'This course has not been used yet',
    book: 'Booked', move: 'Moved', cancel: 'Cancelled', checkin: 'Checked in', checkinUndo: 'Check-in undone', event: 'Event sign-up',
    free: 'Free', bookedBy: 'Booked by',
    since: 'Cancellations, moves and check-ins are available from late July 2026 · cancelled event sign-ups are not shown',
  },
  zh: {
    title: '课程使用记录', filterAll: '全部', filterLive: '有效预约', empty: '此课程尚未使用',
    book: '预约', move: '改期', cancel: '取消', checkin: '签到', checkinUndo: '撤销签到', event: '活动报名',
    free: '免费', bookedBy: '预约人',
    since: '取消/改期/签到记录自 2026 年 7 月底起可查 · 已取消的活动报名不显示',
  },
  ja: {
    title: 'コース利用履歴', filterAll: 'すべて', filterLive: '有効な予約', empty: 'このコースはまだ利用されていません',
    book: '予約', move: '日程変更', cancel: 'キャンセル', checkin: '出席', checkinUndo: '出席取消', event: 'イベント参加',
    free: '無料', bookedBy: '予約者',
    since: 'キャンセル・日程変更・出席は 2026 年 7 月下旬以降のみ表示 · キャンセル済みのイベント参加は表示されません',
  },
  ko: {
    title: '코스 이용 내역', filterAll: '전체', filterLive: '유효한 예약', empty: '아직 이 코스를 이용하지 않았습니다',
    book: '예약', move: '일정 변경', cancel: '취소', checkin: '출석', checkinUndo: '출석 취소', event: '이벤트 참가',
    free: '무료', bookedBy: '예약자',
    since: '취소/일정 변경/출석 내역은 2026년 7월 말부터 제공 · 취소된 이벤트 참가는 표시되지 않음',
  },
}
for (const loc of Object.keys(courseUsageMessages)) {
  messages[loc].courseUsage = Object.assign({}, messages[loc].courseUsage, courseUsageMessages[loc])
}

// ลงบัญชี Peak: ผู้จัดการยืนยันสลิป LINE ของผู้ส่งที่ระบบยังไม่รู้จัก (เจ้าของเห็นด้วย 2026-10-16)
// zh/ja/ko แปลด้วย AI — ควรให้เจ้าของภาษาตรวจ
const accountingLineSlipMessages = {
  th: {
    lineSlipBtn: 'ยืนยันสลิป LINE ({n})',
    lineSlipTitle: 'ยืนยันสลิปจาก LINE',
    lineSlipNote: 'สลิปด้านล่างยอดตรงและส่งมาห่างไม่เกิน 1 วัน แต่ระบบยังไม่รู้ว่าผู้ส่งเป็นใคร — ดูชื่อผู้โอนในรูปให้แน่ใจว่าเป็นของลูกค้ารายนี้ก่อนกดยืนยัน',
    lineSlipEffect: 'ยืนยันแล้ว ระบบจะจำผู้ส่ง LINE นี้กับครอบครัวของผู้ติดต่อที่เลือก ครั้งต่อไปจับคู่ให้เอง (ถ้าเบอร์ผู้ติดต่อไม่ตรงบัญชีผู้ปกครองในแอป จะไม่จำผู้ส่ง ครั้งหน้าต้องยืนยันเอง) · แถวนี้จะเป็น "สร้างได้" แต่ต้องติ๊กเองก่อนสร้าง',
    lineSlipSent: 'ส่งใน LINE {at}',
    lineSlipUse: 'ใช่ สลิปนี้',
    lineSlipNoImage: 'เปิดรูปไม่ได้',
    lineSlipDownload: 'ดาวน์โหลดสลิป',
    lineSlipDownloadFail: 'ดาวน์โหลดสลิปไม่สำเร็จ ลองใหม่อีกครั้ง',
    lineSlipOpenFull: 'เปิดรูปขนาดเต็ม',
  },
  en: {
    lineSlipBtn: 'Confirm LINE slip ({n})',
    lineSlipTitle: 'Confirm a slip from LINE',
    lineSlipNote: 'These slips have the right amount and were sent within 1 day, but the sender is not known yet — check that the payer name on the image is this customer before confirming.',
    lineSlipEffect: "Once confirmed, this LINE sender is remembered for the chosen contact's family and matched automatically next time (if the contact's phone matches no parent account in the app, the sender is not remembered and you confirm again next time) · the row becomes creatable, but you tick it yourself.",
    lineSlipSent: 'Sent on LINE {at}',
    lineSlipUse: 'Yes, this slip',
    lineSlipNoImage: 'Image unavailable',
    lineSlipDownload: 'Download slip',
    lineSlipDownloadFail: 'Could not download the slip. Please try again.',
    lineSlipOpenFull: 'Open full size',
  },
  zh: {
    lineSlipBtn: '确认 LINE 转账单 ({n})',
    lineSlipTitle: '确认来自 LINE 的转账单',
    lineSlipNote: '以下转账单金额相符且在 1 天内发送，但系统尚不认识发送者 — 请先核对图片中的付款人是否为该客户再确认。',
    lineSlipEffect: '确认后，系统会将此 LINE 发送者记为所选联系人的家庭，下次自动匹配（若联系人的手机号与应用中的任何家长账户都不符，则不会记住发送者，下次需再次确认）· 该行将变为可创建，但需自行勾选。',
    lineSlipSent: 'LINE 发送于 {at}',
    lineSlipUse: '是，就是这张',
    lineSlipNoImage: '无法打开图片',
    lineSlipDownload: '下载转账单',
    lineSlipDownloadFail: '下载转账单失败，请重试',
    lineSlipOpenFull: '查看原图',
  },
  ja: {
    lineSlipBtn: 'LINE の振込明細を確認 ({n})',
    lineSlipTitle: 'LINE の振込明細を確認',
    lineSlipNote: '以下の明細は金額が一致し 1 日以内に送信されていますが、送信者がまだ不明です。画像の振込人がこの顧客であることを確認してから確定してください。',
    lineSlipEffect: '確定すると、この LINE 送信者を選択した取引先の家族として記憶し、次回から自動で照合します（取引先の電話番号がアプリ内のどの保護者アカウントとも一致しない場合は送信者を記憶せず、次回も確認が必要です）· 行は作成可能になりますが、チェックはご自身で入れてください。',
    lineSlipSent: 'LINE 送信 {at}',
    lineSlipUse: 'この明細です',
    lineSlipNoImage: '画像を開けません',
    lineSlipDownload: '明細をダウンロード',
    lineSlipDownloadFail: '明細をダウンロードできませんでした。もう一度お試しください。',
    lineSlipOpenFull: '原寸で開く',
  },
  ko: {
    lineSlipBtn: 'LINE 이체 영수증 확인 ({n})',
    lineSlipTitle: 'LINE 이체 영수증 확인',
    lineSlipNote: '아래 영수증은 금액이 맞고 1일 이내에 전송되었지만 보낸 사람을 아직 알 수 없습니다 — 이미지의 송금인이 이 고객인지 확인한 뒤 확정하세요.',
    lineSlipEffect: '확정하면 이 LINE 발신자를 선택한 거래처의 가족으로 기억하고 다음부터 자동으로 매칭합니다 (거래처 전화번호가 앱의 어떤 보호자 계정과도 맞지 않으면 발신자를 기억하지 않으며 다음에도 직접 확인해야 합니다) · 이 행은 생성 가능 상태가 되지만 체크는 직접 해야 합니다.',
    lineSlipSent: 'LINE 전송 {at}',
    lineSlipUse: '네, 이 영수증',
    lineSlipNoImage: '이미지를 열 수 없음',
    lineSlipDownload: '영수증 다운로드',
    lineSlipDownloadFail: '영수증을 다운로드하지 못했습니다. 다시 시도해 주세요.',
    lineSlipOpenFull: '원본 크기로 열기',
  },
}
for (const loc of Object.keys(accountingLineSlipMessages)) {
  messages[loc].accountingSync = Object.assign({}, messages[loc].accountingSync, accountingLineSlipMessages[loc])
}

// leave-request attachment (medical certificate etc.) — CJK translations are AI-produced, native review advised
const leaveAttachMessages = {
  th: {
    leaveAttach: 'ไฟล์แนบ เช่น ใบรับรองแพทย์ (ไม่บังคับ)', leaveAttachPick: 'เลือกรูปภาพหรือไฟล์ PDF',
    leaveAttachHint: 'JPG / PNG / GIF / PDF ไม่เกิน 5MB · แนบได้ 1 ไฟล์', leaveAttachRemove: 'เอาไฟล์ออก',
    leaveAttachView: 'ไฟล์แนบ', leaveAttachTooBig: 'ไฟล์แนบใหญ่เกิน 5MB', leaveAttachBadType: 'แนบได้เฉพาะรูปภาพ (JPG/PNG/GIF) หรือ PDF',
  },
  en: {
    leaveAttach: 'Attachment, e.g. medical certificate (optional)', leaveAttachPick: 'Choose an image or PDF',
    leaveAttachHint: 'JPG / PNG / GIF / PDF, up to 5MB · one file', leaveAttachRemove: 'Remove file',
    leaveAttachView: 'Attachment', leaveAttachTooBig: 'The attachment is larger than 5MB', leaveAttachBadType: 'Only images (JPG/PNG/GIF) or PDF can be attached',
  },
  zh: {
    leaveAttach: '附件，如医疗证明（可选）', leaveAttachPick: '选择图片或 PDF',
    leaveAttachHint: 'JPG / PNG / GIF / PDF，不超过 5MB · 限 1 个文件', leaveAttachRemove: '移除文件',
    leaveAttachView: '附件', leaveAttachTooBig: '附件超过 5MB', leaveAttachBadType: '只能附加图片（JPG/PNG/GIF）或 PDF',
  },
  ja: {
    leaveAttach: '添付ファイル（診断書など・任意）', leaveAttachPick: '画像または PDF を選択',
    leaveAttachHint: 'JPG / PNG / GIF / PDF、5MB まで · 1 ファイル', leaveAttachRemove: 'ファイルを外す',
    leaveAttachView: '添付', leaveAttachTooBig: '添付ファイルが 5MB を超えています', leaveAttachBadType: '添付できるのは画像（JPG/PNG/GIF）または PDF のみです',
  },
  ko: {
    leaveAttach: '첨부 파일, 예: 진단서 (선택)', leaveAttachPick: '이미지 또는 PDF 선택',
    leaveAttachHint: 'JPG / PNG / GIF / PDF, 5MB 이하 · 파일 1개', leaveAttachRemove: '파일 제거',
    leaveAttachView: '첨부', leaveAttachTooBig: '첨부 파일이 5MB를 초과합니다', leaveAttachBadType: '이미지(JPG/PNG/GIF) 또는 PDF만 첨부할 수 있습니다',
  },
}
for (const loc of Object.keys(leaveAttachMessages)) {
  messages[loc].grouping = Object.assign({}, messages[loc].grouping, leaveAttachMessages[loc])
}

// organizer remittance log (EventManager) — CJK translations are AI-produced, native review advised
const organizerRemitMessages = {
  th: {
    title: 'บันทึกนำส่งเงินผู้จัด', hint: 'โอนเงินจริงทำที่ธนาคาร ที่นี่เก็บเฉพาะบันทึกว่านำส่งแล้ว — มีผู้สมัครเพิ่มภายหลังแล้วโอนรอบสอง ให้บันทึกเพิ่มอีกรายการ',
    collected: 'เก็บแทนผู้จัดแล้ว', remitted: 'นำส่งแล้ว', outstanding: 'ค้างนำส่ง',
    history: 'ประวัติการนำส่ง', none: 'ยังไม่เคยบันทึกการนำส่ง', add: 'บันทึกการนำส่งครั้งใหม่',
    amount: 'ยอดที่นำส่ง', date: 'วันที่โอน', note: 'หมายเหตุ (ไม่บังคับ)', notePh: 'เช่น โอนรอบแรก / รอบสอง (สมัครช้า)',
    save: 'บันทึกนำส่ง', allDone: 'นำส่งครบแล้ว ไม่มียอดค้าง', by: 'โดย {name}',
    confirmDelete: 'ลบรายการนำส่ง {amount} บาท ({date}) ใช่หรือไม่? ยอดค้างนำส่งจะกลับมา',
    colHeader: 'นำส่งผู้จัด',
    overpaid: 'นำส่งเกินยอดที่เก็บไว้ {amount} — มีใบที่ถูกยกเลิก/คืนเงินหลังนำส่งไปแล้ว ควรติดต่อผู้จัดขอเงินคืนหรือหักรอบหน้า',
  },
  en: {
    title: 'Organizer remittance log', hint: 'The transfer itself is made at the bank; this only records that it was sent. If late sign-ups lead to a second transfer, add another entry.',
    collected: 'Collected for organizer', remitted: 'Remitted', outstanding: 'Outstanding',
    history: 'Remittance history', none: 'No remittance recorded yet', add: 'Record a new remittance',
    amount: 'Amount remitted', date: 'Transfer date', note: 'Note (optional)', notePh: 'e.g. first transfer / second transfer (late sign-ups)',
    save: 'Record remittance', allDone: 'Fully remitted — nothing outstanding', by: 'by {name}',
    confirmDelete: 'Delete the remittance of {amount} THB ({date})? The outstanding amount will come back.',
    colHeader: 'Organizer remit',
    overpaid: 'Remitted {amount} more than is now collected — a registration was cancelled/refunded after the transfer. Ask the organizer for a refund or deduct it next time.',
  },
  zh: {
    title: '主办方汇款记录', hint: '实际转账在银行完成，这里只记录已汇出。若有人晚报名而需第二次汇款，请再添加一笔记录。',
    collected: '已代收主办方款项', remitted: '已汇出', outstanding: '待汇出',
    history: '汇款历史', none: '尚无汇款记录', add: '记录新的汇款',
    amount: '汇款金额', date: '转账日期', note: '备注（可选）', notePh: '例如：第一次汇款 / 第二次（晚报名）',
    save: '记录汇款', allDone: '已全部汇出，无待汇金额', by: '由 {name}',
    confirmDelete: '删除 {amount} 泰铢（{date}）的汇款记录吗？待汇金额将恢复。',
    colHeader: '汇款主办方',
    overpaid: '汇出金额比现收款多 {amount} — 汇款后有报名被取消/退款。请向主办方要求退还或下次扣除。',
  },
  ja: {
    title: '主催者への送金記録', hint: '実際の送金は銀行で行い、ここでは送金済みの記録のみ残します。遅れて申込があり2回目の送金をする場合は、記録を追加してください。',
    collected: '主催者分の預かり', remitted: '送金済み', outstanding: '未送金',
    history: '送金履歴', none: 'まだ送金記録がありません', add: '新しい送金を記録',
    amount: '送金額', date: '送金日', note: 'メモ（任意）', notePh: '例：1回目 / 2回目（遅れての申込）',
    save: '送金を記録', allDone: '全額送金済み — 未送金なし', by: '{name} による',
    confirmDelete: '{amount} バーツ（{date}）の送金記録を削除しますか？未送金額が元に戻ります。',
    colHeader: '主催者送金',
    overpaid: '現在の預かり額より {amount} 多く送金済み — 送金後に申込がキャンセル/返金されました。主催者に返金を依頼するか次回に差し引いてください。',
  },
  ko: {
    title: '주최자 송금 기록', hint: '실제 송금은 은행에서 하고, 여기에는 송금 완료 기록만 남깁니다. 늦게 신청한 사람이 있어 두 번째 송금을 하면 기록을 추가하세요.',
    collected: '주최자 대신 수금', remitted: '송금 완료', outstanding: '미송금',
    history: '송금 내역', none: '송금 기록이 아직 없습니다', add: '새 송금 기록',
    amount: '송금액', date: '송금일', note: '메모 (선택)', notePh: '예: 1차 송금 / 2차(늦은 신청)',
    save: '송금 기록', allDone: '전액 송금 완료 — 미송금 없음', by: '{name} 님',
    confirmDelete: '{amount} 바트({date}) 송금 기록을 삭제할까요? 미송금액이 다시 늘어납니다.',
    colHeader: '주최자 송금',
    overpaid: '현재 수금액보다 {amount} 더 송금됨 — 송금 후 신청이 취소/환불되었습니다. 주최자에게 환불을 요청하거나 다음 송금에서 차감하세요.',
  },
}
for (const loc of Object.keys(organizerRemitMessages)) {
  messages[loc].evRemit = Object.assign({}, messages[loc].evRemit, organizerRemitMessages[loc])
}

// parent self-cancel of a group booking (Home.vue → /cancelBookingByCustomer, 2026-10-24)
// cancelBlock.* keys mirror the backend's customerCancelBlock() reason codes.
// CJK translations are AI-produced; a native speaker should review them.
const homeCancelMessages = {
  th: {
    cancelBooking: 'ยกเลิก', cancelTitle: 'ยกเลิกการจอง',
    cancelConfirm: 'ยกเลิกการจองของ {name} วันที่ {date} เวลา {time} ใช่ไหม?',
    cancelRefund: 'ระบบจะคืนครั้งเรียน 1 ครั้งเข้าคอร์สให้อัตโนมัติ',
    cancelDone: 'ยกเลิกการจองเรียบร้อยแล้ว',
    cancelBlock: {
      checkedin: 'เช็คชื่อแล้ว ยกเลิกไม่ได้',
      event: 'ใบลงชื่ออีเวนต์ — ติดต่อเจ้าหน้าที่เพื่อยกเลิก',
      free: 'ใบนี้ไม่ได้ใช้คอร์ส — ติดต่อเจ้าหน้าที่เพื่อยกเลิก',
      noPackage: 'ไม่พบคอร์สของใบนี้ — ติดต่อเจ้าหน้าที่',
      trial: 'ใบทดลองเรียน — ติดต่อเจ้าหน้าที่เพื่อยกเลิก',
      perSession: 'ใบเรียนรายครั้ง — ติดต่อเจ้าหน้าที่เพื่อยกเลิก',
      finished: 'คอร์สนี้จบแล้ว — ติดต่อเจ้าหน้าที่',
      deadline: 'ยกเลิกเองได้ถึง 22:00 น. ของวันก่อนวันเรียน — ติดต่อเจ้าหน้าที่',
      notFound: 'ไม่พบใบจองนี้แล้ว (อาจถูกยกเลิกไปแล้ว)',
      legacyEvent: 'อีเวนต์รุ่นเก่า — ติดต่อเจ้าหน้าที่',
    },
  },
  en: {
    cancelBooking: 'Cancel', cancelTitle: 'Cancel booking',
    cancelConfirm: 'Cancel {name}\'s booking on {date} at {time}?',
    cancelRefund: '1 session will be returned to the course automatically',
    cancelDone: 'Booking cancelled',
    cancelBlock: {
      checkedin: 'Already checked in — cannot be cancelled',
      event: 'Event sign-up — please contact staff to cancel',
      free: 'This booking does not use a course — please contact staff to cancel',
      noPackage: 'Course not found for this booking — please contact staff',
      trial: 'Trial class — please contact staff to cancel',
      perSession: 'Single-session booking — please contact staff to cancel',
      finished: 'This course has finished — please contact staff',
      deadline: 'Self-cancel is open until 22:00 the day before class — please contact staff',
      notFound: 'This booking no longer exists (it may already be cancelled)',
      legacyEvent: 'Legacy event — please contact staff',
    },
  },
  zh: {
    cancelBooking: '取消', cancelTitle: '取消预约',
    cancelConfirm: '确定取消 {name} 在 {date} {time} 的预约吗？',
    cancelRefund: '系统将自动把 1 次课时退回课程',
    cancelDone: '预约已取消',
    cancelBlock: {
      checkedin: '已签到，无法取消',
      event: '赛事报名 — 请联系工作人员取消',
      free: '此预约未使用课程 — 请联系工作人员取消',
      noPackage: '找不到此预约的课程 — 请联系工作人员',
      trial: '体验课 — 请联系工作人员取消',
      perSession: '单次课预约 — 请联系工作人员取消',
      finished: '此课程已结束 — 请联系工作人员',
      deadline: '可自行取消至上课前一天 22:00 — 请联系工作人员',
      notFound: '找不到此预约（可能已被取消）',
      legacyEvent: '旧版赛事 — 请联系工作人员',
    },
  },
  ja: {
    cancelBooking: 'キャンセル', cancelTitle: '予約をキャンセル',
    cancelConfirm: '{name} の {date} {time} の予約をキャンセルしますか？',
    cancelRefund: 'コースに 1 回分が自動で戻ります',
    cancelDone: '予約をキャンセルしました',
    cancelBlock: {
      checkedin: '出席済みのためキャンセルできません',
      event: 'イベント申込 — キャンセルはスタッフにご連絡ください',
      free: 'コースを使わない予約です — キャンセルはスタッフにご連絡ください',
      noPackage: 'この予約のコースが見つかりません — スタッフにご連絡ください',
      trial: '体験レッスン — キャンセルはスタッフにご連絡ください',
      perSession: '単発レッスン — キャンセルはスタッフにご連絡ください',
      finished: 'このコースは終了しています — スタッフにご連絡ください',
      deadline: 'ご自身でのキャンセルはレッスン前日 22:00 まで — スタッフにご連絡ください',
      notFound: 'この予約は見つかりません（すでにキャンセル済みの可能性があります）',
      legacyEvent: '旧形式のイベント — スタッフにご連絡ください',
    },
  },
  ko: {
    cancelBooking: '취소', cancelTitle: '예약 취소',
    cancelConfirm: '{name}의 {date} {time} 예약을 취소할까요?',
    cancelRefund: '코스에 수업 1회가 자동으로 반환됩니다',
    cancelDone: '예약이 취소되었습니다',
    cancelBlock: {
      checkedin: '이미 출석 처리되어 취소할 수 없습니다',
      event: '이벤트 신청 — 취소는 직원에게 문의하세요',
      free: '코스를 사용하지 않는 예약입니다 — 취소는 직원에게 문의하세요',
      noPackage: '이 예약의 코스를 찾을 수 없습니다 — 직원에게 문의하세요',
      trial: '체험 수업 — 취소는 직원에게 문의하세요',
      perSession: '1회 수업 예약 — 취소는 직원에게 문의하세요',
      finished: '이 코스는 종료되었습니다 — 직원에게 문의하세요',
      deadline: '직접 취소는 수업 전날 22:00까지 — 직원에게 문의하세요',
      notFound: '이 예약을 찾을 수 없습니다 (이미 취소되었을 수 있음)',
      legacyEvent: '이전 방식 이벤트 — 직원에게 문의하세요',
    },
  },
}
for (const loc of Object.keys(homeCancelMessages)) {
  messages[loc].home = Object.assign({}, messages[loc].home, homeCancelMessages[loc])
}

// ── ผลการแข่ง / เลื่อนเลเวล (EventLevelResults.vue + ประวัติเลเวลใน Student.vue) — LEVEL_PROMOTION_DESIGN.md
// apparatus = ชื่ออุปกรณ์ยิมนาสติกศิลป์ (รหัสสากลอยู่ในวงเล็บบนจอเสมอ) · zh/ja/ko แปลโดย AI ควรให้เจ้าของภาษาตรวจ
const levelResultMessages = {
  th: {
    apparatus: { VT: 'โต๊ะกระโดด', UB: 'บาร์ต่างระดับ', BB: 'คานทรงตัว', FX: 'ฟลอร์', PH: 'ม้าหู', SR: 'ห่วงนิ่ง', PB: 'บาร์คู่', HB: 'บาร์เดี่ยว' },
    levelRes: {
      tab: 'ผลการแข่ง / เลื่อนเลเวล', loadFail: 'โหลดผลการแข่งไม่สำเร็จ — ปิดแล้วเปิดใหม่อีกครั้ง',
      notYet: 'บันทึกผลการแข่งได้ตั้งแต่วันแข่ง ({date})',
      hint: 'กรอกคะแนนแต่ละอุปกรณ์ · ช่องเลเวลใหม่เว้นว่าง = ไม่เปลี่ยนเลเวล · กดบันทึกทั้งหมดครั้งเดียว',
      current: 'เลเวลปัจจุบัน {n}', entry: 'ส่งแข่ง L {n}', changed: 'เลื่อนจาก {from} → {to} แล้ว',
      voidBtn: 'ยกเลิกการเปลี่ยนเลเวลนี้', setF: 'ชุดหญิง (4 อุปกรณ์)', setM: 'ชุดชาย (6 อุปกรณ์)',
      pickSet: 'ไม่มีเพศในระบบ — เลือกชุดอุปกรณ์ก่อนกรอกคะแนน', total: 'รวม', newLevel: 'เลเวลใหม่', noChange: 'ไม่เปลี่ยน',
      note: 'หมายเหตุ', dirty: 'แก้ไขแล้ว {n} คน', saveAll: 'บันทึกทั้งหมด', confirmTitle: 'ยืนยัน',
      bigJump: 'มีการเปลี่ยนเลเวลเกิน 1 ระดับ: {list} — ยืนยันบันทึก?',
      voidConfirm: 'ยกเลิกการเปลี่ยนเลเวลของ {name} ({from} → {to}) และคืนเลเวลเดิม?',
      historyTitle: 'ประวัติเลเวล', historyEmpty: 'ยังไม่มีประวัติการเปลี่ยนเลเวล',
      fromEvent: 'แข่ง {name} ({date})', manual: 'แก้ไขที่หน้านักเรียน', by: 'โดย {by} · {at}', voidedBy: 'ยกเลิกโดย {by}',
    },
  },
  en: {
    apparatus: { VT: 'Vault', UB: 'Uneven bars', BB: 'Balance beam', FX: 'Floor', PH: 'Pommel horse', SR: 'Still rings', PB: 'Parallel bars', HB: 'High bar' },
    levelRes: {
      tab: 'Results / Level-up', loadFail: 'Could not load results — close and reopen',
      notYet: 'Results can be recorded from the competition day ({date})',
      hint: 'Enter a score per apparatus · leave New level empty to keep the level · save everything at once',
      current: 'Current level {n}', entry: 'Entered L {n}', changed: 'Moved {from} → {to}',
      voidBtn: 'Undo this level change', setF: "Women's set (4)", setM: "Men's set (6)",
      pickSet: 'No gender on file — pick an apparatus set first', total: 'Total', newLevel: 'New level', noChange: 'No change',
      note: 'Note', dirty: '{n} edited', saveAll: 'Save all', confirmTitle: 'Confirm',
      bigJump: 'Level changes of more than 1: {list} — save anyway?',
      voidConfirm: 'Undo the level change of {name} ({from} → {to}) and restore the old level?',
      historyTitle: 'Level history', historyEmpty: 'No level changes yet',
      fromEvent: 'Competition {name} ({date})', manual: 'Edited on the student screen', by: 'by {by} · {at}', voidedBy: 'undone by {by}',
    },
  },
  zh: {
    apparatus: { VT: '跳马', UB: '高低杠', BB: '平衡木', FX: '自由操', PH: '鞍马', SR: '吊环', PB: '双杠', HB: '单杠' },
    levelRes: {
      tab: '比赛成绩 / 升级', loadFail: '无法加载成绩 — 请关闭后重新打开',
      notYet: '比赛当天起可记录成绩（{date}）',
      hint: '按器械填写分数 · 新级别留空 = 不变 · 一次保存全部',
      current: '当前级别 {n}', entry: '参赛 L {n}', changed: '已从 {from} → {to}',
      voidBtn: '撤销此级别变更', setF: '女子项目（4）', setM: '男子项目（6）',
      pickSet: '系统中无性别 — 请先选择器械组', total: '合计', newLevel: '新级别', noChange: '不变',
      note: '备注', dirty: '已修改 {n} 人', saveAll: '全部保存', confirmTitle: '确认',
      bigJump: '级别变化超过 1 级：{list} — 确认保存？',
      voidConfirm: '撤销 {name} 的级别变更（{from} → {to}）并恢复原级别？',
      historyTitle: '级别记录', historyEmpty: '暂无级别变更',
      fromEvent: '比赛 {name}（{date}）', manual: '在学员页面修改', by: '由 {by} · {at}', voidedBy: '由 {by} 撤销',
    },
  },
  ja: {
    apparatus: { VT: '跳馬', UB: '段違い平行棒', BB: '平均台', FX: 'ゆか', PH: 'あん馬', SR: 'つり輪', PB: '平行棒', HB: '鉄棒' },
    levelRes: {
      tab: '試合結果 / レベルアップ', loadFail: '結果を読み込めませんでした — 閉じて開き直してください',
      notYet: '試合当日（{date}）から結果を記録できます',
      hint: '種目ごとに得点を入力 · 新レベルが空欄 = 変更なし · まとめて保存',
      current: '現在のレベル {n}', entry: '出場 L {n}', changed: '{from} → {to} に変更済み',
      voidBtn: 'このレベル変更を取り消す', setF: '女子種目（4）', setM: '男子種目（6）',
      pickSet: '性別が未登録です — 先に種目セットを選んでください', total: '合計', newLevel: '新レベル', noChange: '変更なし',
      note: 'メモ', dirty: '{n} 人を編集', saveAll: 'すべて保存', confirmTitle: '確認',
      bigJump: '1 段階を超えるレベル変更があります：{list} — 保存しますか？',
      voidConfirm: '{name} のレベル変更（{from} → {to}）を取り消して元に戻しますか？',
      historyTitle: 'レベル履歴', historyEmpty: 'レベル変更はまだありません',
      fromEvent: '試合 {name}（{date}）', manual: '生徒画面で編集', by: '{by} · {at}', voidedBy: '{by} が取り消し',
    },
  },
  ko: {
    apparatus: { VT: '도마', UB: '이단평행봉', BB: '평균대', FX: '마루', PH: '안마', SR: '링', PB: '평행봉', HB: '철봉' },
    levelRes: {
      tab: '대회 결과 / 레벨 업', loadFail: '결과를 불러오지 못했습니다 — 닫았다가 다시 여세요',
      notYet: '대회 당일({date})부터 결과를 기록할 수 있습니다',
      hint: '종목별 점수 입력 · 새 레벨을 비우면 변경 없음 · 한 번에 모두 저장',
      current: '현재 레벨 {n}', entry: '출전 L {n}', changed: '{from} → {to} 변경됨',
      voidBtn: '이 레벨 변경 취소', setF: '여자 종목 (4)', setM: '남자 종목 (6)',
      pickSet: '성별 정보 없음 — 먼저 종목 세트를 선택하세요', total: '합계', newLevel: '새 레벨', noChange: '변경 없음',
      note: '메모', dirty: '{n}명 수정됨', saveAll: '모두 저장', confirmTitle: '확인',
      bigJump: '1단계를 넘는 레벨 변경: {list} — 저장할까요?',
      voidConfirm: '{name}의 레벨 변경({from} → {to})을 취소하고 이전 레벨로 되돌릴까요?',
      historyTitle: '레벨 기록', historyEmpty: '레벨 변경 기록이 없습니다',
      fromEvent: '대회 {name} ({date})', manual: '학생 화면에서 수정', by: '{by} · {at}', voidedBy: '{by}님이 취소',
    },
  },
}
for (const loc of Object.keys(levelResultMessages)) Object.assign(messages[loc], levelResultMessages[loc])

// ── รายงานเลื่อนเลเวลต่ออีเวนต์ + ช่องเลเวลว่าง (เจ้าของสั่ง 2026-10-26) · zh/ja/ko แปลโดย AI ควรให้เจ้าของภาษาตรวจ
const levelReportMessages = {
  th: { sumScored: 'บันทึกคะแนนแล้ว {n}/{total} คน', sumUp: 'เลื่อนขึ้น {n} คน', sumDown: 'ลดเลเวล {n} คน',
    colHeader: 'เลื่อนเลเวล', colHint: 'ดูผลการแข่ง / เลื่อนเลเวลของงานนี้', noLevel: 'ยังไม่มีเลเวล' },
  en: { sumScored: 'Scored {n}/{total}', sumUp: '{n} moved up', sumDown: '{n} moved down',
    colHeader: 'Level-ups', colHint: 'Open this event’s results / level-ups', noLevel: 'No level yet' },
  zh: { sumScored: '已记录成绩 {n}/{total} 人', sumUp: '升级 {n} 人', sumDown: '降级 {n} 人',
    colHeader: '级别变动', colHint: '查看此赛事的成绩 / 升级', noLevel: '暂无级别' },
  ja: { sumScored: '得点記録 {n}/{total} 人', sumUp: '{n} 人レベルアップ', sumDown: '{n} 人レベルダウン',
    colHeader: 'レベル変更', colHint: 'このイベントの結果 / レベルアップを見る', noLevel: 'レベル未登録' },
  ko: { sumScored: '점수 기록 {n}/{total}명', sumUp: '{n}명 레벨 업', sumDown: '{n}명 레벨 다운',
    colHeader: '레벨 변동', colHint: '이 대회의 결과 / 레벨 업 보기', noLevel: '레벨 없음' },
}
for (const loc of Object.keys(levelReportMessages)) {
  messages[loc].levelRes = Object.assign({}, messages[loc].levelRes, levelReportMessages[loc])
}
